import type {
  AxiosInstance,
  AxiosRequestConfig,
  HeadersDefaults,
  ResponseType,
} from 'axios';
import axios from 'axios';

/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum TicketVersionChangeRecordFields {
  VersionAccessToExternalUser = 'version_accessToExternalUser',
  VersionAddress = 'version_address',
  VersionAssignee = 'version_assignee',
  VersionCategory = 'version_category',
  VersionCity = 'version_city',
  VersionComment = 'version_comment',
  VersionDeletedAt = 'version_deletedAt',
  VersionDescription = 'version_description',
  VersionDocument = 'version_document',
  VersionDueDate = 'version_dueDate',
  VersionExternalUser = 'version_externalUser',
  VersionFollowUpDate = 'version_followUpDate',
  VersionIsParticipant = 'version_isParticipant',
  VersionLocation = 'version_location',
  VersionOrganization = 'version_organization',
  VersionPhoneNumber = 'version_phoneNumber',
  VersionPriority = 'version_priority',
  VersionProject = 'version_project',
  VersionReceiveEmailNotifications = 'version_receiveEmailNotifications',
  VersionSavingsAmount = 'version_savingsAmount',
  VersionScope = 'version_scope',
  VersionState = 'version_state',
  VersionStatus = 'version_status',
  VersionSubCategory = 'version_subCategory',
  VersionSubStatus = 'version_subStatus',
  VersionSubject = 'version_subject',
  VersionTicket = 'version_ticket',
  VersionTicketFile = 'version_ticketFile',
  VersionTicketNumber = 'version_ticketNumber',
  VersionVendor = 'version_vendor',
  VersionVendorName = 'version_vendorName',
  VersionZip = 'version_zip',
}

export enum SortDirection {
  Asc = 'asc',
  Desc = 'desc',
}

export enum VectorApiContractStatus {
  Archived = 'Archived',
  FullyExecuted = 'Fully Executed',
  BillProcessingOnly = 'Bill Processing Only',
}

/** Difficulty level */
export enum Difficulty {
  VeryEasy = 'VeryEasy',
  Easy = 'Easy',
  Neutral = 'Neutral',
  Hard = 'Hard',
  VeryHard = 'VeryHard',
}

export enum DevicePlatform {
  Ios = 'ios',
  Android = 'android',
  Web = 'web',
}

export enum UserType {
  Internal = 'internal',
  External = 'external',
}

export enum SubauditVersionChangeRecordFields {
  VersionAuditName = 'version_auditName',
  VersionOwner = 'version_owner',
  VersionOrganization = 'version_organization',
  VersionVendor = 'version_vendor',
  VersionVendorAccountNumber = 'version_vendorAccountNumber',
  VersionSpendAmount = 'version_spendAmount',
  VersionSubauditStage = 'version_subauditStage',
  VersionUpdatedBy = 'version_updatedBy',
  VersionCreatedBy = 'version_createdBy',
  VersionTeam = 'version_team',
  VersionLocation = 'version_location',
  VersionSubauditName = 'version_subauditName',
  VersionAutoIncrementedId = 'version_autoIncrementedId',
  VersionOnHold = 'version_onHold',
}

export enum SubauditStage {
  New = 'New',
  GatherInfoVendor = 'Gather Info - Vendor',
  NegotiationInProgress = 'Negotiation In Progress',
  NegotiationCompleted = 'Negotiation Completed',
}

export enum EntraGroup {
  Employee = 'employee',
  MicrositeUser = 'microsite-user',
  Cms = 'cms',
}

export enum OrganizationSpecialFilter {
  Membership = 'membership',
  ActiveTasks = 'active-tasks',
}

export enum RecurrenceInterval {
  Day = 'day',
  Week = 'week',
  Month = 'month',
}

export enum NotificationPriority {
  Success = 'success',
  Error = 'error',
  Warning = 'warning',
  Info = 'info',
}

export enum VsrReportNoteSection {
  Summary = 'Summary',
  SibInvoiceByLocation = 'SibInvoiceByLocation',
  SavingsByLocation = 'SavingsByLocation',
  CategoryOverview = 'CategoryOverview',
  CategoryDetail = 'CategoryDetail',
}

export enum VsrReportStatus {
  Draft = 'draft',
  ReadyForReview = 'ready_for_review',
  Approved = 'approved',
  Sent = 'sent',
}

export enum SearchableModule {
  Organizations = 'organizations',
  Vendors = 'vendors',
  Audits = 'audits',
  Tasks = 'tasks',
  Projects = 'projects',
}

export enum SibContractStatus {
  Active = 'active',
  Inactive = 'inactive',
}

export enum SpendValueSource {
  Manual = 'manual',
  Formula = 'formula',
  Sync = 'sync',
}

/** Defaults to "review". */
export enum AuditInvoiceStatus {
  Confirmed = 'confirmed',
  VendorCorrection = 'vendorCorrection',
  Review = 'review',
}

/** How often the bill stream issues an invoice. Distinct from occurrenceInterval, which is how often this charge recurs. */
export enum BillingInterval {
  BiWeekly = 'bi_weekly',
  Weekly = 'weekly',
  Monthly = 'monthly',
  BiMonthly = 'bi_monthly',
  Quarterly = 'quarterly',
  Annually = 'annually',
}

export enum SpendInitiator {
  SIB = 'SIB',
  Client = 'Client',
}

/** What the employee decided on the spend`s line item. */
export enum SpendLineItemValidationStatus {
  Match = 'match',
  Mismatch = 'mismatch',
  Pending = 'pending',
}

export enum InvoiceStatus {
  Draft = 'draft',
  NotCollected = 'notCollected',
  Confirmed = 'confirmed',
  Approved = 'approved',
  Superseded = 'superseded',
  VendorCorrection = 'vendorCorrection',
  Review = 'review',
}

/** Client-side status shown in the Negotiations – client table. */
export enum AuditSpendClientStatus {
  MeetingScheduled = 'meeting_scheduled',
  InReview = 'in_review',
  Rejected = 'rejected',
  Accepted = 'accepted',
}

export enum NegotiationSpendStatus {
  Pending = 'pending',
  Approved = 'approved',
  Rejected = 'rejected',
}

export enum RevenueGrouping {
  Source = 'source',
  Organization = 'organization',
}

/** Set when grouped per service and spend category. */
export enum RevenueType {
  SavingsShare = 'savings_share',
  Fee = 'fee',
}

/** On a NetSuite client no organization names, where to name it: `sf2` gives its organization the client global id, `netsuite` gives the NetSuite customer one. */
export enum NetsuiteClientCorrection {
  Sf2 = 'sf2',
  Netsuite = 'netsuite',
}

export enum InvoiceLineTransition {
  Created = 'created',
  BillingsAdded = 'billings_added',
  BillingRemoved = 'billing_removed',
  MemoChanged = 'memo_changed',
  ItemChanged = 'item_changed',
  Submitted = 'submitted',
  SubmissionWithdrawn = 'submission_withdrawn',
  Invoiced = 'invoiced',
  ChangedInNetsuite = 'changed_in_netsuite',
  DeletedInNetsuite = 'deleted_in_netsuite',
}

export enum InvoiceLineStatus {
  Draft = 'draft',
  AwaitingInvoice = 'awaiting_invoice',
  Invoiced = 'invoiced',
}

export enum InvoiceLineKind {
  Service = 'service',
  SavingsShare = 'savings_share',
}

export enum InvoicePaymentStatus {
  Paid = 'paid',
  Unpaid = 'unpaid',
  PartiallyPaid = 'partially-paid',
}

/** Why the nightly NetSuite billing left this submitted obligation for a person. Null when nothing needs doing. */
export enum OccurrenceAttention {
  AmbiguousNetsuiteMatch = 'ambiguous_netsuite_match',
  NetsuiteAmountDiffers = 'netsuite_amount_differs',
  NotInvoiced = 'not_invoiced',
  BilledOutsideSidecar = 'billed_outside_sidecar',
  OutsideTerm = 'outside_term',
}

/** What the most recent entry recorded, where it recorded one. */
export enum OccurrenceTransition {
  Raised = 'raised',
  RaisedForReconciliation = 'raised_for_reconciliation',
  AmountChanged = 'amount_changed',
  Submitted = 'submitted',
  SubmissionWithdrawn = 'submission_withdrawn',
  Billed = 'billed',
  Voided = 'voided',
  Withdrawn = 'withdrawn',
  NetsuiteItemChanged = 'netsuite_item_changed',
  CategoryAssigned = 'category_assigned',
}

export enum OccurrenceStatus {
  PendingValidation = 'pending_validation',
  Submitted = 'submitted',
  Billed = 'billed',
  Void = 'void',
}

export enum SibInvoiceRange {
  Month = 'month',
  Quarter = 'quarter',
  Year = 'year',
}

/** Former once the term has ended; not billed while the charge has no obligation. */
export enum SibServiceChargeStatus {
  Active = 'active',
  Former = 'former',
  NotBilled = 'not_billed',
}

export enum ContractSoldLineKind {
  Service = 'service',
  SpendCategory = 'spend_category',
}

/** How often a client is billed. */
export enum ServiceOccurrenceInterval {
  OneTime = 'one_time',
  Monthly = 'monthly',
  Quarterly = 'quarterly',
  Annually = 'annually',
}

/** Why this item needs a person to choose its cadence. Null when nothing needs doing. */
export enum SibServiceAttention {
  CadenceUnknown = 'cadence_unknown',
  CadenceConflict = 'cadence_conflict',
}

/** The cadence a client charge on this item starts with; it is then the charge's own. */
export enum OccurrenceInterval {
  OneTime = 'one_time',
  Weekly = 'weekly',
  Monthly = 'monthly',
  Quarterly = 'quarterly',
  Annually = 'annually',
  OnCallAsNeeded = 'on_call_as_needed',
}

/** Fixed fee: owed on its cadence at the agreed price. Usage based: billed at what each invoice charges. */
export enum SibServicePricingModel {
  FixedFee = 'fixed_fee',
  UsageBased = 'usage_based',
}

/** Omit for a regular charge. Fixed at creation. */
export enum SpendKind {
  Discount = 'discount',
  SibCredit = 'sib_credit',
  VendorCredit = 'vendor_credit',
}

export enum SpendTierType {
  Volume = 'volume',
  UsageBand = 'usage_band',
  DiscountTier = 'discount_tier',
}

export enum SpendQuantityType {
  Estimate = 'estimate',
  Average = 'average',
  Actual = 'actual',
}

/** Why the attribution job left this spend unassigned. */
export enum SpendAssignmentReason {
  AmbiguousAuditMatch = 'ambiguous_audit_match',
  NoMatchingAudit = 'no_matching_audit',
  MissingVendorAccount = 'missing_vendor_account',
  MissingVendor = 'missing_vendor',
}

export enum OccurrenceFrequency {
  Weekly = 'weekly',
  Monthly = 'monthly',
  Quarterly = 'quarterly',
  Annually = 'annually',
  OnCallAsNeeded = 'on_call_as_needed',
}

export enum OccurrenceType {
  OneTime = 'one_time',
  Recurring = 'recurring',
}

export enum SpendPricingModel {
  UsageBased = 'usage_based',
  FixedFee = 'fixed_fee',
  PercentageRate = 'percentage_rate',
}

/** Whether this audit is the source (parent) or a copy (child). */
export enum LinkedAuditLinkType {
  Parent = 'parent',
  Child = 'child',
}

/** Whether the value comes from the manual override on the spend category or was computed from completed audits */
export enum AverageAuditDurationSource {
  Manual = 'manual',
  Computed = 'computed',
}

export enum AuditStage {
  MONITORING_SAVINGS = 'MONITORING_SAVINGS',
  INITIAL_VALIDATION = 'INITIAL_VALIDATION',
  SPEND_ESTIMATED = 'SPEND_ESTIMATED',
  MOBILIZATION = 'MOBILIZATION',
  NEGOTIATIONS_VENDOR = 'NEGOTIATIONS_VENDOR',
  NEGOTIATIONS_CLIENT = 'NEGOTIATIONS_CLIENT',
}

export enum AuditStatus {
  Open = 'open',
  Pending = 'pending',
  OnHold = 'on_hold',
  Completed = 'completed',
  Cancelled = 'cancelled',
  ReviewRequired = 'review_required',
}

/** Which Salesforce record this audit was migrated from. */
export enum SalesforceAuditSource {
  ParentAudit = 'parent_audit',
  VendorSplit = 'vendor_split',
  Subaudit = 'subaudit',
}

export enum DashboardMetricsField {
  LastEditedTask = 'lastEditedTask',
  LastEditedTicket = 'lastEditedTicket',
  Notifications = 'notifications',
  CrmCount = 'crmCount',
  Tickets = 'tickets',
  Tasks = 'tasks',
}

export enum ActionItemType {
  MeetingLink = 'meeting-link',
  Link = 'link',
  FileUpload = 'file-upload',
}

export enum OnlineAccessStatus {
  Active = 'active',
  Archived = 'archived',
}

export enum DocumentFieldStatus {
  COMPLETE = 'COMPLETE',
  MISSING_FIELDS = 'MISSING_FIELDS',
  UPLOAD_INVOICES = 'UPLOAD_INVOICES',
  NOT_APPLICABLE_REQUESTED = 'NOT_APPLICABLE_REQUESTED',
  NOT_APPLICABLE = 'NOT_APPLICABLE',
}

export enum LocationStatus {
  Active = 'Active',
  Monitored = 'Monitored',
  Sold = 'Sold',
  Closed = 'Closed',
  UnderConstruction = 'Under Construction',
  NotActive = 'Not Active',
}

/** `organization_wide` is the organization's one non-site bucket; filter it out with `filter=kind:eq:site`. */
export enum LocationKind {
  Site = 'site',
  OrganizationWide = 'organization_wide',
}

/** What the client navigates to when the entry is opened */
export enum OrganizationCommentParent {
  Organization = 'organization',
  Audit = 'audit',
  Task = 'task',
  Ticket = 'ticket',
}

export enum OrganizationCommentSource {
  Organization = 'organization',
  Audit = 'audit',
  AuditMeeting = 'audit_meeting',
  ValidationSpendGroup = 'validation_spend_group',
  Task = 'task',
  Ticket = 'ticket',
}

export enum BillPayPaymentType {
  Ach = 'ach',
  Cc = 'cc',
  Check = 'check',
}

export enum PaymentRemittanceIdentifier {
  InvoiceNumber = 'invoice_number',
  AccountNumber = 'account_number',
}

export enum CardFeeType {
  Amount = 'amount',
  Percentage = 'percentage',
}

/** Vendor lifecycle status from the `vendor_status` column. */
export enum VendorStatus {
  Active = 'active',
  Inactive = 'inactive',
  OnHold = 'on-hold',
}

export enum ContactStatus {
  Active = 'active',
  Inactive = 'inactive',
  OutOfOffice = 'out_of_office',
}

export enum FundingDetailsSubmissionMethod {
  Email = 'email',
  Sftp = 'sftp',
}

export enum BillPayFundingFrequency {
  Monthly = 'monthly',
  Quarterly = 'quarterly',
}

export enum ClientStatus {
  Dormant = 'dormant',
  Mobilization = 'mobilization',
  Negotiation = 'negotiation',
  PostNegotiation = 'post_negotiation',
  PreNegotiation = 'pre_negotiation',
  Prospect = 'prospect',
  UpdateRequired = 'update_required',
  Validation = 'validation',
}

export enum OrganizationStatus {
  Active = 'active',
  Inactive = 'inactive',
}

export enum TicketCommentScope {
  Internal = 'internal',
  External = 'external',
}

export enum TicketCategory {
  Account = 'account',
  Baselines = 'baselines',
  Client = 'client',
  Contract = 'contract',
  CustomerService = 'customer_service',
  Escalation = 'escalation',
  Exceptions = 'exceptions',
  Finance = 'finance',
  FollowUp = 'follow_up',
  InformationRequest = 'information_request',
  Invoice = 'invoice',
  MasterData = 'master_data',
  Negotiation = 'negotiation',
  Others = 'others',
  Payments = 'payments',
  Property = 'property',
  ServiceRequest = 'service_request',
  Transitions = 'transitions',
  VendorLocal = 'vendor_local',
  MissingBill = 'missing_bill',
  UpdateMailingAddress = 'update_mailing_address',
  PotentialLeak = 'potential_leak',
  InvoiceQuestion = 'invoice_question',
}

export enum TicketStatus {
  InProgress = 'in_progress',
  New = 'new',
  Closed = 'closed',
  WorkingWithVendor = 'working_with_vendor',
  AwaitingClientAction = 'awaiting_client_action',
  AwaitingInternalAction = 'awaiting_internal_action',
  Canceled = 'canceled',
  Completed = 'completed',
}

export enum ProjectStatus {
  Unassigned = 'unassigned',
  Unstarted = 'unstarted',
  InProgress = 'in-progress',
  OnHold = 'on-hold',
  ViewOnly = 'view-only',
  InReview = 'in-review',
  Escalated = 'escalated',
  Completed = 'completed',
}

export enum SpendAreaStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  IN_PROGRESS_WITH_SAVINGS = 'IN_PROGRESS_WITH_SAVINGS',
  COMPLETED = 'COMPLETED',
  NOT_ASSIGNED = 'NOT_ASSIGNED',
  REQUESTED = 'REQUESTED',
}

export enum SpendAreaStage {
  MONITORING_SAVINGS = 'MONITORING_SAVINGS',
  INITIAL_VALIDATION = 'INITIAL_VALIDATION',
  SPEND_ESTIMATED = 'SPEND_ESTIMATED',
  MOBILIZATION = 'MOBILIZATION',
  NEGOTIATIONS_VENDOR = 'NEGOTIATIONS_VENDOR',
  NEGOTIATIONS_CLIENT = 'NEGOTIATIONS_CLIENT',
}

export enum TaskTagVersionChangeRecordFields {
  VersionTask = 'version_task',
  VersionRecurringTask = 'version_recurringTask',
  VersionTag = 'version_tag',
  VersionContact = 'version_contact',
  VersionEmployee = 'version_employee',
  VersionType = 'version_type',
  VersionCreatedBy = 'version_createdBy',
  VersionUpdatedBy = 'version_updatedBy',
  VersionDeletedAt = 'version_deletedAt',
}

export enum SubtaskVersionChangeRecordFields {
  VersionTitle = 'version_title',
  VersionDescription = 'version_description',
  VersionPriorityLevel = 'version_priorityLevel',
  VersionCompleted = 'version_completed',
  VersionCreatedBy = 'version_createdBy',
  VersionTask = 'version_task',
  VersionUpdatedBy = 'version_updatedBy',
}

export enum TaskVersionChangeRecordFields {
  VersionTitle = 'version_title',
  VersionDescription = 'version_description',
  VersionPriorityLevel = 'version_priorityLevel',
  VersionReferenceLink = 'version_referenceLink',
  VersionReferenceName = 'version_referenceName',
  VersionCategory = 'version_category',
  VersionStatus = 'version_status',
  VersionAssignee = 'version_assignee',
  VersionOrganization = 'version_organization',
  VersionVendor = 'version_vendor',
  VersionCompleted = 'version_completed',
  VersionCompletedAt = 'version_completedAt',
  VersionDeadline = 'version_deadline',
  VersionSeenAt = 'version_seenAt',
  VersionSeen = 'version_seen',
  VersionFollowUpTaskParent = 'version_followUpTaskParent',
  VersionRecurringTask = 'version_recurringTask',
  VersionSubauditId = 'version_subauditId',
  VersionTimeLogged = 'version_timeLogged',
  VersionEstimatedTime = 'version_estimatedTime',
  VersionHiddenBefore = 'version_hiddenBefore',
  VersionProject = 'version_project',
  VersionTicket = 'version_ticket',
  VersionCreatedBy = 'version_createdBy',
  VersionUpdatedBy = 'version_updatedBy',
  VersionDeletedAt = 'version_deletedAt',
  TagsCreated = 'tags_created',
  TagsDeleted = 'tags_deleted',
}

/** The type of the entity. Usually the name of the entity. */
export enum ChangelogEntityType {
  Task = 'task',
  TaskComment = 'taskComment',
  Subtask = 'subtask',
  TaskTag = 'taskTag',
  Subaudit = 'subaudit',
  SubauditTask = 'subauditTask',
  SubauditComment = 'subauditComment',
  Ticket = 'ticket',
  TicketComment = 'ticketComment',
  TicketFile = 'ticketFile',
  TicketExternalUser = 'ticketExternalUser',
  TicketDocumentFile = 'ticketDocumentFile',
}

export enum AuditingAction {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
}

export enum VendorAccountStatus {
  Active = 'active',
  Inactive = 'inactive',
}

export enum BillingType {
  Paper = 'paper',
  Email = 'email',
  Portal = 'portal',
}

export enum InvoiceFrequency {
  BiWeekly = 'bi_weekly',
  Weekly = 'weekly',
  Monthly = 'monthly',
  BiMonthly = 'bi_monthly',
  Quarterly = 'quarterly',
}

export enum AdditionalColumnsType {
  Select = 'select',
}

export enum TagType {
  Custom = 'custom',
  Contact = 'contact',
  Employee = 'employee',
}

/** Status of the task */
export enum TaskStatus {
  InProgress = 'in_progress',
  New = 'new',
  Closed = 'closed',
  WorkingWithVendor = 'working_with_vendor',
  AwaitingClientAction = 'awaiting_client_action',
  AwaitingInternalAction = 'awaiting_internal_action',
  Canceled = 'canceled',
  Completed = 'completed',
}

export enum TaskCategory {
  VendorCall = 'Vendor Call',
  ClientCall = 'Client Call',
  InternalOutreach = 'Internal outreach',
  VendorEmail = 'Vendor email',
  ClientEmail = 'Client email',
  DataAnalysis = 'Data analysis',
  ReportBuild = 'Report build',
  DataGathering = 'Data gathering',
  InvoiceCollection = 'Invoice Collection',
  Research = 'Research',
  ProactiveClientOutreach = 'Proactive Client Outreach',
  Other = 'Other',
}

/** Priority of the task */
export enum PriorityLevel {
  Low = 'low',
  Medium = 'medium',
  High = 'high',
}

export enum BillingInvoiceContactCompany {
  Sib = 'Sib',
  Vector = 'Vector',
}

export enum PermissionAction {
  NONE = 0,
  CREATE = 1,
  READ = 2,
  UPDATE = 4,
  DELETE = 8,
}

export enum PermissionResource {
  Admin = 'admin',
  Manager = 'manager',
  Employee = 'employee',
  Client = 'client',
  Crm = 'crm',
  Team = 'team',
  Dashboard = 'dashboard',
  Savings = 'savings',
  ActionItems = 'action_items',
  SpendAreas = 'spend_areas',
  Documents = 'documents',
  SensitiveDocuments = 'sensitive_documents',
  InternalDocuments = 'internal_documents',
  Locations = 'locations',
  Reports = 'reports',
  Tickets = 'tickets',
  Teams = 'teams',
  Billings = 'billings',
  Vendors = 'vendors',
  AccessShare = 'access_share',
  RoleAssignment = 'role_assignment',
  Contacts = 'contacts',
  SibContracts = 'sib_contracts',
  InactiveSibContracts = 'inactive_sib_contracts',
  Organizations = 'organizations',
  Projects = 'projects',
  Audits = 'audits',
  Subaudits = 'subaudits',
  AuditTasks = 'audit_tasks',
  Templates = 'templates',
  Settings = 'settings',
  BankAccountDetails = 'bank_account_details',
  OnlineAccessCredentials = 'online_access_credentials',
  Diagnostics = 'diagnostics',
  Maintenance = 'maintenance',
  DeveloperTools = 'developer_tools',
  FranzIntegration = 'franz_integration',
}

export enum UserLoginStatus {
  Uncompleted = 'uncompleted',
  Completed = 'completed',
}

export enum DocumentUploadStage {
  Pending = 'pending',
  Failed = 'failed',
  Uploaded = 'uploaded',
  Removed = 'removed',
}

export enum PaymentFrequency {
  Monthly = 'Monthly',
  Quarterly = 'Quarterly',
  Annually = 'Annually',
  SemiAnnual = 'Semi-Annual',
}

export enum ContractType {
  MSA = 'MSA',
  SOW = 'SOW',
  Amendment = 'Amendment',
  Addendum = 'Addendum',
  OrderForm = 'Order Form',
  EndUserLicenseAgreement = 'End User License Agreement',
  NDA = 'NDA',
  DataSecurityAgreement = 'Data Security Agreement',
  Other = 'Other',
}

export enum DocumentUploadStatus {
  Pending = 'pending',
  Failed = 'failed',
  Uploaded = 'uploaded',
  Removed = 'removed',
}

export enum DocumentProvidedBy {
  Client = 'client',
  Sib = 'sib',
  System = 'system',
  Vector = 'vector',
}

export enum DocumentStage {
  Uploaded = 'uploaded',
  InProgress = 'in-progress',
  ActionNeeded = 'action-needed',
  Approved = 'approved',
  Rejected = 'rejected',
  Expired = 'expired',
}

export enum CategoryManager {
  ErnestoVidal = 'Ernesto Vidal',
  JorgeDiaz = 'Jorge Diaz',
  KayleePolley = 'Kaylee Polley',
  JenniferNorcross = 'Jennifer Norcross',
  GabriellaDion = 'Gabriella Dion',
  WendyRuggiero = 'Wendy Ruggiero',
  JuanBonilla = 'Juan Bonilla',
  FrankMilatta = 'Frank Milatta',
}

export enum DocumentType {
  Invoice = 'invoice',
  Contract = 'contract',
  LetterOfAuthorization = 'letter-of-authorization',
  Other = 'other',
  SiteList = 'site-list',
  SibInvoice = 'sib-invoice',
}

export interface QueueInfoDto {
  /** Queue name */
  name: string;
  /** Number of waiting jobs */
  waiting: number;
  /** Number of active jobs */
  active: number;
  /** Number of completed jobs */
  completed: number;
  /** Number of failed jobs */
  failed: number;
  /** Number of delayed jobs */
  delayed: number;
  /** Number of paused jobs */
  paused: number;
}

export interface ListQueueJobsDto {
  /** Array of jobs in the queue */
  jobs: string[];
  /** Total number of jobs */
  total: number;
}

export interface BulkUpdateDocumentDto {
  /** @uniqueItems true */
  documentIds: string[];
  type?: DocumentType | null;
  /** @uniqueItems true */
  tags?: string[];
  internal?: boolean | null;
  categoryManager?: CategoryManager | null;
  /** @format uuid */
  spendCategory?: string | null;
  vendor?: string | null;
  startDate?: string | null;
  endDate?: string | null;
  renewalDate?: string | null;
  annualContractValue?: number | null;
  notToExceed?: boolean | null;
  annualPriceIncrease?: boolean | null;
  earlyTerminationFee?: boolean | null;
  sensitive?: boolean | null;
  categoryManagerUser?: string | null;
}

export interface PlainExternalUserDto {
  id: string;
  name: string;
  email: string;
  avatarUrl: string | null;
  deletedAt: string | null;
}

export interface SpendCategoryListItemDto {
  id: string;
  name: string;
}

export interface DocumentTagDto {
  uuid: string;
  name: string;
  isPredefined?: boolean;
}

export interface DocumentDto {
  id: string;
  stage: DocumentStage;
  fileUrl: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  name: string;
  sensitive: boolean;
  internal: boolean;
  providedBy: DocumentProvidedBy;
  uploadedBy: PlainExternalUserDto;
  spendCategory?: SpendCategoryListItemDto | null;
  organizationId: string;
  subsidiaryOrganizationName?: string | null;
  tags: DocumentTagDto[] | null;
  uploadStage: DocumentUploadStatus;
  contractType?: ContractType | null;
  categoryManager?: CategoryManager | null;
  categoryManagerUser?: PlainExternalUserDto | null;
  paymentFrequency?: PaymentFrequency | null;
  anomaly?: boolean | null;
  matchingDocuments?: number | null;
  hasVirtualInvoices?: boolean;
  docId?: string | null;
  /** AI-managed fields explicitly edited by a user; Franz sync skips these. */
  userModifiedFields?: string[];
  /**
   * Set when Franz first updates this document; AI-managed fields become read-only for users.
   * @format date-time
   */
  updatedWithAiAt?: string | null;
  vendor: string | null;
  fileSize?: number | null;
  type: string | null;
  /** @format date-time */
  startDate?: string | null;
  /** @format date-time */
  endDate?: string | null;
  /** @format date-time */
  renewalDate?: string | null;
  annualContractValue?: number | null;
  notToExceed?: boolean | null;
  annualPriceIncrease?: boolean | null;
  earlyTerminationFee?: boolean | null;
  cancellationDateNoticePeriod?: string | null;
  autoRenewalClause?: boolean | null;
  autoRenewalLength?: string | null;
  notToExceedPercentage?: number | null;
  additionalColumns?: object | null;
}

export interface InitUploadDocumentItemDto {
  filename: string;
  mimetype: string;
  /**
   * File size in bytes from the client File object, validated before upload starts
   * @min 1
   */
  filesize: number;
  /** MD5 hash of the file content (base64), computed by the client before upload */
  md5Hash: string;
  sensitive?: boolean;
  internal?: boolean;
  type?: DocumentType;
  /** Discard any partial blob in storage and start a fresh upload session */
  restart?: boolean;
}

export interface InitUploadDocumentsDto {
  /** @minItems 1 */
  files: InitUploadDocumentItemDto[];
  /** This is ID helps us groupd the files in the same bulk upload */
  batchUploadId?: string;
  /** Total number of files in the batch upload */
  totalFiles: number;
}

export interface InitUploadDocumentResponseItemDto {
  /** Document ID for this upload session */
  uploadId: string;
  /** SAS URL for staging block blobs (Put Block). Client uploads chunks directly to Azure. */
  sasUrl: string;
  /** Recommended block size in bytes for chunk uploads */
  blockSize: number;
  /** Expected number of blocks for this file size */
  maxBlocks: number;
  /** When false, the client must not resume staged blocks from local storage (e.g. after abandoned-upload cleanup moved the session to failed). */
  resumePartialBlocks: boolean;
  /** Filename for this upload session */
  filename: string;
}

export interface InitUploadDocumentFailedItemDto {
  /** Filename that failed to initialize */
  filename: string;
  /** Error message describing the failure */
  error: string;
}

export interface InitUploadDocumentsResponseDto {
  items: InitUploadDocumentResponseItemDto[];
  failed: InitUploadDocumentFailedItemDto[];
}

export interface CompleteUploadDocumentDto {
  /** Document ID returned from POST /upload/init */
  uploadId: string;
  /** Ordered list of block IDs staged in Azure (base64), one per uploaded chunk. Omit (or send an empty array) for single-blob uploads where the whole file was sent via a single Put Blob. */
  blockIds?: string[];
}

export interface DocumentListDto {
  /** Array of items */
  items: DocumentDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export type StreamableFile = object;

export interface DocumentColumnMaxValuesDto {
  annualContractValue: number | null;
  notToExceedPercentage: number | null;
}

export interface CheckDocumentContentHashQueryDto {
  /**
   * Unique MD5 hashes of file content (base64), computed by the client before upload
   * @minItems 1
   */
  md5Hashes: string[];
}

export interface CheckDocumentContentHashResultDto {
  /** MD5 hash that was checked */
  md5Hash: string;
  /** Whether an uploaded document with identical content already exists */
  isDuplicate: boolean;
  /** Human-readable reason when isDuplicate is true */
  message?: string;
  /**
   * Existing uploaded document with this content when isDuplicate is true
   * @format uuid
   */
  documentId?: string | null;
  /** Filename of the existing uploaded document when isDuplicate is true */
  filename?: string | null;
  /**
   * Invoice the existing document backs, when isDuplicate is true
   * @format uuid
   */
  invoiceId?: string | null;
  /**
   * Bill stream of the invoice the existing document backs, when isDuplicate is true
   * @format uuid
   */
  invoiceTemplateId?: string | null;
}

export interface CheckDocumentContentHashResponseDto {
  /** Duplicate check result for each requested MD5 hash */
  results: CheckDocumentContentHashResultDto[];
}

export interface VirtualDocumentDto {
  id: string;
  franzDocId: string;
  name?: string | null;
  type?: string | null;
  subsidiary?: string | null;
  vendor?: string | null;
  providedBy?: DocumentProvidedBy | null;
  stage?: DocumentStage | null;
  categoryManagerUser?: PlainExternalUserDto | null;
  paymentFrequency?: PaymentFrequency | null;
  spendCategory?: SpendCategoryListItemDto | null;
  /** @format date-time */
  startDate?: string | null;
  /** @format date-time */
  endDate?: string | null;
  /** @format date-time */
  renewalDate?: string | null;
  annualContractValue?: number | null;
  notToExceed?: boolean | null;
  annualPriceIncrease?: boolean | null;
  earlyTerminationFee?: boolean | null;
  contractType?: ContractType | null;
  cancellationDateNoticePeriod?: string | null;
  autoRenewalClause?: boolean | null;
  autoRenewalLength?: string | null;
  notToExceedPercentage?: number | null;
  anomaly?: boolean | null;
  matchingDocuments?: number | null;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export interface VirtualDocumentListDto {
  /** Array of items */
  items: VirtualDocumentDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface UpdateDocumentDto {
  stage?: DocumentStage;
  type?: DocumentType | null;
  contractType?: ContractType | null;
  categoryManagerUser?: string | null;
  categoryManager?: CategoryManager | null;
  paymentFrequency?: PaymentFrequency | null;
  tags?: string[];
  filename?: string;
  vendor?: string | null;
  spendCategory?: string | null;
  sensitive?: boolean | null;
  internal?: boolean | null;
  startDate?: string | null;
  endDate?: string | null;
  renewalDate?: string | null;
  annualContractValue?: number | null;
  notToExceed?: boolean | null;
  annualPriceIncrease?: boolean | null;
  earlyTerminationFee?: boolean | null;
  cancellationDateNoticePeriod?: string | null;
  autoRenewalClause?: boolean | null;
  autoRenewalLength?: string | null;
  notToExceedPercentage?: number | null;
  additionalColumns?: object | null;
}

export interface DocumentUploadStatusDto {
  id: string;
  name: string;
  status: DocumentUploadStage;
  createdAt: string;
  updatedAt: string;
}

export interface DocumentUploadStatusListDto {
  /** Array of items */
  items: DocumentUploadStatusDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface SelectListItemDto {
  id: string;
  name: string;
}

export interface SelectListDto {
  items: SelectListItemDto[];
}

export interface SyncFranzDocumentDto {
  /**
   * Base64 MD5 hash of the uploaded parent document blob
   * @minLength 1
   */
  documentHash: string;
}

export interface DocumentFileUrlDto {
  /** Time-limited SAS URL for reading the document blob */
  fileUrl: string;
}

export interface ExternalUserPartialListDto {
  /** Array of items */
  items: PlainExternalUserDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface UpdateExternalUserDto {
  contactPhoneNumber?: string;
  firstName?: string;
  surname?: string;
  title?: string;
  contactEmail?: string;
  meetingLink?: string;
  userLoginStatus?: UserLoginStatus;
}

export interface PermissionDto {
  resource?: PermissionResource;
  action?: PermissionAction;
}

export interface OrganizationLogoDto {
  fileUrl?: string | null;
  width: number | null;
  height: number | null;
}

export interface ExternalUserDto {
  id: string;
  name: string;
  email: string;
  meetingLink?: string;
  title?: string;
  userLoginStatus?: UserLoginStatus;
  firstName: string | null;
  surname: string | null;
  contactEmail: string | null;
  contactPhoneNumber: string | null;
  avatarUrl: string | null;
  deletedAt: string | null;
}

export interface PowerBiReportDto {
  id: string;
  name?: string;
  groupId: string;
  reportId: string;
  token: string;
  filterQuery?: string;
}

export interface ParentOrganizationDto {
  id: string;
  name: string;
  fileUrl?: string | null;
  logo?: OrganizationLogoDto | null;
  width: number | null;
  height: number | null;
}

export interface OrganizationDto {
  id: string;
  name: string;
  fileUrl?: string | null;
  logo?: OrganizationLogoDto | null;
  createdAt: string;
  updatedAt: string;
  manager?: ExternalUserDto | null;
  powerBiReport?: PowerBiReportDto | null;
  permissions?: Record<string, PermissionAction> | null;
  parentOrganization?: ParentOrganizationDto | null;
  privateEquityFirm?: ParentOrganizationDto | null;
  termsOfServiceAccepted: boolean;
  tosAcceptedAt?: string | null;
  tosAcceptedBy?: PlainExternalUserDto | null;
  domains?: string[] | null;
  vectorClientId: string | null;
  aiEnabled: boolean | null;
  aiPort: string | null;
  aiBrandingAlias: string | null;
  netsuiteCustomerId: string | null;
  width: number | null;
  height: number | null;
}

export interface YourTeamMemberDto {
  id: string;
  name: string;
  email: string;
  meetingLink?: string;
  title?: string;
  userLoginStatus?: UserLoginStatus;
  firstName: string | null;
  surname: string | null;
  contactEmail: string | null;
  contactPhoneNumber: string | null;
  avatarUrl: string | null;
  deletedAt: string | null;
}

export interface BillingContactDto {
  id: string;
  name: string;
  email: string;
  provider: BillingInvoiceContactCompany;
  contactPhoneNumber: string | null;
  meetingLink: string | null;
  title: string | null;
}

export interface YourTeamDto {
  primaryContact: YourTeamMemberDto | null;
  otherSupportingMembers: YourTeamMemberDto[] | null;
  billingContact: BillingContactDto[] | null;
}

export interface TagDto {
  uuid: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  name: string;
  /** @pattern ^#?([0-9A-F]{3}|[0-9A-F]{4}|[0-9A-F]{6}|[0-9A-F]{8})$ */
  color?: string;
  isPredefined?: boolean;
  createdBy: string;
}

export interface ContactDto {
  id: string;
  name?: string;
  email?: string | null;
  isActive: boolean;
  firstName: string | null;
  lastName: string | null;
  title: string | null;
  phoneNumber: string | null;
  note: string | null;
}

export interface TaskTagDto {
  tag?: TagDto | null;
  contact?: ContactDto | null;
  employee?: ExternalUserDto | null;
  type?: TagType;
}

export interface BaseTaskOrganizationDto {
  id: string;
  name: string;
  logoUrl?: string | null;
}

export interface TaskRelationDto {
  uuid: string;
  title: string;
}

export interface TaskDto {
  /**
   * Unique identifier for the task
   * @example "c56a4180-65aa-42ec-a945-5fd21dec0538"
   */
  uuid: string;
  /**
   * Title of the task
   * @example "Complete project documentation"
   */
  title: string;
  /**
   * Description of the task
   * @example "Finish writing the project documentation by end of the day"
   */
  description?: string | null;
  /**
   * Date when the task was created
   * @format date-time
   * @example "2023-01-01T12:00:00Z"
   */
  createdAt: string;
  /**
   * Date when the task was last updated
   * @format date-time
   * @example "2023-01-02T15:30:00Z"
   */
  updatedAt: string;
  /** Priority of the task */
  priorityLevel: PriorityLevel;
  createdByUser: PlainExternalUserDto;
  assigneeUser: PlainExternalUserDto | null;
  category?: TaskCategory;
  /** Status of the task */
  status: TaskStatus;
  /** External reference URL for the task */
  referenceLink?: string | null;
  referenceName?: string | null;
  tags: TaskTagDto[];
  /**
   * Estimated time to complete the task in minutes
   * @min 1
   * @example 120
   */
  estimatedTime?: number | null;
  /**
   * Task completion status
   * @example false
   */
  completed: boolean;
  /**
   * Deadline date of the task
   * @format date-time
   * @example "2024-01-02T15:30:00Z"
   */
  deadline: string | null;
  /**
   * Date of the task completion
   * @format date-time
   * @example "2024-01-02T15:30:00Z"
   */
  completedAt: string | null;
  unfinishedSubtasksCount: number;
  /**
   * Total number of non-deleted subtasks of this task
   * @example 5
   */
  subtasksCount: number;
  /** @format uuid */
  recurringTaskUuid?: string | null;
  /**
   * Date when the task was marked as seen
   * @format date-time
   * @example "2024-01-02T15:30:00Z"
   */
  seenAt?: string | null;
  /** Whether the task has been seen by the assignee */
  seen?: boolean | null;
  /** @format uuid */
  subauditId?: string | null;
  organization?: BaseTaskOrganizationDto | null;
  vendor?: BaseTaskOrganizationDto | null;
  followUpTask?: TaskRelationDto | null;
  parentTask?: TaskRelationDto | null;
  /**
   * Time logged on this task in minutes
   * @min 0
   * @example 120
   */
  timeLogged?: number | null;
  /** Whether the task is delegated (assignee differs from creator) */
  isDelegated?: boolean | null;
  /** @format uuid */
  projectId?: string | null;
  /** @format uuid */
  ticketId?: string | null;
  /**
   * Total number of comments on this task
   * @min 0
   * @example 3
   */
  commentsCount?: number | null;
  /**
   * Total number of files attached to this task
   * @min 0
   * @example 2
   */
  filesCount?: number | null;
  /** Whether the current user can edit this task */
  canEdit: boolean;
}

export interface TaskListDto {
  /** Array of items */
  items: TaskDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
  newItemsCount?: number;
}

export interface AllowedDomainListDto {
  items: string[];
}

export interface SpendCategoryListDto {
  /** Array of items */
  items: SpendCategoryListItemDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
  totalPages: number;
}

export interface AdditionalColumnValueDto {
  value: string;
  label: string | null;
}

export interface AdditionalColumnsDto {
  id: string;
  tableName: string;
  label: string;
  key: string;
  /** @example "select" */
  type: AdditionalColumnsType;
  values?: AdditionalColumnValueDto[] | null;
}

export interface AdditionalColumnsListDto {
  /** List of additional columns */
  items: AdditionalColumnsDto[];
}

export interface PlainDto {
  id: string;
  name: string;
}

export interface VendorAccountDto {
  id: string;
  vendor: PlainDto;
  accountNumber: string;
  name?: string | null;
  note?: string | null;
  invoiceFrequency?: InvoiceFrequency | null;
  serviceType?: string | null;
  summaryAccountNumber?: string | null;
  glCode?: string | null;
  customGlField?: string | null;
  glAllocations?: string | null;
  usageLimit?: number | null;
  dollarLimit?: number | null;
  paymentTerms?: number | null;
  invoiceDay?: number | null;
  billingType?: BillingType | null;
  portalLoginEmailId?: string | null;
  status: VendorAccountStatus;
  /** Number of audits linked to this vendor account. */
  auditsCount: number;
  /** Names of spend categories linked to this vendor account. */
  spendCategories: string[];
  /** Locations assigned to this vendor account. */
  locations: PlainDto[];
  /** Whether the vendor account was attached from the organization vendor accounts list. Only present in audit context. */
  attachedFromVendorAccountsList?: boolean;
  /** Whether the vendor account is linked to this audit (picker). */
  linkedToThisAudit?: boolean;
}

export interface VendorAccountListDto {
  /** Array of items */
  items: VendorAccountDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface CreateVendorAccountDto {
  /** Vendor account number for bill pay. */
  accountNumber?: string;
  name?: string | null;
  note?: string | null;
  invoiceFrequency?: InvoiceFrequency | null;
  serviceType?: string | null;
  summaryAccountNumber?: string | null;
  glCode?: string | null;
  customGlField?: string | null;
  glAllocations?: string | null;
  /** @min 0 */
  usageLimit?: number | null;
  /** @min 0 */
  dollarLimit?: number | null;
  /** @min 0 */
  paymentTerms?: number | null;
  /**
   * @min 1
   * @max 31
   */
  invoiceDay?: number | null;
  billingType?: BillingType | null;
  portalLoginEmailId?: string | null;
  /** @default "active" */
  status?: VendorAccountStatus;
  /** Vendor organization id for the new account. */
  vendorId: string;
  /**
   * IDs of spend categories to associate with this vendor account. At least one is required; a vendor with no spend categories needs them added first.
   * @minItems 1
   */
  spendCategoryIds: string[];
  /**
   * When set, links the new vendor account to this audit with attachedFromVendorAccountsList=false. If locationIds are omitted, locations are inherited from the audit spend footprint.
   * @format uuid
   */
  auditId?: string;
  /**
   * IDs of locations to assign to this vendor account.
   * @uniqueItems true
   */
  locationIds?: string[];
}

export interface FindVendorAccountDuplicatesDto {
  /** Vendor id of the account being created. */
  vendorId: string;
  /**
   * Location ids of the account being created. An existing account matches only when its location set is exactly equal (order ignored).
   * @uniqueItems true
   */
  locationIds: string[];
  /**
   * When set, each match includes `linkedToThisAudit` for this audit.
   * @format uuid
   */
  auditId?: string;
}

export interface VendorAccountDuplicatesDto {
  items: VendorAccountDto[];
}

export interface UpdateVendorAccountDto {
  accountNumber?: string;
  name?: string | null;
  note?: string | null;
  invoiceFrequency?: InvoiceFrequency | null;
  serviceType?: string | null;
  summaryAccountNumber?: string | null;
  glCode?: string | null;
  customGlField?: string | null;
  glAllocations?: string | null;
  /** @min 0 */
  usageLimit?: number | null;
  /** @min 0 */
  dollarLimit?: number | null;
  /** @min 0 */
  paymentTerms?: number | null;
  /**
   * @min 1
   * @max 31
   */
  invoiceDay?: number | null;
  billingType?: BillingType | null;
  portalLoginEmailId?: string | null;
  /** @default "active" */
  status?: VendorAccountStatus;
  /** Vendor organization id to reassign the account to for this organization. */
  vendorId?: string;
  /** Spend category IDs to link to this vendor account. */
  addSpendCategoryIds?: string[];
  /** Spend category IDs to unlink from this vendor account. */
  removeSpendCategoryIds?: string[];
  /**
   * Location IDs to assign to this vendor account.
   * @uniqueItems true
   */
  addLocationIds?: string[];
  /**
   * Location IDs to unassign from this vendor account.
   * @uniqueItems true
   */
  removeLocationIds?: string[];
}

export interface CreateTaskTagDto {
  /**
   * ID of the tag (can be either contact ID or tag UUID)
   * @format uuid
   * @example "a1b2c3d4-e5f6-7890-1234-567890abcdef"
   */
  id: string;
  /**
   * Type of the tag
   * @example "contact"
   */
  type: TagType;
}

export interface CreateTaskDto {
  title: string;
  priorityLevel?: PriorityLevel;
  category: TaskCategory;
  /** @default "new" */
  status?: TaskStatus;
  /**
   * The ID of the user to assign the task to
   * @format uuid
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  assignee?: string;
  /**
   * Estimated time to complete the task in minutes
   * @min 1
   * @example 120
   */
  estimatedTime?: number;
  /**
   * @format date-time
   * @example "2024-12-31T23:59:59Z"
   */
  deadline: string;
  completed?: boolean;
  seen?: boolean;
  tags?: CreateTaskTagDto[] | null;
  /**
   * @min 0
   * @example 120
   */
  timeLogged?: number;
  /** @format uuid */
  subauditId?: string | null;
  /** @format uuid */
  followUpParentTaskId?: string | null;
  /** @format uuid */
  projectId?: string | null;
  /** @format uuid */
  ticketId?: string | null;
  description?: string | null;
  referenceLink?: string | null;
  referenceName?: string | null;
  organizationId?: string | null;
  /** The ID of the vendor organization to associate with the task */
  vendorId?: string | null;
}

export interface AssignedUserTaskSummaryDto {
  /** ID of the user the task is assigned to */
  id: string;
  /** Full name of the user the task is assigned to */
  name: string;
  /**
   * Number of tasks created by current user and assigned to this user
   * @min 0
   * @example 5
   */
  taskCount: number;
  /** Time-limited URL for the assignee profile picture */
  avatarUrl: string | null;
}

export interface AssignedUserTaskSummaryListDto {
  /** Array of items */
  items: AssignedUserTaskSummaryDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface LogTimeDto {
  /**
   * @min 1
   * @example 30
   */
  timeMinutes: number;
}

export interface UpdateTaskDto {
  priorityLevel?: PriorityLevel;
  category?: TaskCategory | null;
  status?: TaskStatus;
  /**
   * The ID of the user to assign the task to. `null` unassigns the task.
   * @format uuid
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  assignee?: string | null;
  /**
   * Estimated time to complete the task in minutes
   * @min 1
   * @example 120
   */
  estimatedTime?: number;
  completed?: boolean;
  seen?: boolean;
  tags?: CreateTaskTagDto[] | null;
  /**
   * @min 0
   * @example 120
   */
  timeLogged?: number;
  /** @format date-time */
  deadline?: string | null;
  /** @format uuid */
  subauditId?: string | null;
  /** @format uuid */
  followUpParentTaskId?: string | null;
  /** @format uuid */
  projectId?: string | null;
  /** @format uuid */
  ticketId?: string | null;
  /** @minLength 1 */
  title?: string | null;
  description?: string | null;
  referenceLink?: string | null;
  referenceName?: string | null;
  organizationId?: string | null;
  /** The ID of the vendor organization to associate with the task */
  vendorId?: string | null;
}

export type DeleteResult = object;

export interface ImportTasksDto {
  /**
   * The excel to upload
   * @format binary
   */
  file: File;
}

export interface TaskVersionChangeRecordDto {
  prevValue: string;
  newValue: string;
  fieldName: TaskVersionChangeRecordFields;
}

export interface TaskVersionChangelogItemDto {
  /** The ID of the version after the changes. Might be useful in the future for reverting to previous versions. */
  afterChangesVersionId: string;
  modifiedBy: PlainExternalUserDto;
  /** @format date-time */
  modifiedAt: string;
  action: AuditingAction;
  /** The ID of the parent entity. */
  parent: string;
  /** The type of the entity. Usually the name of the entity. */
  type: ChangelogEntityType;
  /** String that helps represent the entity in the UI. */
  display: string;
  /** The changes made to the entity. */
  changes: TaskVersionChangeRecordDto[];
}

export interface TaskVersionChangelogList {
  /** Array of items */
  items: TaskVersionChangelogItemDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface DelegateDto {
  /** Delegate user email if set */
  email?: string;
  /** Delegate user name if set */
  fullName?: string;
  /** Delegate user ID if set */
  id: string | null;
}

export interface UserSettingsResponseDto {
  /** User ID */
  userId: string;
  /** Delegate settings */
  delegate: DelegateDto;
  /** Additional email address for notifications */
  additionalEmail?: string | null;
}

export interface UpdateUserSettingsDto {
  /**
   * Additional email address for notifications. Set to null to disable.
   * @format email
   * @example "delegate@aboutsib.com"
   */
  additionalEmail?: string | null;
  /** ID of the user to delegate to. Set to null to disable delegation. */
  delegateId?: string | null;
}

export interface SubtaskVersionChangeRecordDto {
  prevValue: string;
  newValue: string;
  fieldName: SubtaskVersionChangeRecordFields;
}

export interface SubtaskVersionChangelogItemDto {
  /** The ID of the version after the changes. Might be useful in the future for reverting to previous versions. */
  afterChangesVersionId: string;
  modifiedBy: PlainExternalUserDto;
  /** @format date-time */
  modifiedAt: string;
  action: AuditingAction;
  /** The ID of the parent entity. */
  parent: string;
  /** The type of the entity. Usually the name of the entity. */
  type: ChangelogEntityType;
  /** String that helps represent the entity in the UI. */
  display: string;
  /** The changes made to the entity. */
  changes: SubtaskVersionChangeRecordDto[];
}

export interface SubtaskVersionChangelogList {
  /** Array of items */
  items: SubtaskVersionChangelogItemDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface TaskTagVersionChangeRecordDto {
  prevValue: string;
  newValue: string;
  fieldName: TaskTagVersionChangeRecordFields;
}

export interface TaskTagVersionChangelogItemDto {
  /** The ID of the version after the changes. Might be useful in the future for reverting to previous versions. */
  afterChangesVersionId: string;
  modifiedBy: PlainExternalUserDto;
  /** @format date-time */
  modifiedAt: string;
  action: AuditingAction;
  /** The ID of the parent entity. */
  parent: string;
  /** The type of the entity. Usually the name of the entity. */
  type: ChangelogEntityType;
  /** String that helps represent the entity in the UI. */
  display: string;
  /** The changes made to the entity. */
  changes: TaskTagVersionChangeRecordDto[];
}

export interface TaskTagVersionChangelogList {
  /** Array of items */
  items: TaskTagVersionChangelogItemDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface CreateSubtaskDto {
  /**
   * Title of the subtask, providing a short summary of what needs to be done
   * @maxLength 64
   * @example "Write project documentation"
   */
  title: string;
  /**
   * Detailed description of the subtask, outlining specific requirements or instructions
   * @maxLength 256
   * @example "Document all key features and user stories for the project"
   */
  description?: string | null;
  /**
   * Priority level of the subtask, indicating its importance relative to other tasks
   * @example "high"
   */
  priorityLevel?: PriorityLevel;
  /**
   * ID of the user the subtask is assigned to
   * @format uuid
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  assigneeId?: string | null;
  /**
   * Deadline of the subtask
   * @format date-time
   * @example "2024-12-31T23:59:59Z"
   */
  deadline?: string | null;
  /**
   * UUID of the task to which this subtask belongs, linking it to a parent task
   * @format uuid
   * @example "c56a4180-65aa-42ec-a945-5fd21dec0538"
   */
  taskUuid?: string;
}

export interface SubtaskDto {
  /**
   * Unique identifier for the Subtask
   * @example "c56a4180-65aa-42ec-a945-5fd21dec0538"
   */
  uuid: string;
  /**
   * Title of the subtask
   * @example "Complete project documentation"
   */
  title: string;
  /**
   * Description of the subtask
   * @example "Finish writing the project documentation by end of the day"
   */
  description?: string | null;
  /**
   * Subtask completion status
   * @example false
   */
  completed: boolean;
  /**
   * Date when the task was created
   * @format date-time
   * @example "2023-01-01T12:00:00Z"
   */
  createdAt: string;
  /**
   * Date when the task was last updated
   * @format date-time
   * @example "2023-01-02T15:30:00Z"
   */
  updatedAt: string;
  /** Priority of the subtask */
  priorityLevel: PriorityLevel;
  /** @format uuid */
  taskUuid: string;
  /** User the subtask is assigned to */
  assigneeUser: PlainExternalUserDto | null;
  /**
   * Deadline of the subtask
   * @format date-time
   * @example "2024-12-31T23:59:59Z"
   */
  deadline: string | null;
}

export interface SubtaskListDto {
  /** Array of items */
  items: SubtaskDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface UpdateSubtaskDto {
  /**
   * Title of the subtask, providing a short summary of what needs to be done
   * @minLength 1
   * @maxLength 64
   * @example "Write project documentation"
   */
  title?: string | null;
  /**
   * Detailed description of the subtask, outlining specific requirements or instructions
   * @maxLength 256
   * @example "Document all key features and user stories for the project"
   */
  description?: string | null;
  /**
   * Priority level of the subtask, indicating its importance relative to other tasks
   * @example "high"
   */
  priorityLevel?: PriorityLevel;
  /** Defines if subtask was finished */
  completed?: boolean;
  /**
   * ID of the user the subtask is assigned to. Pass null to unassign
   * @format uuid
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  assigneeId?: string | null;
  /**
   * Deadline of the subtask. Pass null to clear it
   * @format date-time
   * @example "2024-12-31T23:59:59Z"
   */
  deadline?: string | null;
}

export interface TeamUserDto {
  id: string;
  name: string;
  email: string;
  avatarUrl: string | null;
  deletedAt: string | null;
  /** Whether the user can be removed from this team */
  isRemovable: boolean | null;
}

export interface TeamDto {
  /** @format uuid */
  uuid: string;
  name: string;
  activeTaskCount?: number;
  allTaskCount?: number;
  userCount: number;
  /** @format uuid */
  createdBy: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** For list To populate this field you need to pass query parameter "withUsers=true" */
  users?: TeamUserDto[] | null;
  canEdit?: boolean;
  description: string | null;
  subtitle: string | null;
  teamLogo: string | null;
}

export interface TeamListDto {
  /** Array of items */
  items: TeamDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface TeamMemberDto {
  id: string;
  name: string;
  email: string;
  teamRole: string;
  activeTaskCount: number;
  overdueTaskCount: number;
  avatarUrl: string | null;
  deletedAt: string | null;
}

export interface TeamMemberListDto {
  /** Array of items */
  items: TeamMemberDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface TeamTaskCountDto {
  dueToday: number;
  overdue: number;
  upcoming: number;
  past: number;
}

export interface UpdateTeamMembersDto {
  /** @uniqueItems true */
  userIds: string[];
}

export interface UpdateTeamMembersResponseDto {
  added: string[];
  removed: string[];
  total: number;
}

export interface UpdateContactDto {
  name?: string;
  /** @format email */
  email?: string;
  phone?: string;
  firstName?: string;
  lastName?: string;
  title?: string;
  note?: string | null;
  isActive?: boolean;
  vendorId?: string;
}

export interface AuditWithSpendAndSavingsDto {
  /**
   * Unique identifier for the audit
   * @example "a09VX000006yT8uYAE"
   */
  id: string;
  /**
   * Audit stage
   * @example "Audit Complete - Finalized Savings"
   */
  auditStage: string;
  /**
   * Audit type
   * @example "Waste - Solid / Recycling / Compost"
   */
  auditType: string;
  /**
   * Annual spend for the audit
   * @example 166381
   */
  auditAnnualSpend: number;
  /**
   * Annual inscope spend for the audit
   * @example 166381
   */
  annualInscopeSpend: number;
  /**
   * Monthly savings identified for the audit
   * @example 2965.56
   */
  monthlySavingsIdentified: number;
  /**
   * Monthly savings approved for the audit
   * @example 2965.56
   */
  monthlySavingsApproved: number;
  /**
   * Annual savings identified for the audit
   * @example 35586.72
   */
  annualSavingsIdentified: number;
  /**
   * Annual savings approved for the audit
   * @example 35586.72
   */
  annualSavingsApproved: number;
  /**
   * Percentage of savings identified against annual spend
   * @example 21.39
   */
  savingsPercentageIdentified: number;
  /**
   * Percentage of savings approved against annual spend
   * @example 21.39
   */
  savingsPercentageApproved: number;
  /**
   * Opportunity count for the audit
   * @example 2
   */
  opportunityCount: number;
  /**
   * Contract length for the audit
   * @example 36
   */
  contractLength: number;
  /**
   * Annual spend analysis complete for the audit
   * @example 166381
   */
  annualSpendAnalysisComplete: number;
  /**
   * Annual spend analysis in progress for the audit
   * @example 0
   */
  annualSpendAnalysisInProgress: number;
  /**
   * Normalized name for the audit type
   * @example "Waste - Solid / Recycling / Compost"
   */
  normalizedName: string;
}

export interface SavingsDto {
  /**
   * Savings value in dollars
   * @example 214943.4
   */
  value: number;
  /**
   * Savings percentage
   * @example 36.97
   */
  percentage: number;
}

export interface SpendAreasSavingsSpendItemTotalsDto {
  /**
   * Annual spend in dollars for the category
   * @example 166381
   */
  annualSpendAnalysisComplete: number;
  /**
   * Spend currently in progress for analysis
   * @example 0
   */
  annualSpendAnalysisInProgress: number;
  /**
   * Spend in scope for the category
   * @example 166381
   */
  inscopeSpend: number;
  /** Savings identified for the category */
  savingsIdentified: SavingsDto;
  /** Savings approved for the category */
  savingsApproved: SavingsDto;
}

export interface SpendAreasSavingsSpendItemDto {
  /**
   * SpendArea name
   * @example "Waste"
   */
  spendArea: string;
  /**
   * Unique identifier for the Spend area
   * @example ""
   */
  id: string;
  /**
   * Description for the Spend Area
   * @example ""
   */
  description: string;
  /** List of audits related to the Spend Area */
  audits: AuditWithSpendAndSavingsDto[];
  /** Total values for the Spend Area */
  totals: SpendAreasSavingsSpendItemTotalsDto;
}

export interface SpendAreasSavingsSpendTotalsDto {
  /**
   * Total annual spend in dollars
   * @example 581414
   */
  annualSpendAnalysisComplete: number;
  /**
   * Total spend currently in progress for analysis
   * @example 5619481
   */
  annualSpendAnalysisInProgress: number;
  /**
   * Total spend in scope
   * @example 6200895
   */
  inscopeSpend: number;
  /** Total savings identified */
  savingsIdentified: SavingsDto;
  /** Total savings approved */
  savingsApproved: SavingsDto;
}

export interface SpendAreasSavingsSpendResponseDto {
  /** List of spend areas with their audit details */
  spendAreas: SpendAreasSavingsSpendItemDto[];
  /** Aggregated totals for all spend areas */
  totals: SpendAreasSavingsSpendTotalsDto;
}

export interface TotalSavingsDto {
  /**
   * Annual savings value in dollars
   * @example 2559.12
   */
  annualSaving: number;
  /**
   * Monthly savings value in dollars
   * @example 213
   */
  monthlySaving: number;
  /**
   * Savings percentage
   * @example 1.42
   */
  percentage: number;
}

export interface AnnualSavingsDto {
  /**
   * Annual savings value in dollars
   * @example 2559.12
   */
  value: number;
  /**
   * Savings percentage
   * @example 100
   */
  percentage: number;
}

export interface AnnualSavingsForSpendAreaSpendCategoryDto {
  /**
   * Spend category name
   * @example "Maintenance - Elevator / Escalator"
   */
  name: string;
  /** Annual savings details for the category */
  annualSavings: AnnualSavingsDto;
}

export interface SpendAndAnalysisSpendAreaDto {
  /**
   * Spend area name
   * @example "Maintenance"
   */
  name: string;
  /**
   * Flag indicating if savings are made in this area
   * @example true
   */
  areSavingsMade: boolean;
  /** Total savings details for the spend area */
  totalSavings: TotalSavingsDto;
  /** List of spend categories within this spend area */
  spendCategories: AnnualSavingsForSpendAreaSpendCategoryDto[];
}

export interface AnnualSavingsForSpendAreaResponseDto {
  /** List of spend areas and their details */
  items: SpendAndAnalysisSpendAreaDto[];
}

export interface VectorClientInfoDto {
  clientId: number | null;
  clientName: string | null;
  oldCost: number | null;
  newCostNegotiated: number | null;
  newCostContracted: number | null;
  grossSavings: number | null;
  clientNo: string | null;
  clientLegalName: string | null;
  contractVersion: string | null;
  managementFee: number | null;
  discountPercentage: number | null;
  clientStatus: string | null;
  vertical: string | null;
  currency: string | null;
  zeroToThirty: number | null;
  thirtyOneToSixty: number | null;
  sixtyOneToNinety: number | null;
  ninetyPlus: number | null;
  termMonths: number | null;
  autoPay: boolean | null;
  unPaidInvoiceCount: number | null;
}

export interface FinancialDetailsDto {
  annual: number;
  monthly: number;
  totalLifetime: number;
}

export interface SavingSummaryResponseDto {
  spend: FinancialDetailsDto;
  saving: FinancialDetailsDto;
  percentSaved: number;
  moreThanYearOfSavings: boolean;
  spendAreasCount: number;
  assignedSpendAreasCount: number;
}

export interface SpendCategorySummaryDto {
  spend: FinancialDetailsDto;
  savingsApproved: FinancialDetailsDto;
  savingsIdentified: FinancialDetailsDto;
  approvedPercentSaved: number;
  identifiedPercentSaved: number;
}

export interface SpendCategoryDto {
  id: string;
  name: string;
  summary: SpendCategorySummaryDto;
}

export interface SpendAreaCategoryVideoDto {
  /** Display label shown in SpendBrain when this category video is expanded */
  categorySpendbrainTitle: string;
  /** @format uri */
  videoUrl: string;
  spendCategoryId?: string;
}

export interface SpendAreaDto {
  id: string;
  spendArea: string;
  description: string;
  spendCategory: SpendCategoryDto[];
  stage: SpendAreaStage[];
  status: SpendAreaStatus;
  summary: SpendCategorySummaryDto;
  categoryVideos?: SpendAreaCategoryVideoDto[];
}

export interface SpendAreaDetailsDto {
  items: SpendAreaDto[];
}

export interface SavingsValueDto {
  /** @example 214943.4 */
  value: number;
  /** @example 36.97 */
  percentage: number;
}

export interface SpendAreasOverviewItemTotalsDto {
  /** @example 166381 */
  annualSpendAnalysisComplete: number;
  /** @example 0 */
  annualSpendAnalysisInProgress: number;
  /** @example 166381 */
  inscopeSpend: number;
  savingsIdentified: SavingsValueDto;
  savingsApproved: SavingsValueDto;
}

export interface SpendAreaSpendCategoryItemDto {
  id: string;
  name: string;
  totals: SpendAreasOverviewItemTotalsDto;
}

export interface SpendAreasOverviewItemDto {
  id: string;
  /** @example "Waste" */
  spendArea: string;
  description: string;
  spendCategories: SpendAreaSpendCategoryItemDto[];
  totals: SpendAreasOverviewItemTotalsDto;
}

export interface SpendAreasOverviewTotalsDto {
  /** @example 166381 */
  annualSpendAnalysisComplete: number;
  /** @example 0 */
  annualSpendAnalysisInProgress: number;
  /** @example 166381 */
  inscopeSpend: number;
  savingsIdentified: SavingsValueDto;
  savingsApproved: SavingsValueDto;
}

export interface SpendAreasOverviewResponseDto {
  spendAreas: SpendAreasOverviewItemDto[];
  totals: SpendAreasOverviewTotalsDto;
}

export interface AnnualSavingsTotalsDto {
  /** @example 2559.12 */
  annualSaving: number;
  /** @example 213 */
  monthlySaving: number;
  /**
   * Percentage of global total annual savings
   * @example 1.42
   */
  percentage: number;
}

export interface AnnualSavingsValueDto {
  /** @example 2559.12 */
  value: number;
  /**
   * Percentage within the spend area
   * @example 100
   */
  percentage: number;
}

export interface AnnualSavingsBreakdownSpendCategoryDto {
  /** @example "Maintenance - Elevator / Escalator" */
  name: string;
  annualSavings: AnnualSavingsValueDto;
}

export interface AnnualSavingsBreakdownItemDto {
  /** @example "Maintenance" */
  name: string;
  /** @example true */
  areSavingsMade: boolean;
  totalSavings: AnnualSavingsTotalsDto;
  spendCategories: AnnualSavingsBreakdownSpendCategoryDto[];
}

export interface AnnualSavingsBreakdownResponseDto {
  items: AnnualSavingsBreakdownItemDto[];
}

export interface VectorClientInfoItemDto {
  clientId: number | null;
  clientName: string | null;
  oldCost: number | null;
  newCostNegotiated: number | null;
  newCostContracted: number | null;
  grossSavings: number | null;
  clientNo: string | null;
  clientLegalName: string | null;
  contractVersion: string | null;
  managementFee: number | null;
  discountPercentage: number | null;
  clientStatus: string | null;
  vertical: string | null;
  currency: string | null;
  zeroToThirty: number | null;
  thirtyOneToSixty: number | null;
  sixtyOneToNinety: number | null;
  ninetyPlus: number | null;
  termMonths: number | null;
  autoPay: boolean | null;
  unPaidInvoiceCount: number | null;
  totalDues: number | null;
  savingsIdentified: number | null;
  analysisInProgress: number | null;
  analysisComplete: number | null;
}

export interface VectorClientInfoResponseDto {
  items: VectorClientInfoItemDto[];
}

export interface SpendAreaListItemDto {
  id: string;
  name: string;
  description: string | null;
  status: SpendAreaStatus;
}

export interface SpendAreasListResponseDto {
  items: SpendAreaListItemDto[];
  assignedCount: number;
  requestedCount: number;
  notAssignedCount: number;
}

export interface TicketFileDto {
  id: string;
  fileName: string;
  fileType?: string;
  fileUrl: string;
  showInDocumentsRepo: boolean;
  fileSize?: number;
}

export interface TicketFileListDto {
  /** Array of items */
  items: TicketFileDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface CreateProjectDto {
  name: string;
  /** @format uuid */
  teamId: string;
  projectStatus?: CreateProjectDtoProjectStatusEnum;
  startDate?: string;
  targetEndDate?: string;
  /** @format uuid */
  assigneeId?: string;
}

export interface PlainTeamDto {
  id: string;
  name: string;
}

export interface ProjectDto {
  id: string;
  name: string;
  projectStatus: ProjectStatus;
  team: PlainTeamDto;
  owner: PlainExternalUserDto;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  startDate?: string | null;
  /** @format date-time */
  targetEndDate?: string | null;
  assignee?: PlainExternalUserDto | null;
}

export interface CopyProjectDto {
  name: string;
  /** @format uuid */
  teamId: string;
  /** @default "in-progress" */
  projectStatus?: ProjectStatus;
  /**
   * Project-level assignee. Omit to leave the copy unassigned.
   * @format uuid
   */
  assigneeId?: string;
  /** Copy start date. When set, also anchors how far task/subtask deadlines shift. Omit to start the copy now. */
  startDate?: string;
  /** Copy target end date. Omit to keep the source span shifted with startDate. */
  targetEndDate?: string;
}

export interface ProjectInTeamSummaryDto {
  id: string;
  name: string;
  projectStatus: ProjectStatus;
  owner: PlainExternalUserDto;
  /** @format date-time */
  startDate?: string | null;
  /** @format date-time */
  targetEndDate?: string | null;
}

export interface TeamWithProjectsDto {
  id: string;
  name: string;
  projectsCount: number;
  projects: ProjectInTeamSummaryDto[];
}

export interface TeamWithProjectsListDto {
  items: TeamWithProjectsDto[];
}

export interface UpdateProjectDto {
  name?: string;
  /** @format uuid */
  teamId?: string;
  projectStatus?: UpdateProjectDtoProjectStatusEnum;
  startDate?: string;
  targetEndDate?: string;
  /** @format uuid */
  assigneeId?: string;
  /** @format uuid */
  ownerId?: string;
}

export interface PlainOrganizationDto {
  id: string;
  name: string;
}

export interface TicketVendorDto {
  id: string;
  name: string;
}

export interface TicketDto {
  id: string;
  /** @default null */
  ticketNumber?: string | null;
  /** @default null */
  vectorTicketId?: number | null;
  clientId?: string | null;
  subject: string;
  description?: string | null;
  status?: TicketStatus | null;
  priority?: PriorityLevel | null;
  category?: TicketCategory | null;
  vendorName?: string | null;
  location?: string | null;
  requestor?: PlainExternalUserDto | null;
  assignee?: PlainExternalUserDto | null;
  /** @format date-time */
  dueDate?: string | null;
  /** @format date-time */
  followUpDate?: string | null;
  contractVersion?: string | null;
  accessToExternalUser?: boolean | null;
  locationId?: string | null;
  locationName?: string | null;
  zip?: string | null;
  state?: string | null;
  address?: string | null;
  city?: string | null;
  subStatus?: string | null;
  updatedBy?: string | null;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  receiveEmailNotifications?: boolean | null;
  organization?: PlainOrganizationDto | null;
  vendor?: TicketVendorDto | null;
  participants?: PlainExternalUserDto[] | null;
  savingsAmount?: number | null;
  project?: string | null;
  /** Non-deleted comments visible to the caller; null when the source system does not report it. */
  commentsCount?: number | null;
}

export interface TicketListDto {
  /** Array of items */
  items: TicketDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface TicketCountsDto {
  /** Non-deleted comments on the ticket */
  commentsCount: number;
  /** Activity-log entries, matching the total of GET /tickets/{ticketId}/versions/changelogs */
  activityCount: number;
  /** Non-deleted tasks linked to the ticket */
  relatedTasksCount: number;
}

export interface UpdateTicketDto {
  /** @maxLength 256 */
  subject?: string;
  /** @maxLength 1024 */
  description?: string;
  status?: TicketStatus;
  priority?: PriorityLevel;
  category?: TicketCategory;
  /**
   * Supported formats: image/jpeg, image/png, image/webp, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, application/pdf, text/csv, text/plain, message/rfc822, application/vnd.ms-outlook, application/octet-stream, video/webm, video/mp4, video/quicktime, audio/mpeg files. Max size: 200MB. Max count: 10 files.
   * @maxItems 10
   * @default null
   */
  files?: File[] | null;
  /**
   * Show in Documents Repository for each file (must match files array length)
   * @maxItems 10
   * @default null
   */
  showInDocumentsRepo?: boolean[] | null;
  /** @default null */
  receiveEmailNotifications?: boolean | null;
  /**
   * If true, ticket is external (accessible to clients). If false, ticket is internal.
   * @default null
   */
  accessToExternalUser?: boolean | null;
  assigneeId?: string;
  /** @format uuid */
  projectId?: string;
  /** The ID of the vendor organization to associate with the ticket */
  vendorId?: string | null;
  /**
   * Array of user IDs to set as participants
   * @uniqueItems true
   */
  participantIds?: string[];
  /**
   * Savings amount (only visible when category is Finance, Invoice, or Payments). For non-vector tickets only.
   * @min 0
   * @default null
   */
  savingsAmount?: number | null;
  /**
   * Due date of the ticket
   * @format date-time
   */
  dueDate?: string | null;
  /**
   * @maxLength 255
   * @default null
   */
  city?: string | null;
  /**
   * @maxLength 255
   * @default null
   */
  state?: string | null;
  /**
   * @maxLength 255
   * @default null
   */
  address?: string | null;
  /**
   * @maxLength 255
   * @default null
   */
  zip?: string | null;
  /**
   * Array of file IDs to remove from the ticket
   * @uniqueItems true
   */
  filesToDelete?: string[];
  /**
   * IDs of files to move FROM the ticket TO the Documents Repository
   * @uniqueItems true
   */
  filesToMoveToDocumentsRepo?: string[];
  /**
   * IDs of files to remove FROM the Documents Repository back TO the ticket
   * @uniqueItems true
   */
  filesToRemoveFromDocumentsRepo?: string[];
  /** Client organisation (optional). When creating from the vendor portal, set to link a client; omit for vendor-only tickets. On POST /organization/:organizationId/tickets this value is ignored — the URL segment is used. */
  organizationId?: string;
}

export interface MessageResponseDto {
  message: string;
}

export interface CreateTicketCommentDto {
  /** @maxLength 4096 */
  text: string;
  /** @default "external" */
  scope?: TicketCommentScope;
  /**
   * List of external users IDs to notify
   * @uniqueItems true
   */
  notifyUsers?: string[];
}

export interface CreateTicketCommentResponseDto {
  message: string;
}

export interface TicketCommentDto {
  /** @format uuid */
  id: string;
  source: TicketCommentDtoSourceEnum;
  comment: string;
  /** @default "external" */
  scope?: TicketCommentScope;
  createdBy: PlainExternalUserDto;
  /**
   * ISO 8601
   * @format date-time
   */
  createdAt: string;
  /**
   * ISO 8601
   * @format date-time
   */
  updatedAt: string;
}

export interface TicketCommentListDto {
  /** Array of items */
  items: TicketCommentDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface ProjectFileDto {
  id: string;
  fileName: string;
  fileType?: string | null;
  /** @format uri */
  fileUrl: string;
  fileSize?: number | null;
  createdAt: string;
  createdBy?: PlainExternalUserDto | null;
  uploadStage: DocumentUploadStage;
}

export interface ProjectFileListDto {
  /** Array of items */
  items: ProjectFileDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface FileBatchStatusDto {
  id: string;
  filename: string;
  uploadStage: DocumentUploadStage;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export interface FileBatchStatusListDto {
  items: FileBatchStatusDto[];
}

export interface GenerateFileUploadUrlDto {
  filename: string;
  mimeType: string;
  filesize: number;
}

export interface GenerateBulkFileUploadUrlDto {
  /** @minItems 1 */
  files: GenerateFileUploadUrlDto[];
}

export interface FileBulkUploadUrlFileDto {
  filename: string;
  fileId: string | null;
  uploadUrl: string | null;
  /** Error message if file preparation failed */
  error?: string | null;
}

export interface FileBulkUploadUrlResponseDto {
  /** Unique identifier for this upload batch */
  batchId: string;
  files: FileBulkUploadUrlFileDto[];
}

export interface UploadFileDto {
  /** @format binary */
  file: File;
}

export interface FileUploadResultDto {
  id: string;
  fileName: string;
  fileType?: string;
  fileSize?: number;
  uploadStage: DocumentUploadStage;
  createdAt: string;
}

export interface PostprocessFileDto {
  filename: string;
}

export interface PostprocessFilesDto {
  /** Batch ID to postprocess */
  batchId?: string;
  successfulFilenames: string[];
  failedFilenames: string[];
}

export interface PostprocessFilesResultDto {
  items: FileUploadResultDto[];
}

export interface OrganizationPrimaryContactDto {
  id: string;
  name: string;
  email?: string | null;
}

export interface OrganizationFinancialMetricsDto {
  /** Total in-scope spend in dollars */
  inScopeSpend: number;
  /** Savings identified in dollars */
  savingsIdentified: number;
  /** Savings approved in dollars */
  savingsApproved: number;
}

export interface OrganizationListItemDto {
  id: string;
  name: string;
  status: OrganizationStatus;
  clientStatus?: ClientStatus | null;
  /** Whether the client status is considered active */
  isActive?: boolean | null;
  primaryContact?: OrganizationPrimaryContactDto | null;
  /** Number of locations */
  locationsCount: number;
  financialMetrics: OrganizationFinancialMetricsDto;
  /** Number of open audits */
  openAuditsCount: number;
  parentOrganization?: PlainOrganizationDto | null;
}

export interface OrganizationListDto {
  /** Array of items */
  items: OrganizationListItemDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface OrganizationAddressDto {
  payeeName: string | null;
  line1: string | null;
  line2: string | null;
  country: string | null;
  state: string | null;
  city: string | null;
  zipCode: string | null;
}

export interface OrganizationOverviewDto {
  id: string;
  name: string;
  clientStatus?: ClientStatus | null;
  /** Whether the client status is considered active */
  isActive?: boolean | null;
  totalInscopeSpend: number;
  totalSavingsIdentified: number;
  totalSavingsApproved: number;
  logo?: OrganizationLogoDto | null;
  mainPointOfContact?: ContactDto | null;
  parentOrganization?: PlainOrganizationDto | null;
  subsidiaryOrganizations: PlainOrganizationDto[];
  /** Null when no billing address part is set. */
  billingAddress?: OrganizationAddressDto | null;
  /** Null when no mailing address part is set. */
  mailingAddress?: OrganizationAddressDto | null;
  /** Whether the mailing address mirrors the billing address */
  mailingAddressSameAsBilling: boolean;
  micrositesEnabled: boolean;
  /** Whether bill pay fields should be shown for this organization */
  billPayEnabled: boolean;
  billPayFundingFrequency?: BillPayFundingFrequency | null;
  fundingDetailsSubmissionMethod?: FundingDetailsSubmissionMethod | null;
  /** @format uuid */
  assignedBpos?: string | null;
  /** Salesforce account record type — read-only, owned by the Salesforce sync. */
  recordType?: string | null;
  /** Salesforce (SF2) account id — read-only, owned by the sync. */
  salesforceSalesId?: string | null;
  phone?: string | null;
  websiteUrl?: string | null;
  /** "Doing business as" trade name. */
  dba?: string | null;
  industry?: string | null;
  /** Salesforce sub-industry. A multi-select picklist, so several values arrive joined with ";". */
  subIndustry?: string | null;
  /** SIB division or partner brand the client originated from. Kept for historic reference. */
  originatingDivision?: PlainOrganizationDto | null;
  annualRevenue?: number | null;
  numberOfEmployees?: number | null;
  /** Deep link to the account in SF2: `<SF2_URL>/Account/<salesforceSalesId>/view`. Null when the base URL is not configured or the account has no SF2 id. */
  sf2AccountUrl?: string | null;
  /** Whether SIB autorenewal terms are approved. */
  sibAutorenewalApproved?: boolean | null;
  /** Person responsible for validating savings for this account. */
  currentValidator?: PlainExternalUserDto | null;
  /** Primary salesperson responsible for the account. */
  primarySalesRep?: PlainExternalUserDto | null;
  /** Client signer on the SIB services agreement. */
  clientWhoSignedSibSa?: ContactDto | null;
  permissions?: Record<string, PermissionAction> | null;
}

export interface CreateOrganizationDto {
  name: string;
  status: OrganizationStatus;
  clientStatus?: ClientStatus | null;
  /**
   * ID of the primary contact
   * @format uuid
   */
  primaryContactId?: string | null;
  /**
   * ID of the parent organization
   * @format uuid
   */
  parentOrganizationId?: string | null;
}

export interface UpdateOrganizationAddressDto {
  payeeName?: string | null;
  line1?: string | null;
  line2?: string | null;
  country?: string | null;
  state?: string | null;
  city?: string | null;
  zipCode?: string | null;
}

export interface UpdateOrganizationDto {
  /** Account name. Not nullable — it is the organization label across the portal. Salesforce owns the value and refreshes it on every sync, so an edit made here does not survive the next run. */
  name?: string;
  /** Main phone number for the account. */
  phone?: string | null;
  /** Primary website URL for the client. Salesforce owns the value and refreshes it on every sync. */
  websiteUrl?: string | null;
  /** "Doing business as" trade name. */
  dba?: string | null;
  /** Industry classification. Free text — Salesforce holds ~90 overlapping labels rather than a fixed list. */
  industry?: string | null;
  /** Sub-industry. Free text: Salesforce keeps a multi-select picklist and delivers several values joined with ";". */
  subIndustry?: string | null;
  /** @min 0 */
  numberOfEmployees?: number | null;
  /** ID of the organization the client originated from — a SIB division or partner brand (SIB Fixed Cost Reduction, Vector97, Shipware, …). Salesforce owns the value and refreshes it on every sync. */
  originatingDivisionId?: string | null;
  clientStatus?: ClientStatus | null;
  aiBrandingAlias?: string | null;
  /**
   * ID of the main point of contact
   * @format uuid
   */
  mainPointOfContactId?: string | null;
  /**
   * ID of the external user responsible for validating savings for this account.
   * @format uuid
   */
  currentValidatorId?: string | null;
  /**
   * ID of the external user acting as primary salesperson for the account.
   * @format uuid
   */
  primarySalesRepId?: string | null;
  /**
   * ID of the contact who signed the SIB services agreement. Must belong to this organization.
   * @format uuid
   */
  clientWhoSignedSibSaId?: string | null;
  /** @format uuid */
  assignedBpos?: string | null;
  billingAddress?: UpdateOrganizationAddressDto;
  /** Ignored when `mailingAddressSameAsBilling` is enabled — the mailing address then mirrors the billing address. */
  mailingAddress?: UpdateOrganizationAddressDto;
  /** When enabled, the mailing address is overwritten with the billing address. */
  mailingAddressSameAsBilling?: boolean;
  billPayFundingFrequency?: BillPayFundingFrequency | null;
  fundingDetailsSubmissionMethod?: FundingDetailsSubmissionMethod | null;
  /**
   * Vendor IDs to link to this client organization.
   * @uniqueItems true
   */
  addVendorIds?: string[];
  /**
   * Vendor IDs to unlink from this client organization. Unlinking deletes the vendor accounts between them; it is rejected with 409 when any of those accounts has an account number or spend, invoice, audit, online access or validation data, or the vendor is part of an audit of the organization.
   * @uniqueItems true
   */
  removeVendorIds?: string[];
}

export interface OrganizationContactDto {
  /** Contact record id, and the id the write endpoints take. Null for a Microsite user with no contact record of their own. */
  contactId?: string | null;
  /** Microsite user id when this person can reach the Microsite. */
  externalUserId?: string | null;
  name: string;
  email?: string | null;
  phone?: string | null;
  title?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  isActive?: boolean | null;
  note?: string | null;
  /** Whether this person can reach the client Microsite (Customer Admin / Common Customer). */
  hasMicrositeAccess: boolean;
  /** Microsite organization role when hasMicrositeAccess is true. */
  micrositeRole?: string | null;
  /** Profile picture URL. Only Microsite users have one. */
  avatarUrl?: string | null;
  status: ContactStatus;
  /** Last time this person loaded the Microsite (GET /user/current), stamped at most every five minutes. Null for someone who has never signed in. */
  lastActiveAt?: string | null;
}

export interface OrganizationContactsListDto {
  /** Array of items */
  items: OrganizationContactDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface CreateOrganizationContactDto {
  name: string;
  /** @format email */
  email?: string | null;
  phone?: string | null;
  title?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  note?: string | null;
  /** @default true */
  isActive?: boolean;
  /** @default "active" */
  status?: ContactStatus;
}

export interface UpdateOrganizationContactDto {
  name?: string;
  /** @format email */
  email?: string | null;
  phone?: string | null;
  title?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  note?: string | null;
  /** @default true */
  isActive?: boolean;
  /** @default "active" */
  status?: ContactStatus;
}

export interface SibEmployeeDto {
  id: string;
  name: string;
  email?: string | null;
  phone?: string | null;
  /** The role this person holds in this organization. */
  role?: string | null;
  title?: string | null;
  /** Profile picture URL. */
  avatarUrl?: string | null;
}

export interface SibEmployeesListDto {
  /** Array of items */
  items: SibEmployeeDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface AssignSibEmployeeDto {
  /** An existing external user to assign. */
  userId: string;
  /**
   * The role to give them here.
   * @format uuid
   */
  roleId: string;
}

export interface VendorUnlinkAuditDto {
  id: string;
  name: string | null;
}

export interface VendorUnlinkSummaryDto {
  /** True when no vendor account of the pair has an account number or data and the pair has no audit; only then does the unlink succeed. */
  canUnlink: boolean;
  /** Vendor accounts the unlink deletes when it is allowed. */
  accountsToDelete: number;
  /** Vendor accounts with an account number or with spend, invoice, audit, online access or validation data; any of them blocks the unlink. */
  accountsWithNumberOrData: number;
  /** Audits of this organization that include the vendor or its accounts, in any status; any of them blocks the unlink. */
  audits: VendorUnlinkAuditDto[];
}

export interface VendorDetailSummaryDto {
  contractsCount: number;
  /** US dollars */
  totalSpend: number;
  clientOrganisationsCount: number;
  /** Open ticket count (`ticket.vendor_id` = vendor org): excludes status closed, canceled, completed; NULL status counts as open. */
  openTicketsCount: number;
  /** Open task count (`task.vendor_id` = vendor org): `completed` false and `deleted_at` IS NULL. */
  openTasksCount: number;
  /** Count of audits where `audit.vendor` references this vendor organization. */
  auditsCount: number;
  /** Count of `contact` rows with `organization_id` set to this vendor organization. */
  contactsCount: number;
}

export interface VendorClientListItemDto {
  id: string;
  name: string;
  /** Spend categories from `vendor_spend_category` → `spend_category`. */
  spendCategories: SpendCategoryListItemDto[];
  /** Spend area names from linked `spend_category` → `spend_area`. */
  spendAreas: string[];
  /** Vendor lifecycle status from the `vendor_status` column. */
  status: VendorStatus;
  /** ISO 8601 */
  lastUpdated: string;
  summary: VendorDetailSummaryDto;
  /** Vendor account numbers for this organization–vendor relationship. */
  vendorAccounts: string[];
}

export interface VendorClientListDto {
  /** Array of items */
  items: VendorClientListItemDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface IpOrganizationTaskDto {
  id: string;
  completed: boolean;
  title: string;
  description?: string | null;
  category: TaskCategory;
  status: TaskStatus;
  assignee?: PlainExternalUserDto | null;
  /** @format date-time */
  deadline?: string | null;
  priorityLevel: PriorityLevel;
  referenceName?: string | null;
  ticketId?: string | null;
  ticketNumber?: string | null;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** Whether the current user can edit this task */
  canEdit: boolean;
}

export interface IpOrganizationTaskListDto {
  /** Array of items */
  items: IpOrganizationTaskDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface IpOrganizationTicketDto {
  id: string;
  ticketNumber: string;
  status?: TicketStatus | null;
  subject: string;
  priority?: PriorityLevel | null;
  assignee?: PlainExternalUserDto | null;
  category?: TicketCategory | null;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export interface IpOrganizationTicketListDto {
  /** Array of items */
  items: IpOrganizationTicketDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface VendorListItemDto {
  id: string;
  name: string;
  /** Spend categories from `vendor_spend_category` → `spend_category`. */
  spendCategories: SpendCategoryListItemDto[];
  /** Spend area names from linked `spend_category` → `spend_area`. */
  spendAreas: string[];
  /** Vendor lifecycle status from the `vendor_status` column. */
  status: VendorStatus;
  /** ISO 8601 */
  lastUpdated: string;
  summary: VendorDetailSummaryDto;
}

export interface VendorListDto {
  /** Array of items */
  items: VendorListItemDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface VendorInformationDto {
  /** ISO 8601 */
  createdAt: string;
  /** @example "https://www.loremipsum.com" */
  websiteUrl: string;
  /** @example "https://www.portal.loremipsum.com" */
  portalUrl: string;
  /** Free-text vendor note. */
  note: string;
}

export interface BankDto {
  /** @format uuid */
  id: string;
  name: string;
}

export interface BillPayAddressDto {
  payeeName: string | null;
  line1: string | null;
  line2: string | null;
  country: string | null;
  state: string | null;
  city: string | null;
  zipCode: string | null;
}

export interface FileDto {
  id: string;
  fileName: string;
  fileType?: string | null;
  /** @format uri */
  fileUrl: string;
  fileSize?: number | null;
  createdAt: string;
  createdBy?: PlainExternalUserDto | null;
  uploadStage: DocumentUploadStage;
}

export interface VendorDetailDto {
  id: string;
  name: string;
  /** Spend categories from `vendor_spend_category` → `spend_category` (internal portal M2M). */
  spendCategories: SpendCategoryListItemDto[];
  /** Spend area names from M2M-linked `spend_category` → `spend_area` (read-only; not in create/update body). */
  spendAreas: string[];
  /** Vendor lifecycle status from the `vendor_status` column. */
  status: VendorStatus;
  /** ISO 8601 */
  lastUpdated: string;
  /** SIB assignee for this vendor (`external-user` linked on organization). */
  assignee?: PlainExternalUserDto | null;
  summary: VendorDetailSummaryDto;
  information: VendorInformationDto;
  emailInvoiceCapability?: boolean | null;
  ediApiInvoiceCapability?: boolean | null;
  paymentMethodCardAccepted?: boolean | null;
  payeeName?: string | null;
  /** Bank selected for bill pay funding details. */
  bankName?: BankDto | null;
  /** ACH routing number. Redacted for callers without READ on `bank_account_details`. */
  routingNumber?: string | null;
  /** ACH bank account number. Redacted for callers without READ on `bank_account_details`. */
  bankAccountNumber?: string | null;
  cardFeeType?: CardFeeType | null;
  /**
   * Dollars or percent, depending on `cardFeeType`.
   * @min 0
   */
  cardFeeAmount?: number | null;
  /** Structured billing address; `null` when no part is set. */
  billingAddress?: BillPayAddressDto | null;
  /** Structured mailing address; `null` when no part is set. */
  mailingAddress?: BillPayAddressDto | null;
  /** When enabled, the mailing address mirrors the billing one. */
  mailingAddressSameAsBilling: boolean;
  paymentMethodAchAccepted?: boolean | null;
  paymentRemittanceEmail?: string | null;
  paymentRemittanceIdentifier?: PaymentRemittanceIdentifier | null;
  earlyPayDiscount?: boolean | null;
  paymentType?: BillPayPaymentType | null;
  /** Vendor W9 file (`vendor.w9_document_id` → `file`). */
  w9Document?: FileDto | null;
}

export interface VendorOrganizationSelectListDto {
  /** Array of items */
  items: SelectListItemDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface VendorClientDetailDto {
  id: string;
  name: string;
  /** Spend categories from `vendor_spend_category` → `spend_category` (internal portal M2M). */
  spendCategories: SpendCategoryListItemDto[];
  /** Spend area names from M2M-linked `spend_category` → `spend_area` (read-only; not in create/update body). */
  spendAreas: string[];
  /** Vendor lifecycle status from the `vendor_status` column. */
  status: VendorStatus;
  /** ISO 8601 */
  lastUpdated: string;
  /** SIB assignee for this vendor (`external-user` linked on organization). */
  assignee?: PlainExternalUserDto | null;
  summary: VendorDetailSummaryDto;
  information: VendorInformationDto;
  emailInvoiceCapability?: boolean | null;
  ediApiInvoiceCapability?: boolean | null;
  paymentMethodCardAccepted?: boolean | null;
  payeeName?: string | null;
  /** Bank selected for bill pay funding details. */
  bankName?: BankDto | null;
  /** ACH routing number. Redacted for callers without READ on `bank_account_details`. */
  routingNumber?: string | null;
  /** ACH bank account number. Redacted for callers without READ on `bank_account_details`. */
  bankAccountNumber?: string | null;
  cardFeeType?: CardFeeType | null;
  /**
   * Dollars or percent, depending on `cardFeeType`.
   * @min 0
   */
  cardFeeAmount?: number | null;
  /** Structured billing address; `null` when no part is set. */
  billingAddress?: BillPayAddressDto | null;
  /** Structured mailing address; `null` when no part is set. */
  mailingAddress?: BillPayAddressDto | null;
  /** When enabled, the mailing address mirrors the billing one. */
  mailingAddressSameAsBilling: boolean;
  paymentMethodAchAccepted?: boolean | null;
  paymentRemittanceEmail?: string | null;
  paymentRemittanceIdentifier?: PaymentRemittanceIdentifier | null;
  earlyPayDiscount?: boolean | null;
  paymentType?: BillPayPaymentType | null;
  /** Vendor W9 file (`vendor.w9_document_id` → `file`). */
  w9Document?: FileDto | null;
  /** Count of client subsidiary organisations linked via parent, referral, or private-equity firm. */
  clientSubsidiaryOrganisationsCount: number;
  /** Vendor account numbers for this organization–vendor relationship. */
  vendorAccounts: string[];
}

export interface UpdateBillPayAddressDto {
  payeeName?: string | null;
  line1?: string | null;
  line2?: string | null;
  country?: string | null;
  state?: string | null;
  city?: string | null;
  zipCode?: string | null;
}

export interface CreateVendorDto {
  name: string;
  vendorStatus: VendorStatus;
  portalUrl?: string;
  websiteUrl?: string;
  note?: string;
  billingAddress?: UpdateBillPayAddressDto;
  mailingAddress?: UpdateBillPayAddressDto;
  /**
   * ID of the external user to assign as vendor assignee.
   * @format uuid
   */
  assigneeId?: string | null;
  /**
   * IDs of spend categories to associate with this vendor (Payload `spend_category` id).
   * @minItems 1
   * @uniqueItems true
   */
  spendCategoryIds: string[];
  /**
   * IDs of client organizations to link to this vendor (vendor_client relationship).
   * @uniqueItems true
   */
  clientIds?: string[];
}

export interface UpdateVendorDto {
  name?: string;
  vendorStatus?: VendorStatus;
  portalUrl?: string;
  websiteUrl?: string;
  note?: string;
  billingAddress?: UpdateBillPayAddressDto;
  mailingAddress?: UpdateBillPayAddressDto;
  /**
   * ID of the external user to assign as vendor assignee.
   * @format uuid
   */
  assigneeId?: string | null;
  /**
   * IDs of spend categories to associate with this vendor (Payload `spend_category` id).
   * @minItems 1
   * @uniqueItems true
   */
  spendCategoryIds?: string[];
  payeeName?: string | null;
  /**
   * ID of the bank (`bank` CMS collection).
   * @format uuid
   */
  bankNameId?: string | null;
  /** Exactly 9 digits, validated with the ABA checksum. */
  routingNumber?: string | null;
  /** Digits only, 4-17 characters. */
  bankAccountNumber?: string | null;
  cardFeeType?: CardFeeType | null;
  /**
   * Dollars or percent, depending on `cardFeeType`.
   * @min 0
   */
  cardFeeAmount?: number | null;
  /** When enabled, the mailing address is overwritten with the billing address, so any `mailingAddress` sent alongside it is ignored. */
  mailingAddressSameAsBilling?: boolean;
  emailInvoiceCapability?: boolean | null;
  ediApiInvoiceCapability?: boolean | null;
  paymentMethodCardAccepted?: boolean | null;
  paymentMethodAchAccepted?: boolean | null;
  paymentRemittanceEmail?: string | null;
  paymentRemittanceIdentifier?: PaymentRemittanceIdentifier | null;
  earlyPayDiscount?: boolean | null;
  paymentType?: BillPayPaymentType | null;
  /**
   * Client organization IDs to add to this vendor.
   * @uniqueItems true
   */
  addClientIds?: string[];
  /**
   * Client organization IDs to remove from this vendor. Unlinking deletes the vendor accounts between them; it is rejected with 409 when any of those accounts has an account number or spend, invoice, audit, online access or validation data, or the vendor is part of an audit of the organization.
   * @uniqueItems true
   */
  removeClientIds?: string[];
}

export interface FileUploadDto {
  /**
   * File to upload
   * @format binary
   */
  file: File;
}

export interface SpreadsheetRow {
  /** 1-based spreadsheet row number */
  row: number;
  data: object;
}

export interface SpreadsheetFieldError {
  /** DTO property name */
  field: string;
  /** Original spreadsheet column name */
  column: string;
  /** Validation error messages */
  messages: string[];
}

export interface SpreadsheetRowError {
  /** 1-based spreadsheet row number (2 = first data row, since row 1 is headers) */
  row: number;
  /** The mapped DTO that failed validation */
  data: object;
  errors: SpreadsheetFieldError[];
}

export interface VendorImportResultDto {
  isValid: boolean;
  /** Mapped DTOs that passed validation (with original row number) */
  validData: SpreadsheetRow[];
  /** Rows that failed validation (includes the DTO + error details) */
  invalidRows: SpreadsheetRowError[];
  totalRows: number;
}

export interface VendorCreateManyDto {
  items: CreateVendorDto[];
}

export interface UpdateVendorBillPayDto {
  /**
   * Vendor W9 file (.pdf, .doc). Upload a file part to add or replace. Send null to remove the existing W9.
   * @format binary
   */
  file?: File | null;
  /**
   * Optional; when provided, must match uploaded file bytes.
   * @min 1
   */
  filesize?: number;
  emailInvoiceCapability?: boolean | null;
  ediApiInvoiceCapability?: boolean | null;
  paymentMethodCardAccepted?: boolean | null;
  paymentMethodAchAccepted?: boolean | null;
  paymentRemittanceEmail?: string | null;
  paymentRemittanceIdentifier?: PaymentRemittanceIdentifier | null;
  earlyPayDiscount?: boolean | null;
  paymentType?: BillPayPaymentType | null;
}

export interface ContactsListDto {
  /** Array of items */
  items: ContactDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface CreateVendorContactDto {
  name: string;
  /** @format email */
  email: string;
  phone?: string;
  firstName?: string;
  lastName?: string;
  title?: string;
  note?: string | null;
  isActive?: boolean;
}

export interface OrganizationCommentDto {
  /** @format uuid */
  id: string;
  comment: string;
  organizationId: string;
  createdBy: PlainExternalUserDto;
  createdAt: string;
  updatedAt: string;
}

export interface OrganizationCommentListDto {
  /** Array of items */
  items: OrganizationCommentDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface OrganizationCommentFeedParentDto {
  /** What the client navigates to when the entry is opened */
  type: OrganizationCommentParent;
  id: string;
  name?: string | null;
}

export interface OrganizationCommentFeedItemDto {
  id: string;
  /** Note kind the client toggles the feed by */
  source: OrganizationCommentSource;
  /** Subject, topic or meeting name — absent for most sources */
  title?: string | null;
  content: string;
  parent: OrganizationCommentFeedParentDto;
  createdBy: PlainExternalUserDto;
  createdAt: string;
  updatedAt: string;
}

export interface OrganizationCommentFeedListDto {
  /** Array of items */
  items: OrganizationCommentFeedItemDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface OrganizationCommentSourceCountDto {
  source: OrganizationCommentSource;
  /** Entries in this source under the filters */
  total: number;
}

export interface OrganizationCommentFeedCountsDto {
  /** One entry per source the caller may read, zero-count sources included */
  items: OrganizationCommentSourceCountDto[];
}

export interface OrganizationCommentFeedAuthorsDto {
  /** Everyone who wrote a readable entry in this feed, sorted by name */
  items: PlainExternalUserDto[];
}

export interface CreateOrganizationCommentDto {
  comment: string;
}

export interface UpdateOrganizationCommentDto {
  comment: string;
}

export interface CreateTicketDto {
  /** @maxLength 256 */
  subject: string;
  /** @maxLength 1024 */
  description?: string;
  status?: TicketStatus;
  priority?: PriorityLevel;
  category?: TicketCategory;
  /**
   * Supported formats: image/jpeg, image/png, image/webp, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, application/pdf, text/csv, text/plain, message/rfc822, application/vnd.ms-outlook, application/octet-stream, video/webm, video/mp4, video/quicktime, audio/mpeg files. Max size: 200MB. Max count: 10 files.
   * @maxItems 10
   * @default null
   */
  files?: File[] | null;
  /**
   * Show in Documents Repository for each file (must match files array length)
   * @maxItems 10
   * @default null
   */
  showInDocumentsRepo?: boolean[] | null;
  /** @default null */
  receiveEmailNotifications?: boolean | null;
  /**
   * If true, ticket is external (accessible to clients). If false, ticket is internal.
   * @default null
   */
  accessToExternalUser?: boolean | null;
  assigneeId?: string;
  /** @format uuid */
  projectId?: string;
  /** The ID of the vendor organization to associate with the ticket */
  vendorId?: string | null;
  /**
   * Array of user IDs to set as participants
   * @uniqueItems true
   */
  participantIds?: string[];
  /**
   * Savings amount (only visible when category is Finance, Invoice, or Payments). For non-vector tickets only.
   * @min 0
   * @default null
   */
  savingsAmount?: number | null;
  /**
   * Due date of the ticket
   * @format date-time
   */
  dueDate?: string | null;
  /**
   * @maxLength 255
   * @default null
   */
  city?: string | null;
  /**
   * @maxLength 255
   * @default null
   */
  state?: string | null;
  /**
   * @maxLength 255
   * @default null
   */
  address?: string | null;
  /**
   * @maxLength 255
   * @default null
   */
  zip?: string | null;
  /** Client organisation (optional). When creating from the vendor portal, set to link a client; omit for vendor-only tickets. On POST /organization/:organizationId/tickets this value is ignored — the URL segment is used. */
  organizationId: string;
}

export interface TicketWithDetailsDto {
  id: string;
  /** @default null */
  ticketNumber?: string | null;
  /** @default null */
  vectorTicketId?: number | null;
  clientId?: string | null;
  subject: string;
  description?: string | null;
  status?: TicketStatus | null;
  priority?: PriorityLevel | null;
  category?: TicketCategory | null;
  vendorName?: string | null;
  location?: string | null;
  requestor?: PlainExternalUserDto | null;
  assignee?: PlainExternalUserDto | null;
  /** @format date-time */
  dueDate?: string | null;
  /** @format date-time */
  followUpDate?: string | null;
  contractVersion?: string | null;
  accessToExternalUser?: boolean | null;
  locationId?: string | null;
  locationName?: string | null;
  zip?: string | null;
  state?: string | null;
  address?: string | null;
  city?: string | null;
  subStatus?: string | null;
  updatedBy?: string | null;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  receiveEmailNotifications?: boolean | null;
  organization?: PlainOrganizationDto | null;
  vendor?: TicketVendorDto | null;
  participants?: PlainExternalUserDto[] | null;
  savingsAmount?: number | null;
  project?: string | null;
  /** Non-deleted comments visible to the caller; null when the source system does not report it. */
  commentsCount?: number | null;
  documents?: TicketFileDto[];
  comments?: TicketCommentDto[];
}

export interface VendorContractVendorDto {
  id: string;
  name: string;
}

export interface VendorContractItemDto {
  id: string;
  name: string;
  vendor: VendorContractVendorDto;
  validFrom: string;
  validTo: string;
}

export interface VendorContractListDto {
  /** Array of items */
  items: VendorContractItemDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface CreateVendorContractDto {
  name: string;
  vendorId: string;
  validFrom: string;
  validTo: string;
}

export interface LocationItemDto {
  id: string;
  displayName?: string | null;
  mainPointOfContact?: ContactDto | null;
  phone?: string | null;
  /** `organization_wide` is the organization's one non-site bucket; filter it out with `filter=kind:eq:site`. */
  kind: LocationKind;
  status?: LocationStatus | null;
  spendAreas: string[];
  stages: string;
  savings: number;
  documentFieldStatus?: DocumentFieldStatus | null;
  activeAudits: number;
  isMissingRow: boolean;
  squareFootage?: number | null;
  weatherStation?: string | null;
  hoursOfOperation?: string | null;
  units?: number | null;
  name: string | null;
  address: string | null;
  locationIdentifier: string | null;
  city: string | null;
  state: string | null;
  zip: string | null;
  taxId: string | null;
  subsidiaryOrganizationName: string | null;
}

export interface LocationsDto {
  /** Array of items */
  items: LocationItemDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
  missingFieldsCount: number;
}

export interface LocationOrganizationDto {
  id: string;
  name: string;
}

export interface LocationDetailDto {
  id: string;
  displayName?: string | null;
  mainPointOfContact?: ContactDto | null;
  phone?: string | null;
  /** `organization_wide` is the organization's one non-site bucket; filter it out with `filter=kind:eq:site`. */
  kind: LocationKind;
  status?: LocationStatus | null;
  spendAreas: string[];
  stages: string;
  savings: number;
  documentFieldStatus?: DocumentFieldStatus | null;
  activeAudits: number;
  isMissingRow: boolean;
  squareFootage?: number | null;
  weatherStation?: string | null;
  hoursOfOperation?: string | null;
  units?: number | null;
  organization: LocationOrganizationDto;
  name: string | null;
  address: string | null;
  locationIdentifier: string | null;
  city: string | null;
  state: string | null;
  zip: string | null;
  taxId: string | null;
  subsidiaryOrganizationName: string | null;
}

export interface IpUpdateLocationDto {
  locationIdentifier?: string | null;
  address?: string;
  city?: string;
  state?: string;
  zip?: string;
  /** @format uuid */
  mainPointOfContactId?: string;
  phone?: string | null;
  status?: LocationStatus;
  /** @min 0 */
  squareFootage?: number | null;
  weatherStation?: string | null;
  hoursOfOperation?: string | null;
  /** @min 0 */
  units?: number | null;
  name?: string | null;
  taxId?: string | null;
}

export interface ImportLocationDto {
  locationIdentifier?: string | null;
  name?: string | null;
  address?: string;
  city?: string;
  state?: string;
  zip?: string;
  taxId?: string | null;
  phone?: string | null;
  status?: LocationStatus;
  /** @min 0 */
  squareFootage?: number | null;
  weatherStation?: string | null;
  hoursOfOperation?: string | null;
  /** @min 0 */
  units?: number | null;
  mainPointOfContactId?: string;
}

export interface LocationCompareRecordDto {
  number: string;
  name: string;
  address: string;
}

export interface LocationDuplicatedPairRowDto {
  /** @example "duplicated-0" */
  id: string;
  /** 1-based spreadsheet row number (2 = first data row, since row 1 is headers) */
  row: number;
  /** Mapped import DTO for this row (used when resolving duplicates) */
  data: ImportLocationDto;
  imported: LocationCompareRecordDto;
  existing: LocationCompareRecordDto;
  /** @example ["number","name","address"] */
  duplicateColumns: string[];
}

export interface LocationImportResultDto {
  isValid: boolean;
  /** Mapped DTOs that passed validation (with original row number) */
  validData: SpreadsheetRow[];
  /** Rows that failed validation (includes the DTO + error details) */
  invalidRows: SpreadsheetRowError[];
  totalRows: number;
  /** True when at least one importable row has an empty or missing imported field */
  hasMissingFields: boolean;
  /** Rows that match an existing location in the organization (excluded from validData) */
  duplicatedRows: LocationDuplicatedPairRowDto[];
}

export interface CreateLocationManyItemDto {
  locationIdentifier?: string | null;
  name?: string | null;
  address?: string;
  city?: string;
  state?: string;
  zip?: string;
  taxId?: string | null;
  phone?: string | null;
  status?: LocationStatus;
  /** @min 0 */
  squareFootage?: number | null;
  weatherStation?: string | null;
  hoursOfOperation?: string | null;
  /** @min 0 */
  units?: number | null;
  /** @format uuid */
  mainPointOfContactId?: string;
}

export interface LocationCreateManyDto {
  items: CreateLocationManyItemDto[];
}

export interface IpCreateLocationDto {
  locationIdentifier?: string | null;
  address: string;
  city: string;
  state: string;
  zip: string;
  /** @format uuid */
  mainPointOfContactId?: string;
  phone?: string | null;
  status?: LocationStatus;
  /** @min 0 */
  squareFootage?: number | null;
  weatherStation?: string | null;
  hoursOfOperation?: string | null;
  /** @min 0 */
  units?: number | null;
  name?: string | null;
  taxId?: string | null;
}

export interface OnlineAccessListItemDto {
  id: string;
  /** AP System / vendor name */
  name: string;
  status: OnlineAccessStatus;
  websiteUrl?: string | null;
  vendor?: PlainDto | null;
  vendorAccounts: PlainDto[];
  username?: string | null;
  /** Whether a stored credential exists; never includes plaintext. */
  hasCredential: boolean;
  /** Whether stored security questions exist; never includes plaintext. */
  hasSecurityQuestions: boolean;
  /**
   * Number of stored security questions; 0 when none.
   * @min 0
   */
  securityQuestionsCount: number;
  note?: string | null;
}

export interface OnlineAccessListDto {
  /** Array of items */
  items: OnlineAccessListItemDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface OnlineAccessCredentialDto {
  credential: string;
}

export interface OnlineAccessSecurityQuestionDto {
  /** @maxLength 500 */
  question: string;
  /** @maxLength 2000 */
  answer: string;
}

export interface OnlineAccessSecretsDto {
  password?: string | null;
  securityQuestions: OnlineAccessSecurityQuestionDto[];
}

export interface CreateOnlineAccessDto {
  /** AP System / vendor name */
  name: string;
  status: OnlineAccessStatus;
  /** @format uri */
  websiteUrl?: string | null;
  vendorId?: string | null;
  /** @uniqueItems true */
  vendorAccountIds: string[];
  username?: string | null;
  /**
   * Write-only portal password. Stored envelope-encrypted and never returned by this endpoint. Setting it requires the online access credentials permission.
   * @maxLength 512
   */
  password?: string;
  /**
   * Write-only security questions for the portal. Stored envelope-encrypted and never returned by this endpoint. Setting them requires the online access credentials permission.
   * @maxItems 10
   */
  securityQuestions?: OnlineAccessSecurityQuestionDto[];
  note?: string | null;
}

export interface UpdateOnlineAccessDto {
  /** AP System / vendor name */
  name?: string;
  status?: OnlineAccessStatus;
  /** @format uri */
  websiteUrl?: string | null;
  vendorId?: string | null;
  /** @uniqueItems true */
  vendorAccountIds?: string[];
  username?: string | null;
  /**
   * Write-only portal password. Stored envelope-encrypted; send `null` to clear it, omit to leave it unchanged. Setting or clearing it requires the online access credentials permission.
   * @maxLength 512
   */
  password?: object | null;
  /**
   * Write-only security questions. Replaces the whole stored list; send `null` or `[]` to clear it, omit to leave it unchanged. Setting or clearing them requires the online access credentials permission.
   * @maxItems 10
   */
  securityQuestions?: OnlineAccessSecurityQuestionDto[] | null;
  note?: string | null;
}

export interface ActionItemListItemDto {
  id: string;
  title: string;
  description?: string | null;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deadline?: string | null;
  /** @format date-time */
  completedAt?: string | null;
  spendAreaStage: SpendAreaStage;
  priorityLevel: PriorityLevel;
  actionType?: ActionItemType | null;
  /** Action details associated with the step. */
  actionDetails?:
    | MeetingLinkActionTypeDto
    | FileUploadActionTypeDto
    | LinkActionTypeDto;
  createdBy?: PlainExternalUserDto | null;
  assignee?: PlainExternalUserDto | null;
  organization?: PlainOrganizationDto | null;
}

export interface IPActionItemListDto {
  /** Array of items */
  items: ActionItemListItemDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface GlobalWorkActionItemListItemDto {
  id: string;
  title: string;
  description?: string | null;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deadline?: string | null;
  /** @format date-time */
  completedAt?: string | null;
  spendAreaStage: SpendAreaStage;
  priorityLevel: PriorityLevel;
  actionType?: ActionItemType | null;
  /** Action details associated with the step. */
  actionDetails?:
    | MeetingLinkActionTypeDto
    | FileUploadActionTypeDto
    | LinkActionTypeDto;
  createdBy?: PlainExternalUserDto | null;
  assignee?: PlainExternalUserDto | null;
  organization?: PlainOrganizationDto | null;
  /** Whether the current user can edit/complete this action item (manager of the organization) */
  canEdit: boolean;
}

export interface GlobalWorkActionItemListDto {
  /** Array of items */
  items: GlobalWorkActionItemListItemDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface IpTaskDto {
  id: string;
  completed: boolean;
  title: string;
  description?: string | null;
  category: TaskCategory;
  status: TaskStatus;
  assignee?: PlainExternalUserDto | null;
  /** @format date-time */
  deadline?: string | null;
  priorityLevel: PriorityLevel;
  referenceName?: string | null;
  ticketId?: string | null;
  ticketNumber?: string | null;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  organization?: PlainOrganizationDto | null;
  /** Whether the current user can edit this task */
  canEdit: boolean;
}

export interface IpTicketDto {
  id: string;
  ticketNumber: string;
  status?: TicketStatus | null;
  subject: string;
  priority?: PriorityLevel | null;
  assignee?: PlainExternalUserDto | null;
  category?: TicketCategory | null;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  organization?: PlainOrganizationDto | null;
}

export interface TicketMetricsDto {
  openTotal: number;
  openLowPriority: number;
  openMediumPriority: number;
  openHighPriority: number;
}

export interface TaskMetricsDto {
  openTotal: number;
  openLowPriority: number;
  openMediumPriority: number;
  openHighPriority: number;
  dueTodayTotal: number;
  dueTodayLowPriority: number;
  dueTodayMediumPriority: number;
  dueTodayHighPriority: number;
}

export interface DashboardMetricsDto {
  lastEditedTask?: IpTaskDto;
  lastEditedTicket?: IpTicketDto;
  notifications?: number;
  crmCount?: number;
  tickets?: TicketMetricsDto;
  tasks?: TaskMetricsDto;
}

export interface ManagedOrganizationsListDto {
  /** Array of items */
  items: PlainOrganizationDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface ProjectListDto {
  /** Array of items */
  items: ProjectDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface IpTeamDto {
  /** @format uuid */
  id: string;
  name: string;
  activeTaskCount?: number;
  allTaskCount?: number;
  userCount: number;
}

export interface IpTeamListDto {
  /** Array of items */
  items: IpTeamDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface AuditSalesforceSourceDto {
  /** Which Salesforce record this audit was migrated from. */
  source: SalesforceAuditSource;
  auditId?: string | null;
  /** Salesforce Location Audit record number, e.g. Audit-76850. */
  auditName?: string | null;
  subauditId?: string | null;
  /** Salesforce SubAudit record number, e.g. SubAudit-00107. Set only when source is subaudit. */
  subauditName?: string | null;
}

export interface IncludedLocationsDto {
  count: number;
  matched: string[];
  matchCount: number;
}

export interface AuditSalesforceOpportunityDto {
  salesforceOpportunityId: string;
  name?: string | null;
  stage?: string | null;
  /** @example "3448.93" */
  amount?: string | null;
  /**
   * TCV: the opportunity contract value (Salesforce CV).
   * @example "49665.00"
   */
  contractValue?: string | null;
  /**
   * Expected Completion - Initial Validation.
   * @format date
   */
  expectedInitialValidationCompletion?: string | null;
}

export interface AuditSalesforceDetailsDto {
  /** @example "109266.00" */
  cvTotal?: string | null;
  currentAnnualSpend?: string | null;
  achievedAnnualSpend?: string | null;
  achievedAnnualSavings?: string | null;
  /**
   * The earliest Expected Completion - Initial Validation of the audit's opportunities.
   * @format date
   */
  earliestExpectedInitialValidationCompletion?: string | null;
  /** Earliest expected completion first. Empty on audit lists; filled when fetching, creating or updating a single audit. */
  opportunities: AuditSalesforceOpportunityDto[];
}

export interface PinnedAuditItemDto {
  id: string;
  /** Migrated from Salesforce rather than created here. Such an audit may lack a vendor or contract, which creation requires; see GET /sf-migration/audits/:auditId/backfill-required. */
  isMigrated: boolean;
  name?: string | null;
  /** Where this audit came from; null when created here. */
  salesforceSource?: AuditSalesforceSourceDto | null;
  status?: AuditStatus | null;
  stage?: AuditStage | null;
  spendCategory?: PlainDto | null;
  spendArea?: PlainDto | null;
  vendor?: PlainDto | null;
  includedLocations: IncludedLocationsDto;
  /** Locations assigned to this audit via its optimization subject. Only populated when fetching a single audit. */
  locations?: PlainDto[];
  /** Figures and opportunities migrated from the Salesforce audit; null when the audit was not migrated. */
  salesforceDetails: AuditSalesforceDetailsDto | null;
  dueDate?: string | null;
  /**
   * Earliest savings window opened across this audit`s spends. Null while none has one.
   * @format date
   */
  savingsStartDate?: string | null;
  createdAt: string;
  baselineSpend: number;
  invoicesAttachedCount: number;
  createdBy?: PlainExternalUserDto | null;
  assignedTeam?: PlainDto | null;
  owner?: PlainExternalUserDto | null;
  contract?: PlainDto | null;
  subsidiaryOrganization?: PlainDto | null;
  organization: PlainDto;
}

export interface PinnedAuditListDto {
  /** Array of items */
  items: PinnedAuditItemDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface UpsertPreferenceBodyDto {
  /**
   * Any valid JSON value to be stored (string, number, boolean, array, object, null)
   * @example ["org1","org2"]
   */
  value: string | number | boolean | any[] | object | null;
}

export interface PreferenceDto {
  /** @example "user" */
  type: PreferenceDtoTypeEnum;
  userId?: string;
  organizationId?: string;
  key: string;
  /** @example {"columns":["id","name","created"]} */
  value: string | number | boolean | any[] | object | null;
}

export interface PreferenceListDto {
  /** List of preferences */
  items: PreferenceDto[];
}

export interface AuditsListItemDto {
  id: string;
  /** Migrated from Salesforce rather than created here. Such an audit may lack a vendor or contract, which creation requires; see GET /sf-migration/audits/:auditId/backfill-required. */
  isMigrated: boolean;
  name?: string | null;
  /** Where this audit came from; null when created here. */
  salesforceSource?: AuditSalesforceSourceDto | null;
  status?: AuditStatus | null;
  stage?: AuditStage | null;
  spendCategory?: PlainDto | null;
  spendArea?: PlainDto | null;
  vendor?: PlainDto | null;
  includedLocations: IncludedLocationsDto;
  /** Locations assigned to this audit via its optimization subject. Only populated when fetching a single audit. */
  locations?: PlainDto[];
  /** Figures and opportunities migrated from the Salesforce audit; null when the audit was not migrated. */
  salesforceDetails: AuditSalesforceDetailsDto | null;
  dueDate?: string | null;
  /**
   * Earliest savings window opened across this audit`s spends. Null while none has one.
   * @format date
   */
  savingsStartDate?: string | null;
  createdAt: string;
  baselineSpend: number;
  invoicesAttachedCount: number;
  createdBy?: PlainExternalUserDto | null;
  assignedTeam?: PlainDto | null;
  owner?: PlainExternalUserDto | null;
  contract?: PlainDto | null;
  subsidiaryOrganization?: PlainDto | null;
  organization: PlainDto;
  /** The portal audit migrated from the SF1 parent audit. Set on vendor splits and subaudits; null on the parent row and portal-created audits. */
  parentAudit?: PlainDto | null;
}

export interface AuditsListDto {
  /** Array of items */
  items: AuditsListItemDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface AuditItemDto {
  id: string;
  /** Migrated from Salesforce rather than created here. Such an audit may lack a vendor or contract, which creation requires; see GET /sf-migration/audits/:auditId/backfill-required. */
  isMigrated: boolean;
  name?: string | null;
  /** Where this audit came from; null when created here. */
  salesforceSource?: AuditSalesforceSourceDto | null;
  status?: AuditStatus | null;
  stage?: AuditStage | null;
  spendCategory?: PlainDto | null;
  spendArea?: PlainDto | null;
  vendor?: PlainDto | null;
  includedLocations: IncludedLocationsDto;
  /** Locations assigned to this audit via its optimization subject. Only populated when fetching a single audit. */
  locations?: PlainDto[];
  /** Figures and opportunities migrated from the Salesforce audit; null when the audit was not migrated. */
  salesforceDetails: AuditSalesforceDetailsDto | null;
  dueDate?: string | null;
  /**
   * Earliest savings window opened across this audit`s spends. Null while none has one.
   * @format date
   */
  savingsStartDate?: string | null;
  createdAt: string;
  baselineSpend: number;
  invoicesAttachedCount: number;
  createdBy?: PlainExternalUserDto | null;
  assignedTeam?: PlainDto | null;
  owner?: PlainExternalUserDto | null;
  contract?: PlainDto | null;
  subsidiaryOrganization?: PlainDto | null;
  /** Set during Negotiations – vendor; required before leaving that stage. */
  savingsSource?: PlainDto | null;
}

export interface AuditListDto {
  /** Array of items */
  items: AuditItemDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface CreateAuditDto {
  /**
   * Spend category that scopes the audit
   * @format uuid
   */
  spendCategoryId: string;
  /**
   * SIB contract id
   * @format uuid
   */
  contractId: string;
  dueDate: string;
  /** Vendor id */
  vendorId: string;
  /**
   * Vendor point of contact ids
   * @uniqueItems true
   */
  contactIds?: string[];
  /**
   * Assigned team id
   * @format uuid
   */
  teamId?: string;
  /**
   * Owner external user id; must be a member of the team when both are provided
   * @format uuid
   */
  ownerId?: string;
}

export interface AverageAuditDurationDto {
  /** Average audit duration in days for the spend category; null when there is no manual value and no completed audits to compute from */
  averageDurationDays?: number | null;
  /** Whether the value comes from the manual override on the spend category or was computed from completed audits */
  source?: AverageAuditDurationSource | null;
}

export interface UpdateAuditDto {
  dueDate?: string;
  /** Vendor id */
  vendorId?: string;
  /**
   * SIB contract id. Accepted only while the audit has no contract; assigning over an existing one is rejected.
   * @format uuid
   */
  contractId?: string;
  /**
   * Assigned team id. Pass null to unassign the team.
   * @format uuid
   */
  teamId?: string | null;
  /**
   * Owner external user id; must be a member of the team. Pass null to unassign the owner.
   * @format uuid
   */
  ownerId?: string | null;
  status?: AuditStatus;
  stage?: SpendAreaStage;
}

export interface LinkedAuditItemDto {
  /** @format uuid */
  id: string;
  name?: string | null;
  fullName?: string | null;
  vendor?: PlainDto | null;
  createdAt: string;
  /** Whether this audit is the source (parent) or a copy (child). */
  linkType: LinkedAuditLinkType;
}

export interface CopyAuditResultDto {
  /** @format uuid */
  id: string;
  name?: string | null;
  fullName?: string | null;
}

export interface UnassignedSpendVendorAccountDto {
  id: string;
  accountNumber?: string | null;
  name?: string | null;
}

export interface UnassignedSpendLocationDto {
  id: string;
  name?: string | null;
  locationIdentifier?: string | null;
}

export interface UnassignedSpendVendorDto {
  id: string;
  name?: string | null;
}

export interface UnassignedSpendAssignableAuditDto {
  id: string;
  name?: string | null;
  /** SF1 parent audit id — the same for every member of the family. */
  salesforceAuditId?: string | null;
  /** Set only for a subaudit. A parent audit and a vendor split both leave this null; the vendor is what tells them apart. */
  salesforceSubauditId?: string | null;
  /** The vendor this audit covers. A vendor split is a parent audit narrowed to one vendor. */
  vendor?: UnassignedSpendVendorDto | null;
}

export interface UnassignedSpendGroupDto {
  vendorAccount?: UnassignedSpendVendorAccountDto | null;
  location?: UnassignedSpendLocationDto | null;
  /** Spends a family audit covering their vendor and vendor account can take. */
  assignableSpendCount: number;
  unassignableSpendCount: number;
  /** Audits covering one of this group's vendors that are linked to its vendor account. Empty when nothing in the group is assignable. */
  assignableAudits: UnassignedSpendAssignableAuditDto[];
}

export interface BackfillRequiredDto {
  auditId: string;
  /** Every app audit migrated from the same SF1 parent audit, which is what the counts cover. */
  auditIds: string[];
  assignableSpendCount: number;
  unassignableSpendCount: number;
  groups: UnassignedSpendGroupDto[];
}

export interface BackfillAuditStatusDto {
  auditId: string;
  /** Whether the audit in the path has a vendor. Required at creation, so a migrated audit without one cannot be worked until it is set via PATCH /audits/:auditId. */
  isVendorAssigned: boolean;
  /** Whether the audit in the path has a SIB contract. Assignable once, via PATCH /audits/:auditId. */
  isSibContractAssigned: boolean;
}

export interface BackfillSpendDto {
  /** @format uuid */
  id: string;
  name: string;
  vendorId?: string | null;
  vendorName?: string | null;
  vendorAccountNumber?: string | null;
  locationName?: string | null;
  pricingModel: SpendPricingModel;
  unit?: string | null;
  quantity?: number | null;
  pricePerUnit?: number | null;
  /** Percentage POINTS (7.5 = 7.5%). */
  percentageRate?: number | null;
  total: number;
  type: OccurrenceType;
  frequency?: OccurrenceFrequency | null;
  /** Why the attribution job left this spend unassigned. */
  reason: SpendAssignmentReason;
  /** True when a family audit covers both its vendor and vendor account, so POST assign can move it. */
  assignable: boolean;
}

export interface BackfillSpendListDto {
  /** Array of items */
  items: BackfillSpendDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface AssignBackfillSpendDto {
  /** @format uuid */
  vendorAccountId: string;
  /** @format uuid */
  locationId: string;
  /**
   * App audit the combo should be attributed to.
   * @format uuid
   */
  targetAuditId: string;
}

export interface AuditCommentDto {
  /** @format uuid */
  id: string;
  subject?: string | null;
  comment: string;
  auditStage?: AuditStage | null;
  /** @format uuid */
  auditId: string;
  createdBy: PlainExternalUserDto;
  assignee?: PlainExternalUserDto | null;
  createdAt: string;
}

export interface AuditCommentListDto {
  /** Array of items */
  items: AuditCommentDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface CreateAuditCommentDto {
  subject: string;
  comment: string;
  /** @format uuid */
  assigneeId?: string | null;
  auditStage?: AuditStage | null;
}

export interface AuditDocumentDto {
  id: string;
  stage: DocumentStage;
  fileUrl: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  name: string;
  sensitive: boolean;
  internal: boolean;
  providedBy: DocumentProvidedBy;
  uploadedBy: PlainExternalUserDto;
  spendCategory?: SpendCategoryListItemDto | null;
  organizationId: string;
  subsidiaryOrganizationName?: string | null;
  tags: DocumentTagDto[] | null;
  uploadStage: DocumentUploadStatus;
  contractType?: ContractType | null;
  categoryManager?: CategoryManager | null;
  categoryManagerUser?: PlainExternalUserDto | null;
  paymentFrequency?: PaymentFrequency | null;
  anomaly?: boolean | null;
  matchingDocuments?: number | null;
  hasVirtualInvoices?: boolean;
  docId?: string | null;
  /** AI-managed fields explicitly edited by a user; Franz sync skips these. */
  userModifiedFields?: string[];
  /**
   * Set when Franz first updates this document; AI-managed fields become read-only for users.
   * @format date-time
   */
  updatedWithAiAt?: string | null;
  /** Whether the document is linked to this audit (picker). */
  linkedToThisAudit?: boolean;
  attachedFromDocumentsRepo?: boolean;
  /** Set when the document is the scan a bill arrived as, naming that invoice. */
  invoiceId?: string | null;
  uploadedAuditStage?: AuditStage | null;
  vendor: string | null;
  fileSize?: number | null;
  type: string | null;
  /** @format date-time */
  startDate?: string | null;
  /** @format date-time */
  endDate?: string | null;
  /** @format date-time */
  renewalDate?: string | null;
  annualContractValue?: number | null;
  notToExceed?: boolean | null;
  annualPriceIncrease?: boolean | null;
  earlyTerminationFee?: boolean | null;
  cancellationDateNoticePeriod?: string | null;
  autoRenewalClause?: boolean | null;
  autoRenewalLength?: string | null;
  notToExceedPercentage?: number | null;
  additionalColumns?: object | null;
}

export interface AuditDocumentListDto {
  /** Array of items */
  items: AuditDocumentDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface AttachAuditDocumentsDto {
  /**
   * @minItems 1
   * @uniqueItems true
   */
  documentIds: string[];
}

export interface AttachAuditDocumentsResultDto {
  successfullyAttached: number;
}

export interface DetachAuditDocumentsDto {
  /**
   * @minItems 1
   * @uniqueItems true
   */
  documentIds: string[];
}

export interface DetachAuditDocumentsResultDto {
  successfullyDetached: number;
}

export interface DeleteAuditDocumentsResultDto {
  successfullyDeleted: number;
}

export interface AuditVendorAccountListDto {
  /** Array of items */
  items: VendorAccountDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface AttachAuditVendorAccountsDto {
  /**
   * @minItems 1
   * @uniqueItems true
   */
  vendorAccountIds: string[];
}

export interface AttachAuditVendorAccountsResultDto {
  successfullyAttached: number;
}

export interface DetachAuditVendorAccountsDto {
  /**
   * @minItems 1
   * @uniqueItems true
   */
  vendorAccountIds: string[];
}

export interface DetachAuditVendorAccountsResultDto {
  successfullyDetached: number;
}

export interface PercentageBasisCandidateDto {
  /** @format uuid */
  id: string;
  name: string;
}

export interface SpendEstimatedSpendDto {
  /**
   * Underlying spend id (used by spend-estimated CRUD routes).
   * @format uuid
   */
  id: string;
  /** @format uuid */
  auditSpendId: string;
  pricingModel: SpendPricingModel;
  name: string;
  vendorAccountNumber: string;
  quantityType?: SpendQuantityType | null;
  unit: string;
  quantity: number;
  pricePerUnit: number;
  /** Percentage POINTS (7.5 = 7.5%). Set only on a percentage rate spend, where unit / quantity / pricePerUnit are empty. */
  percentageRate?: number | null;
  /** The charges this fee is a percentage of. Empty for every other pricing model. */
  percentageBasisMembers: PercentageBasisCandidateDto[];
  total: number;
  type: OccurrenceType;
  frequency?: OccurrenceFrequency | null;
  /** @format uuid */
  locationId?: string;
  locationName?: string;
  minimumFee?: number | null;
  minimumFeeNote?: string | null;
  taxable?: boolean | null;
  tierType?: SpendTierType | null;
  tierValue?: string | null;
  indexRate?: string | null;
  notesCount: number;
  /**
   * When this audit spend row was created (entry order), not last edit.
   * @format date-time
   */
  createdAt: string;
}

export interface SpendEstimatedListDto {
  /** Array of items */
  items: SpendEstimatedSpendDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
  /** Sum of line totals for all rows matching the current filters (not just the current page). */
  totalSpend: number;
}

export interface ImportSpendEstimatedItemDto {
  vendorAccountNumber: string;
  name: string;
  /** @default "usage_based" */
  pricingModel?: SpendPricingModel;
  /** @default null */
  quantityType?: SpendQuantityType | null;
  unit?: string;
  /** @min 0 */
  quantity: number;
  /** @min 0 */
  pricePerUnit: number;
  /**
   * Percentage POINTS (7.5 = 7.5%), stored at four decimal places. Required for a percentage rate spend, forbidden otherwise; read from the price column when the sheet states it there.
   * @min 0
   */
  percentageRate?: number;
  type?: OccurrenceType;
  frequency: OccurrenceFrequency;
  /** Location identifier. When the location name is unique for the organization it may be used as the identifier; otherwise use the location UUID. Resolved to a UUID before persist. */
  locationId: string;
  /**
   * @min 0
   * @default null
   */
  minimumFee?: number | null;
  minimumFeeNote?: string | null;
  taxable?: boolean | null;
  indexRate?: string | null;
  tierType?: SpendTierType | null;
  tierValue?: string | null;
}

export interface SpendEstimatedSpendCompareDto {
  name: string;
  vendorAccountNumber: string;
  pricingModel?: SpendPricingModel;
  quantityType: SpendQuantityType | null;
  unit: string;
  quantity: number;
  pricePerUnit: number;
  percentageRate?: number | null;
  /** Null on an imported percentage rate row: a sheet states the rate but not the charges it applies to, so no total is derivable. */
  total?: number | null;
  type: OccurrenceType;
  frequency?: OccurrenceFrequency | null;
  minimumFee: number | null;
  minimumFeeNote: string | null;
  taxable: boolean | null;
  indexRate: string | null;
  tierType: SpendTierType | null;
  tierValue: string | null;
}

export interface SpendEstimatedDuplicatedSpendDto {
  /** @example "dup-spend-0" */
  id: string;
  /** 1-based spreadsheet row number for this spend */
  row: number;
  data: ImportSpendEstimatedItemDto;
  imported: SpendEstimatedSpendCompareDto;
  existing: SpendEstimatedSpendCompareDto;
  /**
   * Fields that differ between imported and existing spend values
   * @example ["quantity","total"]
   */
  changedFields: string[];
}

export interface SpendEstimatedImportResultDto {
  isValid: boolean;
  /** Mapped DTOs that passed validation (with original row number) */
  validData: SpreadsheetRow[];
  /** Rows that failed validation (includes the DTO + error details) */
  invalidRows: SpreadsheetRowError[];
  totalRows: number;
  /** True when at least one importable row is missing an optional location */
  hasMissingFields: boolean;
  /** Imported spends that match existing spends by name and vendor account number but differ in values (excluded from validData) */
  duplicatedItems: SpendEstimatedDuplicatedSpendDto[];
}

export interface ConfirmSpendEstimatedDto {
  /**
   * @maxItems 500
   * @minItems 1
   */
  items: ImportSpendEstimatedItemDto[];
}

export interface ConfirmSpendEstimatedResultDto {
  importedCount: number;
  totalSpend: number;
}

export interface SpendEstimatedVendorAccountOptionDto {
  /** @format uuid */
  id: string;
  accountNumber?: string | null;
  label: string;
}

export interface CreateSpendEstimatedSpendDto {
  name: string;
  vendorAccountNumber: string;
  /** @default "usage_based" */
  pricingModel?: SpendPricingModel;
  /** Omit for a regular charge. Fixed at creation. */
  kind?: SpendKind | null;
  quantityType?: SpendQuantityType | null;
  unit?: string;
  /** @min 0 */
  quantity: number;
  pricePerUnit: number;
  /**
   * Percentage POINTS (7.5 = 7.5%), stored at four decimal places. Required for a percentage rate spend, and forbidden on any other model.
   * @min 0
   */
  percentageRate?: number;
  /**
   * Charges this fee is a percentage of, attached as the spend is created. Only for a percentage rate spend; every id must be another charge on the same bill stream. A member may itself be a fee, as long as no cycle forms and no chain exceeds 8 fee levels.
   * @uniqueItems true
   */
  percentageBasisMemberIds?: string[];
  type: OccurrenceType;
  /** Required when the type is recurring; absent otherwise. */
  frequency?: OccurrenceFrequency | null;
  /** @format uuid */
  locationId: string;
  /** @min 0 */
  minimumFee?: number | null;
  minimumFeeNote?: string | null;
  taxable?: boolean | null;
  indexRate?: string | null;
  tierType?: SpendTierType | null;
  tierValue?: string | null;
}

export interface BulkUpdateSpendEstimatedSpendsDto {
  quantityType?: SpendQuantityType | null;
  name?: string;
  vendorAccountNumber?: string;
  unit?: string;
  /**
   * Percentage POINTS (7.5 = 7.5%), stored at four decimal places. Only on a percentage rate spend; the model itself is immutable after creation.
   * @min 0
   */
  percentageRate?: number;
  /** @min 0 */
  quantity?: number;
  /** @min 0 */
  pricePerUnit?: number;
  type?: OccurrenceType;
  /** Required when the type is recurring. */
  frequency?: OccurrenceFrequency | null;
  /**
   * Omit to leave unchanged.
   * @format uuid
   */
  locationId?: string;
  /** @min 0 */
  minimumFee?: number | null;
  minimumFeeNote?: string | null;
  taxable?: boolean | null;
  indexRate?: string | null;
  tierType?: SpendTierType | null;
  tierValue?: string | null;
  /**
   * @minItems 1
   * @uniqueItems true
   */
  spendIds: string[];
}

export interface BulkUpdateSpendEstimatedResultDto {
  successfullyUpdated: number;
}

export interface UpdateSpendEstimatedSpendDto {
  quantityType?: SpendQuantityType | null;
  name?: string;
  vendorAccountNumber?: string;
  unit?: string;
  /**
   * Percentage POINTS (7.5 = 7.5%), stored at four decimal places. Only on a percentage rate spend; the model itself is immutable after creation.
   * @min 0
   */
  percentageRate?: number;
  /**
   * The complete set of charges this fee is a percentage of. Only for a percentage rate spend; omit to leave the basis untouched, send an empty array to detach everything.
   * @uniqueItems true
   */
  percentageBasisMemberIds?: string[];
  /** @min 0 */
  quantity?: number;
  /** @min 0 */
  pricePerUnit?: number;
  type?: OccurrenceType;
  /** Required when the type is recurring. */
  frequency?: OccurrenceFrequency | null;
  /**
   * Omit to leave unchanged.
   * @format uuid
   */
  locationId?: string;
  /** @min 0 */
  minimumFee?: number | null;
  minimumFeeNote?: string | null;
  taxable?: boolean | null;
  indexRate?: string | null;
  tierType?: SpendTierType | null;
  tierValue?: string | null;
}

export interface BulkDeleteSpendEstimatedSpendsDto {
  /**
   * @minItems 1
   * @uniqueItems true
   */
  spendIds: string[];
}

export interface DeleteSpendEstimatedResultDto {
  successfullyDeleted: number;
}

export interface AuditMeetingNoteDto {
  /** @format uuid */
  id: string;
  note: string;
  createdBy: PlainExternalUserDto;
  createdAt: string;
  /** True when the requesting user authored the note. */
  canDelete: boolean;
}

export interface AuditMeetingDto {
  /** @format uuid */
  id: string;
  name: string;
  meetingUrl?: string | null;
  meetingDate: string;
  pointOfContact?: ContactDto | null;
  /** True when the meeting is mirrored as an action item in the client SpendBrain. */
  displayedInSpendBrain: boolean;
  assignee: PlainExternalUserDto;
  createdBy: PlainExternalUserDto;
  /** True when the requesting user created the meeting. */
  canDelete: boolean;
  notes: AuditMeetingNoteDto[];
}

export interface AuditMeetingListDto {
  /** Meetings whose date has not passed yet, soonest first. */
  upcoming: AuditMeetingDto[];
  /** Meetings whose date has passed, most recent first. */
  past: AuditMeetingDto[];
}

export interface CreateAuditMeetingDto {
  name: string;
  meetingUrl?: string | null;
  /** @example "2026-08-25T00:00:00.000Z" */
  meetingDate: string;
  /** @format uuid */
  pointOfContactId: string;
  /**
   * SIB employee running the meeting. Defaults to the creating user.
   * @format uuid
   */
  assigneeId?: string;
  /** Notes to store with the meeting, in the order they are displayed. */
  notes?: string[];
  /**
   * Mirrors the meeting as an action item in the client SpendBrain. Once on it cannot be turned off — delete the meeting instead.
   * @default false
   */
  displayInSpendBrain?: boolean;
}

export interface UpdateAuditMeetingDto {
  name?: string;
  meetingUrl?: string | null;
  /** @example "2026-08-25T00:00:00.000Z" */
  meetingDate?: string;
  /** @format uuid */
  pointOfContactId?: string;
  /**
   * SIB employee running the meeting. Defaults to the creating user.
   * @format uuid
   */
  assigneeId?: string;
  /**
   * Mirrors the meeting as an action item in the client SpendBrain. Once on it cannot be turned off — delete the meeting instead.
   * @default false
   */
  displayInSpendBrain?: boolean;
}

export interface CreateAuditMeetingNoteDto {
  note: string;
}

export interface SibServiceCadenceEvidenceDto {
  occurrenceInterval: OccurrenceInterval;
  /** How many of the charges billed through the item point at this cadence. */
  count: number;
}

export interface SibServiceCatalogueItemDto {
  /** @format uuid */
  id: string;
  /** NetSuite's internal id of the item. */
  netsuiteId: string;
  /** The item as NetSuite names it. */
  name: string;
  displayName?: string | null;
  /** The SF2 services this item bills. */
  services: string[];
  /** Fixed fee: owed on its cadence at the agreed price. Usage based: billed at what each invoice charges. */
  pricingModel: SibServicePricingModel;
  /** The cadence a client charge on this item starts with; it is then the charge's own. */
  occurrenceInterval?: OccurrenceInterval | null;
  /** How many organizations are billed through this item now. */
  organizationCount: number;
  /** Why this item needs a person to choose its cadence. Null when nothing needs doing. */
  attention?: SibServiceAttention | null;
  /** The cadences the sales priced on it (from the SF2 TCV) and its charges point at, most common first. */
  cadenceEvidence: SibServiceCadenceEvidenceDto[];
}

export interface CatalogueNetsuiteItemDto {
  /** @format uuid */
  id: string;
  /** NetSuite's internal id. */
  netsuiteId: string;
  name: string;
}

export interface SpendCategoryCatalogueItemDto {
  /** @format uuid */
  id: string;
  name: string;
  spendArea?: string | null;
  /** Offered to clients; a disabled one is listed because NetSuite bills it. */
  enabled: boolean;
  /** The NetSuite items that bill savings shares of it. */
  netsuiteItems: CatalogueNetsuiteItemDto[];
  /** Clients with a contract on it. */
  organizationCount: number;
}

export interface CadenceDto {
  /** How often a client is billed. */
  occurrenceInterval: ServiceOccurrenceInterval;
}

export interface UncategorizedSavingsShareDto {
  /** @format uuid */
  id: string;
  /** The month NetSuite billed it for. */
  periodFrom: string;
  periodTo: string;
  amount: number;
  /** @format uuid */
  sibInvoiceId?: string | null;
  sibInvoiceNumber?: string | null;
  sibInvoiceDate?: string | null;
  sibInvoiceNetsuiteTransactionId?: string | null;
  netsuiteItemName?: string | null;
  /** The NetSuite line's memo, which often names the category. */
  netsuiteMemo?: string | null;
}

export interface AssignableSpendCategoryDto {
  /** @format uuid */
  id: string;
  name: string;
  /** One of the categories on the client’s contracts. */
  onContract: boolean;
}

export interface AssignSavingsShareCategoryDto {
  /**
   * The client's savings shares billed without a category.
   * @minItems 1
   */
  occurrenceIds: string[];
  /** @format uuid */
  spendCategoryId: string;
}

export interface AssignSavingsShareCategoryResultDto {
  /** Shares filed under the category. */
  assigned: number;
  /** Of those, shares that took the place of the month a contract owed for the category. */
  scheduled: number;
}

export interface SibInvoiceAttachmentDto {
  /** NetSuite's file id. */
  id: string;
  name: string;
  /** Size in bytes. */
  fileSize: number;
  /** When NetSuite emailed it with the invoice. */
  sentAt: string;
}

export interface ContractSoldLineDto {
  kind: ContractSoldLineKind;
  /**
   * The service line's charge; null on a spend category.
   * @format uuid
   */
  chargeId?: string | null;
  /** @format uuid */
  spendCategoryId?: string | null;
  /** The service or spend category. */
  name: string;
  /** What SF2 sold: the line's share of its opportunity's TCV; for a spend category, all its lines on the contract. Null when SF2 does not state it. */
  lineTcv?: number | null;
  /** Revenue it brought in, as the revenue screen counts it: a service line's billed obligations; a spend category's savings shares on the contract once billed or reported on a sent VSR report. */
  billed: number;
}

export interface OrganizationSibServiceItemDto {
  /** @format uuid */
  chargeId: string;
  /** An SF2 opportunity line. Otherwise the charge holds what NetSuite billed that no SF2 line sold. */
  sold: boolean;
  salesforceOpportunityId?: string | null;
  /** SF2's price per period: unit price times quantity. */
  soldPrice?: number | null;
  revenueStartDate?: string | null;
  /** SF2's term; null when SF2 gives none and the charge runs 36 months. */
  termMonths?: number | null;
  /** The SF2 opportunity's owner, as matched here. */
  ownerName?: string | null;
  /** @format uuid */
  serviceId: string;
  serviceName: string;
  /** NetSuite's internal id of the item the client is billed through; null until a charge bills the service. */
  netsuiteItemId?: string | null;
  /** The NetSuite item, as NetSuite names it. */
  netsuiteItemName?: string | null;
  /**
   * The NetSuite item the client is billed through, as chosen here.
   * @format uuid
   */
  itemId?: string | null;
  /** On No service: billed in NetSuite, but not yet assigned to a service the client bought. */
  orphan: boolean;
  /** Text NetSuite's invoice lines carry for this client's service. */
  netsuiteMemo?: string | null;
  occurrenceInterval?: OccurrenceInterval | null;
  /** A usage-based item is billed per NetSuite invoice and has no cadence; null until there is an item. */
  pricingModel?: SibServicePricingModel | null;
  /** First day of the term. */
  startsOn: string;
  /** The day after the last day of the term. */
  endsOn: string;
  /** Former once the term has ended; not billed while the charge has no obligation. */
  status: SibServiceChargeStatus;
  price?: number | null;
  /** Prices after the first that take effect within the term. 0 means the price never changed. */
  priceChangeCount: number;
  /** SF2's TCV of the opportunity; null when no SF2 line sold the charge. */
  tcv?: number | null;
  /** How many lines the opportunity has. Above one, its TCV also covers the other lines. */
  tcvOpportunityLines?: number | null;
  /** This line's share of the opportunity TCV, from SF2's Estimated Savings on the line; null when SF2 does not state it. */
  lineTcv?: number | null;
  /**
   * The synced SIB contract this was sold under; null when none matches its SF2 opportunity.
   * @format uuid
   */
  contractId?: string | null;
  contractName?: string | null;
  /** What NetSuite has billed on this charge so far. */
  billed: number;
  /** The billing date of the last obligation already submitted or billed. A price change must start after it. */
  lastSettledBillingDate?: string | null;
}

export interface SibInvoiceOccurrenceDto {
  /** @format uuid */
  id: string;
  /** @format uuid */
  chargeId: string;
  serviceName: string;
  periodFrom: string;
  periodTo: string;
  billingDate: string;
  /** The charge's price for this period; null when the charge states none. */
  expectedAmount: number | null;
  /** What this will actually bill. */
  amount: number;
  status: OccurrenceStatus;
  note?: string | null;
  /**
   * The SIB invoice it was billed on, once one exists.
   * @format uuid
   */
  sibInvoiceId?: string | null;
  sibInvoiceNumber?: string | null;
  /** NetSuite's invoice date -- the actual date, against billingDate's expected one. */
  sibInvoiceDate?: string | null;
  /** The NetSuite invoice's transaction id; its PDF is read from NetSuite. Null for an invoice recorded only by number. */
  sibInvoiceNetsuiteTransactionId?: string | null;
  billedAt?: string | null;
  /** @format uuid */
  serviceId: string;
  /** False while the reveal date is still in the future. */
  revealed: boolean;
  /** How many activity entries the obligation carries. */
  activityLogCount: number;
  /** The most recent entry, which a transition may have left empty. */
  latestNote?: string | null;
  /** What the most recent entry recorded, where it recorded one. */
  latestTransition?: OccurrenceTransition | null;
  /** Why the nightly NetSuite billing left this submitted obligation for a person. Null when nothing needs doing. */
  attention?: OccurrenceAttention | null;
  /** What the person needs to know, e.g. which NetSuite invoices match. */
  attentionDetail?: string | null;
  /**
   * The synced SIB contract this was sold under; null when none matches its SF2 opportunity.
   * @format uuid
   */
  contractId?: string | null;
  contractName?: string | null;
  /** NetSuite's internal id of the item this billing goes out on. */
  netsuiteItemId: string;
  /** The NetSuite item, as NetSuite names it. */
  netsuiteItemName: string;
  /**
   * The item this billing goes out on.
   * @format uuid
   */
  itemId: string;
  /** Billed through another item than its charge's. */
  itemOverridden: boolean;
}

export interface SibInvoiceOccurrenceListDto {
  /** Array of items */
  items: SibInvoiceOccurrenceDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface SibContractChargeValueDto {
  /** @format uuid */
  id: string;
  amount: number;
  /** First day this price applies. */
  effectiveFrom: string;
  /** The day after the last day this price applies: the next price takes effect, or the term ends. */
  effectiveTo: string;
  /** The price this one replaced. Null for the first price. */
  previousAmount?: number | null;
  note: string;
}

export interface CreateChargeValueDto {
  /**
   * What the charge costs from that day on.
   * @min 1
   */
  amount: number;
  /** The day the new price applies from. A future date is allowed: agreed step-ups are entered once. */
  effectiveFrom: string;
  /** Why the price changed. Required — an unexplained change is the expensive one. */
  note: string;
}

export interface UpdateChargeValueDto {
  /**
   * What the charge costs from that day on.
   * @min 1
   */
  amount?: number;
  /** The day this price starts applying. */
  effectiveFrom?: string;
  /** Why the price changed. */
  note?: string;
}

export interface AssignOrphanChargesDto {
  /**
   * The client's No service charges to assign.
   * @minItems 1
   */
  chargeIds: string[];
  /**
   * One of the client's SF2 lines: their obligations move onto it.
   * @format uuid
   */
  targetChargeId: string;
}

export interface AssignOrphanChargesResultDto {
  /** No service charges emptied onto the target. */
  assigned: number;
  /** Obligations moved with them. */
  obligations: number;
}

export interface UpdateChargeNetsuiteDto {
  /**
   * The NetSuite item this client is billed through for the service.
   * @format uuid
   */
  netsuiteItemId?: string;
  /** Left as it is when omitted; null clears it. */
  netsuiteMemo?: string | null;
}

export interface UpdateOccurrenceNetsuiteDto {
  /**
   * The item this billing goes out on; null follows its charge's.
   * @format uuid
   */
  netsuiteItemId?: string | null;
}

export interface ScheduledOccurrenceDto {
  periodFrom: string;
  periodTo: string;
  billingDate: string;
  hiddenBefore: string;
  amount: number;
}

export interface GeneratedScheduleDto {
  /** Obligations left alone: Accounting holds them, or their period has begun. */
  retained: number;
  /** Voided periods, left dropped: somebody decided the client is not billed for them. */
  dropped: number;
  /** Owed future obligations withdrawn and raised again from the current cadence and price. */
  replaced: number;
  occurrences: ScheduledOccurrenceDto[];
  /** Written only when the run is committed. */
  created: number;
}

export interface RaiseOccurrenceDto {
  /** @format uuid */
  chargeId: string;
  periodFrom: string;
  /** Last day of the period. */
  periodTo: string;
  amount?: number;
  /**
   * The NetSuite item it goes out on; the charge's when omitted.
   * @format uuid
   */
  netsuiteItemId?: string;
  /** Why this obligation exists. Required: an obligation raised outside the schedule has no other record of why the client is billed for it. */
  note: string;
}

export interface RaiseOccurrenceResultDto {
  /** @format uuid */
  id: string;
}

export interface UpdateOccurrenceAmountDto {
  /** @maxLength 500 */
  note: string;
  amount: number;
}

export interface OccurrenceActivityLogEntryDto {
  /** @format uuid */
  id: string;
  /** Absent where a transition needed no explanation and none was given. */
  note?: string | null;
  /** What moved, for a reader: amounts, periods, invoice numbers. */
  details?: object | null;
  createdAt: string;
  authorId?: string | null;
  /** Null where the system acted rather than a person. */
  authorName?: string | null;
  /** What this entry records. Absent on a note alone: somebody said something without moving anything. */
  transition?: OccurrenceTransition | null;
}

export interface NoteDto {
  /** @maxLength 500 */
  note: string;
}

export interface InvoiceFileDto {
  id: string;
  name: string;
  url: string;
  fileSize: number;
  messageDate: string;
}

export interface SibNetsuiteInvoiceDto {
  id: string;
  date: string;
  dueDate: string;
  amount: number;
  balance: number;
  status: InvoicePaymentStatus;
  /** Link to the main PDF file of the invoice */
  fileUrl: string;
  internalId: string;
  paymentUrl: string;
  /** Additional files associated with the netsuite invoice */
  files: InvoiceFileDto[];
  /**
   * The SIB invoice filed for it, whose billed lines Sidecar knows; null until the billing sync reads it.
   * @format uuid
   */
  sibInvoiceId?: string | null;
  /** Lines of the invoice no billing explains yet: each to be assigned to a line awaiting its invoice number, or given a billing of its own. */
  linesToReconcile: number;
}

export interface SibNetsuiteInvoiceListDto {
  /** Array of items */
  items: SibNetsuiteInvoiceDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface InvoiceSummaryDto {
  thirtyDays: number;
  sixtyDays: number;
  ninetyDays: number;
  overNinetyDays: number;
  total: number;
  totalUnpaidInvoices: number;
}

export interface InvoiceLineAllocationDto {
  /** @format uuid */
  occurrenceId: string;
  /** The part of the line this billing takes. */
  amount: number;
  /** The billing's SIB service, or a savings share's spend category. */
  serviceName?: string | null;
  periodFrom: string;
  periodTo: string;
  status: OccurrenceStatus;
  /** What the billing came to, from every line allocated to it. */
  billingAmount: number;
  /** The charge's price for the period. */
  expectedAmount?: number | null;
}

export interface InvoiceLineDto {
  /** @format uuid */
  id: string;
  /** A line Sidecar prepared that NetSuite has not invoiced yet. */
  draft: boolean;
  /** NetSuite's invoice number; null on a draft. */
  tranid?: string | null;
  trandate?: string | null;
  netsuiteTransactionId?: string | null;
  /**
   * The SIB invoice filed for its NetSuite invoice, once filed.
   * @format uuid
   */
  sibInvoiceId?: string | null;
  netsuiteItemId?: string | null;
  netsuiteItemName?: string | null;
  memo?: string | null;
  amount: number;
  allocations: InvoiceLineAllocationDto[];
  /** A spend-category line comes from a VSR report and can only be recorded, never edited. */
  kind: InvoiceLineKind;
  /**
   * The invoice draft a service line goes out with.
   * @format uuid
   */
  invoiceDraftId?: string | null;
  status: InvoiceLineStatus;
  /** When the line was sent for invoicing; kept once invoiced. */
  submittedAt?: string | null;
  /** Why the nightly run left this line awaiting its invoice number for a person. */
  attention?: OccurrenceAttention | null;
  attentionDetail?: string | null;
  activityLogCount: number;
}

export interface InvoiceLineListDto {
  /** Array of items */
  items: InvoiceLineDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface DraftInvoiceLineItemDto {
  /** The NetSuite item's internal id. */
  netsuiteId: string;
  name: string;
  /** The mapping links it to the billing's SF2 service. */
  mapped: boolean;
}

export interface UnassignedBillingDto {
  /** @format uuid */
  occurrenceId: string;
  serviceName?: string | null;
  periodFrom: string;
  periodTo: string;
  status: OccurrenceStatus;
  amount: number;
  /** Its charge's NetSuite item (internal id), the likeliest line for it. */
  chargeItemId?: string | null;
  chargeItemName?: string | null;
  /** Its SF2 service maps to the requested NetSuite item, or its charge is on it. */
  mapped: boolean;
  /**
   * The unsent draft it is on, which it leaves when moved.
   * @format uuid
   */
  draftLineId?: string | null;
  draftLineMemo?: string | null;
}

export interface AddDraftBillingsDto {
  /** @minItems 1 */
  occurrenceIds: string[];
}

export interface UpdateDraftInvoiceLineDto {
  /**
   * Text the NetSuite line will carry; null clears it, absent leaves it.
   * @maxLength 500
   */
  memo?: string | null;
  /** The NetSuite item (internal id) the line goes out on; absent leaves it. */
  netsuiteItemId?: string;
}

export interface InvoiceLineLogBillingDto {
  /** @format uuid */
  id: string;
  /** Its service, or a savings share's spend category. */
  name?: string | null;
  periodFrom: string;
  periodTo: string;
  amount: number;
}

export interface InvoiceLineActivityLogEntryDto {
  /** @format uuid */
  id: string;
  /** Absent where a transition needed no explanation and none was given. */
  note?: string | null;
  /** What moved, for a reader: amounts, periods, invoice numbers. */
  details?: object | null;
  createdAt: string;
  authorId?: string | null;
  /** Null where the system acted rather than a person. */
  authorName?: string | null;
  transition?: InvoiceLineTransition | null;
  /** The billings the entry added or removed; empty for any other entry. */
  billings: InvoiceLineLogBillingDto[];
}

export interface ReconcileAwaitingLineDto {
  /** @format uuid */
  id: string;
  memo?: string | null;
  netsuiteItemName?: string | null;
  amount: number;
  /** On the NetSuite line's item. */
  sameItem: boolean;
  /** The NetSuite line's amount less this line's. Nonzero is billed as one more billing, which needs a note. */
  difference: number;
}

export interface ReconcileChargeDto {
  /** @format uuid */
  id: string;
  serviceName?: string | null;
  netsuiteItemName?: string | null;
  /** On the NetSuite line's item. */
  sameItem: boolean;
}

export interface InvoiceLineReconcileOptionsDto {
  kind: InvoiceLineKind;
  awaiting: ReconcileAwaitingLineDto[];
  /** For a service line: the charges a new billing can go on. */
  charges: ReconcileChargeDto[];
  /** For a spend-category line: the category a new savings share goes in; null when its item bills none or several. */
  spendCategory?: PlainDto | null;
}

export interface ReconcileInvoiceLineDto {
  /**
   * The line awaiting its invoice number the NetSuite line invoiced.
   * @format uuid
   */
  awaitingLineId?: string;
  /**
   * A new billing on this charge, for a service line.
   * @format uuid
   */
  chargeId?: string;
  /** A new savings share in the line's spend category. */
  savingsShare?: boolean;
  /** Required for a new billing, and when an assigned line differs in amount. */
  note?: string;
}

export interface InvoiceDraftDto {
  /** @format uuid */
  id: string;
  /** Draft until sent for invoicing; awaiting its invoice number after. */
  status: InvoiceLineStatus;
  submittedAt?: string | null;
  /** What its lines not yet invoiced come to. */
  amount: number;
  /** NetSuite has invoiced part of it: it is being worked on there and can no longer be withdrawn. */
  pickedUp: boolean;
  /** Its lines NetSuite has not invoiced, as filtered. */
  lines: InvoiceLineDto[];
}

export interface OptionalNoteDto {
  /** @maxLength 500 */
  note?: string;
}

export interface MoveInvoiceLineDto {
  /**
   * The unsent invoice draft to put the line in; absent starts a new one.
   * @format uuid
   */
  invoiceDraftId?: string;
}

export interface NetsuiteInvoiceDto {
  id: string;
  date: string;
  dueDate: string;
  amount: number;
  balance: number;
  status: InvoicePaymentStatus;
  /** Link to the main PDF file of the invoice */
  fileUrl: string;
  internalId: string;
  paymentUrl: string;
  /** Additional files associated with the netsuite invoice */
  files: InvoiceFileDto[];
}

export interface NetsuiteInvoiceListDto {
  /** Array of items */
  items: NetsuiteInvoiceDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface VectorInvoiceDto {
  id: string;
  date: string;
  dueDate: string;
  amount: number;
  balance: number;
  status: InvoicePaymentStatus;
  /** Link to the main PDF file of the invoice */
  fileUrl: string;
  vendorName: string;
  locationId?: number;
  locationName?: string;
  accountNumber?: string;
}

export interface VectorInvoiceListResponseDto {
  /** Array of items */
  items: VectorInvoiceDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface CreateZipNetsuiteRequestDto {
  /**
   * Array of invoice IDs to include in the ZIP archive
   * @minItems 1
   * @uniqueItems true
   */
  invoiceIds: string[];
}

export interface FailedDownloadDocumentDto {
  url: string;
  name: string;
}

export interface CreateBillingsZipResponseDto {
  sasUrl: string;
  failedDownloads: FailedDownloadDocumentDto[];
  successDownloadsCount: number;
}

export interface CreateZipVectorRequestDto {
  /**
   * Array of invoice download urls take from vector api to include in the ZIP archive
   * @minItems 1
   */
  downloadUrls: string[];
}

export interface RevenueTotalsDto {
  savingsShare: number;
  fee: number;
  total: number;
  /** The part of the total a synced contract backs. Accomplishment against estimated TCV counts only this, so invoices for deals not in Sidecar do not inflate it. */
  earnedOnContracts: number;
  /** What the fee periods in this window come to, earned or to come, priced as the charge stood when each period opened. */
  expectedFee: number;
  /** Expected savings-share revenue in this window, from spend somebody verified in initial validation. */
  expectedContractValidated: number;
  /** The same recipe over every spend with a baseline in this window, verified or not. */
  expectedContractTotal: number;
  /** The share of estimated TCV this window covers: whole months of the contract's term, a part month counting as one. */
  estimatedTcvForWindow: number;
  /** Contract-level TCV. Salesforce's per-line figure is not replicated, so this cannot be split per service. */
  estimatedTcv?: number | null;
  /** Earned on contracts against estimated TCV, as a percentage. Absent when no estimated TCV is stated. */
  achievedPercent?: number | null;
}

export interface OrganizationRevenueDto {
  organizationId: string;
  organizationName?: string | null;
  /** A NetSuite client no organization names yet, under its NetSuite name: SF2 lacks its NetSuite id, or NetSuite its global id. Its billing moves to the organization once either names it. */
  netsuiteOnly: boolean;
  /** On a NetSuite client no organization names, where to name it: `sf2` gives its organization the client global id, `netsuite` gives the NetSuite customer one. */
  netsuiteCorrection?: NetsuiteClientCorrection | null;
  /** The id to correct it with: the client global id for `sf2`, the NetSuite customer id for `netsuite`. */
  netsuiteClientId?: string | null;
  totals: RevenueTotalsDto;
}

export interface OrganizationRevenueListDto {
  /** Array of items */
  items: OrganizationRevenueDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
  /** Every organization in the window, whatever page and filter. */
  totals: RevenueTotalsDto;
}

export interface RevenueGroupDto {
  /** Per organization, the organization id. Per service and spend category, the source id: `groupId`, or `revenueType` for one with neither. */
  id: string;
  /** Set when grouped per service and spend category. */
  revenueType?: RevenueType | null;
  /** The SIB service of a fee, or the spend category of a savings share; null for one with none. */
  groupId?: string | null;
  /** The service or spend category name. */
  name?: string | null;
  /** Set when grouped per organization. */
  organizationId?: string | null;
  organizationName?: string | null;
  /** A NetSuite client no organization names yet, under its NetSuite name: SF2 lacks its NetSuite id, or NetSuite its global id. Its billing moves to the organization once either names it. */
  netsuiteOnly: boolean;
  /** On a NetSuite client no organization names, where to name it: `sf2` gives its organization the client global id, `netsuite` gives the NetSuite customer one. */
  netsuiteCorrection?: NetsuiteClientCorrection | null;
  /** The id to correct it with: the client global id for `sf2`, the NetSuite customer id for `netsuite`. */
  netsuiteClientId?: string | null;
  /** What its obligations earned. */
  amount: number;
  /** What all its obligations in the window, earned or to come, are expected to bring. Null where none states an expectation. */
  expectedAmount?: number | null;
  /** Obligations in the window. */
  billingCount: number;
}

export interface RevenueReportDto {
  /** Array of items */
  items: RevenueGroupDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
  /** The whole window, whatever page and filter. */
  totals: RevenueTotalsDto;
}

export interface RevenueGroupListDto {
  /** Array of items */
  items: RevenueGroupDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface DeprecatedRevenueReportDto {
  totals: RevenueTotalsDto;
  /** Per SIB service and spend category; their billings load on their own. */
  groups: RevenueGroupDto[];
}

export interface RevenueBillingDto {
  /** @format uuid */
  id: string;
  revenueType: RevenueType;
  /** The spend category for a savings share, the service for a fee. */
  sourceName?: string | null;
  /** What the line is reported under: its spend category for a savings share (null when it has none), its SIB service for a fee. */
  groupName?: string | null;
  periodFrom: string;
  periodTo: string;
  /** The SIB contract behind this revenue: a savings share's own, a fee's through its charge. Null when no synced contract backs it. */
  sibContractId?: string | null;
  /** Who this revenue belongs to: the contract's sales representative, or the deal's owner. */
  createdByName?: string | null;
  createdById?: string | null;
  /** The report that argued a savings share. A fee has none: its own id is the billing row. */
  vsrReportId?: string | null;
  /** The NetSuite invoice this was billed on, once one exists. */
  sibInvoiceNumber?: string | null;
  sibInvoiceDate?: string | null;
  /**
   * The SIB invoice this was billed on, once one exists.
   * @format uuid
   */
  sibInvoiceId?: string | null;
  /** The NetSuite invoice's transaction id; its PDF is read from NetSuite. Null for an invoice recorded only by number. */
  sibInvoiceNetsuiteTransactionId?: string | null;
  earnedAt?: string | null;
  /** Earned: a fee once billed, a savings share once reported or billed. */
  earned: boolean;
  /** What it earned; null until it is earned. */
  amount?: number | null;
  /** What this line was expected to come to: a fee at the price its charge stood at, a savings share from the spend behind its subject. Null where nothing states an expectation. */
  expectedAmount?: number | null;
}

export interface RevenueBillingListDto {
  /** Array of items */
  items: RevenueBillingDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface SibInvoiceDetailsDto {
  /** @format uuid */
  id: string;
  /** NetSuite's reference for the invoice. */
  sibInvoiceNumber: string;
  /** @format date */
  sibInvoiceDate?: string | null;
  /** The NetSuite invoice's transaction id; its PDF is read from NetSuite. Null for an invoice recorded only by number. */
  netsuiteTransactionId?: string | null;
  /** When the invoice was filed here. */
  filedAt: string;
  /** What NetSuite invoiced: its header's amount, else its lines summed, else the billings on it. */
  total: number;
  /** The revenue this invoice billed: fee billings and savings shares. */
  billings: RevenueBillingDto[];
}

export interface NegotiationVendorCardDto {
  id: string;
  name: string;
  /** Whether this is the baseline spend vendor */
  isBaseline: boolean;
  /** Whether this vendor is still a draft. Draft attached vendors are deletable. */
  isDraft: boolean;
  baselineSpend: number;
  proposedSpend: number;
  savingsIdentified: number;
  savingsPercent: number;
  approvedSpendItemCount: number;
  spendItemCount: number;
}

export interface NegotiationSummaryDto {
  baselineSpend: number;
  proposedSpend: number;
  savingsIdentified: number;
  savingsPercent: number;
  spendItemCount: number;
  approvedCount: number;
  /** Audit spend rows the client has approved. */
  clientApprovedCount: number;
  /** Count of audit spend rows that do not yet have a negotiated (proposed) spend. */
  itemsWithoutProposedSpendCount: number;
  baselineVendor?: NegotiationVendorCardDto | null;
  proposedVendor?: NegotiationVendorCardDto | null;
}

export interface NegotiationContinueDto {
  approvedCount: number;
  spendItemCount: number;
  /** Count of approved audit spend rows that still have no negotiated (proposed) spend. */
  approvedItemsWithoutProposedSpendCount: number;
  /** Count of audit spend rows where proposed spend exceeds baseline (negative savings). */
  itemsWithNegativeSavingsCount: number;
  savingsPercent: number;
}

export interface NegotiationSpendDetailsDto {
  /** @format uuid */
  id: string;
  pricingModel: SpendPricingModel;
  quantityType?: SpendQuantityType | null;
  unit?: string | null;
  quantity?: number | null;
  pricePerUnit?: number | null;
  /** Percentage POINTS (7.5 = 7.5%). Set only on a percentage rate spend. */
  percentageRate?: number | null;
  /** The charges this fee is a percentage of. Empty for every other pricing model. */
  percentageBasisMembers: PercentageBasisCandidateDto[];
  minimumFee?: number | null;
  minimumFeeNote?: string | null;
  taxable?: boolean | null;
  indexRate?: string | null;
  tierType?: SpendTierType | null;
  tierValue?: string | null;
  totalValue: number;
}

export interface NegotiationSpendItemDto {
  /** @format uuid */
  id: string;
  /** @format uuid */
  auditSpendId: string;
  /** @format uuid */
  spendId: string;
  name: string;
  baselineSpend: NegotiationSpendDetailsDto;
  negotiatedSpend?: NegotiationSpendDetailsDto | null;
  savingsIdentified: number;
  status: NegotiationSpendStatus;
  /** Whether the underlying spend recurs. An unset one reads as one-time. */
  type: OccurrenceType;
  /** How often it recurs; absent when the type is one-time. */
  frequency?: OccurrenceFrequency | null;
  /** Vendor-side approval from the Negotiations – vendor substage. Filter on it to list only the items the client stage presents. */
  approved: boolean;
  /** Client-side status shown in the Negotiations – client table. */
  clientStatus: AuditSpendClientStatus;
  /** Client-side approval toggle. */
  clientApproved: boolean;
  /** Savings the client actually agreed to, captured at approval. May diverge from `savingsIdentified` if the baseline moved afterwards. */
  clientApprovedSavings?: number | null;
  /** Baseline spend captured alongside `clientApprovedSavings`. */
  clientApprovedBaseline?: number | null;
  vendor?: PlainDto | null;
  locationName?: string | null;
  vendorAccountNumber: string;
  notesCount: number;
}

export interface NegotiationSpendListDto {
  /** Array of items */
  items: NegotiationSpendItemDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface BulkSetNegotiationSpendApprovalDto {
  /** When true, approve spends; when false, revoke approval. */
  approved: boolean;
  /**
   * When omitted, all audit spends matching the approval state on the audit are updated. Values are audit_spend ids.
   * @uniqueItems true
   */
  auditSpendIds?: string[];
  /** Required when approving with zero savings (proposed equals baseline). */
  acknowledgeNoSavings?: boolean;
}

export interface BulkNegotiationResultDto {
  successfullyUpdated: number;
}

export interface BulkSetNegotiationClientStatusDto {
  status: AuditSpendClientStatus;
  /** Required to move a client-approved item away from `accepted`. Doing so also revokes the client approval. */
  acknowledgeApprovalRevoke?: boolean;
  /**
   * When omitted, every audit spend on the audit is updated. Values are audit_spend ids.
   * @uniqueItems true
   */
  auditSpendIds?: string[];
}

export interface BulkSetNegotiationClientApprovalDto {
  /** When true, record the client approval; when false, revoke it. Approving forces the item status to `accepted`. */
  approved: boolean;
  /**
   * When omitted, all audit spends matching the approval state on the audit are updated. Values are audit_spend ids.
   * @uniqueItems true
   */
  auditSpendIds?: string[];
}

export interface UpsertNegotiatedSpendDto {
  /** @default "usage_based" */
  pricingModel?: SpendPricingModel;
  /** Ignored when the baseline has the same pricing model: SIB negotiates price, never quantity (SOTR-4399). Required on a usage based or fixed fee spend whose baseline has another model. */
  quantityType?: SpendQuantityType | null;
  /** Ignored when the baseline has the same pricing model: SIB negotiates price, never quantity (SOTR-4399). Required on a usage based or fixed fee spend whose baseline has another model. */
  unit?: string | null;
  /**
   * Ignored when the baseline has the same pricing model: SIB negotiates price, never quantity (SOTR-4399). Required on a usage based or fixed fee spend whose baseline has another model.
   * @min 0
   */
  quantity?: number;
  /**
   * Required on a usage based or fixed fee spend, and forbidden on a percentage rate one.
   * @min 0
   */
  pricePerUnit?: number;
  /** Percentage POINTS (7.5 = 7.5%), stored at four decimal places. Required for a percentage rate spend, and forbidden on any other model. */
  percentageRate?: number;
  /** @min 0 */
  minimumFee?: number | null;
  minimumFeeNote?: string | null;
  taxable?: boolean | null;
  indexRate?: string | null;
  /** Usage based only, like indexRate. */
  tierType?: SpendTierType | null;
  tierValue?: string | null;
  /**
   * The charges this negotiated fee is a percentage of: any current charge of the audit at its location and on its bill stream, other fees included. A baseline spend id is stored as its negotiated spend once it has one. Omit to keep the current set (a new fee starts with the baseline's), send an empty array to detach everything.
   * @uniqueItems true
   */
  percentageBasisMemberIds?: string[];
}

export interface SetNegotiationSpendApprovalDto {
  /** When true, approve the spend; when false, revoke approval. */
  approved: boolean;
  /** Required when approving with zero savings (proposed equals baseline). */
  acknowledgeNoSavings?: boolean;
}

export interface SetNegotiationClientStatusDto {
  status: AuditSpendClientStatus;
  /** Required to move a client-approved item away from `accepted`. Doing so also revokes the client approval. */
  acknowledgeApprovalRevoke?: boolean;
}

export interface SetNegotiationClientApprovalDto {
  /** When true, record the client approval; when false, revoke it. Approving forces the item status to `accepted`. */
  approved: boolean;
}

export interface NegotiationItemDto {
  /** @format uuid */
  id: string;
  vendor: PlainDto;
  startedAt?: string | null;
  closedAt?: string | null;
  notes?: string | null;
  /** @format uuid */
  vendorContractId?: string | null;
}

export interface CreateNegotiationDto {
  /** Vendor for this negotiation path. Must be the baseline vendor or the proposed vendor. Vendor ids are varchar (UUID or Salesforce id). */
  vendorId: string;
  notes?: string | null;
  /** @format uuid */
  vendorContractId?: string | null;
}

export interface CreateProposedVendorDto {
  name: string;
  /**
   * IDs of spend categories to associate with this vendor (Payload `spend_category` id).
   * @minItems 1
   * @uniqueItems true
   */
  spendCategoryIds: string[];
  portalUrl?: string;
  websiteUrl?: string;
  note?: string;
  /**
   * ID of the external user to assign as vendor assignee.
   * @format uuid
   */
  assigneeId?: string | null;
}

export interface SavingsSourceDto {
  /** @format uuid */
  id: string;
  name: string;
}

export interface SetAuditSavingsSourceDto {
  /** @format uuid */
  savingsSourceId: string;
}

export interface AttachProposedVendorDto {
  /** Existing vendor id to use as the proposed vendor path. Mutually exclusive with newVendor. Vendor ids are varchar (UUID or Salesforce id). */
  vendorId?: string;
  /** Inline payload to create a draft vendor scoped to this audit. Mutually exclusive with vendorId. */
  newVendor?: CreateProposedVendorDto;
  /** Optional notes stored on the contract negotiation. */
  notes?: object | null;
}

export interface NegotiationAvailableVendorItemDto {
  id: string;
  name: string;
  /** Spend categories from `vendor_spend_category` → `spend_category`. */
  spendCategories: SpendCategoryListItemDto[];
  /** Spend area names from linked `spend_category` → `spend_area`. */
  spendAreas: string[];
  /** Vendor lifecycle status from the `vendor_status` column. */
  status: VendorStatus;
  /** ISO 8601 */
  lastUpdated: string;
  summary: VendorDetailSummaryDto;
  /** Whether this vendor is still a draft. */
  isDraft: boolean;
  /** Whether this vendor is the proposed vendor currently attached to the audit. */
  isAttached: boolean;
}

export interface NegotiationAvailableVendorListDto {
  /** Array of items */
  items: NegotiationAvailableVendorItemDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface RemoveProposedVendorResultDto {
  removed: boolean;
}

export interface DeleteAuditScopedVendorResultDto {
  deleted: boolean;
}

export interface PercentageBasisTotalDto {
  /** Sum of the selected charges. */
  subtotal: number;
  /** percentageRate of the subtotal. */
  total: number;
}

export interface AttachableInvoiceDto {
  /** @format uuid */
  id: string;
  /** Empty while the bill was keyed in without a file. */
  fileName: string;
  /** @format date-time */
  issueDate?: string | null;
  status: InvoiceStatus;
  /** @format uuid */
  invoiceTemplateId?: string | null;
  /** Name of the bill stream this invoice is filed under. */
  invoiceTemplateName?: string | null;
}

export interface InitialValidationSpendItemDto {
  /** @format uuid */
  id: string;
  /** @format uuid */
  auditSpendId: string;
  /** @format uuid */
  spendId: string;
  name: string;
  baselineSpend: NegotiationSpendDetailsDto;
  negotiatedSpend?: NegotiationSpendDetailsDto | null;
  savingsIdentified: number;
  status: NegotiationSpendStatus;
  /** Whether the underlying spend recurs. An unset one reads as one-time. */
  type: OccurrenceType;
  /** How often it recurs; absent when the type is one-time. */
  frequency?: OccurrenceFrequency | null;
  /** Vendor-side approval from the Negotiations – vendor substage. Filter on it to list only the items the client stage presents. */
  approved: boolean;
  /** Client-side status shown in the Negotiations – client table. */
  clientStatus: AuditSpendClientStatus;
  /** Client-side approval toggle. */
  clientApproved: boolean;
  /** Savings the client actually agreed to, captured at approval. May diverge from `savingsIdentified` if the baseline moved afterwards. */
  clientApprovedSavings?: number | null;
  /** Baseline spend captured alongside `clientApprovedSavings`. */
  clientApprovedBaseline?: number | null;
  vendor?: PlainDto | null;
  locationName?: string | null;
  vendorAccountNumber: string;
  notesCount: number;
  vendorAccountName: string;
  /** @format uuid */
  vendorAccountId: string;
  /** @format uuid */
  locationId?: string | null;
  /**
   * The bill the charge was first validated against; the validated values below are read from its line. Null is the invoiceless line.
   * @format uuid
   */
  firstValidationInvoiceId?: string | null;
  /** The bill of `firstValidationInvoiceId`; null with the invoiceless line. */
  firstValidationInvoice?: AttachableInvoiceDto | null;
  /**
   * Start of the savings window, entered by the user; null until then, validated or not.
   * @format date
   */
  startDate?: string | null;
  /**
   * End of the savings window, derived from the start and the audit contract's term; null while open.
   * @format date
   */
  endDate?: string | null;
  /** What the employee decided on the spend`s line item. */
  validationStatus?: SpendLineItemValidationStatus | null;
  /** Whether validated amounts were confirmed (validatedAt is set). */
  isValidated: boolean;
  /** Validated spend value minus the negotiated spend value; null when either value is missing. */
  validatedDifference?: number | null;
  /** Baseline spend minus validated spend for the bill in scope; null when validated spend is missing. Unnegotiated charges are floored at 0. */
  savings?: number | null;
  /** SIB's contingency fee on `savings`, at the audit contract's rate for the savings month; null when either is missing. */
  sibRevenue?: number | null;
  /** Validated cost / item from the spend line item. */
  validatedPricePerUnit?: number | null;
  /** Validated quantity from the spend line item. */
  validatedQuantity?: number | null;
  /** Validated unit from the spend line item. */
  validatedUnit?: string | null;
  /** Validated spend total from the spend line item (`value`). */
  validatedSpend?: number | null;
  /** Validated percentage rate (points) from the spend line item. */
  validatedPercentageRate?: number | null;
  /** Validated basis members from the spend line item; empty when not a percentage fee. */
  validatedPercentageBasisMembers: PercentageBasisCandidateDto[];
}

export interface InitialValidationSpendListDto {
  /** Array of items */
  items: InitialValidationSpendItemDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface ValidateInitialSpendDto {
  /** When true, stamp validatedAt/By; amounts may be set only while unvalidated, so sending them on an already validated line is rejected. When false, clear validatedAt/By and write any amounts sent. When omitted, only the amounts (and status) sent are written — a line that was validated is un-validated by the edit. */
  validated?: boolean;
  unit?: string | null;
  /** @min 0 */
  quantity?: number | null;
  pricePerUnit?: number | null;
  /** Percentage POINTS (7.5 = 7.5%), on a percentage fee line. Its money is resolved from the line percentage basis, so `value` stays empty. */
  percentageRate?: number | null;
  /** What the line costs on the bill, as stated rather than recomputed. */
  value?: number | null;
  /**
   * The billed lines this fee is a percentage of. Counts as an amount change, so it is refused on an already-validated line.
   * @uniqueItems true
   */
  percentageBasisMemberIds?: string[];
  /** User decision only. Written only when provided — never defaulted or derived. */
  status?: SpendLineItemValidationStatus;
  /**
   * The bill to validate the charge against. Omitted: the bill it was first validated against, else the newest bill (by issue date) filed under its validation group. Validating with no bill to attach is rejected.
   * @format uuid
   */
  invoiceId?: string;
}

export interface InitialValidationResultDto {
  /** @format uuid */
  auditSpendId: string;
  /**
   * The negotiated spend behind the audit spend.
   * @format uuid
   */
  spendId: string;
  /**
   * The bill the charge was validated against; null on the invoiceless line.
   * @format uuid
   */
  invoiceId?: string | null;
  validationStatus?: SpendLineItemValidationStatus | null;
  isValidated: boolean;
  validatedPricePerUnit?: number | null;
  validatedQuantity?: number | null;
  validatedUnit?: string | null;
  validatedSpend?: number | null;
  /** Validated percentage POINTS (7.5 = 7.5%) on a percentage fee. */
  validatedPercentageRate?: number | null;
  /** The billed lines this fee is a percentage of; empty when not a percentage fee. */
  validatedPercentageBasisMembers: PercentageBasisCandidateDto[];
}

export interface AttachableInvoiceListDto {
  items: AttachableInvoiceDto[];
}

export interface AttachInitialSpendInvoiceDto {
  /**
   * A bill filed under the validation group of this charge.
   * @format uuid
   */
  invoiceId: string;
}

export interface AttachInitialSpendInvoiceResultDto {
  /** @format uuid */
  auditSpendId: string;
  /** @format uuid */
  invoiceId: string;
  /** @format uuid */
  spendLineItemId: string;
}

export interface SetSavingsDatesDto {
  /**
   * When the savings window opens — usually the vendor bill date, earlier when the bill carries credits for a prior month. Validating never sets it. Send null to clear it.
   * @format date
   */
  startDate: string | null;
}

export interface SavingsDatesResultDto {
  /** @format uuid */
  auditSpendId: string;
  /**
   * The negotiated spend of the charge, when it has one.
   * @format uuid
   */
  spendId?: object | null;
  /** @format date */
  startDate?: string | null;
  /**
   * Derived, never set: the last day of the month before start + the audit contract's term. Null without a start or a term.
   * @format date
   */
  endDate?: string | null;
}

export interface BulkSetSavingsDatesDto {
  /**
   * When the savings window opens — usually the vendor bill date, earlier when the bill carries credits for a prior month. Validating never sets it. Send null to clear it.
   * @format date
   */
  startDate: string | null;
  /**
   * Audit spend ids on this audit, all given the same start.
   * @maxItems 500
   * @minItems 1
   * @uniqueItems true
   */
  auditSpendIds: string[];
}

export interface BulkSavingsDatesResultDto {
  items: SavingsDatesResultDto[];
}

export interface BulkValidateSpendsDto {
  /**
   * Audit spend ids on this audit. Each one is validated through its negotiated spend — initial validation works per charge, not per invoice line.
   * @maxItems 500
   * @minItems 1
   * @uniqueItems true
   */
  auditSpendIds: string[];
  /** When true, stamp validatedAt/By (and write status when provided). When false, clear validatedAt/By only — amounts and status are left as they are unless status is sent. */
  validated: boolean;
  /** User decision only. Written only when provided — never defaulted. Ignored when omitted. */
  status?: SpendLineItemValidationStatus;
}

export interface BulkValidateSpendsResultDto {
  /** How many spend_line_item rows were updated. */
  successfullyValidated: number;
}

export interface SpendRoundItemDto {
  /** @format uuid */
  id: string;
  /** @format uuid */
  auditSpendId: string;
  /** @format uuid */
  spendId: string;
  name: string;
  baselineSpend: NegotiationSpendDetailsDto;
  negotiatedSpend?: NegotiationSpendDetailsDto | null;
  savingsIdentified: number;
  status: NegotiationSpendStatus;
  /** Whether the underlying spend recurs. An unset one reads as one-time. */
  type: OccurrenceType;
  /** How often it recurs; absent when the type is one-time. */
  frequency?: OccurrenceFrequency | null;
  /** Vendor-side approval from the Negotiations – vendor substage. Filter on it to list only the items the client stage presents. */
  approved: boolean;
  /** Client-side status shown in the Negotiations – client table. */
  clientStatus: AuditSpendClientStatus;
  /** Client-side approval toggle. */
  clientApproved: boolean;
  /** Savings the client actually agreed to, captured at approval. May diverge from `savingsIdentified` if the baseline moved afterwards. */
  clientApprovedSavings?: number | null;
  /** Baseline spend captured alongside `clientApprovedSavings`. */
  clientApprovedBaseline?: number | null;
  vendor?: PlainDto | null;
  locationName?: string | null;
  vendorAccountNumber: string;
  notesCount: number;
  vendorAccountName: string;
  /** @format uuid */
  vendorAccountId: string;
  /** @format uuid */
  locationId?: string | null;
  /**
   * The bill the charge was first validated against; the validated values below are read from its line. Null is the invoiceless line.
   * @format uuid
   */
  firstValidationInvoiceId?: string | null;
  /** The bill of `firstValidationInvoiceId`; null with the invoiceless line. */
  firstValidationInvoice?: AttachableInvoiceDto | null;
  /**
   * Start of the savings window, entered by the user; null until then, validated or not.
   * @format date
   */
  startDate?: string | null;
  /**
   * End of the savings window, derived from the start and the audit contract's term; null while open.
   * @format date
   */
  endDate?: string | null;
  /** What the employee decided on the spend`s line item. */
  validationStatus?: SpendLineItemValidationStatus | null;
  /** Whether validated amounts were confirmed (validatedAt is set). */
  isValidated: boolean;
  /** Validated spend value minus the negotiated spend value; null when either value is missing. */
  validatedDifference?: number | null;
  /** Baseline spend minus validated spend for the bill in scope; null when validated spend is missing. Unnegotiated charges are floored at 0. */
  savings?: number | null;
  /** SIB's contingency fee on `savings`, at the audit contract's rate for the savings month; null when either is missing. */
  sibRevenue?: number | null;
  /** Validated cost / item from the spend line item. */
  validatedPricePerUnit?: number | null;
  /** Validated quantity from the spend line item. */
  validatedQuantity?: number | null;
  /** Validated unit from the spend line item. */
  validatedUnit?: string | null;
  /** Validated spend total from the spend line item (`value`). */
  validatedSpend?: number | null;
  /** Validated percentage rate (points) from the spend line item. */
  validatedPercentageRate?: number | null;
  /** Validated basis members from the spend line item; empty when not a percentage fee. */
  validatedPercentageBasisMembers: PercentageBasisCandidateDto[];
  /**
   * Null for a charge keyed in outside an audit.
   * @format uuid
   */
  auditId?: string | null;
  auditName?: string | null;
  /** @format uuid */
  groupId: string;
  /** @format uuid */
  periodId: string;
  /**
   * Issue date of the bill on this period.
   * @format date-time
   */
  issueDate?: string | null;
  /**
   * The bill on this period.
   * @format uuid
   */
  invoiceId: string;
  /**
   * The line recording this round; null while nothing was keyed in.
   * @format uuid
   */
  spendLineItemId?: string | null;
  /** @format date-time */
  validatedAt?: string | null;
  /** The charge does not appear on this bill. Kept out of savings entirely. */
  hidden: boolean;
  /** The charge is on this bill, but the client is not billed for it. */
  excludedFromSavings: boolean;
  /** A locked or sent VSR report closed this bill: the round can no longer be validated, flagged or keyed in. Rounds on a draft report stay editable. */
  locked: boolean;
}

export interface SpendRoundListDto {
  /** Array of items */
  items: SpendRoundItemDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface ValidateSpendRoundDto {
  /** When true, stamp validatedAt/By; amounts may be set only while unvalidated, so sending them on an already validated line is rejected. When false, clear validatedAt/By and write any amounts sent. When omitted, only the amounts (and status) sent are written — a line that was validated is un-validated by the edit. */
  validated?: boolean;
  unit?: string | null;
  /** @min 0 */
  quantity?: number | null;
  pricePerUnit?: number | null;
  /** Percentage POINTS (7.5 = 7.5%), on a percentage fee line. Its money is resolved from the line percentage basis, so `value` stays empty. */
  percentageRate?: number | null;
  /** What the line costs on the bill, as stated rather than recomputed. */
  value?: number | null;
  /**
   * The billed lines this fee is a percentage of. Counts as an amount change, so it is refused on an already-validated line.
   * @uniqueItems true
   */
  percentageBasisMemberIds?: string[];
  /** User decision only. Written only when provided — never defaulted or derived. */
  status?: SpendLineItemValidationStatus;
  /**
   * The period the round belongs to.
   * @format uuid
   */
  periodId: string;
}

export interface SpendRoundValidationResultDto {
  /** @format uuid */
  auditSpendId: string;
  /**
   * The negotiated spend behind the audit spend.
   * @format uuid
   */
  spendId: string;
  /**
   * The bill the charge was validated against; null on the invoiceless line.
   * @format uuid
   */
  invoiceId?: string | null;
  validationStatus?: SpendLineItemValidationStatus | null;
  isValidated: boolean;
  validatedPricePerUnit?: number | null;
  validatedQuantity?: number | null;
  validatedUnit?: string | null;
  validatedSpend?: number | null;
  /** Validated percentage POINTS (7.5 = 7.5%) on a percentage fee. */
  validatedPercentageRate?: number | null;
  /** The billed lines this fee is a percentage of; empty when not a percentage fee. */
  validatedPercentageBasisMembers: PercentageBasisCandidateDto[];
  /** @format uuid */
  spendLineItemId: string;
}

export interface SetSpendRoundFlagsDto {
  /** The charge does not appear on this bill. Kept out of savings entirely. */
  hidden?: boolean;
  /** The charge is on this bill, but the client is not billed for it. */
  excludedFromSavings?: boolean;
  /**
   * The period the round belongs to.
   * @format uuid
   */
  periodId: string;
}

export interface SpendRoundFlagsResultDto {
  /** @format uuid */
  auditSpendId: string;
  /** @format uuid */
  invoiceId: string;
  /** @format uuid */
  spendLineItemId: string;
  hidden: boolean;
  excludedFromSavings: boolean;
}

export interface SpendRoundValidationTargetDto {
  /** @format uuid */
  auditSpendId: string;
  /**
   * The bill this round validates.
   * @format uuid
   */
  invoiceId: string;
}

export interface BulkValidateSpendRoundsDto {
  /**
   * @maxItems 500
   * @minItems 1
   */
  targets: SpendRoundValidationTargetDto[];
  /** When true, stamp validatedAt/By (and write status when provided), first filling every target line that is unvalidated, not hidden and has no amount keyed in: from the charge's latest validated, non-hidden line on an earlier bill, else from the negotiated (approved) rate in force on this bill. Lines with keyed-in amounts keep them. When false, clear validatedAt/By only — amounts and status are left as they are unless status is sent. */
  validated: boolean;
  /** User decision only. Written only when provided — never defaulted. Ignored when omitted. */
  status?: SpendLineItemValidationStatus;
}

export interface CreateSpendLineItemInlineDto {
  /** @format uuid */
  invoiceId: string;
  unit?: string | null;
  /** @min 0 */
  quantity?: number | null;
  /** Not sent when the line states percentageRate. */
  pricePerUnit: number;
  /** Percentage POINTS (7.5 = 7.5%). Required instead of pricePerUnit on a percentage rate charge. */
  percentageRate?: number;
  /**
   * Billed lines on the same bill this fee is a percentage of.
   * @uniqueItems true
   */
  percentageBasisMemberIds?: string[];
  value?: number | null;
}

export interface CreateSpendDto {
  /**
   * The account this charge is billed on. With the subject location it names the validation group the charge belongs to.
   * @format uuid
   */
  vendorAccountId: string;
  /**
   * The service at one location. The charge is linked to it with a full allocation share.
   * @format uuid
   */
  optimizationSubjectId: string;
  /** @format uuid */
  vendorContractId?: string | null;
  initiator: SpendInitiator;
  occurrenceInterval: OccurrenceInterval;
  /** How often the bill stream issues an invoice. Distinct from occurrenceInterval, which is how often this charge recurs. */
  billingInterval?: BillingInterval;
  /**
   * Fixed at creation; it cannot be changed afterwards.
   * @default "usage_based"
   */
  pricingModel?: SpendPricingModel;
  /** Omit for a regular charge. Fixed at creation. */
  kind?: SpendKind | null;
  quantityType?: SpendQuantityType | null;
  unit?: string | null;
  /**
   * Always 1 on a fixed fee; none on a percentage rate charge.
   * @min 0
   */
  quantity?: number | null;
  /** Not sent on a percentage rate charge. */
  pricePerUnit: number;
  /** Percentage POINTS (7.5 = 7.5%). Required for a percentage rate charge, and forbidden on any other model. */
  percentageRate?: number;
  /**
   * Charges this fee is a percentage of. Only on a percentage rate charge; every id must be another charge on the same bill stream. A member may itself be a fee, as long as no cycle forms and no chain exceeds 8 fee levels.
   * @uniqueItems true
   */
  percentageBasisMemberIds?: string[];
  /** @min 0 */
  minimumFee?: number | null;
  minimumFeeNote?: string | null;
  indexRate?: string | null;
  tierType?: SpendTierType | null;
  tierValue?: string | null;
  taxable?: boolean | null;
  /**
   * The charge this one was optimized from.
   * @format uuid
   */
  baselineSpendId?: string | null;
  /**
   * The audit this charge is keyed in for. Omit when entering data outside an audit.
   * @format uuid
   */
  auditId?: string | null;
  /** When supplied, the charge is also written as a line on this bill. */
  lineItem?: CreateSpendLineItemInlineDto;
}

export interface SpendOptimizationSubjectDto {
  id: string;
}

export interface SpendVendorAccountDto {
  id: string;
}

export interface SpendVendorContractDto {
  id: string;
}

export interface SpendItemDto {
  id: string;
  optimizationSubject: SpendOptimizationSubjectDto;
  vendorAccount?: SpendVendorAccountDto | null;
  vendorContract?: SpendVendorContractDto | null;
  initiator: SpendInitiator;
  pricingModel: SpendPricingModel;
  /** NULL on a regular charge. */
  kind?: SpendKind | null;
  unit?: string | null;
  quantity?: number | null;
  pricePerUnit?: number | null;
  /** Percentage POINTS (7.5 = 7.5%), on a percentage rate charge. */
  percentageRate?: number | null;
  baselineSpend?: string | null;
  occurrenceInterval: OccurrenceInterval;
}

export interface ValidationSpendGroupPeriodVendorAccountDto {
  /** @format uuid */
  id: string;
  accountNumber?: string | null;
  name?: string | null;
}

export interface ValidationSpendGroupPeriodLocationDto {
  /** @format uuid */
  id: string;
  name?: string | null;
}

export interface ValidationSpendGroupPeriodGroupDto {
  /** @format uuid */
  id: string;
  vendorAccount: ValidationSpendGroupPeriodVendorAccountDto;
  location: ValidationSpendGroupPeriodLocationDto;
}

export interface ValidationSpendGroupPeriodDto {
  /** @format uuid */
  id: string;
  group: ValidationSpendGroupPeriodGroupDto;
  /**
   * The bill this period was read from.
   * @format uuid
   */
  invoice: string;
  /**
   * The spend category of the bill.
   * @format uuid
   */
  spendCategoryId: string | null;
  /** Audits of the spend lines on the bill for the group's vendor account. Filter with `in` (e.g. `filter=auditIds:in:["uuid"]`). */
  auditIds: string[];
  issueDate: string;
  validationStatus?: SpendLineItemValidationStatus | null;
  validatedAt?: string | null;
  validatedBy?: PlainExternalUserDto | null;
  /** True when this bill is omitted from validation. Derived from omittedValidationReason. */
  omitted: boolean;
  /** Reason for omitted validation. Set: every line of this bill period stays on the VSR at $0.00 savings with the reason. */
  omittedValidationReason: string | null;
  /** A locked or sent VSR report closed this bill: the period and its spend items can no longer be validated, flagged or keyed in. Bills on a draft report stay editable. */
  locked: boolean;
  spendItemsCount: number;
  /** How many spend items in the group are validated on this bill. */
  validatedSpendItemsCount: number;
  /** Sum of line amounts on this bill, validated or not. Missing amounts count as 0. */
  totalValidatedSpend: number;
  /** Sum of baseline spend on this bill from `audit_spend_period_pricing` (`oldTotal`, else `oldCost`), weighted by subject share. */
  totalBaselinesSpend: number;
  /** Sum of baseline spend of items not yet validated on this bill. */
  totalUnvalidatedBaselinesSpend: number;
  /** Sum of savings on this bill from the period-pricing view (`savings` per line). */
  totalSavings: number;
  /** SIB's contingency fee on `totalSavings`: each line's savings at the audit contract's rate for its savings month (`fee` per line). */
  totalSibRevenue: number;
  /** Notes on this period, from any audit. */
  notesCount: number;
}

export interface ValidationSpendGroupPeriodListDto {
  /** Array of items */
  items: ValidationSpendGroupPeriodDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface ValidateValidationSpendGroupPeriodDto {
  /** When true, marks the period validated. When false, clears the period flag. Lines keep their own validation either way. */
  validated: boolean;
  /** Written on the period when given. */
  status?: SpendLineItemValidationStatus;
}

export interface OmitValidationSpendGroupPeriodDto {
  /** When true, omits this bill from validation; omittedValidationReason is required. When false, the reason is cleared. */
  omitted: boolean;
  /**
   * Required when omitted is true. Ignored when false.
   * @maxLength 1000
   */
  omittedValidationReason?: string;
}

export interface ValidationSpendGroupNoteDto {
  /** @format uuid */
  id: string;
  body: string;
  /**
   * The validation period the note is on; null for a group-wide note.
   * @format uuid
   */
  periodId?: string | null;
  /**
   * The audit the note was written while reviewing.
   * @format uuid
   */
  auditId?: string | null;
  auditName?: string | null;
  /** Stage of the audit when the note was written; null outside an audit. */
  auditStage?: AuditStage | null;
  createdBy: PlainExternalUserDto;
  createdAt: string;
  /** True when the requesting user authored the note. */
  canDelete: boolean;
}

export interface ValidationSpendGroupNoteListDto {
  /** Array of items */
  items: ValidationSpendGroupNoteDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface CreateValidationSpendGroupPeriodNoteDto {
  /**
   * The audit being reviewed while writing this note. Omit for a note written outside an audit.
   * @format uuid
   */
  auditId?: string | null;
  /** @maxLength 4000 */
  body: string;
}

export interface CreateValidationSpendGroupNoteDto {
  /**
   * The audit being reviewed while writing this note. Omit for a note written outside an audit.
   * @format uuid
   */
  auditId?: string | null;
  /**
   * A validation period of this group to pin the note to. Omit for a group-wide note.
   * @format uuid
   */
  periodId?: string | null;
  /** @maxLength 4000 */
  body: string;
}

export interface AuditSpendNoteDto {
  /** @format uuid */
  id: string;
  value: string;
  /**
   * The bill on screen when the note was written.
   * @format uuid
   */
  invoiceId?: string | null;
  /** Stage of the audit when the note was written; null outside an audit. */
  auditStage?: AuditStage | null;
  createdBy: PlainExternalUserDto;
  createdAt: string;
  /** True when the requesting user authored the note on the current audit stage. */
  canDelete: boolean;
}

export interface AuditSpendNoteListDto {
  /** Array of items */
  items: AuditSpendNoteDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface CreateAuditSpendNoteDto {
  value: string;
  /**
   * The bill the note is written on (the round being viewed); the charge must have a line on it. Defaults to the bill the charge was first validated against.
   * @format uuid
   */
  invoiceId?: string;
}

export interface DataEntryInvoiceDto {
  id: string;
  fileName: string;
  fileUrl?: string | null;
  /**
   * Id of the document this invoice is backed by.
   * @format uuid
   */
  documentId?: string | null;
  /**
   * The bill stream this invoice belongs to.
   * @format uuid
   */
  invoiceTemplateId?: string | null;
  issueDate?: string | null;
  /** When the file was uploaded. */
  uploadDate: string;
  status: InvoiceStatus;
  internal: boolean;
  /** Account numbers of every vendor account on this bill stream. */
  vendorAccountNumbers: string[];
  /** Locations assigned to this bill stream. */
  attachedLocationsCount: number;
  /** Distinct locations served by the attached vendor accounts — the size of the set this invoice may assign from. */
  totalVendorAccountLocations: number;
  createdBy?: string | null;
  updatedBy?: string | null;
}

export interface DataEntryInvoiceListDto {
  /** Array of items */
  items: DataEntryInvoiceDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface InvoiceDocumentPickerItemDto {
  id: string;
  stage: DocumentStage;
  fileUrl: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  name: string;
  sensitive: boolean;
  internal: boolean;
  providedBy: DocumentProvidedBy;
  uploadedBy: PlainExternalUserDto;
  spendCategory?: SpendCategoryListItemDto | null;
  organizationId: string;
  subsidiaryOrganizationName?: string | null;
  tags: DocumentTagDto[] | null;
  uploadStage: DocumentUploadStatus;
  contractType?: ContractType | null;
  categoryManager?: CategoryManager | null;
  categoryManagerUser?: PlainExternalUserDto | null;
  paymentFrequency?: PaymentFrequency | null;
  anomaly?: boolean | null;
  matchingDocuments?: number | null;
  hasVirtualInvoices?: boolean;
  docId?: string | null;
  /** AI-managed fields explicitly edited by a user; Franz sync skips these. */
  userModifiedFields?: string[];
  /**
   * Set when Franz first updates this document; AI-managed fields become read-only for users.
   * @format date-time
   */
  updatedWithAiAt?: string | null;
  /** Whether the document already backs an invoice. */
  linkedToInvoice: boolean;
  /**
   * The invoice the document backs.
   * @format uuid
   */
  invoiceId?: string | null;
  /**
   * The invoice template (stream) of the invoice the document backs.
   * @format uuid
   */
  invoiceTemplateId?: string | null;
  vendor: string | null;
  fileSize?: number | null;
  type: string | null;
  /** @format date-time */
  startDate?: string | null;
  /** @format date-time */
  endDate?: string | null;
  /** @format date-time */
  renewalDate?: string | null;
  annualContractValue?: number | null;
  notToExceed?: boolean | null;
  annualPriceIncrease?: boolean | null;
  earlyTerminationFee?: boolean | null;
  cancellationDateNoticePeriod?: string | null;
  autoRenewalClause?: boolean | null;
  autoRenewalLength?: string | null;
  notToExceedPercentage?: number | null;
  additionalColumns?: object | null;
}

export interface InvoiceDocumentPickerListDto {
  /** Array of items */
  items: InvoiceDocumentPickerItemDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface UploadDataEntryInvoiceDto {
  /**
   * Never reaches the body — the interceptor takes the file part first.
   * @format binary
   */
  file: File;
  /**
   * An existing bill stream to file the invoice under. Omitted: a new stream is opened from `vendorAccountIds` and `locationIds`.
   * @format uuid
   */
  invoiceTemplateId?: string;
  /**
   * Spend category of a new bill stream; required when `invoiceTemplateId` is omitted. Only fills a stream that has no category yet.
   * @format uuid
   */
  spendCategoryId?: string;
  /**
   * Issue date of the bill; opens its validation period. Fixed once set.
   * @format date-time
   */
  issueDate: string;
  /** How often the bill stream issues an invoice; the rounds list derives the expected bills from it. No default. */
  billingInterval?: BillingInterval;
  /** Marks the uploaded bill as an internal-only document. */
  internal?: boolean;
  /** Defaults to "review". */
  status?: AuditInvoiceStatus;
  /**
   * Vendor account IDs of a new bill stream; at least one is required when `invoiceTemplateId` is omitted. Ignored when filing under an existing stream — accounts come from that template. Repeat the form field for multiple IDs.
   * @minItems 1
   * @uniqueItems true
   */
  vendorAccountIds?: string[];
  /**
   * Location IDs of a new bill stream. Each must be served by one of its vendor accounts. Ignored when filing under an existing stream — locations come from that template. Repeat the form field for multiple IDs.
   * @uniqueItems true
   */
  locationIds?: string[];
}

export interface AttachDataEntryInvoiceDto {
  /**
   * An existing bill stream to file the invoice under. Omitted: a new stream is opened from `vendorAccountIds` and `locationIds`.
   * @format uuid
   */
  invoiceTemplateId?: string;
  /**
   * Spend category of a new bill stream; required when `invoiceTemplateId` is omitted. Only fills a stream that has no category yet.
   * @format uuid
   */
  spendCategoryId?: string;
  /**
   * Issue date of the bill; opens its validation period. Fixed once set.
   * @format date-time
   */
  issueDate: string;
  /** How often the bill stream issues an invoice; the rounds list derives the expected bills from it. No default. */
  billingInterval?: BillingInterval;
  /** Defaults to "review". */
  status?: AuditInvoiceStatus;
  /**
   * Vendor account IDs of a new bill stream; at least one is required when `invoiceTemplateId` is omitted. Ignored when filing under an existing stream — accounts come from that template. Repeat the form field for multiple IDs.
   * @minItems 1
   * @uniqueItems true
   */
  vendorAccountIds?: string[];
  /**
   * Location IDs of a new bill stream. Each must be served by one of its vendor accounts. Ignored when filing under an existing stream — locations come from that template. Repeat the form field for multiple IDs.
   * @uniqueItems true
   */
  locationIds?: string[];
  /**
   * A document already in the organization repository, in uploaded stage and not yet backing an invoice.
   * @format uuid
   */
  documentId: string;
}

export interface CreateManualInvoiceDto {
  /**
   * An existing bill stream to file the invoice under. Omitted: a new stream is opened from `vendorAccountIds` and `locationIds`.
   * @format uuid
   */
  invoiceTemplateId?: string;
  /**
   * Spend category of a new bill stream; required when `invoiceTemplateId` is omitted. Only fills a stream that has no category yet.
   * @format uuid
   */
  spendCategoryId?: string;
  /**
   * Issue date of the bill; opens its validation period. Fixed once set.
   * @format date-time
   */
  issueDate: string;
  /** How often the bill stream issues an invoice; the rounds list derives the expected bills from it. No default. */
  billingInterval?: BillingInterval;
  /** Defaults to "review". */
  status?: AuditInvoiceStatus;
  /**
   * Vendor account IDs of a new bill stream; at least one is required when `invoiceTemplateId` is omitted. Ignored when filing under an existing stream — accounts come from that template. Repeat the form field for multiple IDs.
   * @minItems 1
   * @uniqueItems true
   */
  vendorAccountIds?: string[];
  /**
   * Location IDs of a new bill stream. Each must be served by one of its vendor accounts. Ignored when filing under an existing stream — locations come from that template. Repeat the form field for multiple IDs.
   * @uniqueItems true
   */
  locationIds?: string[];
}

export interface UploadDataEntryInvoiceDocumentDto {
  /**
   * Never reaches the body — the interceptor takes the file part first.
   * @format binary
   */
  file: File;
  /** Marks the uploaded bill as an internal-only document. */
  internal?: boolean;
}

export interface AuditInvoiceVendorAccountDto {
  id: string;
  accountNumber?: string | null;
  name?: string | null;
  /** Locations served by this vendor account. */
  locationsCount: number;
}

export interface DataEntryInvoiceDetailDto {
  id: string;
  fileName: string;
  fileUrl?: string | null;
  /**
   * Id of the document this invoice is backed by.
   * @format uuid
   */
  documentId?: string | null;
  /**
   * The bill stream this invoice belongs to.
   * @format uuid
   */
  invoiceTemplateId?: string | null;
  issueDate?: string | null;
  /** When the file was uploaded. */
  uploadDate: string;
  status: InvoiceStatus;
  internal: boolean;
  /** Account numbers of every vendor account on this bill stream. */
  vendorAccountNumbers: string[];
  /** Locations assigned to this bill stream. */
  attachedLocationsCount: number;
  /** Distinct locations served by the attached vendor accounts — the size of the set this invoice may assign from. */
  totalVendorAccountLocations: number;
  createdBy?: string | null;
  updatedBy?: string | null;
  /** Every attached vendor account, unpaginated. */
  vendorAccounts: AuditInvoiceVendorAccountDto[];
}

export interface AssignableLocationDto {
  id: string;
  name?: string | null;
  locationIdentifier?: string | null;
  address?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
  /** Whether this location is already assigned to the invoice. */
  isAttached: boolean;
}

export interface AssignableLocationListDto {
  /** Array of items */
  items: AssignableLocationDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface UpdateDataEntryInvoiceDto {
  /**
   * Accepted only on a bill that has no issue date yet; a set date is fixed.
   * @format date-time
   */
  issueDate?: string;
  /**
   * A file already in the organization repository to attach to a bill keyed in without one. Refused when the invoice already has a document.
   * @format uuid
   */
  documentId?: string;
  status?: AuditInvoiceStatus;
  /** How often the bill stream issues an invoice; the rounds list derives the expected bills from it. No default. */
  billingInterval?: BillingInterval;
  /**
   * Location IDs to attach on the bill stream. Each must be served by a vendor account on that stream.
   * @uniqueItems true
   */
  addLocations?: string[];
  /**
   * Location IDs to detach from the bill stream.
   * @uniqueItems true
   */
  removeLocations?: string[];
}

export interface UploadAuditDataEntryInvoiceDto {
  /**
   * Never reaches the body — the interceptor takes the file part first.
   * @format binary
   */
  file: File;
  /**
   * An existing bill stream to file the invoice under. Omitted: a new stream is opened from `vendorAccountIds` and `locationIds`.
   * @format uuid
   */
  invoiceTemplateId?: string;
  /**
   * Issue date of the bill; opens its validation period. Fixed once set.
   * @format date-time
   */
  issueDate: string;
  /** How often the bill stream issues an invoice; the rounds list derives the expected bills from it. No default. */
  billingInterval?: BillingInterval;
  /** Marks the uploaded bill as an internal-only document. */
  internal?: boolean;
  /** Defaults to "review". */
  status?: AuditInvoiceStatus;
  /**
   * Vendor account IDs of a new bill stream; at least one is required when `invoiceTemplateId` is omitted. Ignored when filing under an existing stream — accounts come from that template. Repeat the form field for multiple IDs.
   * @minItems 1
   * @uniqueItems true
   */
  vendorAccountIds?: string[];
  /**
   * Location IDs of a new bill stream. Each must be served by one of its vendor accounts. Ignored when filing under an existing stream — locations come from that template. Repeat the form field for multiple IDs.
   * @uniqueItems true
   */
  locationIds?: string[];
}

export interface AttachAuditDataEntryInvoiceDto {
  /**
   * An existing bill stream to file the invoice under. Omitted: a new stream is opened from `vendorAccountIds` and `locationIds`.
   * @format uuid
   */
  invoiceTemplateId?: string;
  /**
   * Issue date of the bill; opens its validation period. Fixed once set.
   * @format date-time
   */
  issueDate: string;
  /** How often the bill stream issues an invoice; the rounds list derives the expected bills from it. No default. */
  billingInterval?: BillingInterval;
  /** Defaults to "review". */
  status?: AuditInvoiceStatus;
  /**
   * Vendor account IDs of a new bill stream; at least one is required when `invoiceTemplateId` is omitted. Ignored when filing under an existing stream — accounts come from that template. Repeat the form field for multiple IDs.
   * @minItems 1
   * @uniqueItems true
   */
  vendorAccountIds?: string[];
  /**
   * Location IDs of a new bill stream. Each must be served by one of its vendor accounts. Ignored when filing under an existing stream — locations come from that template. Repeat the form field for multiple IDs.
   * @uniqueItems true
   */
  locationIds?: string[];
  /**
   * A document already in the organization repository, in uploaded stage and not yet backing an invoice.
   * @format uuid
   */
  documentId: string;
}

export interface CreateAuditManualInvoiceDto {
  /**
   * An existing bill stream to file the invoice under. Omitted: a new stream is opened from `vendorAccountIds` and `locationIds`.
   * @format uuid
   */
  invoiceTemplateId?: string;
  /**
   * Issue date of the bill; opens its validation period. Fixed once set.
   * @format date-time
   */
  issueDate: string;
  /** How often the bill stream issues an invoice; the rounds list derives the expected bills from it. No default. */
  billingInterval?: BillingInterval;
  /** Defaults to "review". */
  status?: AuditInvoiceStatus;
  /**
   * Vendor account IDs of a new bill stream; at least one is required when `invoiceTemplateId` is omitted. Ignored when filing under an existing stream — accounts come from that template. Repeat the form field for multiple IDs.
   * @minItems 1
   * @uniqueItems true
   */
  vendorAccountIds?: string[];
  /**
   * Location IDs of a new bill stream. Each must be served by one of its vendor accounts. Ignored when filing under an existing stream — locations come from that template. Repeat the form field for multiple IDs.
   * @uniqueItems true
   */
  locationIds?: string[];
}

export interface InvoiceTemplateVendorAccountDto {
  /** @format uuid */
  id: string;
  accountNumber?: string | null;
  name?: string | null;
}

export interface InvoiceTemplateLocationDto {
  /** @format uuid */
  id: string;
  name?: string | null;
}

export interface InvoiceTemplateDto {
  /** @format uuid */
  id: string;
  name?: string | null;
  /** True for a stream opened by an upload; false for one resolved from a vendor account. */
  createdFromUpload: boolean;
  /**
   * Stamped from the audit the first bill was uploaded under; null for a stream never billed inside an audit.
   * @format uuid
   */
  spendCategoryId?: string | null;
  /** The validation spend groups this stream serves — one per (vendor account, location) it names; empty while it names no vendor account. */
  validationSpendGroupIds: string[];
  /** How often the bill stream issues an invoice. */
  billingInterval?: BillingInterval | null;
  vendorAccounts: InvoiceTemplateVendorAccountDto[];
  locations: InvoiceTemplateLocationDto[];
  /** The bills issued inside the requested window, oldest first. Every bill when no window is given. */
  invoices: DataEntryInvoiceDto[];
}

export interface InvoiceTemplateListDto {
  /** Array of items */
  items: InvoiceTemplateDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface UpdateInvoiceTemplateDto {
  /** How often the bill stream issues an invoice; the rounds list derives the expected bills from it. No default. */
  billingInterval?: BillingInterval;
  /**
   * Vendor account IDs to attach to the bill stream.
   * @uniqueItems true
   */
  addVendorAccounts?: string[];
  /**
   * Vendor account IDs to detach. Locations left unserved by any remaining account are detached with them.
   * @uniqueItems true
   */
  removeVendorAccounts?: string[];
  /**
   * Location IDs to attach. Each must be served by an attached vendor account.
   * @uniqueItems true
   */
  addLocations?: string[];
  /**
   * Location IDs to detach from the bill stream.
   * @uniqueItems true
   */
  removeLocations?: string[];
  /** @maxLength 255 */
  name?: string | null;
}

export interface SpendValueListItemDto {
  /** @format uuid */
  id: string;
  /**
   * YYYY-MM-DD; the day this rate takes effect.
   * @format date
   */
  effectiveFrom: string;
  /** The agreed rate from this day on: the price per unit, or percentage POINTS (7.5 = 7.5%) on a percentage rate spend. */
  value?: number | null;
  note?: string | null;
  valueSource: SpendValueSource;
  /** Only manual breakpoints can be removed; formula and sync rows are recomputed, never deleted. */
  canDelete: boolean;
  createdBy?: PlainExternalUserDto | null;
  createdAt: string;
  /** The breakpoint in force on `activeDate` — the latest one taking effect on or before it; without `activeDate`, the latest breakpoint. Exactly one item is active. */
  isActive: boolean;
}

export interface SpendValueListDto {
  items: SpendValueListItemDto[];
}

export interface CreateSpendValueDto {
  /**
   * YYYY-MM-DD. One breakpoint per day and spend; a second one on the same day is rejected.
   * @format date
   */
  effectiveFrom: string;
  /** The rate from this day on: the price per unit, or percentage POINTS (7.5 = 7.5%) on a percentage rate spend. Everything else carries over from the breakpoint in force before it. */
  value: number;
  /** @maxLength 4000 */
  note?: string | null;
}

export interface SpendValueDto {
  /** @format uuid */
  id: string;
  /**
   * YYYY-MM-DD; the day this rate takes effect.
   * @format date
   */
  effectiveFrom: string;
  /** The agreed rate from this day on: the price per unit, or percentage POINTS (7.5 = 7.5%) on a percentage rate spend. */
  value?: number | null;
  note?: string | null;
  valueSource: SpendValueSource;
  /** Only manual breakpoints can be removed; formula and sync rows are recomputed, never deleted. */
  canDelete: boolean;
  createdBy?: PlainExternalUserDto | null;
  createdAt: string;
}

export interface ValidationSpendGroupVendorAccountDto {
  /** @format uuid */
  id: string;
  accountNumber?: string | null;
  name?: string | null;
}

export interface ValidationSpendGroupLocationDto {
  /** @format uuid */
  id: string;
  name?: string | null;
}

export interface ValidationSpendGroupPeriodTotalsDto {
  /** @format uuid */
  id: string;
  /**
   * The bill this period was read from.
   * @format uuid
   */
  invoiceId: string;
  /**
   * YYYY-MM-DD; the bill issue date.
   * @format date
   */
  issueDate?: string | null;
  /** A locked or sent VSR report closed this bill: its spend items can no longer be validated, flagged or keyed in. Bills on a draft report stay editable. */
  locked: boolean;
  spendItemsCount: number;
  /** How many spend items in the group are validated on this bill. */
  validatedSpendItemsCount: number;
  /** Sum of line amounts entered on this bill, validated or not. Missing amounts count as 0. */
  totalValidatedSpend: number;
  /** Sum of baseline spend of items on this bill, validated or not, priced at the baseline price per unit times the quantity on the bill. */
  totalBaselinesSpend: number;
  /** Sum of baseline spend of items not yet validated on this bill, priced at the baseline price per unit times the quantity on the bill. */
  totalUnvalidatedBaselinesSpend: number;
  /** Sum of (baseline − line amount) per item with an amount on this bill, validated or not. Others contribute 0. */
  totalSavings: number;
  /** Notes this audit wrote on this bill period. */
  notesCount: number;
}

export interface ValidationSpendGroupItemDto {
  /** @format uuid */
  id: string;
  vendorAccount: ValidationSpendGroupVendorAccountDto;
  location: ValidationSpendGroupLocationDto;
  spendItemsCount: number;
  /** How many spend items in the group are already validated. */
  validatedSpendItemsCount: number;
  /** Sum of line amounts entered in the group, validated or not. Missing amounts count as 0. */
  totalValidatedSpend: number;
  /** Sum of baseline spend of items in the group, validated or not, priced at the baseline price per unit times the line quantity. */
  totalBaselinesSpend: number;
  /** Sum of baseline spend of items that are not validated yet, priced at the baseline price per unit times the line quantity when one exists. */
  totalUnvalidatedBaselinesSpend: number;
  /** Sum of (baseline − line amount) per item with an amount, validated or not. Others contribute 0. */
  totalSavings: number;
  notesCount: number;
  /** The group has bills and a locked or sent VSR report closed every one of them (see `periods[].locked`). */
  locked: boolean;
  /** What the employee decided on the group as a whole; independent of its periods and lines. */
  validationStatus?: SpendLineItemValidationStatus | null;
  /** Set while the group is validated. */
  validatedAt?: string | null;
  validatedBy?: PlainExternalUserDto | null;
  /** The bill stream linked to the group; `null` until the user links one. The group cannot be validated without it. */
  invoiceTemplateId?: string | null;
  invoiceTemplateName?: string | null;
  /** The same savings and baseline totals as the group row, broken down by validation period (bill). */
  periods: ValidationSpendGroupPeriodTotalsDto[];
}

export interface ValidationSpendGroupListDto {
  /** Array of items */
  items: ValidationSpendGroupItemDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface ValidateValidationSpendGroupDto {
  /** When true, marks the group validated; the group must be linked to a bill stream with at least one bill first. When false, writes status only while the group is still unvalidated — clearing an already validated group is rejected. Its periods and lines keep their own validation either way. */
  validated: boolean;
  /** Written on the group when given. */
  status?: SpendLineItemValidationStatus;
}

export interface LinkValidationSpendGroupInvoiceTemplateDto {
  /**
   * Bill stream to serve the group; it must name the group vendor account; the group location is added to it. A linked group cannot be unlinked, only moved to another stream; a validated group only by an admin.
   * @format uuid
   */
  invoiceTemplateId: string;
}

export interface AuditLocationOptionDto {
  /** @format uuid */
  id: string;
  name?: string | null;
  /** Name, falling back to the location identifier. */
  displayName?: string | null;
  locationIdentifier?: string | null;
}

export interface AuditLocationListDto {
  /** Array of items */
  items: AuditLocationOptionDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface SibContractPeriodDto {
  /** @format uuid */
  id: string;
  /**
   * Contract ID
   * @format uuid
   */
  contract: string;
  /** Term length */
  term: number | null;
  /** Fee amount */
  fee: number | null;
  order: number;
  updatedAt: string;
  createdAt: string;
  /** Start date of the period */
  startDate: string | null;
}

export interface SibContractDto {
  /** @format uuid */
  id: string;
  /** Contract name from the database. IP-created contracts are auto-generated as SIB Contract-###### (6-digit pad, from 10000). Salesforce-synced contracts keep their SF name. */
  name: string;
  organization: string;
  status: SibContractStatus;
  /** Contingency fee percentage from the latest contract period */
  fee?: number | null;
  /** @format date-time */
  startDate?: string | null;
  /** @format date-time */
  endDate?: string | null;
  /** Contract term in months from the latest contract period */
  termMonths?: number | null;
  autoRenewal: boolean;
  /** @format date-time */
  autoRenewalDate?: string | null;
  auditsCount: number;
  totalContractValue?: number | null;
  /**
   * Latest contract file upload timestamp
   * @format date-time
   */
  uploadDate?: string | null;
  /** SAS URL of the first (oldest) contract file */
  fileUrl?: string | null;
  salesRepresentative?: PlainExternalUserDto | null;
  contractPeriods: SibContractPeriodDto[];
  updatedAt: string;
  createdAt: string;
  salesforceId: string | null;
  salesforceSalesId: string | null;
}

export interface SibContractListDto {
  /** Array of items */
  items: SibContractDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface ArchiveDocumentsResponseDto {
  sasUrl: string;
  failedDownloads: FailedDownloadDocumentDto[];
  successDownloadsCount: number;
}

export interface CreateSibContractDto {
  /**
   * Total Contract Value
   * @min 0
   */
  totalContractValue?: number | null;
  /** @default false */
  autoRenewal?: boolean;
  autoRenewalDate?: string | null;
  /** @format uuid */
  salesRepresentativeId?: string | null;
  /** Spend category IDs to link to this contract on create. */
  spendCategoryIds?: string[];
}

export interface SibContractDetailDto {
  /** @format uuid */
  id: string;
  /** Contract name from the database. IP-created contracts are auto-generated as SIB Contract-###### (6-digit pad, from 10000). Salesforce-synced contracts keep their SF name. */
  name: string;
  organization: string;
  status: SibContractStatus;
  /** Contingency fee percentage from the latest contract period */
  fee?: number | null;
  /** @format date-time */
  startDate?: string | null;
  /** @format date-time */
  endDate?: string | null;
  /** Contract term in months from the latest contract period */
  termMonths?: number | null;
  autoRenewal: boolean;
  /** @format date-time */
  autoRenewalDate?: string | null;
  auditsCount: number;
  totalContractValue?: number | null;
  /**
   * Latest contract file upload timestamp
   * @format date-time
   */
  uploadDate?: string | null;
  /** SAS URL of the first (oldest) contract file */
  fileUrl?: string | null;
  salesRepresentative?: PlainExternalUserDto | null;
  contractPeriods: SibContractPeriodDto[];
  updatedAt: string;
  createdAt: string;
  spendCategories: SpendCategoryListItemDto[];
  files: FileDto[];
  salesforceId: string | null;
  salesforceSalesId: string | null;
}

export interface UpsertSibContractPeriodItemDto {
  /**
   * Term length in months
   * @min 1
   */
  term?: number;
  /**
   * Fee percentage
   * @min 0
   * @max 100
   */
  fee?: number;
}

export interface UpdateSibContractDto {
  /**
   * Total Contract Value
   * @min 0
   */
  totalContractValue?: number | null;
  /** @default false */
  autoRenewal?: boolean;
  autoRenewalDate?: string | null;
  /** @format uuid */
  salesRepresentativeId?: string | null;
  /** Spend category IDs to link to this contract. */
  addSpendCategoryIds?: string[];
  /** Spend category IDs to unlink from this contract. */
  removeSpendCategoryIds?: string[];
  /** Sync contract periods by position among live periods sorted by order. Overlapping slots update in place; extras restore soft-deleted rows when possible, otherwise create; trailing live periods are soft-deleted. Omit to leave periods unchanged. */
  contractPeriods?: UpsertSibContractPeriodItemDto[];
}

export interface SibContractPeriodListDto {
  /** Array of items */
  items: SibContractPeriodDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface CreateSibContractPeriodDto {
  /** Start date of the period */
  startDate?: string;
  /**
   * Term length in months
   * @min 1
   */
  term?: number;
  /**
   * Fee percentage
   * @min 0
   * @max 100
   */
  fee?: number;
  /**
   * Order/sequence number (cannot be negative). Defaults to the next available order for the contract.
   * @min 0
   */
  order?: number;
}

export interface UpdateSibContractPeriodDto {
  /** Start date of the period */
  startDate?: string;
  /**
   * Term length in months
   * @min 1
   */
  term?: number;
  /**
   * Fee percentage
   * @min 0
   * @max 100
   */
  fee?: number;
  /**
   * Order/sequence number (cannot be negative). Defaults to the next available order for the contract.
   * @min 0
   */
  order?: number;
}

export interface SibContractSpendCategoryDto {
  /**
   * Linked spend category identifier
   * @format uuid
   */
  id: string;
  name: string;
}

export interface SibContractSpendCategoryListDto {
  /** Array of items */
  items: SibContractSpendCategoryDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface CreateSibContractSpendCategoryDto {
  /** @format uuid */
  spendCategoryId: string;
}

export interface FileListDto {
  /** Array of items */
  items: FileDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface GlobalSearchItemDto {
  /** Identifier of the matched entity */
  id: string;
  /** Module the entity belongs to */
  module: SearchableModule;
  /** Primary label — entity name or task title */
  title: string;
  /** Owning organization id, needed to build the link to tasks and audits */
  organizationId?: string | null;
}

export interface GlobalSearchBucketDto {
  module: SearchableModule;
  /** Total matches in this module, ignoring preview size */
  totalItems: number;
  items: GlobalSearchItemDto[];
}

export interface GlobalSearchResultDto {
  /** One bucket per searched module. Modules the user cannot read are omitted. */
  buckets: GlobalSearchBucketDto[];
}

export interface GlobalSearchListDto {
  /** Array of items */
  items: GlobalSearchItemDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface VsrReportListItemDto {
  /** @format uuid */
  id: string;
  title?: string | null;
  organizationId?: string | null;
  /** @format uuid */
  sibContractId?: string | null;
  /** @format date */
  periodFrom: string;
  /** @format date */
  periodTo: string;
  /**
   * Month the report states savings for, as `YYYY-MM`.
   * @pattern ^\d{4}-(0[1-9]|1[0-2])$
   * @example "2026-09"
   */
  savingsPeriod: string;
  /** @format date */
  reportDate?: string | null;
  /**
   * The SIB invoice it was invoiced on, once one exists.
   * @format uuid
   */
  sibInvoiceId?: string | null;
  sibInvoiceNumber?: string | null;
  /** @format date */
  sibInvoiceDate?: string | null;
  /** The NetSuite invoice's transaction id; its PDF is read from NetSuite. Null for an invoice recorded only by number. */
  sibInvoiceNetsuiteTransactionId?: string | null;
  /** Decimal string. Fixed at lock; on a draft, calculated live from the lines locking it would claim. */
  totalSavings: string;
  /** Decimal string. Fixed at lock; on a draft, calculated live from the lines locking it would claim. */
  totalRevenue: string;
  status: VsrReportStatus;
  sentAt?: string | null;
  createdById?: string | null;
  /**
   * The report this one was copied from.
   * @format uuid
   */
  previousReportId?: string | null;
  createdAt: string;
  updatedAt: string;
  /** Sites the report covers. */
  locationsCount: number;
  /** Spend categories the report covers. */
  spendCategoriesCount: number;
  /**
   * Names of the spend categories the report covers, alphabetical and comma-separated.
   * @example "Electricity, Waste"
   */
  spendCategories: string;
  /** Sites the report covers. Filter with `in` (e.g. `filter=locationIds:in:["uuid"]`). */
  locationIds: string[];
  /** Spend categories the report covers. Filter with `in` (e.g. `filter=spendCategoryIds:in:["uuid"]`). */
  spendCategoryIds: string[];
  /** Audits of the spend lines on the report. Filter with `in` (e.g. `filter=auditIds:in:["uuid"]`). */
  auditIds: string[];
}

export interface VsrReportListDto {
  /** Array of items */
  items: VsrReportListItemDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface VsrReportLocationOptionDto {
  /** @format uuid */
  id: string;
  name?: string | null;
  address?: string | null;
  city?: string | null;
  state?: string | null;
}

export interface VsrReportLocationOptionListDto {
  /** Array of items */
  items: VsrReportLocationOptionDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface VsrReportMatrixSpendCategoryDto {
  /** @format uuid */
  id: string;
  name: string;
}

export interface VsrReportDto {
  /** @format uuid */
  id: string;
  title?: string | null;
  organizationId?: string | null;
  /** @format uuid */
  sibContractId?: string | null;
  /** @format date */
  periodFrom: string;
  /** @format date */
  periodTo: string;
  /**
   * Month the report states savings for, as `YYYY-MM`.
   * @pattern ^\d{4}-(0[1-9]|1[0-2])$
   * @example "2026-09"
   */
  savingsPeriod: string;
  /** @format date */
  reportDate?: string | null;
  /**
   * The SIB invoice it was invoiced on, once one exists.
   * @format uuid
   */
  sibInvoiceId?: string | null;
  sibInvoiceNumber?: string | null;
  /** @format date */
  sibInvoiceDate?: string | null;
  /** The NetSuite invoice's transaction id; its PDF is read from NetSuite. Null for an invoice recorded only by number. */
  sibInvoiceNetsuiteTransactionId?: string | null;
  /** Sites the report covers. */
  locations: VsrReportLocationOptionDto[];
  /** Spend categories the report covers, by name. */
  spendCategories: VsrReportMatrixSpendCategoryDto[];
  /** Decimal string. Fixed at lock; on a draft, calculated live from the lines locking it would claim. */
  totalSavings: string;
  /** Decimal string. Fixed at lock; on a draft, calculated live from the lines locking it would claim. */
  totalRevenue: string;
  status: VsrReportStatus;
  sentAt?: string | null;
  createdById?: string | null;
  /**
   * The report this one was copied from.
   * @format uuid
   */
  previousReportId?: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface VsrReportCopyDto {
  /**
   * The report being copied.
   * @format uuid
   */
  previousReportId: string;
  /** @format uuid */
  sibContractId?: string | null;
  /** The copied report's spend categories, by name. */
  spendCategories: VsrReportMatrixSpendCategoryDto[];
  /**
   * One month after the copied report’s `periodFrom`.
   * @format date
   */
  periodFrom: string;
  /**
   * One month after the copied report’s `periodTo`; a month end stays a month end.
   * @format date
   */
  periodTo: string;
  /**
   * The month after the copied report’s savings period.
   * @pattern ^\d{4}-(0[1-9]|1[0-2])$
   * @example "2026-10"
   */
  savingsPeriod: string;
  /** The copied report's sites that are still offered for its spend categories. */
  locationIds: string[];
}

export interface VsrReportPreviewRowDto {
  /** @format uuid */
  spendLineItemId: string;
  /** @format uuid */
  invoiceId: string;
  /**
   * Audit of the audit spend the line bills against.
   * @format uuid
   */
  auditId?: string | null;
  /** @format uuid */
  auditSpendId: string;
  /**
   * Validation spend group period of the line's bill; with `auditId` and `auditSpendId` it addresses the line on the monitoring-savings flag routes.
   * @format uuid
   */
  periodId?: string | null;
  /** @format uuid */
  spendCategoryId?: string | null;
  /** @format date */
  issueDate?: string | null;
  /**
   * Site: the location of the charge's optimization subject.
   * @format uuid
   */
  locationId?: string | null;
  address?: string | null;
  /** @example "Austin, TX" */
  cityState?: string | null;
  vendor?: string | null;
  accountNumber?: string | null;
  /** Charge on vendor invoice. */
  charge?: string | null;
  chargeBasis?: string | null;
  /** Pricing model of the spend the line bills against; `percentage_rate` lines are priced from their basis lines. */
  pricingModel: string;
  quantity?: number | null;
  /** The audit spend's baseline price per unit, in force on the invoice issue date. */
  oldRate?: number | null;
  /** The baseline's percentage points on a percentage-fee line. */
  oldPercentageRate?: number | null;
  /** Old total of the lines a percentage-fee line is a percentage of. */
  basisOldTotal?: number | null;
  /** Billed quantity × old rate; on a percentage-fee line, old percentage × basis old total. */
  oldTotal?: number | null;
  /** Price per unit as billed. */
  newRate?: number | null;
  /** Billed percentage points on a percentage-fee line. */
  newPercentageRate?: number | null;
  /** Billed total of the lines a percentage-fee line is a percentage of. */
  basisNewTotal?: number | null;
  /** Line value as billed; on a percentage-fee line, billed percentage × basis billed total. */
  newTotal?: number | null;
  /** Old total less new total. */
  savings?: number | null;
  /**
   * The audit's SIB contract, whose periods price the fee.
   * @format uuid
   */
  contractId?: string | null;
  /**
   * The first-validation bill's issue date.
   * @format date
   */
  savingsStartDate?: string | null;
  /**
   * The savings start plus the contract term. The fee is priced outside the window too.
   * @format date
   */
  savingsEndDate?: string | null;
  /** Month of the invoice billing period counted from the savings start, which is month 1. */
  billedMonth?: number | null;
  /**
   * The contract period whose cumulative terms cover the billed month.
   * @format uuid
   */
  contractPeriodId?: string | null;
  /** Contingency fee in percentage points: an override for the category at the site, then org-wide, then the period's own. */
  feeRate?: number | null;
  /** Savings × fee rate. */
  fee?: number | null;
  invoiceStatus: string;
  /** A locked or sent report claimed the line or closed its invoice; it cannot be hidden or changed. */
  locked: boolean;
  /**
   * The report the line is locked by.
   * @format uuid
   */
  lockedBy?: string | null;
  hidden: boolean;
  excludedFromSavings: boolean;
  /** Reason for omitted validation, read live from the line's bill period. Set: the line stays on the report with `savings` and `fee` at 0. */
  omittedValidationReason?: string | null;
  validationStatus?: string | null;
  validatedAt?: string | null;
}

export interface VsrReportPreviewRowListDto {
  /** Array of items */
  items: VsrReportPreviewRowDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface VsrReportMatrixRowDto {
  /**
   * The location of the charge's optimization subject; NULL gathers lines with no site.
   * @format uuid
   */
  locationId?: string | null;
  site?: string | null;
  address?: string | null;
  /** @example "Austin, TX" */
  cityState?: string | null;
  /** Summed savings (or fee) per spend category, in `spendCategories` order. NULL when the site has no counted line in that category with a value. */
  values: number[] | null;
  /** Sum of the row's values; NULL when every cell is NULL. */
  total?: number | null;
}

export interface VsrReportMatrixDto {
  /** The columns: requested spend categories with at least one counted line, by name. */
  spendCategories: VsrReportMatrixSpendCategoryDto[];
  rows: VsrReportMatrixRowDto[];
  /** Sum per spend category over every site, in `spendCategories` order. */
  totals: number[] | null;
  /** Sum over every site and spend category. */
  total?: number | null;
}

export interface VsrReportPreviewMatrixDto {
  /** Each cell is the summed savings (old total less new total). */
  savings: VsrReportMatrixDto;
  /** Each cell is SIB's contingency fee on those savings. Same columns and rows as `savings`. */
  fee: VsrReportMatrixDto;
}

export interface VsrReportPdfSectionDto {
  section: VsrReportNoteSection;
  /**
   * Set for `CategoryOverview` and `CategoryDetail` sections.
   * @format uuid
   */
  spendCategoryId: string | null;
  /** 1-based. */
  firstPage: number;
  /** 1-based, inclusive. */
  lastPage: number;
}

export interface GenerateVsrReportDto {
  title?: string;
  /** @format uuid */
  sibContractId?: string | null;
  /**
   * @minItems 1
   * @uniqueItems true
   */
  spendCategoryIds: string[];
  /**
   * Locations from `GET vsr-reports/locations`.
   * @minItems 1
   * @uniqueItems true
   */
  locationIds: string[];
  /**
   * Inclusive invoice issue date.
   * @format date
   */
  periodFrom: string;
  /**
   * Inclusive invoice issue date.
   * @format date
   */
  periodTo: string;
  /**
   * Month the report states savings for, as `YYYY-MM`.
   * @pattern ^\d{4}-(0[1-9]|1[0-2])$
   * @example "2026-09"
   */
  savingsPeriod: string;
  /** @format date */
  reportDate?: string;
  /**
   * The report this one copies, as returned by `GET vsr-reports/:reportId/copy`.
   * @format uuid
   */
  previousReportId?: string;
}

export interface UpdateVsrReportDto {
  title?: string;
  /** @format uuid */
  sibContractId?: string | null;
  /**
   * @minItems 1
   * @uniqueItems true
   */
  spendCategoryIds: string[];
  /**
   * Locations from `GET vsr-reports/locations`.
   * @minItems 1
   * @uniqueItems true
   */
  locationIds: string[];
  /**
   * Inclusive invoice issue date.
   * @format date
   */
  periodFrom: string;
  /**
   * Inclusive invoice issue date.
   * @format date
   */
  periodTo: string;
  /**
   * Month the report states savings for, as `YYYY-MM`.
   * @pattern ^\d{4}-(0[1-9]|1[0-2])$
   * @example "2026-09"
   */
  savingsPeriod: string;
  /** @format date */
  reportDate?: string;
}

export interface UpdateVsrReportStatusDto {
  /** Moving to `approved` locks the report; moving off it unlocks it and needs an admin. `sent` is set by sending. */
  status: UpdateVsrReportStatusDtoStatusEnum;
}

export interface RecordVsrInvoiceDto {
  /**
   * NetSuite's number for the invoice issued from the report. Its date and PDF are read from NetSuite.
   * @maxLength 100
   */
  sibInvoiceNumber: string;
}

export interface VsrReportNoteDto {
  /** @format uuid */
  id: string;
  /** @format uuid */
  reportId: string;
  section: VsrReportNoteSection;
  /**
   * Set for `CategoryOverview` and `CategoryDetail` notes.
   * @format uuid
   */
  spendCategoryId: string | null;
  content: string;
  /** True when the note is left off the PDF. */
  hidden: boolean;
  order: number | null;
  /** 1-based page within the section the note prints after; null at the section end. */
  page: number | null;
  createdAt: string;
  updatedAt: string;
}

export interface CreateVsrReportNoteDto {
  /** The report page the note is printed beneath. */
  section: VsrReportNoteSection;
  /**
   * Required for `CategoryOverview` and `CategoryDetail`, rejected otherwise. Must be one of the report’s spend categories.
   * @format uuid
   */
  spendCategoryId?: string;
  /** @maxLength 4000 */
  content: string;
  /**
   * Kept on the report but left off the PDF.
   * @default false
   */
  hidden?: boolean;
  /** Position among the notes of a section, ascending; unset notes follow, oldest first. */
  order?: number;
  /**
   * Page within the section, counted from 1 at its first page, that the note prints after (`firstPage + page - 1` of `X-Vsr-Report-Sections`). Omitted or null prints it at the section end, as does a page past it.
   * @min 1
   */
  page?: number | null;
}

export interface UpdateVsrReportNoteDto {
  /** The report page the note is printed beneath. */
  section?: VsrReportNoteSection;
  /**
   * Required for `CategoryOverview` and `CategoryDetail`, rejected otherwise. Must be one of the report’s spend categories.
   * @format uuid
   */
  spendCategoryId?: string;
  /** @maxLength 4000 */
  content?: string;
  /**
   * Kept on the report but left off the PDF.
   * @default false
   */
  hidden?: boolean;
  /** Position among the notes of a section, ascending; unset notes follow, oldest first. */
  order?: number;
  /**
   * Page within the section, counted from 1 at its first page, that the note prints after (`firstPage + page - 1` of `X-Vsr-Report-Sections`). Omitted or null prints it at the section end, as does a page past it.
   * @min 1
   */
  page?: number | null;
}

export interface VendorContactDto {
  id: string;
  name?: string;
  email?: string | null;
  isActive: boolean;
  serviceProvider: string;
  firstName: string | null;
  lastName: string | null;
  title: string | null;
  phoneNumber: string | null;
  note: string | null;
}

export interface VendorContactsListDto {
  /** Array of items */
  items: VendorContactDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface NotificationDto {
  uuid: string;
  title: string;
  description?: string;
  type: string;
  priority: NotificationPriority;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  actionMetadata?: any;
  /** @format date-time */
  seenAt: string | null;
}

export interface NotificationListDto {
  /** Array of items */
  items: NotificationDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
  newItemsCount?: number;
}

export interface UpdateNotificationDto {
  seen?: boolean;
}

export interface NotificationCountDto {
  count: number;
}

export interface CreateRecurringTaskDto {
  title: string;
  priorityLevel?: PriorityLevel;
  category: TaskCategory;
  /** @default "new" */
  status?: TaskStatus;
  /**
   * The ID of the user to assign the task to
   * @format uuid
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  assignee?: string;
  /**
   * Estimated time to complete the task in minutes
   * @min 1
   * @example 120
   */
  estimatedTime?: number;
  timeToComplete: RecurrenceInterval;
  timeToCompleteAmount: number;
  /**
   * Start date for the recurring task
   * @format date-time
   */
  repeatStartDate?: string;
  /**
   * End date for the recurring task
   * @format date-time
   */
  repeatEndDate?: string;
  /** Recurrence interval - day, week, month */
  repeatInterval?: RecurrenceInterval;
  /** Interval amount for the recurrence */
  repeatIntervalAmount?: number | null;
  /** Days of the week for the recurrence (1-5) */
  repeatOnWeekDays?: number[] | null;
  /** Day of the month for the recurrence (1-31) */
  repeatOnMonthDay?: number | null;
  /** Weekday order for the recurrence (1-5) */
  repeatOnMonthWeekdayOrder?: number | null;
  /** Weekday for the recurrence (1-5) */
  repeatOnMonthWeekdayDay?: number | null;
  tags?: CreateTaskTagDto[] | null;
  description?: string | null;
  referenceLink?: string | null;
  referenceName?: string | null;
  organizationId?: string | null;
  /** The ID of the vendor organization to associate with the task */
  vendorId?: string | null;
}

export interface RecurringTaskDto {
  /**
   * Unique identifier for the task
   * @example "c56a4180-65aa-42ec-a945-5fd21dec0538"
   */
  uuid: string;
  /**
   * Title of the task
   * @example "Complete project documentation"
   */
  title: string;
  /**
   * Description of the task
   * @example "Finish writing the project documentation by end of the day"
   */
  description?: string | null;
  /**
   * Date when the task was created
   * @format date-time
   * @example "2023-01-01T12:00:00Z"
   */
  createdAt: string;
  /**
   * Date when the task was last updated
   * @format date-time
   * @example "2023-01-02T15:30:00Z"
   */
  updatedAt: string;
  /** Priority of the task */
  priorityLevel: PriorityLevel;
  createdByUser: PlainExternalUserDto;
  assigneeUser: PlainExternalUserDto | null;
  category?: TaskCategory;
  /** Status of the task */
  status: TaskStatus;
  /** External reference URL for the task */
  referenceLink?: string | null;
  referenceName?: string | null;
  tags: TaskTagDto[];
  /**
   * Estimated time to complete the task in minutes
   * @min 1
   * @example 120
   */
  estimatedTime?: number | null;
  organization?: BaseTaskOrganizationDto | null;
  timeToComplete: RecurrenceInterval;
  timeToCompleteAmount: number;
  /**
   * Start date for the recurring task
   * @format date-time
   */
  repeatStartDate?: string;
  /**
   * End date for the recurring task
   * @format date-time
   */
  repeatEndDate?: string;
  /** Recurrence interval - day, week, month */
  repeatInterval?: RecurrenceInterval;
  /** Interval amount for the recurrence */
  repeatIntervalAmount?: number;
  /** Days of the week for the recurrence (1-5) */
  repeatOnWeekDays?: number[];
  /** Day of the month for the recurrence (1-31) */
  repeatOnMonthDay?: number;
  /** Weekday order for the recurrence (1-5) */
  repeatOnMonthWeekdayOrder?: number;
  /** Weekday for the recurrence (1-5) */
  repeatOnMonthWeekdayDay?: number;
}

export interface RecurringTaskListDto {
  /** Array of items */
  items: RecurringTaskDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export type Date = object;

export interface UpdateRecurringTaskDto {
  priorityLevel?: PriorityLevel;
  category?: TaskCategory | null;
  status?: TaskStatus;
  /**
   * The ID of the user to assign the task to. `null` unassigns the task.
   * @format uuid
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  assignee?: string | null;
  /**
   * Estimated time to complete the task in minutes
   * @min 1
   * @example 120
   */
  estimatedTime?: number;
  timeToComplete?: RecurrenceInterval;
  timeToCompleteAmount?: number;
  /**
   * Start date for the recurring task
   * @format date-time
   */
  repeatStartDate?: string | null;
  /**
   * End date for the recurring task
   * @format date-time
   */
  repeatEndDate?: string | null;
  /** Recurrence interval - day, week, month */
  repeatInterval?: RecurrenceInterval | null;
  /** Interval amount for the recurrence */
  repeatIntervalAmount?: number | null;
  /** Days of the week for the recurrence (1-5) */
  repeatOnWeekDays?: number[] | null;
  /** Day of the month for the recurrence (1-31) */
  repeatOnMonthDay?: number | null;
  /** Weekday order for the recurrence (1-5) */
  repeatOnMonthWeekdayOrder?: number | null;
  /** Weekday for the recurrence (1-5) */
  repeatOnMonthWeekdayDay?: number | null;
  tags?: CreateTaskTagDto[] | null;
  /** @minLength 1 */
  title?: string | null;
  description?: string | null;
  referenceLink?: string | null;
  referenceName?: string | null;
  organizationId?: string | null;
  /** The ID of the vendor organization to associate with the task */
  vendorId?: string | null;
}

export interface OrganizationMemberDto {
  id: string;
  name: string;
  email: string;
  /** @example "3" */
  taskCount?: number;
  avatarUrl: string | null;
  deletedAt: string | null;
}

export interface MemberListDto {
  /** Array of items */
  items: OrganizationMemberDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface OrganizationSummaryWithCountsDto {
  /** @example "123e4567-e89b-12d3-a456-426614174000" */
  id: string;
  /** @example "Acme Corp" */
  organizationName: string;
  /** @example "Acme Corp" */
  organizationLogoUrl: string;
  /** @example 5 */
  membersCount: number;
  /** @example 3 */
  activeTasksCount: number;
}

export interface OrganizationSummaryWithCountsListDto {
  /** Array of items */
  items: OrganizationSummaryWithCountsDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface OrganizationSummaryWithMyActiveTasksCountDto {
  /** @example "123e4567-e89b-12d3-a456-426614174000" */
  id: string;
  /** @example "Acme Corp" */
  organizationName: string;
  /** @example "Acme Corp" */
  organizationLogoUrl: string;
  /** @example 5 */
  myActiveTasksCount: number;
}

export interface OrganizationSummaryWithMyActiveTasksCountListDto {
  /** Array of items */
  items: OrganizationSummaryWithMyActiveTasksCountDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface OrganizationSummaryWithActionItemsCountDto {
  /** @example "123e4567-e89b-12d3-a456-426614174000" */
  id: string;
  /** @example "Acme Corp" */
  organizationName: string;
  /** @example "Acme Corp" */
  organizationLogoUrl: string;
  /** @example 5 */
  actionItems: number;
  permissions: Record<string, PermissionAction>;
}

export interface OrganizationSummaryWithActionItemsCountListDto {
  /** Array of items */
  items: OrganizationSummaryWithActionItemsCountDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
  /** @example 100 */
  allActionItems: number;
  /** @example 40 */
  myOrganizationsActionItems: number;
}

export interface CurrentUserOrganizationDto {
  id: string;
  name: string;
}

export interface CurrentUserDto {
  id: string;
  name: string;
  email: string;
  meetingLink?: string;
  title?: string;
  userLoginStatus?: UserLoginStatus;
  organizations: CurrentUserOrganizationDto[] | null;
  /** @deprecated */
  isSibEmployee: boolean;
  firstSignedInAt: string | null;
  hasGlobalAccess: boolean;
  /**
   * @deprecated
   * @example "employee"
   */
  roles: EntraGroup[];
  permissions?: Record<string, PermissionAction> | null;
  firstName: string | null;
  surname: string | null;
  contactEmail: string | null;
  contactPhoneNumber: string | null;
  avatarUrl: string | null;
  deletedAt: string | null;
}

export interface PlainOrganizationListDto {
  /** Array of items */
  items: PlainOrganizationDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface TaskCommentDto {
  id: string;
  comment: string;
  taskId: string;
  createdBy: PlainExternalUserDto;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export interface TaskCommentListDto {
  /** Array of items */
  items: TaskCommentDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface CreateTaskCommentDto {
  /** @maxLength 4096 */
  comment: string;
}

export interface AuditDto {
  id: string;
  name: string;
  type: string;
  stage: string;
}

export interface LocationSelectListItemDto {
  id: string;
  name: string;
}

export interface TeamReferenceDto {
  /** @format uuid */
  uuid: string;
  name: string;
  photoUrl: string;
}

export interface SubauditDto {
  id: string;
  onHold: boolean;
  subauditName: string;
  autoIncrementedId: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  audit: AuditDto;
  owner: PlainExternalUserDto;
  organization: PlainOrganizationDto;
  location: LocationSelectListItemDto;
  spendArea: string;
  vendor: PlainOrganizationDto;
  vendorAccountIdentifier: string;
  spendAmount: number;
  subAuditStage: SubauditStage;
  team: TeamReferenceDto;
}

export interface SubauditsListDto {
  /** Array of items */
  items: SubauditDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface CreateSubauditDto {
  onHold?: boolean;
  subauditName: string;
  auditId: string;
  /** @format uuid */
  ownerId: string;
  vendorId: string;
  /** @format uuid */
  locationId: string;
  vendorAccountNumber: string;
  spendAmount: number;
  subauditStage: SubauditStage;
  /** @format uuid */
  teamId: string;
}

export interface UpdateSubauditDto {
  onHold?: boolean;
  subauditName?: string;
  auditId?: string;
  /** @format uuid */
  ownerId?: string;
  vendorId?: string;
  /** @format uuid */
  locationId?: string;
  vendorAccountNumber?: string;
  spendAmount?: number;
  subauditStage?: SubauditStage;
  /** @format uuid */
  teamId?: string;
}

export interface ExtensionAuditsListDto {
  /** Array of items */
  items: AuditDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface SubauditCommentDto {
  /** @format uuid */
  id: string;
  content: string;
  topic: string;
  /** @format uuid */
  subauditId: string;
  createdBy: PlainExternalUserDto;
  createdAt: string;
}

export interface SubauditCommentListDto {
  /** Array of items */
  items: SubauditCommentDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface CreateSubauditCommentDto {
  topic: string;
  content: string;
}

export interface UpdateSubauditCommentDto {
  topic?: string;
  content?: string;
}

export interface SubauditVersionChangeRecordDto {
  prevValue: string;
  newValue: string;
  fieldName: SubauditVersionChangeRecordFields;
}

export interface SubauditVersionChangelogItemDto {
  /** The ID of the version after the changes. Might be useful in the future for reverting to previous versions. */
  afterChangesVersionId: string;
  modifiedBy: PlainExternalUserDto;
  /** @format date-time */
  modifiedAt: string;
  action: AuditingAction;
  /** The ID of the parent entity. */
  parent: string;
  /** The type of the entity. Usually the name of the entity. */
  type: ChangelogEntityType;
  /** String that helps represent the entity in the UI. */
  display: string;
  /** The changes made to the entity. */
  changes: SubauditVersionChangeRecordDto[];
}

export interface SubauditVersionChangelogList {
  /** Array of items */
  items: SubauditVersionChangelogItemDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface FileUploadActionTypeDto {
  /**
   * Type of the action, indicating file upload.
   * @example "file-upload"
   */
  type: ActionItemType;
  /**
   * Public URL to the uploaded file
   * @example "/api/document/file/001XYZ_file.png"
   */
  url: string;
  /**
   * Original filename of the uploaded document
   * @example "001XYZ_file.png"
   */
  filename: string;
  id: string;
}

export interface PutFileUploadActionTypeDto {
  /** @example "file-upload" */
  type: ActionItemType;
}

export interface MeetingLinkActionTypeDto {
  /** @example "meeting-link" */
  type: ActionItemType;
  /** Meeting link URL. Absent for meetings held in person. */
  url?: string;
  /**
   * Date of the meeting.
   * @format date-time
   */
  date: string;
}

export interface LinkActionTypeDto {
  /** @example "link" */
  type: ActionItemType;
  url: string;
}

export interface ActionItemDto {
  id: string;
  title: string;
  description?: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  spendAreaStage: SpendAreaStage;
  organization: PlainOrganizationDto;
  priorityLevel: PriorityLevel;
  actionType: ActionItemType | null;
  /** Action details associated with the step. */
  actionDetails?:
    | MeetingLinkActionTypeDto
    | FileUploadActionTypeDto
    | LinkActionTypeDto;
  createdBy: PlainExternalUserDto;
  assignee: PlainExternalUserDto;
  notifyExternalClient: boolean;
  /** @format date-time */
  deadline?: string | null;
  /** @format date-time */
  completedAt: string | null;
}

export interface ActionItemListDto {
  /** Array of items */
  items: ActionItemDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface CreateActionItemDto {
  title: string;
  description?: string;
  /** @example "MOBILIZATION" */
  spendAreaStage: SpendAreaStage;
  /** @example "high" */
  priorityLevel: PriorityLevel;
  /** @format uuid */
  projectId?: string;
  /**
   * Action details associated with the step. Must be a valid JSON string in multipart/form-data.
   *
   * file-upload type:
   * {"type": "file-upload"}
   *
   * meeting-link type:
   * {
   * "type": "meeting-link",
   * "url": "https://meet.google.com/example",
   * "date": "2025-03-11T17:46:33.200Z"
   * }
   * @example "{"type": "file-upload"}"
   */
  action?:
    | MeetingLinkActionTypeDto
    | PutFileUploadActionTypeDto
    | LinkActionTypeDto
    | null;
  /**
   * File to upload (only required if action.type = file-upload)
   * @format binary
   */
  file?: File;
  /**
   * Send notification email to external client when assigned
   * @default false
   */
  notifyExternalClient?: boolean;
  /**
   * @format date-time
   * @example "2024-12-31T23:59:59Z"
   */
  deadline: string | null;
  /** @format uuid */
  assignee?: string | null;
}

export interface UpdateActionItemDto {
  title?: string;
  description?: string;
  /** @example "MOBILIZATION" */
  spendAreaStage?: SpendAreaStage;
  /** @example "high" */
  priorityLevel?: PriorityLevel;
  /** @format uuid */
  projectId?: string;
  /**
   * Action details associated with the step. Must be a valid JSON string in multipart/form-data.
   *
   * file-upload type:
   * {"type": "file-upload"}
   *
   * meeting-link type:
   * {
   * "type": "meeting-link",
   * "url": "https://meet.google.com/example",
   * "date": "2025-03-11T17:46:33.200Z"
   * }
   * @example "{"type": "file-upload"}"
   */
  action?:
    | MeetingLinkActionTypeDto
    | PutFileUploadActionTypeDto
    | LinkActionTypeDto
    | null;
  /**
   * File to upload (only required if action.type = file-upload)
   * @format binary
   */
  file?: File;
  /**
   * Send notification email to external client when assigned
   * @default false
   */
  notifyExternalClient?: boolean;
  completed?: boolean;
  /**
   * @format date-time
   * @example "2024-12-31T23:59:59Z"
   */
  deadline?: string | null;
  /** @format uuid */
  assignee?: string | null;
}

export interface LocationDto {
  id: string;
  dba: string;
  address: string;
  city: string;
  state: string;
  zip: string;
  taxId: string;
  phone: string;
  fullLegalName: string;
  /** `organization_wide` is the organization's one non-site bucket; filter it out with `filter=kind:eq:site`. */
  kind: LocationKind;
  /** The status of the location */
  status: LocationDtoStatusEnum;
  spendArea: string;
  /** List of stages associated with the location */
  spendAreaStage: LocationDtoSpendAreaStageEnum[];
  savingsApproved?: number;
  spendApproved?: number;
  /** Additional information as key-value pairs */
  additionalInfo?: object;
  /** Status of the document field */
  documentFieldStatus?: LocationDtoDocumentFieldStatusEnum;
  name: string;
  locationIdentifier: string;
  salesforceId: string;
  requestedChange?: LocationDtoRequestedChangeEnum;
}

export interface LocationListDto {
  /** Array of items */
  items: LocationDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface FileMetadataDto {
  /**
   * Unique ID of the uploaded file
   * @example "file_abc123"
   */
  id: string;
  /**
   * Original name of the uploaded file
   * @example "site-list.xlsx"
   */
  filename: string;
  /**
   * Signed URL to access the uploaded file
   * @example "https://s3.bucket.com/documents/site-list.xlsx?..."
   */
  url: string;
  /**
   * Timestamp when the file was uploaded
   * @example "2025-06-05T10:20:30.000Z"
   */
  uploadedAt?: string;
}

export interface GetFilesUnderValidationResponseDto {
  /** Array of unique uploaded files under validation */
  items: FileMetadataDto[];
  /** Most recently uploaded file, or an empty object if none found */
  lastUploadedFile?: FileMetadataDto;
}

export interface UploadDocumentDto {
  stage?: DocumentStage;
  type?: DocumentType | null;
  /** Total number of files in the batch upload */
  totalFiles: number;
  /** MD5 hash of the file content (base64), computed by the client before upload */
  md5Hash?: string;
  contractType?: ContractType | null;
  categoryManagerUser?: string | null;
  categoryManager?: CategoryManager | null;
  paymentFrequency?: PaymentFrequency | null;
  /** This is ID helps us groupd the files in the same bulk upload */
  batchUploadId?: string;
  /**
   * File size in bytes from the client File object, validated before upload starts
   * @min 1
   */
  filesize: number;
  /**
   * The file to upload
   * @format binary
   */
  file: File;
  vendor?: string | null;
  spendCategory?: string | null;
  sensitive?: boolean | null;
  internal?: boolean | null;
  startDate?: string | null;
  endDate?: string | null;
  renewalDate?: string | null;
  annualContractValue?: number | null;
  notToExceed?: boolean | null;
  annualPriceIncrease?: boolean | null;
  earlyTerminationFee?: boolean | null;
  cancellationDateNoticePeriod?: string | null;
  autoRenewalClause?: boolean | null;
  autoRenewalLength?: string | null;
  notToExceedPercentage?: number | null;
  additionalColumns?: object | null;
}

export interface ExcelUploadResponseDto {
  /**
   * Informacja, czy plik Excel pochodzi ze standardowego szablonu
   * @example true
   */
  isExcelFileFromTemplate: boolean;
  /** Uploaded file URL */
  fileUrl: string;
  /**
   * List of created location UUIDs
   * @example ["550e8400-e29b-41d4-a716-446655440000"]
   */
  createdLocationIds: string[];
}

export interface LocationActionBodyDto {
  /**
   * The type of action to perform on the locations
   * @example "exclude_from_audit"
   */
  actionType: LocationActionBodyDtoActionTypeEnum;
  /**
   * Array of location IDs to apply the action to
   * @minItems 1
   * @uniqueItems true
   * @example ["location_1","location_2","location_3"]
   */
  locationIds: string[];
}

export interface LocationActionResponseDto {
  /**
   * Confirmation message for the action request
   * @example "Change request created successfully"
   */
  message: string;
  /**
   * Array of location IDs that were processed
   * @example ["location_1","location_2"]
   */
  updatedLocations: string[];
}

export interface UpdateLocationDto {
  dba?: string;
  address?: string;
  city?: string;
  state?: string;
  zip?: string;
  taxId?: string;
  phone?: string;
  legalName?: string;
  status?: LocationStatus;
  spendArea?: string;
  /** List of stages associated with the location */
  spendAreaStage?: UpdateLocationDtoSpendAreaStageEnum[];
  /** Additional information as key-value pairs */
  additionalInfo?: object;
  documentFieldStatus?: UpdateLocationDtoDocumentFieldStatusEnum;
  locationIdentifier?: string;
  /** The requested change action, can be one of LocationAction values or an empty string */
  requestedChange?: UpdateLocationDtoRequestedChangeEnum | null;
}

export interface TemplateActionItemFileDto {
  filename: string;
  url: string;
  size: number;
  mimeType: string;
}

export interface TemplateActionItemDto {
  id: string;
  title: string;
  spendAreaStage: SpendAreaStage;
  priorityLevel: PriorityLevel;
  actionType?: ActionItemType | null;
  /** @format date-time */
  dueDate?: string | null;
  file?: TemplateActionItemFileDto | null;
  description?: string | null;
  link?: string | null;
  dueDateInDays?: number | null;
}

export interface ActionItemTemplateDto {
  id: string;
  name: string;
  actionItems: TemplateActionItemDto[];
  description?: string | null;
}

export interface ActionItemTemplateListDto {
  /** Array of items */
  items: ActionItemTemplateDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface RequestSpendAreaResponseDto {
  /** Ids of "requested spend areas" */
  createdRequestSpendAreasIds: string[];
  /** List of "spend areas" that were created */
  createdSpendAreasIds: string[];
  /** List of spend areas that were not created */
  skippedSpendAreasIds: string[];
}

export interface RequestSpendAreaBodyDto {
  /** @uniqueItems true */
  spendAreaIds: string[];
}

export interface PowerBiReportListItemDto {
  id: string;
  name?: string;
  groupId: string;
  reportId: string;
}

export interface PowerBiReportListDto {
  /** Array of items */
  items: PowerBiReportListItemDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface ChildOrganizationDto {
  id: string;
  name: string;
  savingsApproved: number;
  savingsIdentified: number;
  inScopeSpend: number;
}

export interface ChildOrganizationListDto {
  /** Array of items */
  items: ChildOrganizationDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface FaqCategoryDto {
  id: string;
  name: string;
  description?: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export interface FaqIconDto {
  id: string;
  url: string;
  alt?: string;
  filename: string;
  mimeType: string;
  filesize: number;
  width?: number;
  height?: number;
}

export interface FaqFileDto {
  id: string;
  fileName: string;
  fileType?: string;
  url: string;
}

export interface FaqDto {
  id: string;
  title: string;
  description: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** FAQ category information */
  category: FaqCategoryDto;
  /** FAQ icon/image */
  icon?: FaqIconDto;
  /** FAQ file attachment (PDF) */
  file?: FaqFileDto;
}

export interface FaqListDto {
  /** Array of items */
  items: FaqDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface ParcelPayInvoiceDto {
  /** @default "" */
  carrier: string;
  /** @default "" */
  status: string;
  /** @default "" */
  invoiceNo: string;
  /** @default "" */
  accountNumber: string;
  /** @default "" */
  invoiceDate: string;
  /** @default "" */
  dueDate: string;
  /** @default 0 */
  netCharge: number;
  /** @default null */
  paymentDate?: string | null;
}

export interface ParcelPayInvoiceListDto {
  data: ParcelPayInvoiceDto[];
  total: number;
}

export interface ApproveInvoicesRequestDto {
  action: ApproveInvoicesRequestDtoActionEnum;
  user: string;
  accountIds?: string[];
  invoiceDates?: string[];
  selectedInvoiceIds?: number[];
}

export interface ApproveInvoicesResponseItemDto {
  /** @default false */
  resultStatus: boolean;
  /** @default "" */
  resultMessage: string;
  /** @default "" */
  resultDate: string;
}

export interface ShipwareAccessTokenDto {
  accessToken: string;
}

export interface BlobBrowserConnectivityResponseDto {
  url: string;
}

export interface OptimizationSubjectItemDto {
  id: string;
  organization: PlainDto;
  spendCategory: PlainDto;
}

export interface OptimizationSubjectListDto {
  /** Array of items */
  items: OptimizationSubjectItemDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface CreateOptimizationSubjectDto {
  /** @format uuid */
  locationId: string;
  /** @format uuid */
  spendCategoryId: string;
}

export interface InvoiceItemDto {
  id: string;
  value: number;
  issueDate: string;
  billingPeriodFrom: string;
  billingPeriodTo: string;
}

export interface InvoiceListDto {
  /** Array of items */
  items: InvoiceItemDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface CreateInvoiceDto {
  vendorId: string;
  invoiceNumber: string;
  /** @min 0 */
  value: number;
  issueDate: string;
  billingPeriodFrom: string;
  billingPeriodTo: string;
  /**
   * The account the bill arrived on. Without it there is no bill stream.
   * @format uuid
   */
  vendorAccountId?: string;
  /**
   * Resolved from the vendor account when omitted.
   * @format uuid
   */
  invoiceTemplateId?: string;
  source?: CreateInvoiceDtoSourceEnum;
}

export interface InvitedUserDto {
  /**
   * User ID (OID)
   * @example "ad8ff82f-9ab9-4009-8364-513c030c83c8"
   */
  oid: string;
  /**
   * User display name
   * @example "John Doe"
   */
  name: string;
  /**
   * User email
   * @format email
   * @example "john.doe@example.com"
   */
  email: string;
  /**
   * User creation timestamp
   * @example "2025-03-21T06:30:15Z"
   */
  createdDateTime: string;
  userLoginStatus: UserLoginStatus;
  organizations: PlainOrganizationDto[];
  userType: UserType;
}

export interface InviteUserBodyDto {
  /** List of emails to invite to the organization */
  emails: string[];
}

export interface EntraUserPartialDto {
  /**
   * User ID (OID)
   * @example "ad8ff82f-9ab9-4009-8364-513c030c83c8"
   */
  oid: string;
  /**
   * User display name
   * @example "John Doe"
   */
  name: string;
  /**
   * User email
   * @format email
   * @example "john.doe@example.com"
   */
  email: string;
  /**
   * User creation timestamp
   * @example "2025-03-21T06:30:15Z"
   */
  createdDateTime: string;
  userLoginStatus: UserLoginStatus;
}

export interface InviteUserResponseDto {
  /** List of successfully invited users */
  success: EntraUserPartialDto[];
  /**
   * List of failed invitations with error messages
   * @example [{"email":"invalid@example.com","error":"Invited emails must be in the allowed domain"},{"email":"another@example.com","error":"A Microsoft identity operation failed. Please try again or contact support."}]
   */
  failed: string[];
}

export interface RegisterDeviceTokenDto {
  /**
   * @maxLength 512
   * @example "fMwqR9p0TXa..."
   */
  token: string;
  /** @example "ios" */
  platform: DevicePlatform;
  /**
   * @maxLength 512
   * @example "iPhone 15 Pro"
   */
  deviceName?: string;
}

export interface DeviceTokenDto {
  id: string;
  /** @example "ios" */
  platform: DevicePlatform;
  isActive: boolean;
  /** @format date-time */
  createdAt: string;
  deviceName?: string | null;
  /** @format date-time */
  lastUsedAt?: string | null;
}

export interface UnregisterTokenDto {
  message: string;
}

export interface DeviceTokensListDto {
  /** Array of items */
  items: DeviceTokenDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface CreateReviewDto {
  /**
   * Difficulty level
   * @example "Neutral"
   */
  gettingStarted: Difficulty;
  /**
   * Difficulty level
   * @example "VeryEasy"
   */
  navigationEase: Difficulty;
  improvementSuggestion?: string;
}

export interface TagsListDto {
  /** Array of items */
  items: TagDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface CreateTagDto {
  name: string;
  /**
   * Hexadecimal color value (e.g., #FF0000, #f00)
   * @pattern ^#?([0-9A-F]{3}|[0-9A-F]{4}|[0-9A-F]{6}|[0-9A-F]{8})$
   * @example "#FF0000"
   */
  color?: string;
  isPredefined?: boolean;
}

export interface UpdateTagDto {
  name?: string;
  /**
   * Hexadecimal color value (e.g., #FF0000, #f00)
   * @pattern ^#?([0-9A-F]{3}|[0-9A-F]{4}|[0-9A-F]{6}|[0-9A-F]{8})$
   * @example "#FF0000"
   */
  color?: string;
  isPredefined?: boolean;
}

export interface VendorSelectListItemDto {
  id: string;
  name: string;
}

export interface VendorSelectListDto {
  /** Array of items */
  items: VendorSelectListItemDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface ServiceCategoryDto {
  id: string;
  categoryName: string;
}

export interface VendorDto {
  id: string;
  salesforceId: string;
  vendorName: string;
  recordType: string;
  serviceCategory?: ServiceCategoryDto;
  pointOfContact?: string;
  pointOfContactDetails?: VendorContactDto;
  subauditId: string;
  contractsCount?: number;
  vectorVendorId?: number;
}

export interface VendorsListDto {
  /** Array of items */
  items: VendorDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface LocationSelectListDto {
  /** Array of items */
  items: LocationSelectListItemDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface DocumentTagsListDto {
  /** Array of items */
  items: DocumentTagDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface CreateDocumentTagDto {
  name: string;
}

export interface UpdateDocumentTagDto {
  name?: string;
}

export interface CreateArchiveDocumentsRequestDto {
  /**
   * Array of document IDs to include in the ZIP archive
   * @minItems 1
   * @uniqueItems true
   * @example ["550e8400-e29b-41d4-a716-446655440000","550e8400-e29b-41d4-a716-446655440001"]
   */
  documentIds: string[];
}

export interface VectorLocationDto {
  id: number;
  name: string;
  address: string;
  city: string;
  state: string;
  zipCode: string;
  status: string;
  savings: number;
  autoPay: boolean;
  cost: number;
  ledgerNo: string | null;
}

export interface VectorLocationListDto {
  /** Array of items */
  items: VectorLocationDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface VectorContractDto {
  id: string;
  negotiationNo?: string | null;
  locationName: string;
  vendorName: string;
  status: VectorApiContractStatus;
  /** @format date-time */
  effectiveDate?: string | null;
  isVetted: boolean;
  fileUrl?: string | null;
}

export interface VectorContractsListDto {
  /** Array of items */
  items: VectorContractDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface UpdateProfilePictureDto {
  /** @format binary */
  file: File;
}

export interface OrganizationUserDto {
  /**
   * User ID
   * @example "ad8ff82f-9ab9-4009-8364-513c030c83c8"
   */
  id: string;
  /**
   * User display name
   * @example "John Doe"
   */
  name: string;
  /**
   * User email
   * @format email
   * @example "john.doe@example.com"
   */
  email: string;
  /** Whether the user has ever signed in (false — invitation not accepted yet) */
  hasSignedIn: boolean;
  /**
   * Deprecated — profile-completion state, kept for clients not yet migrated to `hasSignedIn`. Active (completed) or Inactive (uncompleted).
   * @deprecated
   */
  status: UserLoginStatus;
  /** Organization role: Customer Admin or Common Customer */
  role: OrganizationUserDtoRoleEnum;
  /** User job title */
  title: string | null;
  /**
   * User phone number
   * @example "+1234567890"
   */
  phone: string | null;
  /** Profile picture URL */
  avatarUrl: string | null;
}

export interface OrganizationUsersGroupedDto {
  admins: OrganizationUserDto[];
  standardUsers: OrganizationUserDto[];
}

export interface UpdateUserRoleDto {
  /** The new role to assign */
  role: UpdateUserRoleDtoRoleEnum;
}

export interface CreateTicketCommentExternalDto {
  /** @maxLength 4096 */
  text: string;
  /**
   * List of external users IDs to notify
   * @uniqueItems true
   */
  notifyUsers?: string[];
}

export interface OrganizationTicketCountDto {
  /** @example "123e4567-e89b-12d3-a456-426614174000" */
  id: string;
  /** @example "Acme Corp" */
  organizationName: string;
  /** @example "Acme Corp" */
  organizationLogoUrl: string;
  ticketCount: number;
}

export interface OrganizationTicketCountListDto {
  items: OrganizationTicketCountDto[];
}

export interface AssigneeTicketGroupingDto {
  id: string;
  name: string;
  email: string;
  ticketCount: number;
  avatarUrl: string | null;
  deletedAt: string | null;
}

export interface AssigneeTicketGroupingListDto {
  /** Array of items */
  items: AssigneeTicketGroupingDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface StatusTicketGroupingDto {
  status: string;
  ticketCount: number;
}

export interface StatusTicketGroupingListDto {
  items: StatusTicketGroupingDto[];
}

export interface CategoryTicketGroupingDto {
  category: string;
  ticketCount: number;
}

export interface CategoryTicketGroupingListDto {
  items: CategoryTicketGroupingDto[];
}

export interface TicketVersionChangeRecordDto {
  prevValue: string;
  newValue: string;
  fieldName: TicketVersionChangeRecordFields;
}

export interface TicketVersionChangelogItemDto {
  /** The ID of the version after the changes. Might be useful in the future for reverting to previous versions. */
  afterChangesVersionId: string;
  modifiedBy: PlainExternalUserDto;
  /** @format date-time */
  modifiedAt: string;
  action: AuditingAction;
  /** The ID of the parent entity. */
  parent: string;
  /** The type of the entity. Usually the name of the entity. */
  type: ChangelogEntityType;
  /** String that helps represent the entity in the UI. */
  display: string;
  /** The changes made to the entity. */
  changes: TicketVersionChangeRecordDto[];
}

export interface TicketVersionChangelogList {
  /** Array of items */
  items: TicketVersionChangelogItemDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface TicketVersionSnapshotDto {
  /** Id of this version row (not the ticket id). */
  id: string;
  /** Id of the ticket this snapshot belongs to. */
  ticketId: string;
  subject?: string | null;
  description?: string | null;
  status?: string | null;
  priority?: string | null;
  category?: string | null;
  subCategory?: string | null;
  phoneNumber?: string | null;
  vendorName?: string | null;
  location?: string | null;
  assigneeId?: string | null;
  /** @format date-time */
  dueDate?: string | null;
  /** @format date-time */
  followUpDate?: string | null;
  accessToExternalUser?: boolean | null;
  zip?: string | null;
  state?: string | null;
  address?: string | null;
  city?: string | null;
  subStatus?: string | null;
  savingsAmount?: number | null;
  createdById?: string | null;
  updatedById?: string | null;
  organizationId?: string | null;
  vendorId?: string | null;
  projectId?: string | null;
  /**
   * When this version was written.
   * @format date-time
   */
  modifiedAt: string;
}

export interface TosContentResponseDto {
  /** Lexical editor richtext document (freeform JSON) */
  tosContent: object;
}

export interface SfMigrationLocationDto {
  /** @format uuid */
  id: string;
  name?: string | null;
  locationIdentifier?: string | null;
  salesforceId?: string | null;
}

export interface SfMigrationVendorDto {
  id: string;
  name?: string | null;
  salesforceId?: string | null;
}

export interface SfMigrationVendorAccountDto {
  /** @format uuid */
  id: string;
  name?: string | null;
  accountNumber?: string | null;
  /** SF1 Affected Vendor Account id */
  salesforceId?: string | null;
}

export interface SfMigrationOrphanBaselineSpendItemDto {
  /** @format uuid */
  spendId: string;
  /** @format uuid */
  originId: string;
  /**
   * App parent audit id (provenance)
   * @format uuid
   */
  auditId: string;
  salesforceAuditId: string;
  salesforceVendorCostId?: string | null;
  /** Line optimization subject name (vendor cost name) */
  name?: string | null;
  unit?: string | null;
  quantity?: number | null;
  pricePerUnit?: number | null;
  occurrenceInterval?: string | null;
  location?: SfMigrationLocationDto | null;
  vendor?: SfMigrationVendorDto | null;
  /** Affected vendor account (AVA) */
  vendorAccount?: SfMigrationVendorAccountDto | null;
}

export interface SfMigrationOrphanBaselineSpendListDto {
  salesforceAuditId: string;
  count: number;
  items: SfMigrationOrphanBaselineSpendItemDto[];
}

export interface SfMigrationVendorScopeRefDto {
  id: string;
  name?: string | null;
}

export interface SfMigrationVendorAccountScopeRefDto {
  id: string;
  /** Vendor account number (portal identifier). Prefer this over name for distinguishing AVAs. */
  accountNumber?: string | null;
  /** SF Account_Name__c — often the client/org label, not unique per AVA. */
  name?: string | null;
}

export interface SfMigrationVendorScopeItemDto {
  vendor: SfMigrationVendorScopeRefDto;
  locations: SfMigrationVendorScopeRefDto[];
  /** Affected vendor accounts (vendor_account) for this vendor */
  affectedVendorAccounts: SfMigrationVendorAccountScopeRefDto[];
}

export interface SfMigrationVendorScopeListDto {
  salesforceAuditId: string;
  count: number;
  items: SfMigrationVendorScopeItemDto[];
}

export interface SensitiveDocumentsPermissionDto {
  canAccess: boolean;
}

export interface InternalDocumentsPermissionDto {
  canAccess: boolean;
}

export interface CreateIntegrationTicketDto {
  /**
   * @maxLength 256
   * @example "Invoice mismatch for account 1042"
   */
  subject: string;
  /**
   * @maxLength 1024
   * @example "Invoice #INV-123 does not match the agreed rate card."
   */
  description?: string;
  /** @default "medium" */
  priority?: PriorityLevel;
  /** @default "others" */
  category?: TicketCategory;
  /**
   * If true, ticket is external (accessible to the client organization users). If false, ticket is internal.
   * @default false
   */
  accessToExternalUser?: boolean;
  /**
   * Due date of the ticket
   * @format date-time
   */
  dueDate?: string | null;
  /**
   * @maxLength 255
   * @default null
   */
  city?: string | null;
  /**
   * @maxLength 255
   * @default null
   */
  state?: string | null;
  /**
   * @maxLength 255
   * @default null
   */
  address?: string | null;
  /**
   * @maxLength 255
   * @default null
   */
  zip?: string | null;
}

export interface IntegrationTicketResponseDto {
  /** @format uuid */
  id: string;
  /**
   * Human-readable ticket number
   * @example "T-000123"
   */
  ticketNumber: string | null;
  status: TicketStatus;
  /** @format date-time */
  createdAt: string;
}

export interface OrganizationMappingLookupDto {
  /**
   * Current page number (1-based)
   * @min 1
   * @default 1
   * @example 1
   */
  page?: number;
  /**
   * Number of items per page
   * @min 1
   * @max 1000
   * @default 25
   * @example 25
   */
  size?: number;
  /**
   * Salesforce 2 organization ids to resolve
   * @maxItems 1000
   * @minItems 1
   * @example ["001VX000004vJKlYAM","001VX000004vJKmYAM"]
   */
  salesforce2Ids: string[];
}

export interface OrganizationMappingDto {
  /**
   * Salesforce 2 organization id
   * @example "001VX000004vJKlYAM"
   */
  salesforce2Id: string;
  /**
   * SpendBrain organization id — the blob folder id
   * @format uuid
   * @example "223e4567-e89b-12d3-a456-426614174000"
   */
  blobFolderId: string;
}

export interface OrganizationMappingListDto {
  /** Array of items */
  items: OrganizationMappingDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface MobileVersionsDto {
  /**
   * Minimum supported Android version
   * @example "1.0.0"
   */
  minAndroidVersion: string;
  /**
   * Minimum supported iOS version
   * @example "1.0.0"
   */
  minIosVersion: string;
  /**
   * Latest available Android version
   * @example "2.1.0"
   */
  latestAndroidVersion: string;
  /**
   * Latest available iOS version
   * @example "2.1.0"
   */
  latestIosVersion: string;
}

export enum CreateProjectDtoProjectStatusEnum {
  Unassigned = 'unassigned',
  Unstarted = 'unstarted',
  InProgress = 'in-progress',
  OnHold = 'on-hold',
  ViewOnly = 'view-only',
  InReview = 'in-review',
  Escalated = 'escalated',
  Completed = 'completed',
}

export enum UpdateProjectDtoProjectStatusEnum {
  Unassigned = 'unassigned',
  Unstarted = 'unstarted',
  InProgress = 'in-progress',
  OnHold = 'on-hold',
  ViewOnly = 'view-only',
  InReview = 'in-review',
  Escalated = 'escalated',
  Completed = 'completed',
}

export enum TicketCommentDtoSourceEnum {
  Vector = 'vector',
  Spendbrain = 'spendbrain',
}

/** @example "user" */
export enum PreferenceDtoTypeEnum {
  User = 'user',
  Organization = 'organization',
  Global = 'global',
}

/** Moving to `approved` locks the report; moving off it unlocks it and needs an admin. `sent` is set by sending. */
export enum UpdateVsrReportStatusDtoStatusEnum {
  Draft = 'draft',
  ReadyForReview = 'ready_for_review',
  Approved = 'approved',
}

/** The status of the location */
export enum LocationDtoStatusEnum {
  Active = 'Active',
  Monitored = 'Monitored',
  Sold = 'Sold',
  Closed = 'Closed',
  UnderConstruction = 'Under Construction',
  NotActive = 'Not Active',
}

export enum LocationDtoSpendAreaStageEnum {
  MONITORING_SAVINGS = 'MONITORING_SAVINGS',
  INITIAL_VALIDATION = 'INITIAL_VALIDATION',
  SPEND_ESTIMATED = 'SPEND_ESTIMATED',
  MOBILIZATION = 'MOBILIZATION',
  NEGOTIATIONS_VENDOR = 'NEGOTIATIONS_VENDOR',
  NEGOTIATIONS_CLIENT = 'NEGOTIATIONS_CLIENT',
}

/** Status of the document field */
export enum LocationDtoDocumentFieldStatusEnum {
  COMPLETE = 'COMPLETE',
  MISSING_FIELDS = 'MISSING_FIELDS',
  UPLOAD_INVOICES = 'UPLOAD_INVOICES',
  NOT_APPLICABLE_REQUESTED = 'NOT_APPLICABLE_REQUESTED',
  NOT_APPLICABLE = 'NOT_APPLICABLE',
}

export enum LocationDtoRequestedChangeEnum {
  ExcludeFromAudit = 'exclude_from_audit',
  IncludeInAudit = 'include_in_audit',
  ChangeSpendArea = 'change_spend_area',
  Create = 'create',
}

/**
 * The type of action to perform on the locations
 * @example "exclude_from_audit"
 */
export enum LocationActionBodyDtoActionTypeEnum {
  ExcludeFromAudit = 'exclude_from_audit',
  IncludeInAudit = 'include_in_audit',
  ChangeSpendArea = 'change_spend_area',
}

export enum UpdateLocationDtoSpendAreaStageEnum {
  MONITORING_SAVINGS = 'MONITORING_SAVINGS',
  INITIAL_VALIDATION = 'INITIAL_VALIDATION',
  SPEND_ESTIMATED = 'SPEND_ESTIMATED',
  MOBILIZATION = 'MOBILIZATION',
  NEGOTIATIONS_VENDOR = 'NEGOTIATIONS_VENDOR',
  NEGOTIATIONS_CLIENT = 'NEGOTIATIONS_CLIENT',
}

export enum UpdateLocationDtoDocumentFieldStatusEnum {
  COMPLETE = 'COMPLETE',
  MISSING_FIELDS = 'MISSING_FIELDS',
  UPLOAD_INVOICES = 'UPLOAD_INVOICES',
  NOT_APPLICABLE_REQUESTED = 'NOT_APPLICABLE_REQUESTED',
  NOT_APPLICABLE = 'NOT_APPLICABLE',
}

/** The requested change action, can be one of LocationAction values or an empty string */
export enum UpdateLocationDtoRequestedChangeEnum {
  ExcludeFromAudit = 'exclude_from_audit',
  IncludeInAudit = 'include_in_audit',
  ChangeSpendArea = 'change_spend_area',
  Create = 'create',
}

export enum ApproveInvoicesRequestDtoActionEnum {
  APPROVE = 'APPROVE',
  APPROVE_PARTIAL = 'APPROVE_PARTIAL',
  APPROVE_INDIVIDUAL = 'APPROVE_INDIVIDUAL',
  APPROVE_INDIVIDUAL_PARTIAL = 'APPROVE_INDIVIDUAL_PARTIAL',
}

export enum CreateInvoiceDtoSourceEnum {
  Generated = 'generated',
  Uploaded = 'uploaded',
  Manual = 'manual',
}

/** Organization role: Customer Admin or Common Customer */
export enum OrganizationUserDtoRoleEnum {
  CustomerAdmin = 'Customer Admin',
  CommonCustomer = 'Common Customer',
}

/** The new role to assign */
export enum UpdateUserRoleDtoRoleEnum {
  CustomerAdmin = 'Customer Admin',
  CommonCustomer = 'Common Customer',
}

/** @default "desc" */
export enum OrganizationCommentsControllerGetFeedParamsDirectionEnum {
  Asc = 'asc',
  Desc = 'desc',
}

/** @example "user" */
export enum PreferenceControllerUpsertPreferencesParamsTypeEnum {
  User = 'user',
  Organization = 'organization',
  Global = 'global',
}

/** @example "user" */
export enum PreferenceControllerGetPreferencesParamsTypeEnum {
  User = 'user',
  Organization = 'organization',
  Global = 'global',
}

/** Also billings not revealed yet: those more than a week ahead. */
export enum SibInvoiceLinesControllerUnassignedBillingsParamsIncludeFutureEnum {
  True = 'true',
  False = 'false',
}

/** Also lines whose billings are all still hidden, for periods further ahead. A line sent for invoicing always shows. */
export enum SibInvoiceLinesControllerInvoiceDraftsParamsIncludeFutureEnum {
  True = 'true',
  False = 'false',
}

/** `scoped` (default): notes on the bill and those on none. `all`: every note on the charge */
export enum AuditSpendNotesControllerListNotesParamsDisplaySpendNotesEnum {
  Scoped = 'scoped',
  All = 'all',
}

export enum GlobalSearchControllerSearchModuleParamsModuleEnum {
  Organizations = 'organizations',
  Vendors = 'vendors',
  Audits = 'audits',
  Tasks = 'tasks',
  Projects = 'projects',
}

export enum GlobalSearchControllerSearchModuleParamsEnum {
  Organizations = 'organizations',
  Vendors = 'vendors',
  Audits = 'audits',
  Tasks = 'tasks',
  Projects = 'projects',
}

/** Export this page only. Omit for every page but the summary. */
export enum VsrReportsControllerReportXlsxParamsSectionEnum {
  SibInvoiceByLocation = 'SibInvoiceByLocation',
  SavingsByLocation = 'SavingsByLocation',
  CategoryOverview = 'CategoryOverview',
  CategoryDetail = 'CategoryDetail',
}

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<
  FullRequestParams,
  'body' | 'method' | 'query' | 'path'
>;

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, 'data' | 'cancelToken'> {
  securityWorker?: (
    securityData: SecurityDataType | null
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = 'application/json',
  JsonApi = 'application/vnd.api+json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || '/api',
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[
            method.toLowerCase() as keyof HeadersDefaults
          ]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === 'object' && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] =
        property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(
          key,
          isFileType ? formItem : this.stringifyFormItem(formItem)
        );
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<T> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (
      type === ContentType.FormData &&
      body &&
      body !== null &&
      typeof body === 'object'
    ) {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (
      type === ContentType.Text &&
      body &&
      body !== null &&
      typeof body !== 'string'
    ) {
      body = JSON.stringify(body);
    }

    return this.instance
      .request({
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type ? { 'Content-Type': type } : {}),
        },
        params: query,
        responseType: responseFormat,
        data: body,
        url: path,
      })
      .then(response => response.data);
  };
}

/**
 * @title SIB service
 * @version 1.0
 * @baseUrl /api
 * @contact
 *
 * SIB service API
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  healthCheck = {
    /**
     * No description
     *
     * @tags Health-Check
     * @name ApiControllerHealthCheck
     * @request GET:/health-check
     */
    apiControllerHealthCheck: (params: RequestParams = {}) =>
      this.request<StreamableFile, any>({
        path: `/health-check`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  queues = {
    /**
     * @description Get information about all available queues including job counts
     *
     * @tags Queues
     * @name QueueControllerGetAllQueues
     * @summary List all queues
     * @request GET:/queues
     * @secure
     */
    queueControllerGetAllQueues: (params: RequestParams = {}) =>
      this.request<QueueInfoDto[], void>({
        path: `/queues`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get all jobs (waiting, active, completed, failed, delayed) in a specific queue
     *
     * @tags Queues
     * @name QueueControllerGetQueueJobs
     * @summary List jobs in a queue
     * @request GET:/queues/{queueName}/jobs
     * @secure
     */
    queueControllerGetQueueJobs: (
      queueName: string,
      params: RequestParams = {}
    ) =>
      this.request<ListQueueJobsDto, void>({
        path: `/queues/${queueName}/jobs`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retry a specific failed job in a queue
     *
     * @tags Queues
     * @name QueueControllerRetryJob
     * @summary Retry a failed job
     * @request POST:/queues/{queueName}/jobs/{jobId}/retry
     * @secure
     */
    queueControllerRetryJob: (
      queueName: string,
      jobId: string,
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/queues/${queueName}/jobs/${jobId}/retry`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * @description Delete a specific job from a queue
     *
     * @tags Queues
     * @name QueueControllerDeleteJob
     * @summary Delete a job from a queue
     * @request DELETE:/queues/{queueName}/jobs/{jobId}
     * @secure
     */
    queueControllerDeleteJob: (
      queueName: string,
      jobId: string,
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/queues/${queueName}/jobs/${jobId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  };
  organization = {
    /**
     * No description
     *
     * @tags Documents
     * @name DocumentControllerBulkUpdate
     * @request PATCH:/organization/{organizationId}/document/bulk-update
     * @secure
     */
    documentControllerBulkUpdate: (
      organizationId: string,
      data: BulkUpdateDocumentDto,
      params: RequestParams = {}
    ) =>
      this.request<DocumentDto[], void>({
        path: `/organization/${organizationId}/document/bulk-update`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name DocumentControllerInitUploadSession
     * @summary Initialize a direct-to-Azure upload session (metadata only). Supports both chunked (Put Block) and single-blob (Put Blob) uploads via the returned SAS URL.
     * @request POST:/organization/{organizationId}/document/upload/init
     * @secure
     */
    documentControllerInitUploadSession: (
      organizationId: string,
      data: InitUploadDocumentsDto,
      params: RequestParams = {}
    ) =>
      this.request<InitUploadDocumentsResponseDto, void>({
        path: `/organization/${organizationId}/document/upload/init`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name DocumentControllerCompleteUploadSession
     * @summary Finalize an upload: commit staged blocks (chunked) or verify an already-committed blob (single-blob, when blockIds is omitted)
     * @request POST:/organization/{organizationId}/document/upload/complete
     * @secure
     */
    documentControllerCompleteUploadSession: (
      organizationId: string,
      data: CompleteUploadDocumentDto,
      params: RequestParams = {}
    ) =>
      this.request<DocumentDto, void>({
        path: `/organization/${organizationId}/document/upload/complete`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name DocumentControllerGetAllDocuments
     * @request GET:/organization/{organizationId}/document
     * @secure
     */
    documentControllerGetAllDocuments: (
      organizationId: string,
      query?: {
        searchTerm?: string;
        isContractActive?: boolean;
        excludeType?: string[];
        withSubsidiaries?: boolean;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - stage
         * - vendor
         * - createdAt
         * - updatedAt
         * - providedBy
         * - type
         * - spendCategory
         * - uploadedBy
         * - startDate
         * - endDate
         * - renewalDate
         * - annualContractValue
         * - notToExceed
         * - annualPriceIncrease
         * - earlyTerminationFee
         * - contractType
         * - additionalColumns
         * - categoryManager
         * - categoryManagerUser
         * - paymentFrequency
         * - cancellationDateNoticePeriod
         * - autoRenewalClause
         * - autoRenewalLength
         * - notToExceedPercentage
         * - anomaly
         * - matchingDocuments
         * - tags
         * - sensitive
         * - internal
         * - hasVirtualInvoices
         * - subsidiaryOrganizationName
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                          | Type    | Allowed Rules                                                                | Possible Values |
         * | ---------------------------- | ------- | ---------------------------------------------------------------------------- | --------------- |
         * | id                           | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | name                         | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | stage                        | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendor                       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdAt                    | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | updatedAt                    | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | providedBy                   | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | type                         | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | spendCategory                | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | uploadedBy                   | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | startDate                    | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | endDate                      | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | renewalDate                  | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | annualContractValue          | number  | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | notToExceed                  | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                 |
         * | annualPriceIncrease          | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                 |
         * | earlyTerminationFee          | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                 |
         * | contractType                 | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | additionalColumns            | object  |                                                                              |                 |
         * | categoryManager              | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | categoryManagerUser          | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | paymentFrequency             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | cancellationDateNoticePeriod | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | autoRenewalClause            | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                 |
         * | autoRenewalLength            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | notToExceedPercentage        | number  | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | anomaly                      | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                 |
         * | matchingDocuments            | number  | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | tags                         | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | sensitive                    | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                 |
         * | internal                     | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                 |
         * | hasVirtualInvoices           | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                 |
         * | subsidiaryOrganizationName   | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<DocumentListDto, void>({
        path: `/organization/${organizationId}/document`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name DocumentControllerExportDocuments
     * @request GET:/organization/{organizationId}/document/export
     * @secure
     */
    documentControllerExportDocuments: (
      organizationId: string,
      query: {
        searchTerm?: string;
        isContractActive?: boolean;
        excludeType?: string[];
        withSubsidiaries?: boolean;
        /** Column paths to export. Pass as repeated query params (preferred) or a JSON array string. Headers are auto-generated from keys. Example: columns=name&columns=status */
        columns: string[];
        /** Custom filename for the CSV download (without extension). */
        filename?: string;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - stage
         * - vendor
         * - createdAt
         * - updatedAt
         * - providedBy
         * - type
         * - spendCategory
         * - uploadedBy
         * - startDate
         * - endDate
         * - renewalDate
         * - annualContractValue
         * - notToExceed
         * - annualPriceIncrease
         * - earlyTerminationFee
         * - contractType
         * - additionalColumns
         * - categoryManager
         * - categoryManagerUser
         * - paymentFrequency
         * - cancellationDateNoticePeriod
         * - autoRenewalClause
         * - autoRenewalLength
         * - notToExceedPercentage
         * - anomaly
         * - matchingDocuments
         * - tags
         * - sensitive
         * - internal
         * - hasVirtualInvoices
         * - subsidiaryOrganizationName
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                          | Type    | Allowed Rules                                                                | Possible Values |
         * | ---------------------------- | ------- | ---------------------------------------------------------------------------- | --------------- |
         * | id                           | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | name                         | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | stage                        | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendor                       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdAt                    | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | updatedAt                    | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | providedBy                   | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | type                         | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | spendCategory                | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | uploadedBy                   | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | startDate                    | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | endDate                      | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | renewalDate                  | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | annualContractValue          | number  | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | notToExceed                  | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                 |
         * | annualPriceIncrease          | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                 |
         * | earlyTerminationFee          | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                 |
         * | contractType                 | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | additionalColumns            | object  |                                                                              |                 |
         * | categoryManager              | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | categoryManagerUser          | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | paymentFrequency             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | cancellationDateNoticePeriod | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | autoRenewalClause            | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                 |
         * | autoRenewalLength            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | notToExceedPercentage        | number  | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | anomaly                      | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                 |
         * | matchingDocuments            | number  | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | tags                         | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | sensitive                    | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                 |
         * | internal                     | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                 |
         * | hasVirtualInvoices           | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                 |
         * | subsidiaryOrganizationName   | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<StreamableFile, void>({
        path: `/organization/${organizationId}/document/export`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name DocumentControllerGetColumnMaxValues
     * @request GET:/organization/{organizationId}/document/column-max-values
     * @secure
     */
    documentControllerGetColumnMaxValues: (
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<DocumentColumnMaxValuesDto, void>({
        path: `/organization/${organizationId}/document/column-max-values`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name DocumentControllerCheckContentHash
     * @summary Check whether uploaded document content already exists by MD5 hashes
     * @request POST:/organization/{organizationId}/document/check-content-hash
     * @secure
     */
    documentControllerCheckContentHash: (
      organizationId: string,
      data: CheckDocumentContentHashQueryDto,
      params: RequestParams = {}
    ) =>
      this.request<CheckDocumentContentHashResponseDto, void>({
        path: `/organization/${organizationId}/document/check-content-hash`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name DocumentControllerGetVirtualInvoices
     * @request GET:/organization/{organizationId}/document/{id}/virtual-invoices
     * @secure
     */
    documentControllerGetVirtualInvoices: (
      id: string,
      organizationId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - franzDocId
         * - name
         * - type
         * - subsidiary
         * - vendor
         * - providedBy
         * - stage
         * - categoryManagerUser
         * - paymentFrequency
         * - spendCategory
         * - startDate
         * - endDate
         * - renewalDate
         * - annualContractValue
         * - notToExceed
         * - annualPriceIncrease
         * - earlyTerminationFee
         * - contractType
         * - cancellationDateNoticePeriod
         * - autoRenewalClause
         * - autoRenewalLength
         * - notToExceedPercentage
         * - anomaly
         * - matchingDocuments
         * - createdAt
         * - updatedAt
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                          | Type                     | Allowed Rules                                                                | Possible Values                                                                                            |
         * | ---------------------------- | ------------------------ | ---------------------------------------------------------------------------- | ---------------------------------------------------------------------------------------------------------- |
         * | id                           | string                   | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                            |
         * | franzDocId                   | string                   | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                            |
         * | name                         | string                   | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                            |
         * | type                         | string                   | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                            |
         * | subsidiary                   | string                   | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                            |
         * | vendor                       | string                   | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                            |
         * | providedBy                   | object                   |                                                                              | client, sib, system, vector                                                                                |
         * | stage                        | object                   |                                                                              | uploaded, in-progress, action-needed, approved, rejected, expired                                          |
         * | categoryManagerUser          | plainexternaluserdto     |                                                                              |                                                                                                            |
         * | paymentFrequency             | object                   |                                                                              | Monthly, Quarterly, Annually, Semi-Annual                                                                  |
         * | spendCategory                | spendcategorylistitemdto |                                                                              |                                                                                                            |
         * | startDate                    | date                     | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty   |                                                                                                            |
         * | endDate                      | date                     | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty   |                                                                                                            |
         * | renewalDate                  | date                     | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty   |                                                                                                            |
         * | annualContractValue          | number                   | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                                            |
         * | notToExceed                  | boolean                  | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                                                                                                            |
         * | annualPriceIncrease          | boolean                  | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                                                                                                            |
         * | earlyTerminationFee          | boolean                  | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                                                                                                            |
         * | contractType                 | object                   |                                                                              | MSA, SOW, Amendment, Addendum, Order Form, End User License Agreement, NDA, Data Security Agreement, Other |
         * | cancellationDateNoticePeriod | string                   | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                            |
         * | autoRenewalClause            | boolean                  | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                                                                                                            |
         * | autoRenewalLength            | string                   | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                            |
         * | notToExceedPercentage        | number                   | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                                            |
         * | anomaly                      | boolean                  | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                                                                                                            |
         * | matchingDocuments            | number                   | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                                            |
         * | createdAt                    | date                     | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty   |                                                                                                            |
         * | updatedAt                    | date                     | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty   |                                                                                                            |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<VirtualDocumentListDto, void>({
        path: `/organization/${organizationId}/document/${id}/virtual-invoices`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name DocumentControllerGetOneDocument
     * @request GET:/organization/{organizationId}/document/{id}
     * @secure
     */
    documentControllerGetOneDocument: (
      id: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<DocumentDto, void>({
        path: `/organization/${organizationId}/document/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name DocumentControllerDeleteDocuement
     * @request DELETE:/organization/{organizationId}/document/{id}
     * @secure
     */
    documentControllerDeleteDocuement: (
      id: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<string, void>({
        path: `/organization/${organizationId}/document/${id}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name DocumentControllerUpdate
     * @request PATCH:/organization/{organizationId}/document/{id}
     * @secure
     */
    documentControllerUpdate: (
      id: string,
      organizationId: string,
      data: UpdateDocumentDto,
      params: RequestParams = {}
    ) =>
      this.request<DocumentDto, void>({
        path: `/organization/${organizationId}/document/${id}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name DocumentControllerGetUploadStatus
     * @request GET:/organization/{organizationId}/document/batch/{batchId}/status
     * @secure
     */
    documentControllerGetUploadStatus: (
      organizationId: string,
      batchId: string,
      params: RequestParams = {}
    ) =>
      this.request<DocumentUploadStatusListDto, void>({
        path: `/organization/${organizationId}/document/batch/${batchId}/status`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name DocumentControllerGetDocumentTypeSelectList
     * @request GET:/organization/{organizationId}/document/select-list/document-types
     * @secure
     */
    documentControllerGetDocumentTypeSelectList: (
      organizationId: string,
      query?: {
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key  | Type   | Allowed Rules                                                                | Possible Values |
         * | ---- | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | id   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | name | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<SelectListDto, void>({
        path: `/organization/${organizationId}/document/select-list/document-types`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name DocumentControllerGetVendorSelectList
     * @request GET:/organization/{organizationId}/document/select-list/vendors
     * @secure
     */
    documentControllerGetVendorSelectList: (
      organizationId: string,
      query?: {
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key  | Type   | Allowed Rules                                                                | Possible Values |
         * | ---- | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | id   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | name | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<SelectListDto, void>({
        path: `/organization/${organizationId}/document/select-list/vendors`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name DocumentControllerGetCategoryManagerSelectList
     * @request GET:/organization/{organizationId}/document/select-list/category-managers
     * @secure
     */
    documentControllerGetCategoryManagerSelectList: (
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<SelectListDto, void>({
        path: `/organization/${organizationId}/document/select-list/category-managers`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organization
     * @name OrganizationControllerGetOrganizationById
     * @request GET:/organization/{organizationId}
     * @secure
     */
    organizationControllerGetOrganizationById: (
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<OrganizationDto, void>({
        path: `/organization/${organizationId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organization
     * @name OrganizationControllerAcceptMicrositeTermsOfService
     * @request POST:/organization/{organizationId}/terms-of-service/accept
     * @secure
     */
    organizationControllerAcceptMicrositeTermsOfService: (
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<OrganizationDto, void>({
        path: `/organization/${organizationId}/terms-of-service/accept`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organization
     * @name OrganizationControllerGetYourTeam
     * @request GET:/organization/{organizationId}/your-team
     * @secure
     */
    organizationControllerGetYourTeam: (
      organizationId: string,
      query?: {
        billingContactProvider?: BillingInvoiceContactCompany;
      },
      params: RequestParams = {}
    ) =>
      this.request<YourTeamDto, void>({
        path: `/organization/${organizationId}/your-team`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organization
     * @name OrganizationControllerFindAllTasks
     * @request GET:/organization/{organizationId}/tasks
     * @secure
     */
    organizationControllerFindAllTasks: (
      organizationId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - title
         * - description
         * - completed
         * - priorityLevel
         * - createdAt
         * - updatedAt
         * - deadline
         * - completedAt
         * - timeLogged
         * - estimatedTime
         * - category
         * - referenceLink
         * - referenceName
         * - organizationId
         * - vendorId
         * - seenAt
         * - seen
         * - taskTags.tag.name
         * - taskTags.tag.color
         * - taskTags.tag.createdBy
         * - taskTags.contactId
         * - taskTags.employeeId
         * - taskTags.type
         * - assignee
         * - subauditId
         * - projectId
         * - ticketId
         * - commentsCount
         * - unfinishedSubtasksCount
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                     | Type    | Allowed Rules                                                                | Possible Values |
         * | ----------------------- | ------- | ---------------------------------------------------------------------------- | --------------- |
         * | id                      | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | title                   | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | description             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | completed               | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                 |
         * | priorityLevel           | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdAt               | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | updatedAt               | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | deadline                | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | completedAt             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | timeLogged              | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | estimatedTime           | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | category                | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | referenceLink           | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | referenceName           | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organizationId          | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendorId                | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | seenAt                  | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | seen                    | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                 |
         * | taskTags.tag.name       | object  |                                                                              |                 |
         * | taskTags.tag.color      | object  |                                                                              |                 |
         * | taskTags.tag.createdBy  | object  |                                                                              |                 |
         * | taskTags.contactId      | object  |                                                                              |                 |
         * | taskTags.employeeId     | object  |                                                                              |                 |
         * | taskTags.type           | object  |                                                                              |                 |
         * | assignee                | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subauditId              | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | projectId               | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | ticketId                | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | commentsCount           | number  | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | unfinishedSubtasksCount | number  | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - title
         * - description
         * - category
         * - assignee.name
         * - assignee.emailAddress
         * - createdBy.name
         * - createdBy.emailAddress
         * - subtasks.title
         * - subtasks.description
         * - taskTagss.tag.name
         * - taskTagss.contact.name
         * - taskTagss.employee.name
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<TaskListDto, void>({
        path: `/organization/${organizationId}/tasks`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organization
     * @name OrganizationControllerFindAllUsers
     * @request GET:/organization/{organizationId}/users
     * @secure
     */
    organizationControllerFindAllUsers: (
      organizationId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - email
         * - deletedAt
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key       | Type   | Allowed Rules                                                                | Possible Values |
         * | --------- | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | id        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | name      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | email     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | deletedAt | object |                                                                              |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - name
         * - emailAddress
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<ExternalUserPartialListDto, void>({
        path: `/organization/${organizationId}/users`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organization
     * @name OrganizationControllerFindAllowedDomains
     * @request GET:/organization/{organizationId}/allowed-domains
     * @secure
     */
    organizationControllerFindAllowedDomains: (
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<AllowedDomainListDto, void>({
        path: `/organization/${organizationId}/allowed-domains`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organization
     * @name OrganizationControllerGetAllSpendCategoriesDeprecated
     * @summary Use GET /spend-categories instead
     * @request GET:/organization/{organizationId}/spend-categories
     * @deprecated
     * @secure
     */
    organizationControllerGetAllSpendCategoriesDeprecated: (
      organizationId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - spendAreaId
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type   | Allowed Rules                                                                | Possible Values |
         * | ----------- | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | id          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | name        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | spendAreaId | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - name
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<SpendCategoryListDto, void>({
        path: `/organization/${organizationId}/spend-categories`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organization
     * @name OrganizationControllerGetAdditionalColumns
     * @request GET:/organization/{organizationId}/additional-columns/{tableName}
     * @secure
     */
    organizationControllerGetAdditionalColumns: (
      tableName: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<AdditionalColumnsListDto, void>({
        path: `/organization/${organizationId}/additional-columns/${tableName}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billings
     * @name BillingsControllerGetInvoiceFile
     * @request GET:/organization/{organizationId}/billings/netsuite/invoices/{invoiceId}/file
     * @secure
     */
    billingsControllerGetInvoiceFile: (
      invoiceId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/organization/${organizationId}/billings/netsuite/invoices/${invoiceId}/file`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billings
     * @name BillingsControllerGetNetsuiteInvoiceById
     * @request GET:/organization/{organizationId}/billings/netsuite/invoices/{invoiceId}
     * @secure
     */
    billingsControllerGetNetsuiteInvoiceById: (
      invoiceId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<NetsuiteInvoiceDto, void>({
        path: `/organization/${organizationId}/billings/netsuite/invoices/${invoiceId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billings
     * @name BillingsControllerGetInvoiceNetsuiteSummary
     * @request GET:/organization/{organizationId}/billings/netsuite/summary
     * @secure
     */
    billingsControllerGetInvoiceNetsuiteSummary: (
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<InvoiceSummaryDto, void>({
        path: `/organization/${organizationId}/billings/netsuite/summary`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billings
     * @name BillingsControllerExportNetsuiteInvoices
     * @request GET:/organization/{organizationId}/billings/netsuite/export
     * @secure
     */
    billingsControllerExportNetsuiteInvoices: (
      organizationId: string,
      query: {
        /** Column paths to export. Pass as repeated query params (preferred) or a JSON array string. Headers are auto-generated from keys. Example: columns=name&columns=status */
        columns: string[];
        /** Custom filename for the CSV download (without extension). */
        filename?: string;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - dueDate
         * - status
         * - date
         * - vendorName
         * - invoiceNumber
         * - amount
         * - balance
         * - locationName
         * - locationId
         * - accountNumber
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key           | Type   | Allowed Rules                                                                | Possible Values              |
         * | ------------- | ------ | ---------------------------------------------------------------------------- | ---------------------------- |
         * | dueDate       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                              |
         * | status        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | paid, unpaid, partially-paid |
         * | date          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                              |
         * | vendorName    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                              |
         * | invoiceNumber | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                              |
         * | amount        | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                              |
         * | balance       | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                              |
         * | locationName  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                              |
         * | locationId    | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                              |
         * | accountNumber | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                              |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<StreamableFile, void>({
        path: `/organization/${organizationId}/billings/netsuite/export`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billings
     * @name BillingsControllerGetInvoiceNetsuite
     * @request GET:/organization/{organizationId}/billings/netsuite
     * @secure
     */
    billingsControllerGetInvoiceNetsuite: (
      organizationId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - dueDate
         * - status
         * - date
         * - vendorName
         * - invoiceNumber
         * - amount
         * - balance
         * - locationName
         * - locationId
         * - accountNumber
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key           | Type   | Allowed Rules                                                                | Possible Values              |
         * | ------------- | ------ | ---------------------------------------------------------------------------- | ---------------------------- |
         * | dueDate       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                              |
         * | status        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | paid, unpaid, partially-paid |
         * | date          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                              |
         * | vendorName    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                              |
         * | invoiceNumber | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                              |
         * | amount        | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                              |
         * | balance       | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                              |
         * | locationName  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                              |
         * | locationId    | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                              |
         * | accountNumber | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                              |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<NetsuiteInvoiceListDto, void>({
        path: `/organization/${organizationId}/billings/netsuite`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billings
     * @name BillingsControllerGetInvoiceVectorSummary
     * @request GET:/organization/{organizationId}/billings/vector/summary
     * @secure
     */
    billingsControllerGetInvoiceVectorSummary: (
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<InvoiceSummaryDto, void>({
        path: `/organization/${organizationId}/billings/vector/summary`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billings
     * @name BillingsControllerExportVectorInvoices
     * @request GET:/organization/{organizationId}/billings/vector/export
     * @secure
     */
    billingsControllerExportVectorInvoices: (
      organizationId: string,
      query: {
        /** Column paths to export. Pass as repeated query params (preferred) or a JSON array string. Headers are auto-generated from keys. Example: columns=name&columns=status */
        columns: string[];
        /** Custom filename for the CSV download (without extension). */
        filename?: string;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - dueDate
         * - status
         * - date
         * - vendorName
         * - invoiceNumber
         * - amount
         * - balance
         * - locationName
         * - locationId
         * - accountNumber
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key           | Type   | Allowed Rules                                                                | Possible Values              |
         * | ------------- | ------ | ---------------------------------------------------------------------------- | ---------------------------- |
         * | dueDate       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                              |
         * | status        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | paid, unpaid, partially-paid |
         * | date          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                              |
         * | vendorName    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                              |
         * | invoiceNumber | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                              |
         * | amount        | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                              |
         * | balance       | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                              |
         * | locationName  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                              |
         * | locationId    | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                              |
         * | accountNumber | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                              |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<StreamableFile, void>({
        path: `/organization/${organizationId}/billings/vector/export`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billings
     * @name BillingsControllerGetInvoice
     * @request GET:/organization/{organizationId}/billings/vector
     * @secure
     */
    billingsControllerGetInvoice: (
      organizationId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - dueDate
         * - status
         * - date
         * - vendorName
         * - invoiceNumber
         * - amount
         * - balance
         * - locationName
         * - locationId
         * - accountNumber
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key           | Type   | Allowed Rules                                                                | Possible Values              |
         * | ------------- | ------ | ---------------------------------------------------------------------------- | ---------------------------- |
         * | dueDate       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                              |
         * | status        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | paid, unpaid, partially-paid |
         * | date          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                              |
         * | vendorName    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                              |
         * | invoiceNumber | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                              |
         * | amount        | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                              |
         * | balance       | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                              |
         * | locationName  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                              |
         * | locationId    | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                              |
         * | accountNumber | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                              |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<VectorInvoiceListResponseDto, void>({
        path: `/organization/${organizationId}/billings/vector`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billings
     * @name BillingsControllerCreateZipJobForBillingsNetsuite
     * @request POST:/organization/{organizationId}/billings/netsuite/zip
     * @secure
     */
    billingsControllerCreateZipJobForBillingsNetsuite: (
      organizationId: string,
      data: CreateZipNetsuiteRequestDto,
      params: RequestParams = {}
    ) =>
      this.request<CreateBillingsZipResponseDto, void>({
        path: `/organization/${organizationId}/billings/netsuite/zip`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billings
     * @name BillingsControllerGetInvoiceFileById
     * @request GET:/organization/{organizationId}/billings/netsuite/invoices/{invoiceId}/files/{fileId}
     * @secure
     */
    billingsControllerGetInvoiceFileById: (
      invoiceId: string,
      fileId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<StreamableFile, void>({
        path: `/organization/${organizationId}/billings/netsuite/invoices/${invoiceId}/files/${fileId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billings
     * @name BillingsControllerCreateZipJobForBillingsVector
     * @request POST:/organization/{organizationId}/billings/vector/zip
     * @secure
     */
    billingsControllerCreateZipJobForBillingsVector: (
      organizationId: string,
      data: CreateZipVectorRequestDto,
      params: RequestParams = {}
    ) =>
      this.request<CreateBillingsZipResponseDto, void>({
        path: `/organization/${organizationId}/billings/vector/zip`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contacts
     * @name OrganizationContactsControllerGetOrganizationContacts
     * @request GET:/organization/{organizationId}/contacts
     * @secure
     */
    organizationContactsControllerGetOrganizationContacts: (
      organizationId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - email
         * - firstName
         * - lastName
         * - title
         * - isActive
         * - phoneNumber
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type    | Allowed Rules                                                                | Possible Values |
         * | ----------- | ------- | ---------------------------------------------------------------------------- | --------------- |
         * | id          | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | name        | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | email       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | firstName   | object  |                                                                              |                 |
         * | lastName    | object  |                                                                              |                 |
         * | title       | object  |                                                                              |                 |
         * | isActive    | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                 |
         * | phoneNumber | object  |                                                                              |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - name
         * - email
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<ContactsListDto, void>({
        path: `/organization/${organizationId}/contacts`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contacts
     * @name OrganizationContactsControllerGetAllVendorContactsOfOrganization
     * @request GET:/organization/{organizationId}/contacts/vendors
     * @secure
     */
    organizationContactsControllerGetAllVendorContactsOfOrganization: (
      organizationId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - email
         * - firstName
         * - lastName
         * - title
         * - isActive
         * - phoneNumber
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type    | Allowed Rules                                                                | Possible Values |
         * | ----------- | ------- | ---------------------------------------------------------------------------- | --------------- |
         * | id          | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | name        | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | email       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | firstName   | object  |                                                                              |                 |
         * | lastName    | object  |                                                                              |                 |
         * | title       | object  |                                                                              |                 |
         * | isActive    | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                 |
         * | phoneNumber | object  |                                                                              |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - name
         * - email
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<VendorContactsListDto, void>({
        path: `/organization/${organizationId}/contacts/vendors`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subaudits
     * @name SubauditsControllerFindAll
     * @request GET:/organization/{organizationId}/subaudits
     * @secure
     */
    subauditsControllerFindAll: (
      organizationId: string,
      query?: {
        searchTerm?: string;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - subauditStage
         * - vendorAccountNumber
         * - onHold
         * - spendAmount
         * - createdAt
         * - updatedAt
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                 | Type    | Allowed Rules                                                                | Possible Values |
         * | ------------------- | ------- | ---------------------------------------------------------------------------- | --------------- |
         * | id                  | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subauditStage       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendorAccountNumber | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | onHold              | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                 |
         * | spendAmount         | number  | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | createdAt           | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | updatedAt           | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<SubauditsListDto, void>({
        path: `/organization/${organizationId}/subaudits`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subaudits
     * @name SubauditsControllerCreate
     * @request POST:/organization/{organizationId}/subaudits
     * @secure
     */
    subauditsControllerCreate: (
      organizationId: string,
      data: CreateSubauditDto,
      params: RequestParams = {}
    ) =>
      this.request<SubauditDto, void>({
        path: `/organization/${organizationId}/subaudits`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subaudits
     * @name SubauditsControllerUpdate
     * @request PATCH:/organization/{organizationId}/subaudits/{id}
     * @secure
     */
    subauditsControllerUpdate: (
      organizationId: string,
      id: string,
      data: UpdateSubauditDto,
      params: RequestParams = {}
    ) =>
      this.request<SubauditDto, void>({
        path: `/organization/${organizationId}/subaudits/${id}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subaudits
     * @name SubauditsControllerFindOne
     * @request GET:/organization/{organizationId}/subaudits/{id}
     * @secure
     */
    subauditsControllerFindOne: (
      organizationId: string,
      id: string,
      params: RequestParams = {}
    ) =>
      this.request<SubauditDto, void>({
        path: `/organization/${organizationId}/subaudits/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subaudits
     * @name SubauditsControllerDeleteOne
     * @request DELETE:/organization/{organizationId}/subaudits/{id}
     * @secure
     */
    subauditsControllerDeleteOne: (
      organizationId: string,
      id: string,
      params: RequestParams = {}
    ) =>
      this.request<SubauditDto, void>({
        path: `/organization/${organizationId}/subaudits/${id}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SubauditComments
     * @name SubauditCommentsControllerGetSubauditComments
     * @request GET:/organization/{organizationId}/subaudit/{subauditId}/comments
     * @secure
     */
    subauditCommentsControllerGetSubauditComments: (
      subauditId: string,
      organizationId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - topic
         * - content
         * - createdAt
         * - updatedAt
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key       | Type   | Allowed Rules                                                                | Possible Values |
         * | --------- | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | id        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | topic     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | content   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdAt | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | updatedAt | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<SubauditCommentListDto, void>({
        path: `/organization/${organizationId}/subaudit/${subauditId}/comments`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SubauditComments
     * @name SubauditCommentsControllerCreateSubauditComment
     * @request POST:/organization/{organizationId}/subaudit/{subauditId}/comments
     * @secure
     */
    subauditCommentsControllerCreateSubauditComment: (
      subauditId: string,
      organizationId: string,
      data: CreateSubauditCommentDto,
      params: RequestParams = {}
    ) =>
      this.request<SubauditCommentDto, void>({
        path: `/organization/${organizationId}/subaudit/${subauditId}/comments`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SubauditComments
     * @name SubauditCommentsControllerGetSubauditComment
     * @request GET:/organization/{organizationId}/subaudit/{subauditId}/comments/{commentId}
     * @secure
     */
    subauditCommentsControllerGetSubauditComment: (
      subauditId: string,
      commentId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<SubauditCommentDto, void>({
        path: `/organization/${organizationId}/subaudit/${subauditId}/comments/${commentId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SubauditComments
     * @name SubauditCommentsControllerUpdateSubauditComment
     * @request PATCH:/organization/{organizationId}/subaudit/{subauditId}/comments/{commentId}
     * @secure
     */
    subauditCommentsControllerUpdateSubauditComment: (
      subauditId: string,
      commentId: string,
      organizationId: string,
      data: UpdateSubauditCommentDto,
      params: RequestParams = {}
    ) =>
      this.request<SubauditCommentDto, void>({
        path: `/organization/${organizationId}/subaudit/${subauditId}/comments/${commentId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SubauditComments
     * @name SubauditCommentsControllerDeleteSubauditComment
     * @request DELETE:/organization/{organizationId}/subaudit/{subauditId}/comments/{commentId}
     * @secure
     */
    subauditCommentsControllerDeleteSubauditComment: (
      subauditId: string,
      commentId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<SubauditCommentDto, void>({
        path: `/organization/${organizationId}/subaudit/${subauditId}/comments/${commentId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Action Item
     * @name ActionItemControllerFindAllActionItems
     * @request GET:/organization/{organizationId}/action-items
     * @secure
     */
    actionItemControllerFindAllActionItems: (
      organizationId: string,
      query?: {
        searchTerm?: string;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - title
         * - description
         * - spendAreaStage
         * - priorityLevel
         * - actionType
         * - createdBy
         * - deadline
         * - completedAt
         * - createdAt
         * - updatedAt
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key            | Type   | Allowed Rules                                                                | Possible Values |
         * | -------------- | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | title          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | description    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | spendAreaStage | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | priorityLevel  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | actionType     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdBy      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | deadline       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | completedAt    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdAt      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | updatedAt      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<ActionItemListDto, void>({
        path: `/organization/${organizationId}/action-items`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Action Item
     * @name ActionItemControllerCreateActionItem
     * @request POST:/organization/{organizationId}/action-items
     * @secure
     */
    actionItemControllerCreateActionItem: (
      organizationId: string,
      data: CreateActionItemDto,
      params: RequestParams = {}
    ) =>
      this.request<ActionItemDto, void>({
        path: `/organization/${organizationId}/action-items`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Action Item
     * @name ActionItemControllerFindOneActionItems
     * @request GET:/organization/{organizationId}/action-items/{actionItemId}
     * @secure
     */
    actionItemControllerFindOneActionItems: (
      actionItemId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<ActionItemDto, void>({
        path: `/organization/${organizationId}/action-items/${actionItemId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Action Item
     * @name ActionItemControllerUpdateActionItem
     * @request PATCH:/organization/{organizationId}/action-items/{actionItemId}
     * @secure
     */
    actionItemControllerUpdateActionItem: (
      organizationId: string,
      actionItemId: string,
      data: UpdateActionItemDto,
      params: RequestParams = {}
    ) =>
      this.request<ActionItemDto, void>({
        path: `/organization/${organizationId}/action-items/${actionItemId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Action Item
     * @name ActionItemControllerDeleteActionItem
     * @request DELETE:/organization/{organizationId}/action-items/{actionItemId}
     * @secure
     */
    actionItemControllerDeleteActionItem: (
      actionItemId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<ActionItemDto, void>({
        path: `/organization/${organizationId}/action-items/${actionItemId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Request Spend Area
     * @name RequestSpendAreaControllerCreateRequestedSpendArea
     * @request POST:/organization/{organizationId}/request-spend-areas/{spendAreaId}
     * @secure
     */
    requestSpendAreaControllerCreateRequestedSpendArea: (
      organizationId: string,
      spendAreaId: string,
      params: RequestParams = {}
    ) =>
      this.request<any, void | RequestSpendAreaResponseDto>({
        path: `/organization/${organizationId}/request-spend-areas/${spendAreaId}`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Request Spend Area
     * @name RequestSpendAreaControllerCreateManyRequestedSpendArea
     * @request POST:/organization/{organizationId}/request-spend-areas
     * @secure
     */
    requestSpendAreaControllerCreateManyRequestedSpendArea: (
      organizationId: string,
      data: RequestSpendAreaBodyDto,
      params: RequestParams = {}
    ) =>
      this.request<any, void | RequestSpendAreaResponseDto>({
        path: `/organization/${organizationId}/request-spend-areas`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ChildOrganization
     * @name ChildOrganizationControllerGetChildrenOrganizations
     * @request GET:/organization/{organizationId}/child-organizations
     * @secure
     */
    childOrganizationControllerGetChildrenOrganizations: (
      organizationId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - createdAt
         * - updatedAt
         * - micrositesEnabled
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key               | Type    | Allowed Rules                                                                | Possible Values |
         * | ----------------- | ------- | ---------------------------------------------------------------------------- | --------------- |
         * | id                | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | name              | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdAt         | date    | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty   |                 |
         * | updatedAt         | date    | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty   |                 |
         * | micrositesEnabled | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                 |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<ChildOrganizationListDto, void>({
        path: `/organization/${organizationId}/child-organizations`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Access Share
     * @name AccessShareControllerGetInvitedUsers
     * @request GET:/organization/{organizationId}/invited-users
     * @secure
     */
    accessShareControllerGetInvitedUsers: (
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<InvitedUserDto[], void>({
        path: `/organization/${organizationId}/invited-users`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Access Share
     * @name AccessShareControllerInviteUsers
     * @request POST:/organization/{organizationId}/invite
     * @secure
     */
    accessShareControllerInviteUsers: (
      organizationId: string,
      data: InviteUserBodyDto,
      params: RequestParams = {}
    ) =>
      this.request<InviteUserResponseDto, void>({
        path: `/organization/${organizationId}/invite`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Access Share
     * @name AccessShareControllerResendInvitation
     * @request POST:/organization/{organizationId}/invited-users/{userId}/resend-invitation
     * @secure
     */
    accessShareControllerResendInvitation: (
      userId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/organization/${organizationId}/invited-users/${userId}/resend-invitation`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Locations
     * @name OrganizationLocationsControllerFindAllSelectList
     * @request GET:/organization/{organizationId}/locations/select-list
     * @secure
     */
    organizationLocationsControllerFindAllSelectList: (
      organizationId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - address
         * - city
         * - state
         * - zip
         * - taxId
         * - phone
         * - kind
         * - status
         * - documentFieldStatus
         * - locationIdentifier
         * - name
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                 | Type   | Allowed Rules                                                                | Possible Values                                                                     |
         * | ------------------- | ------ | ---------------------------------------------------------------------------- | ----------------------------------------------------------------------------------- |
         * | id                  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | address             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | city                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | state               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | zip                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | taxId               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | phone               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | kind                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | site, organization_wide                                                             |
         * | status              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | Active, Monitored, Sold, Closed, Under Construction, Not Active                     |
         * | documentFieldStatus | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | COMPLETE, MISSING_FIELDS, UPLOAD_INVOICES, NOT_APPLICABLE_REQUESTED, NOT_APPLICABLE |
         * | locationIdentifier  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | name                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<LocationSelectListDto, void>({
        path: `/organization/${organizationId}/locations/select-list`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Document
     * @name ArchiveDocumentControllerCreateZipJob
     * @request POST:/organization/{organizationId}/document/zip
     * @secure
     */
    archiveDocumentControllerCreateZipJob: (
      organizationId: string,
      data: CreateArchiveDocumentsRequestDto,
      params: RequestParams = {}
    ) =>
      this.request<ArchiveDocumentsResponseDto, void>({
        path: `/organization/${organizationId}/document/zip`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Management
     * @name UserManagementControllerGetOrganizationUsers
     * @request GET:/organization/{organizationId}/user-management
     * @secure
     */
    userManagementControllerGetOrganizationUsers: (
      organizationId: string,
      query?: {
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - name
         * - email
         * - title
         * - role
         * - firstSignedInAt
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key             | Type   | Allowed Rules                                                                | Possible Values |
         * | --------------- | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | name            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | email           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | title           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | role            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | firstSignedInAt | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - user.name
         * - user.emailAddress
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<OrganizationUsersGroupedDto, void>({
        path: `/organization/${organizationId}/user-management`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Management
     * @name UserManagementControllerUpdateUserRole
     * @request PATCH:/organization/{organizationId}/user-management/{userId}/role
     * @secure
     */
    userManagementControllerUpdateUserRole: (
      userId: string,
      organizationId: string,
      data: UpdateUserRoleDto,
      params: RequestParams = {}
    ) =>
      this.request<OrganizationUserDto, void>({
        path: `/organization/${organizationId}/user-management/${userId}/role`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags OrganizationTickets
     * @name OrganizationTicketsControllerGetTickets
     * @request GET:/organization/{organizationId}/tickets
     * @secure
     */
    organizationTicketsControllerGetTickets: (
      organizationId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - vectorTicketId
         * - subject
         * - description
         * - status
         * - priority
         * - category
         * - subCategory
         * - vendorName
         * - location
         * - zip
         * - address
         * - city
         * - state
         * - subStatus
         * - assignee
         * - requestor
         * - assigneeEmail
         * - assigneeName
         * - requestorEmail
         * - requestorName
         * - organizationId
         * - organizationName
         * - vendorId
         * - ticketNumber
         * - commentsCount
         * - accessToExternalUser
         * - createdAt
         * - updatedAt
         * - dueDate
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                  | Type    | Allowed Rules                                                                | Possible Values |
         * | -------------------- | ------- | ---------------------------------------------------------------------------- | --------------- |
         * | id                   | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vectorTicketId       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subject              | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | description          | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | status               | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | priority             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | category             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subCategory          | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendorName           | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | location             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | zip                  | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | address              | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | city                 | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | state                | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subStatus            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assignee             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | requestor            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeEmail        | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeName         | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | requestorEmail       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | requestorName        | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organizationId       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organizationName     | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendorId             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | ticketNumber         | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | commentsCount        | number  | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | accessToExternalUser | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                 |
         * | createdAt            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | updatedAt            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | dueDate              | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - subject
         * - description
         * - category
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<TicketListDto, void>({
        path: `/organization/${organizationId}/tickets`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags OrganizationTickets
     * @name OrganizationTicketsControllerCreateTicket
     * @request POST:/organization/{organizationId}/tickets
     * @secure
     */
    organizationTicketsControllerCreateTicket: (
      organizationId: string,
      data: CreateTicketDto,
      params: RequestParams = {}
    ) =>
      this.request<TicketWithDetailsDto, void>({
        path: `/organization/${organizationId}/tickets`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags OrganizationTickets
     * @name OrganizationTicketsControllerExportTickets
     * @request GET:/organization/{organizationId}/tickets/export
     * @secure
     */
    organizationTicketsControllerExportTickets: (
      organizationId: string,
      query: {
        /** Column paths to export. Pass as repeated query params (preferred) or a JSON array string. Headers are auto-generated from keys. Example: columns=name&columns=status */
        columns: string[];
        /** Custom filename for the CSV download (without extension). */
        filename?: string;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - vectorTicketId
         * - subject
         * - description
         * - status
         * - priority
         * - category
         * - subCategory
         * - vendorName
         * - location
         * - zip
         * - address
         * - city
         * - state
         * - subStatus
         * - assignee
         * - requestor
         * - assigneeEmail
         * - assigneeName
         * - requestorEmail
         * - requestorName
         * - organizationId
         * - organizationName
         * - vendorId
         * - ticketNumber
         * - commentsCount
         * - accessToExternalUser
         * - createdAt
         * - updatedAt
         * - dueDate
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                  | Type    | Allowed Rules                                                                | Possible Values |
         * | -------------------- | ------- | ---------------------------------------------------------------------------- | --------------- |
         * | id                   | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vectorTicketId       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subject              | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | description          | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | status               | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | priority             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | category             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subCategory          | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendorName           | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | location             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | zip                  | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | address              | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | city                 | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | state                | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subStatus            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assignee             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | requestor            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeEmail        | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeName         | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | requestorEmail       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | requestorName        | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organizationId       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organizationName     | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendorId             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | ticketNumber         | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | commentsCount        | number  | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | accessToExternalUser | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                 |
         * | createdAt            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | updatedAt            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | dueDate              | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - subject
         * - description
         * - category
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<StreamableFile, void>({
        path: `/organization/${organizationId}/tickets/export`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags OrganizationTickets
     * @name OrganizationTicketsControllerGetTicket
     * @request GET:/organization/{organizationId}/tickets/{ticketId}
     * @secure
     */
    organizationTicketsControllerGetTicket: (
      ticketId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<TicketWithDetailsDto, void>({
        path: `/organization/${organizationId}/tickets/${ticketId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags OrganizationTickets
     * @name OrganizationTicketsControllerCreateExternalComment
     * @request POST:/organization/{organizationId}/tickets/{ticketId}/comments
     * @secure
     */
    organizationTicketsControllerCreateExternalComment: (
      ticketId: string,
      organizationId: string,
      data: CreateTicketCommentExternalDto,
      params: RequestParams = {}
    ) =>
      this.request<CreateTicketCommentResponseDto, void>({
        path: `/organization/${organizationId}/tickets/${ticketId}/comments`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  aiAgent = {
    /**
     * No description
     *
     * @tags AI Agent Integration - Documents
     * @name DocumentsControllerGetVendorSelectList
     * @request GET:/ai-agent/organizations/{organizationId}/documents/select-list/vendors
     * @secure
     */
    documentsControllerGetVendorSelectList: (
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<SelectListDto, any>({
        path: `/ai-agent/organizations/${organizationId}/documents/select-list/vendors`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AI Agent Integration - Documents
     * @name DocumentsControllerGetSpendCategorySelectList
     * @request GET:/ai-agent/organizations/{organizationId}/documents/select-list/spend-categories
     * @secure
     */
    documentsControllerGetSpendCategorySelectList: (
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<SelectListDto, any>({
        path: `/ai-agent/organizations/${organizationId}/documents/select-list/spend-categories`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AI Agent Integration - Documents
     * @name DocumentsControllerGetDocumentTypeSelectList
     * @request GET:/ai-agent/organizations/{organizationId}/documents/select-list/document-types
     * @secure
     */
    documentsControllerGetDocumentTypeSelectList: (
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<SelectListDto, any>({
        path: `/ai-agent/organizations/${organizationId}/documents/select-list/document-types`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AI Agent Integration - Documents
     * @name DocumentsControllerGetContractTypeSelectList
     * @request GET:/ai-agent/organizations/{organizationId}/documents/select-list/contract-types
     * @secure
     */
    documentsControllerGetContractTypeSelectList: (
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<SelectListDto, any>({
        path: `/ai-agent/organizations/${organizationId}/documents/select-list/contract-types`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AI Agent Integration - Documents
     * @name DocumentsControllerEnqueueDocumentSync
     * @request POST:/ai-agent/organizations/{organizationId}/documents/sync
     * @secure
     */
    documentsControllerEnqueueDocumentSync: (
      organizationId: string,
      data: SyncFranzDocumentDto,
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/ai-agent/organizations/${organizationId}/documents/sync`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AI Agent Integration - Documents
     * @name DocumentsControllerGetFileUrl
     * @summary Return a time-limited SAS URL for reading the document blob by MD5 hash
     * @request GET:/ai-agent/organizations/{organizationId}/documents/{documentHash}/file-url
     * @secure
     */
    documentsControllerGetFileUrl: (
      organizationId: string,
      documentHash: string,
      params: RequestParams = {}
    ) =>
      this.request<DocumentFileUrlDto, any>({
        path: `/ai-agent/organizations/${organizationId}/documents/${documentHash}/file-url`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AI Agent Integration - Documents
     * @name DocumentsControllerGetById
     * @request GET:/ai-agent/organizations/{organizationId}/documents/{id}
     * @secure
     */
    documentsControllerGetById: (
      id: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<DocumentDto, any>({
        path: `/ai-agent/organizations/${organizationId}/documents/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AI Agent Integration - Users
     * @name UsersControllerHasUserAccess
     * @request GET:/ai-agent/users/{userId}/organizations/{organizationId}
     * @secure
     */
    usersControllerHasUserAccess: (
      userId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/ai-agent/users/${userId}/organizations/${organizationId}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AI Agent Integration - Users
     * @name UsersControllerCanAccessSensitiveDocuments
     * @request GET:/ai-agent/users/{userId}/organizations/{organizationId}/permissions/sensitive-documents
     * @secure
     */
    usersControllerCanAccessSensitiveDocuments: (
      userId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<SensitiveDocumentsPermissionDto, any>({
        path: `/ai-agent/users/${userId}/organizations/${organizationId}/permissions/sensitive-documents`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AI Agent Integration - Users
     * @name UsersControllerCanAccessInternalDocuments
     * @request GET:/ai-agent/users/{userId}/organizations/{organizationId}/permissions/internal-documents
     * @secure
     */
    usersControllerCanAccessInternalDocuments: (
      userId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<InternalDocumentsPermissionDto, any>({
        path: `/ai-agent/users/${userId}/organizations/${organizationId}/permissions/internal-documents`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  externalUsers = {
    /**
     * No description
     *
     * @tags External Users
     * @name ExternalUsersControllerGetAllList
     * @request GET:/external-users
     * @secure
     */
    externalUsersControllerGetAllList: (
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - emailAddress
         * - surname
         * - contactPhoneNumber
         * - title
         * - userLoginStatus
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                | Type   | Allowed Rules                                                                | Possible Values |
         * | ------------------ | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | id                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | name               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | emailAddress       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | surname            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | contactPhoneNumber | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | title              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | userLoginStatus    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - name
         * - emailAddress
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<ExternalUserPartialListDto, void>({
        path: `/external-users`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags External Users
     * @name ExternalUsersControllerFindAllCoworkers
     * @request GET:/external-users/coworkers
     * @secure
     */
    externalUsersControllerFindAllCoworkers: (
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - emailAddress
         * - surname
         * - contactPhoneNumber
         * - title
         * - userLoginStatus
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                | Type   | Allowed Rules                                                                | Possible Values |
         * | ------------------ | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | id                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | name               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | emailAddress       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | surname            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | contactPhoneNumber | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | title              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | userLoginStatus    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - name
         * - emailAddress
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<ExternalUserPartialListDto, void>({
        path: `/external-users/coworkers`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags External Users
     * @name ExternalUsersControllerUpdateExternalUser
     * @request PATCH:/external-users/{id}
     * @secure
     */
    externalUsersControllerUpdateExternalUser: (
      id: string,
      data: UpdateExternalUserDto,
      params: RequestParams = {}
    ) =>
      this.request<PlainExternalUserDto, void>({
        path: `/external-users/${id}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  organizations = {
    /**
     * No description
     *
     * @tags Category Managers
     * @name CategoryManagersControllerGetCategoryManagers
     * @request GET:/organizations/{organizationId}/category-managers
     * @secure
     */
    categoryManagersControllerGetCategoryManagers: (
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<SelectListDto, void>({
        path: `/organizations/${organizationId}/category-managers`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - SIB Invoice
     * @name SibInvoiceControllerListUncategorizedSavingsShares
     * @request GET:/organizations/{organizationId}/sib-invoice/savings-shares/uncategorized
     * @secure
     */
    sibInvoiceControllerListUncategorizedSavingsShares: (
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<UncategorizedSavingsShareDto[], void>({
        path: `/organizations/${organizationId}/sib-invoice/savings-shares/uncategorized`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - SIB Invoice
     * @name SibInvoiceControllerListAssignableSpendCategories
     * @request GET:/organizations/{organizationId}/sib-invoice/savings-shares/assignable-categories
     * @secure
     */
    sibInvoiceControllerListAssignableSpendCategories: (
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<AssignableSpendCategoryDto[], void>({
        path: `/organizations/${organizationId}/sib-invoice/savings-shares/assignable-categories`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - SIB Invoice
     * @name SibInvoiceControllerAssignSavingsShareCategory
     * @request POST:/organizations/{organizationId}/sib-invoice/savings-shares/assign-category
     * @secure
     */
    sibInvoiceControllerAssignSavingsShareCategory: (
      organizationId: string,
      data: AssignSavingsShareCategoryDto,
      params: RequestParams = {}
    ) =>
      this.request<AssignSavingsShareCategoryResultDto, void>({
        path: `/organizations/${organizationId}/sib-invoice/savings-shares/assign-category`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - SIB Invoice
     * @name SibInvoiceControllerInvoicePdf
     * @request GET:/organizations/{organizationId}/sib-invoice/invoices/{sibInvoiceId}/pdf
     * @secure
     */
    sibInvoiceControllerInvoicePdf: (
      organizationId: string,
      sibInvoiceId: string,
      params: RequestParams = {}
    ) =>
      this.request<Blob, void>({
        path: `/organizations/${organizationId}/sib-invoice/invoices/${sibInvoiceId}/pdf`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - SIB Invoice
     * @name SibInvoiceControllerInvoiceAttachments
     * @request GET:/organizations/{organizationId}/sib-invoice/invoices/{sibInvoiceId}/attachments
     * @secure
     */
    sibInvoiceControllerInvoiceAttachments: (
      organizationId: string,
      sibInvoiceId: string,
      params: RequestParams = {}
    ) =>
      this.request<SibInvoiceAttachmentDto[], void>({
        path: `/organizations/${organizationId}/sib-invoice/invoices/${sibInvoiceId}/attachments`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - SIB Invoice
     * @name SibInvoiceControllerInvoiceAttachment
     * @request GET:/organizations/{organizationId}/sib-invoice/invoices/{sibInvoiceId}/attachments/{fileId}
     * @secure
     */
    sibInvoiceControllerInvoiceAttachment: (
      organizationId: string,
      sibInvoiceId: string,
      fileId: string,
      params: RequestParams = {}
    ) =>
      this.request<StreamableFile, void>({
        path: `/organizations/${organizationId}/sib-invoice/invoices/${sibInvoiceId}/attachments/${fileId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - SIB Invoice
     * @name SibInvoiceControllerListContractSold
     * @request GET:/organizations/{organizationId}/sib-invoice/contracts/{contractId}/sold
     * @secure
     */
    sibInvoiceControllerListContractSold: (
      organizationId: string,
      contractId: string,
      params: RequestParams = {}
    ) =>
      this.request<ContractSoldLineDto[], void>({
        path: `/organizations/${organizationId}/sib-invoice/contracts/${contractId}/sold`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - SIB Invoice
     * @name SibInvoiceControllerListServices
     * @request GET:/organizations/{organizationId}/sib-invoice/services
     * @secure
     */
    sibInvoiceControllerListServices: (
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<OrganizationSibServiceItemDto[], void>({
        path: `/organizations/${organizationId}/sib-invoice/services`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - SIB Invoice
     * @name SibInvoiceControllerListOccurrences
     * @request GET:/organizations/{organizationId}/sib-invoice/occurrences
     * @secure
     */
    sibInvoiceControllerListOccurrences: (
      organizationId: string,
      query?: {
        range?: SibInvoiceRange;
        /** Any day inside the window. Today by default. */
        anchor?: string;
        /** First day of an explicit window. With `to`, it replaces range and anchor. */
        from?: string;
        /** Last day of an explicit window. */
        to?: string;
        /** Include obligations that have not reached their reveal date, to check a generated run. */
        includeFuture?: boolean;
        /** Also billings whose charge no synced SIB contract backs. Defaults to true. */
        includeWithoutContract?: boolean;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - serviceName
         * - status
         * - attention
         * - billingDate
         * - periodFrom
         * - sibInvoiceNumber
         * - sibInvoiceDate
         * - expectedAmount
         * - amount
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key              | Type   | Allowed Rules                                                                | Possible Values                                                                                       |
         * | ---------------- | ------ | ---------------------------------------------------------------------------- | ----------------------------------------------------------------------------------------------------- |
         * | serviceName      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                       |
         * | status           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | pending_validation, submitted, billed, void                                                           |
         * | attention        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | ambiguous_netsuite_match, netsuite_amount_differs, not_invoiced, billed_outside_sidecar, outside_term |
         * | billingDate      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                       |
         * | periodFrom       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                       |
         * | sibInvoiceNumber | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                       |
         * | sibInvoiceDate   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                       |
         * | expectedAmount   | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                                       |
         * | amount           | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                                       |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<SibInvoiceOccurrenceListDto, void>({
        path: `/organizations/${organizationId}/sib-invoice/occurrences`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - SIB Invoice
     * @name SibInvoiceControllerRaise
     * @request POST:/organizations/{organizationId}/sib-invoice/occurrences
     * @secure
     */
    sibInvoiceControllerRaise: (
      organizationId: string,
      data: RaiseOccurrenceDto,
      params: RequestParams = {}
    ) =>
      this.request<RaiseOccurrenceResultDto, void>({
        path: `/organizations/${organizationId}/sib-invoice/occurrences`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - SIB Invoice
     * @name SibInvoiceControllerListPriceHistory
     * @request GET:/organizations/{organizationId}/sib-invoice/charges/{chargeId}/values
     * @secure
     */
    sibInvoiceControllerListPriceHistory: (
      organizationId: string,
      chargeId: string,
      params: RequestParams = {}
    ) =>
      this.request<SibContractChargeValueDto[], void>({
        path: `/organizations/${organizationId}/sib-invoice/charges/${chargeId}/values`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - SIB Invoice
     * @name SibInvoiceControllerAddPriceChange
     * @request POST:/organizations/{organizationId}/sib-invoice/charges/{chargeId}/values
     * @secure
     */
    sibInvoiceControllerAddPriceChange: (
      organizationId: string,
      chargeId: string,
      data: CreateChargeValueDto,
      params: RequestParams = {}
    ) =>
      this.request<SibContractChargeValueDto, void>({
        path: `/organizations/${organizationId}/sib-invoice/charges/${chargeId}/values`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - SIB Invoice
     * @name SibInvoiceControllerEditPriceChange
     * @request PATCH:/organizations/{organizationId}/sib-invoice/charges/{chargeId}/values/{valueId}
     * @secure
     */
    sibInvoiceControllerEditPriceChange: (
      organizationId: string,
      chargeId: string,
      valueId: string,
      data: UpdateChargeValueDto,
      params: RequestParams = {}
    ) =>
      this.request<SibContractChargeValueDto, void>({
        path: `/organizations/${organizationId}/sib-invoice/charges/${chargeId}/values/${valueId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - SIB Invoice
     * @name SibInvoiceControllerRemovePriceChange
     * @request DELETE:/organizations/{organizationId}/sib-invoice/charges/{chargeId}/values/{valueId}
     * @secure
     */
    sibInvoiceControllerRemovePriceChange: (
      organizationId: string,
      chargeId: string,
      valueId: string,
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/organizations/${organizationId}/sib-invoice/charges/${chargeId}/values/${valueId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - SIB Invoice
     * @name SibInvoiceControllerUpdateCadence
     * @request PATCH:/organizations/{organizationId}/sib-invoice/charges/{chargeId}
     * @secure
     */
    sibInvoiceControllerUpdateCadence: (
      organizationId: string,
      chargeId: string,
      data: CadenceDto,
      params: RequestParams = {}
    ) =>
      this.request<CadenceDto, void>({
        path: `/organizations/${organizationId}/sib-invoice/charges/${chargeId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - SIB Invoice
     * @name SibInvoiceControllerAssignOrphans
     * @request POST:/organizations/{organizationId}/sib-invoice/charges/assign-orphans
     * @secure
     */
    sibInvoiceControllerAssignOrphans: (
      organizationId: string,
      data: AssignOrphanChargesDto,
      params: RequestParams = {}
    ) =>
      this.request<AssignOrphanChargesResultDto, void>({
        path: `/organizations/${organizationId}/sib-invoice/charges/assign-orphans`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - SIB Invoice
     * @name SibInvoiceControllerUpdateChargeNetsuite
     * @request PATCH:/organizations/{organizationId}/sib-invoice/charges/{chargeId}/netsuite
     * @secure
     */
    sibInvoiceControllerUpdateChargeNetsuite: (
      organizationId: string,
      chargeId: string,
      data: UpdateChargeNetsuiteDto,
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/organizations/${organizationId}/sib-invoice/charges/${chargeId}/netsuite`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - SIB Invoice
     * @name SibInvoiceControllerUpdateOccurrenceNetsuite
     * @request PATCH:/organizations/{organizationId}/sib-invoice/occurrences/{occurrenceId}/netsuite
     * @secure
     */
    sibInvoiceControllerUpdateOccurrenceNetsuite: (
      organizationId: string,
      occurrenceId: string,
      data: UpdateOccurrenceNetsuiteDto,
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/organizations/${organizationId}/sib-invoice/occurrences/${occurrenceId}/netsuite`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - SIB Invoice
     * @name SibInvoiceControllerPreviewSchedule
     * @request GET:/organizations/{organizationId}/sib-invoice/charges/{chargeId}/schedule
     * @secure
     */
    sibInvoiceControllerPreviewSchedule: (
      organizationId: string,
      chargeId: string,
      params: RequestParams = {}
    ) =>
      this.request<GeneratedScheduleDto, void>({
        path: `/organizations/${organizationId}/sib-invoice/charges/${chargeId}/schedule`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - SIB Invoice
     * @name SibInvoiceControllerCommitSchedule
     * @request POST:/organizations/{organizationId}/sib-invoice/charges/{chargeId}/schedule
     * @secure
     */
    sibInvoiceControllerCommitSchedule: (
      organizationId: string,
      chargeId: string,
      params: RequestParams = {}
    ) =>
      this.request<GeneratedScheduleDto, void>({
        path: `/organizations/${organizationId}/sib-invoice/charges/${chargeId}/schedule`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - SIB Invoice
     * @name SibInvoiceControllerUpdateAmount
     * @request PATCH:/organizations/{organizationId}/sib-invoice/occurrences/{occurrenceId}
     * @secure
     */
    sibInvoiceControllerUpdateAmount: (
      organizationId: string,
      occurrenceId: string,
      data: UpdateOccurrenceAmountDto,
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/organizations/${organizationId}/sib-invoice/occurrences/${occurrenceId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - SIB Invoice
     * @name SibInvoiceControllerListActivityLog
     * @request GET:/organizations/{organizationId}/sib-invoice/occurrences/{occurrenceId}/activity-log
     * @secure
     */
    sibInvoiceControllerListActivityLog: (
      organizationId: string,
      occurrenceId: string,
      params: RequestParams = {}
    ) =>
      this.request<OccurrenceActivityLogEntryDto[], void>({
        path: `/organizations/${organizationId}/sib-invoice/occurrences/${occurrenceId}/activity-log`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - SIB Invoice
     * @name SibInvoiceControllerAddNote
     * @request POST:/organizations/{organizationId}/sib-invoice/occurrences/{occurrenceId}/activity-log
     * @secure
     */
    sibInvoiceControllerAddNote: (
      organizationId: string,
      occurrenceId: string,
      data: NoteDto,
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/organizations/${organizationId}/sib-invoice/occurrences/${occurrenceId}/activity-log`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - SIB Invoice
     * @name SibInvoiceControllerVoidOccurrence
     * @request POST:/organizations/{organizationId}/sib-invoice/occurrences/{occurrenceId}/void
     * @secure
     */
    sibInvoiceControllerVoidOccurrence: (
      organizationId: string,
      occurrenceId: string,
      data: NoteDto,
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/organizations/${organizationId}/sib-invoice/occurrences/${occurrenceId}/void`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - SIB Invoice
     * @name SibInvoiceNetsuiteControllerListNetsuiteInvoices
     * @request GET:/organizations/{organizationId}/sib-invoice/netsuite
     * @secure
     */
    sibInvoiceNetsuiteControllerListNetsuiteInvoices: (
      organizationId: string,
      query?: {
        /** Only invoices with a NetSuite line nothing bills yet. */
        toReconcile?: boolean;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - dueDate
         * - status
         * - date
         * - invoiceNumber
         * - amount
         * - balance
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key           | Type   | Allowed Rules                                                                | Possible Values              |
         * | ------------- | ------ | ---------------------------------------------------------------------------- | ---------------------------- |
         * | dueDate       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                              |
         * | status        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | paid, unpaid, partially-paid |
         * | date          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                              |
         * | invoiceNumber | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                              |
         * | amount        | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                              |
         * | balance       | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                              |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<SibNetsuiteInvoiceListDto, void>({
        path: `/organizations/${organizationId}/sib-invoice/netsuite`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - SIB Invoice
     * @name SibInvoiceNetsuiteControllerNetsuiteSummary
     * @request GET:/organizations/{organizationId}/sib-invoice/netsuite/summary
     * @secure
     */
    sibInvoiceNetsuiteControllerNetsuiteSummary: (
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<InvoiceSummaryDto, void>({
        path: `/organizations/${organizationId}/sib-invoice/netsuite/summary`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - SIB Invoice
     * @name SibInvoiceNetsuiteControllerExportNetsuiteInvoices
     * @request GET:/organizations/{organizationId}/sib-invoice/netsuite/export
     * @secure
     */
    sibInvoiceNetsuiteControllerExportNetsuiteInvoices: (
      organizationId: string,
      query: {
        /** Only invoices with a NetSuite line nothing bills yet. */
        toReconcile?: boolean;
        /** Column paths to export. Pass as repeated query params (preferred) or a JSON array string. Headers are auto-generated from keys. Example: columns=name&columns=status */
        columns: string[];
        /** Custom filename for the CSV download (without extension). */
        filename?: string;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - dueDate
         * - status
         * - date
         * - invoiceNumber
         * - amount
         * - balance
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key           | Type   | Allowed Rules                                                                | Possible Values              |
         * | ------------- | ------ | ---------------------------------------------------------------------------- | ---------------------------- |
         * | dueDate       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                              |
         * | status        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | paid, unpaid, partially-paid |
         * | date          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                              |
         * | invoiceNumber | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                              |
         * | amount        | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                              |
         * | balance       | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                              |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<StreamableFile, void>({
        path: `/organizations/${organizationId}/sib-invoice/netsuite/export`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - SIB Invoice
     * @name SibInvoiceNetsuiteControllerNetsuiteInvoicePdf
     * @request GET:/organizations/{organizationId}/sib-invoice/netsuite/invoices/{invoiceId}/file
     * @secure
     */
    sibInvoiceNetsuiteControllerNetsuiteInvoicePdf: (
      invoiceId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<Blob, void>({
        path: `/organizations/${organizationId}/sib-invoice/netsuite/invoices/${invoiceId}/file`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - SIB Invoice
     * @name SibInvoiceNetsuiteControllerNetsuiteInvoiceFile
     * @request GET:/organizations/{organizationId}/sib-invoice/netsuite/invoices/{invoiceId}/files/{fileId}
     * @secure
     */
    sibInvoiceNetsuiteControllerNetsuiteInvoiceFile: (
      invoiceId: string,
      fileId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<StreamableFile, void>({
        path: `/organizations/${organizationId}/sib-invoice/netsuite/invoices/${invoiceId}/files/${fileId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - SIB Invoice
     * @name SibInvoiceLinesControllerList
     * @request GET:/organizations/{organizationId}/sib-invoice/lines
     * @secure
     */
    sibInvoiceLinesControllerList: (
      organizationId: string,
      query?: {
        /** Service lines, or the spend-category lines VSR reports go out on. Services when omitted. */
        kind?: InvoiceLineKind;
        /** Also drafts whose billings are all still hidden, for periods further ahead. A line sent for invoicing always shows. */
        includeFuture?: boolean;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - memo
         * - netsuiteItemName
         * - amount
         * - submittedAt
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key              | Type   | Allowed Rules                                                                | Possible Values |
         * | ---------------- | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | memo             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | netsuiteItemName | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | amount           | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | submittedAt      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - memo
         * - netsuiteItemName
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<InvoiceLineListDto, void>({
        path: `/organizations/${organizationId}/sib-invoice/lines`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - SIB Invoice
     * @name SibInvoiceLinesControllerInvoiceLines
     * @request GET:/organizations/{organizationId}/sib-invoice/lines/invoices/{sibInvoiceId}
     * @secure
     */
    sibInvoiceLinesControllerInvoiceLines: (
      organizationId: string,
      sibInvoiceId: string,
      params: RequestParams = {}
    ) =>
      this.request<InvoiceLineDto[], void>({
        path: `/organizations/${organizationId}/sib-invoice/lines/invoices/${sibInvoiceId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - SIB Invoice
     * @name SibInvoiceLinesControllerLineItems
     * @request GET:/organizations/{organizationId}/sib-invoice/lines/drafts/{lineId}/items
     * @secure
     */
    sibInvoiceLinesControllerLineItems: (
      organizationId: string,
      lineId: string,
      params: RequestParams = {}
    ) =>
      this.request<DraftInvoiceLineItemDto[], void>({
        path: `/organizations/${organizationId}/sib-invoice/lines/drafts/${lineId}/items`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - SIB Invoice
     * @name SibInvoiceLinesControllerDraftItems
     * @request GET:/organizations/{organizationId}/sib-invoice/lines/drafts/items
     * @secure
     */
    sibInvoiceLinesControllerDraftItems: (
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<DraftInvoiceLineItemDto[], void>({
        path: `/organizations/${organizationId}/sib-invoice/lines/drafts/items`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - SIB Invoice
     * @name SibInvoiceLinesControllerUnassignedBillings
     * @request GET:/organizations/{organizationId}/sib-invoice/lines/drafts/unassigned-billings
     * @secure
     */
    sibInvoiceLinesControllerUnassignedBillings: (
      organizationId: string,
      query?: {
        /** Also billings not revealed yet: those more than a week ahead. */
        includeFuture?: SibInvoiceLinesControllerUnassignedBillingsParamsIncludeFutureEnum;
        /** NetSuite item (internal id) the billings are for: those it bills come first, flagged mapped. */
        netsuiteItemId?: string;
        /**
         * The draft the billings are for, whose own billings are left out.
         * @format uuid
         */
        invoiceLineId?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<UnassignedBillingDto[], void>({
        path: `/organizations/${organizationId}/sib-invoice/lines/drafts/unassigned-billings`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - SIB Invoice
     * @name SibInvoiceLinesControllerAddToDraft
     * @request POST:/organizations/{organizationId}/sib-invoice/lines/drafts/{lineId}/billings
     * @secure
     */
    sibInvoiceLinesControllerAddToDraft: (
      organizationId: string,
      lineId: string,
      data: AddDraftBillingsDto,
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/organizations/${organizationId}/sib-invoice/lines/drafts/${lineId}/billings`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - SIB Invoice
     * @name SibInvoiceLinesControllerUpdateDraft
     * @request PATCH:/organizations/{organizationId}/sib-invoice/lines/drafts/{lineId}
     * @secure
     */
    sibInvoiceLinesControllerUpdateDraft: (
      organizationId: string,
      lineId: string,
      data: UpdateDraftInvoiceLineDto,
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/organizations/${organizationId}/sib-invoice/lines/drafts/${lineId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - SIB Invoice
     * @name SibInvoiceLinesControllerStandalone
     * @request POST:/organizations/{organizationId}/sib-invoice/lines/drafts/billings/{occurrenceId}/standalone
     * @secure
     */
    sibInvoiceLinesControllerStandalone: (
      organizationId: string,
      occurrenceId: string,
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/organizations/${organizationId}/sib-invoice/lines/drafts/billings/${occurrenceId}/standalone`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - SIB Invoice
     * @name SibInvoiceLinesControllerActivityLog
     * @request GET:/organizations/{organizationId}/sib-invoice/lines/{lineId}/activity-log
     * @secure
     */
    sibInvoiceLinesControllerActivityLog: (
      organizationId: string,
      lineId: string,
      params: RequestParams = {}
    ) =>
      this.request<InvoiceLineActivityLogEntryDto[], void>({
        path: `/organizations/${organizationId}/sib-invoice/lines/${lineId}/activity-log`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - SIB Invoice
     * @name SibInvoiceLinesControllerAddNote
     * @request POST:/organizations/{organizationId}/sib-invoice/lines/{lineId}/activity-log
     * @secure
     */
    sibInvoiceLinesControllerAddNote: (
      organizationId: string,
      lineId: string,
      data: NoteDto,
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/organizations/${organizationId}/sib-invoice/lines/${lineId}/activity-log`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - SIB Invoice
     * @name SibInvoiceLinesControllerReconcileOptions
     * @request GET:/organizations/{organizationId}/sib-invoice/lines/{lineId}/reconcile-options
     * @secure
     */
    sibInvoiceLinesControllerReconcileOptions: (
      organizationId: string,
      lineId: string,
      params: RequestParams = {}
    ) =>
      this.request<InvoiceLineReconcileOptionsDto, void>({
        path: `/organizations/${organizationId}/sib-invoice/lines/${lineId}/reconcile-options`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - SIB Invoice
     * @name SibInvoiceLinesControllerReconcile
     * @request POST:/organizations/{organizationId}/sib-invoice/lines/{lineId}/reconcile
     * @secure
     */
    sibInvoiceLinesControllerReconcile: (
      organizationId: string,
      lineId: string,
      data: ReconcileInvoiceLineDto,
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/organizations/${organizationId}/sib-invoice/lines/${lineId}/reconcile`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - SIB Invoice
     * @name SibInvoiceLinesControllerInvoiceDrafts
     * @request GET:/organizations/{organizationId}/sib-invoice/lines/invoice-drafts
     * @secure
     */
    sibInvoiceLinesControllerInvoiceDrafts: (
      organizationId: string,
      query?: {
        /** Also lines whose billings are all still hidden, for periods further ahead. A line sent for invoicing always shows. */
        includeFuture?: SibInvoiceLinesControllerInvoiceDraftsParamsIncludeFutureEnum;
        /** Memo or NetSuite item name contains. */
        search?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<InvoiceDraftDto[], void>({
        path: `/organizations/${organizationId}/sib-invoice/lines/invoice-drafts`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - SIB Invoice
     * @name SibInvoiceLinesControllerSubmitInvoiceDraft
     * @request POST:/organizations/{organizationId}/sib-invoice/lines/invoice-drafts/{draftId}/submit
     * @secure
     */
    sibInvoiceLinesControllerSubmitInvoiceDraft: (
      organizationId: string,
      draftId: string,
      data: OptionalNoteDto,
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/organizations/${organizationId}/sib-invoice/lines/invoice-drafts/${draftId}/submit`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - SIB Invoice
     * @name SibInvoiceLinesControllerWithdrawInvoiceDraft
     * @request POST:/organizations/{organizationId}/sib-invoice/lines/invoice-drafts/{draftId}/withdraw
     * @secure
     */
    sibInvoiceLinesControllerWithdrawInvoiceDraft: (
      organizationId: string,
      draftId: string,
      data: NoteDto,
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/organizations/${organizationId}/sib-invoice/lines/invoice-drafts/${draftId}/withdraw`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - SIB Invoice
     * @name SibInvoiceLinesControllerMoveToInvoiceDraft
     * @request POST:/organizations/{organizationId}/sib-invoice/lines/drafts/{lineId}/move
     * @secure
     */
    sibInvoiceLinesControllerMoveToInvoiceDraft: (
      organizationId: string,
      lineId: string,
      data: MoveInvoiceLineDto,
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/organizations/${organizationId}/sib-invoice/lines/drafts/${lineId}/move`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Use `GET …/revenue/sources`.
     *
     * @tags Internal Portal - SIB Revenue
     * @name OrganizationRevenueControllerReport
     * @request GET:/organizations/{organizationId}/revenue
     * @deprecated
     * @secure
     */
    organizationRevenueControllerReport: (
      organizationId: string,
      query?: {
        /** First day of the window. Omit with `to` for all time. */
        from?: string;
        /** Last day of the window. Omit with `from` for all time. */
        to?: string;
        /** Also count billings scheduled ahead and not yet revealed: fee periods and savings shares more than a week before their billing date. */
        includeProjected?: boolean;
        /** Also count spend that has not passed initial validation in expected savings. */
        includeNotValidated?: boolean;
        /** Also revenue no synced SIB contract backs. Defaults to true; false counts only revenue a contract backs. */
        includeWithoutContract?: boolean;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - name
         * - revenueType
         * - organizationName
         * - netsuiteOnly
         * - amount
         * - expectedAmount
         * - billingCount
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key              | Type    | Allowed Rules                                                                | Possible Values    |
         * | ---------------- | ------- | ---------------------------------------------------------------------------- | ------------------ |
         * | name             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                    |
         * | revenueType      | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | savings_share, fee |
         * | organizationName | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                    |
         * | netsuiteOnly     | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                    |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - groupName
         * - organizationName
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<DeprecatedRevenueReportDto, void>({
        path: `/organizations/${organizationId}/revenue`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - SIB Revenue
     * @name OrganizationRevenueControllerSources
     * @request GET:/organizations/{organizationId}/revenue/sources
     * @secure
     */
    organizationRevenueControllerSources: (
      organizationId: string,
      query?: {
        /** First day of the window. Omit with `to` for all time. */
        from?: string;
        /** Last day of the window. Omit with `from` for all time. */
        to?: string;
        /** Also count billings scheduled ahead and not yet revealed: fee periods and savings shares more than a week before their billing date. */
        includeProjected?: boolean;
        /** Also count spend that has not passed initial validation in expected savings. */
        includeNotValidated?: boolean;
        /** Also revenue no synced SIB contract backs. Defaults to true; false counts only revenue a contract backs. */
        includeWithoutContract?: boolean;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - name
         * - revenueType
         * - organizationName
         * - netsuiteOnly
         * - amount
         * - expectedAmount
         * - billingCount
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key              | Type    | Allowed Rules                                                                | Possible Values    |
         * | ---------------- | ------- | ---------------------------------------------------------------------------- | ------------------ |
         * | name             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                    |
         * | revenueType      | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | savings_share, fee |
         * | organizationName | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                    |
         * | netsuiteOnly     | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                    |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - groupName
         * - organizationName
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<RevenueReportDto, void>({
        path: `/organizations/${organizationId}/revenue/sources`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - SIB Revenue
     * @name OrganizationRevenueControllerSourceBillings
     * @request GET:/organizations/{organizationId}/revenue/sources/{sourceId}/billings
     * @secure
     */
    organizationRevenueControllerSourceBillings: (
      organizationId: string,
      sourceId: string,
      query?: {
        /** First day of the window. Omit with `to` for all time. */
        from?: string;
        /** Last day of the window. Omit with `from` for all time. */
        to?: string;
        /** Also count billings scheduled ahead and not yet revealed: fee periods and savings shares more than a week before their billing date. */
        includeProjected?: boolean;
        /** Also count spend that has not passed initial validation in expected savings. */
        includeNotValidated?: boolean;
        /** Also revenue no synced SIB contract backs. Defaults to true; false counts only revenue a contract backs. */
        includeWithoutContract?: boolean;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - sourceName
         * - periodFrom
         * - periodTo
         * - earned
         * - earnedAt
         * - sibInvoiceNumber
         * - sibInvoiceDate
         * - createdByName
         * - amount
         * - expectedAmount
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key              | Type    | Allowed Rules                                                                | Possible Values |
         * | ---------------- | ------- | ---------------------------------------------------------------------------- | --------------- |
         * | sourceName       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | periodFrom       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | periodTo         | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | earned           | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                 |
         * | earnedAt         | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | sibInvoiceNumber | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | sibInvoiceDate   | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdByName    | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - groupName
         * - sibInvoiceNumber
         * - createdByName
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<RevenueBillingListDto, void>({
        path: `/organizations/${organizationId}/revenue/sources/${sourceId}/billings`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Use `GET …/revenue/sources/:sourceId/billings`.
     *
     * @tags Internal Portal - SIB Revenue
     * @name OrganizationRevenueControllerBillings
     * @request GET:/organizations/{organizationId}/revenue/billings
     * @deprecated
     * @secure
     */
    organizationRevenueControllerBillings: (
      organizationId: string,
      query: {
        /** Set when grouped per service and spend category. */
        revenueType: RevenueType;
        /** The SIB service of a fee, or the spend category of a savings share. Absent: one with neither. */
        groupId?: string;
        /** First day of the window. Omit with `to` for all time. */
        from?: string;
        /** Last day of the window. Omit with `from` for all time. */
        to?: string;
        /** Also count billings scheduled ahead and not yet revealed: fee periods and savings shares more than a week before their billing date. */
        includeProjected?: boolean;
        /** Also count spend that has not passed initial validation in expected savings. */
        includeNotValidated?: boolean;
        /** Also revenue no synced SIB contract backs. Defaults to true; false counts only revenue a contract backs. */
        includeWithoutContract?: boolean;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - sourceName
         * - periodFrom
         * - periodTo
         * - earned
         * - earnedAt
         * - sibInvoiceNumber
         * - sibInvoiceDate
         * - createdByName
         * - amount
         * - expectedAmount
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key              | Type    | Allowed Rules                                                                | Possible Values |
         * | ---------------- | ------- | ---------------------------------------------------------------------------- | --------------- |
         * | sourceName       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | periodFrom       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | periodTo         | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | earned           | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                 |
         * | earnedAt         | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | sibInvoiceNumber | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | sibInvoiceDate   | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdByName    | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - groupName
         * - sibInvoiceNumber
         * - createdByName
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<RevenueBillingDto[], void>({
        path: `/organizations/${organizationId}/revenue/billings`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - SIB Revenue
     * @name OrganizationRevenueControllerInvoice
     * @request GET:/organizations/{organizationId}/revenue/invoices/{sibInvoiceId}
     * @secure
     */
    organizationRevenueControllerInvoice: (
      organizationId: string,
      sibInvoiceId: string,
      params: RequestParams = {}
    ) =>
      this.request<SibInvoiceDetailsDto, void>({
        path: `/organizations/${organizationId}/revenue/invoices/${sibInvoiceId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SIB Contracts
     * @name SibContractsControllerFindAll
     * @request GET:/organizations/{organizationId}/sib-contracts
     * @secure
     */
    sibContractsControllerFindAll: (
      organizationId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - organization
         * - status
         * - fee
         * - startDate
         * - endDate
         * - termMonths
         * - autoRenewal
         * - autoRenewalDate
         * - auditsCount
         * - totalContractValue
         * - uploadDate
         * - fileUrl
         * - salesRepresentative
         * - salesforceId
         * - salesforceSalesId
         * - updatedAt
         * - createdAt
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                 | Type                 | Allowed Rules                                                                | Possible Values  |
         * | ------------------- | -------------------- | ---------------------------------------------------------------------------- | ---------------- |
         * | id                  | string               | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                  |
         * | name                | string               | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                  |
         * | organization        | string               | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                  |
         * | status              | string               | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | active, inactive |
         * | fee                 | number               | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                  |
         * | startDate           | date                 | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty   |                  |
         * | endDate             | date                 | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty   |                  |
         * | termMonths          | number               | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                  |
         * | autoRenewal         | boolean              | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                  |
         * | autoRenewalDate     | date                 | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty   |                  |
         * | auditsCount         | number               | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                  |
         * | totalContractValue  | number               | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                  |
         * | uploadDate          | date                 | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty   |                  |
         * | fileUrl             | string               | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                  |
         * | salesRepresentative | plainexternaluserdto |                                                                              |                  |
         * | salesforceId        | object               |                                                                              |                  |
         * | salesforceSalesId   | object               |                                                                              |                  |
         * | updatedAt           | string               | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                  |
         * | createdAt           | string               | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                  |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<SibContractListDto, void>({
        path: `/organizations/${organizationId}/sib-contracts`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SIB Contracts
     * @name SibContractsControllerCreate
     * @request POST:/organizations/{organizationId}/sib-contracts
     * @secure
     */
    sibContractsControllerCreate: (
      organizationId: string,
      data: CreateSibContractDto,
      params: RequestParams = {}
    ) =>
      this.request<SibContractDto, void>({
        path: `/organizations/${organizationId}/sib-contracts`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SIB Contracts
     * @name SibContractsControllerExportContracts
     * @request GET:/organizations/{organizationId}/sib-contracts/export
     * @secure
     */
    sibContractsControllerExportContracts: (
      organizationId: string,
      query: {
        /** Column paths to export. Pass as repeated query params (preferred) or a JSON array string. Headers are auto-generated from keys. Example: columns=name&columns=status */
        columns: string[];
        /** Custom filename for the CSV download (without extension). */
        filename?: string;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - organization
         * - status
         * - fee
         * - startDate
         * - endDate
         * - termMonths
         * - autoRenewal
         * - autoRenewalDate
         * - auditsCount
         * - totalContractValue
         * - uploadDate
         * - fileUrl
         * - salesRepresentative
         * - salesforceId
         * - salesforceSalesId
         * - updatedAt
         * - createdAt
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                 | Type                 | Allowed Rules                                                                | Possible Values  |
         * | ------------------- | -------------------- | ---------------------------------------------------------------------------- | ---------------- |
         * | id                  | string               | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                  |
         * | name                | string               | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                  |
         * | organization        | string               | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                  |
         * | status              | string               | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | active, inactive |
         * | fee                 | number               | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                  |
         * | startDate           | date                 | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty   |                  |
         * | endDate             | date                 | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty   |                  |
         * | termMonths          | number               | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                  |
         * | autoRenewal         | boolean              | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                  |
         * | autoRenewalDate     | date                 | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty   |                  |
         * | auditsCount         | number               | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                  |
         * | totalContractValue  | number               | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                  |
         * | uploadDate          | date                 | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty   |                  |
         * | fileUrl             | string               | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                  |
         * | salesRepresentative | plainexternaluserdto |                                                                              |                  |
         * | salesforceId        | object               |                                                                              |                  |
         * | salesforceSalesId   | object               |                                                                              |                  |
         * | updatedAt           | string               | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                  |
         * | createdAt           | string               | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                  |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<StreamableFile, void>({
        path: `/organizations/${organizationId}/sib-contracts/export`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags SIB Contracts
     * @name SibContractsControllerExportFiles
     * @request GET:/organizations/{organizationId}/sib-contracts/files/export
     * @secure
     */
    sibContractsControllerExportFiles: (
      organizationId: string,
      query?: {
        filename?: string;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - organization
         * - status
         * - fee
         * - startDate
         * - endDate
         * - termMonths
         * - autoRenewal
         * - autoRenewalDate
         * - auditsCount
         * - totalContractValue
         * - uploadDate
         * - fileUrl
         * - salesRepresentative
         * - salesforceId
         * - salesforceSalesId
         * - updatedAt
         * - createdAt
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                 | Type                 | Allowed Rules                                                                | Possible Values  |
         * | ------------------- | -------------------- | ---------------------------------------------------------------------------- | ---------------- |
         * | id                  | string               | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                  |
         * | name                | string               | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                  |
         * | organization        | string               | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                  |
         * | status              | string               | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | active, inactive |
         * | fee                 | number               | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                  |
         * | startDate           | date                 | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty   |                  |
         * | endDate             | date                 | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty   |                  |
         * | termMonths          | number               | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                  |
         * | autoRenewal         | boolean              | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                  |
         * | autoRenewalDate     | date                 | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty   |                  |
         * | auditsCount         | number               | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                  |
         * | totalContractValue  | number               | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                  |
         * | uploadDate          | date                 | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty   |                  |
         * | fileUrl             | string               | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                  |
         * | salesRepresentative | plainexternaluserdto |                                                                              |                  |
         * | salesforceId        | object               |                                                                              |                  |
         * | salesforceSalesId   | object               |                                                                              |                  |
         * | updatedAt           | string               | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                  |
         * | createdAt           | string               | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                  |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<ArchiveDocumentsResponseDto, void>({
        path: `/organizations/${organizationId}/sib-contracts/files/export`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SIB Contracts
     * @name SibContractsControllerFindOne
     * @request GET:/organizations/{organizationId}/sib-contracts/{contractId}
     * @secure
     */
    sibContractsControllerFindOne: (
      contractId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<SibContractDto, void>({
        path: `/organizations/${organizationId}/sib-contracts/${contractId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SIB Contracts
     * @name SibContractsControllerUpdate
     * @request PATCH:/organizations/{organizationId}/sib-contracts/{contractId}
     * @secure
     */
    sibContractsControllerUpdate: (
      contractId: string,
      organizationId: string,
      data: UpdateSibContractDto,
      params: RequestParams = {}
    ) =>
      this.request<SibContractDto, void>({
        path: `/organizations/${organizationId}/sib-contracts/${contractId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SIB Contracts
     * @name SibContractsControllerDelete
     * @request DELETE:/organizations/{organizationId}/sib-contracts/{contractId}
     * @secure
     */
    sibContractsControllerDelete: (
      contractId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<SibContractDto, void>({
        path: `/organizations/${organizationId}/sib-contracts/${contractId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SIB Contracts
     * @name SibContractsControllerFindOneWithDetails
     * @request GET:/organizations/{organizationId}/sib-contracts/{contractId}/details
     * @secure
     */
    sibContractsControllerFindOneWithDetails: (
      contractId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<SibContractDetailDto, void>({
        path: `/organizations/${organizationId}/sib-contracts/${contractId}/details`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SIB Contract Periods
     * @name SibContractPeriodsControllerFindAll
     * @request GET:/organizations/{organizationId}/sib-contracts/{contractId}/periods
     * @secure
     */
    sibContractPeriodsControllerFindAll: (
      contractId: string,
      organizationId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - contract
         * - startDate
         * - term
         * - fee
         * - order
         * - updatedAt
         * - createdAt
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key       | Type   | Allowed Rules                                                                | Possible Values |
         * | --------- | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | id        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | contract  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | startDate | object |                                                                              |                 |
         * | term      | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | fee       | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | order     | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | updatedAt | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdAt | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<SibContractPeriodListDto, void>({
        path: `/organizations/${organizationId}/sib-contracts/${contractId}/periods`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SIB Contract Periods
     * @name SibContractPeriodsControllerCreate
     * @request POST:/organizations/{organizationId}/sib-contracts/{contractId}/periods
     * @secure
     */
    sibContractPeriodsControllerCreate: (
      contractId: string,
      organizationId: string,
      data: CreateSibContractPeriodDto,
      params: RequestParams = {}
    ) =>
      this.request<SibContractPeriodDto, void>({
        path: `/organizations/${organizationId}/sib-contracts/${contractId}/periods`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SIB Contract Periods
     * @name SibContractPeriodsControllerFindOne
     * @request GET:/organizations/{organizationId}/sib-contracts/{contractId}/periods/{id}
     * @secure
     */
    sibContractPeriodsControllerFindOne: (
      contractId: string,
      id: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<SibContractPeriodDto, void>({
        path: `/organizations/${organizationId}/sib-contracts/${contractId}/periods/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SIB Contract Periods
     * @name SibContractPeriodsControllerUpdate
     * @request PATCH:/organizations/{organizationId}/sib-contracts/{contractId}/periods/{id}
     * @secure
     */
    sibContractPeriodsControllerUpdate: (
      contractId: string,
      id: string,
      organizationId: string,
      data: UpdateSibContractPeriodDto,
      params: RequestParams = {}
    ) =>
      this.request<SibContractPeriodDto, void>({
        path: `/organizations/${organizationId}/sib-contracts/${contractId}/periods/${id}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SIB Contract Periods
     * @name SibContractPeriodsControllerDelete
     * @request DELETE:/organizations/{organizationId}/sib-contracts/{contractId}/periods/{id}
     * @secure
     */
    sibContractPeriodsControllerDelete: (
      contractId: string,
      id: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<SibContractPeriodDto, void>({
        path: `/organizations/${organizationId}/sib-contracts/${contractId}/periods/${id}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SIB Contract Spend Categories
     * @name SibContractSpendCategoriesControllerFindAll
     * @request GET:/organizations/{organizationId}/sib-contracts/{contractId}/spend-categories
     * @secure
     */
    sibContractSpendCategoriesControllerFindAll: (
      contractId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<SibContractSpendCategoryListDto, void>({
        path: `/organizations/${organizationId}/sib-contracts/${contractId}/spend-categories`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SIB Contract Spend Categories
     * @name SibContractSpendCategoriesControllerCreate
     * @request POST:/organizations/{organizationId}/sib-contracts/{contractId}/spend-categories
     * @secure
     */
    sibContractSpendCategoriesControllerCreate: (
      contractId: string,
      organizationId: string,
      data: CreateSibContractSpendCategoryDto,
      params: RequestParams = {}
    ) =>
      this.request<SibContractSpendCategoryDto, void>({
        path: `/organizations/${organizationId}/sib-contracts/${contractId}/spend-categories`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SIB Contract Spend Categories
     * @name SibContractSpendCategoriesControllerDelete
     * @request DELETE:/organizations/{organizationId}/sib-contracts/{contractId}/spend-categories/{spendCategoryId}
     * @secure
     */
    sibContractSpendCategoriesControllerDelete: (
      contractId: string,
      spendCategoryId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<SibContractSpendCategoryDto, void>({
        path: `/organizations/${organizationId}/sib-contracts/${contractId}/spend-categories/${spendCategoryId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SIB Contract Files
     * @name SibContractFilesControllerFindAll
     * @request GET:/organizations/{organizationId}/sib-contracts/{contractId}/files
     * @secure
     */
    sibContractFilesControllerFindAll: (
      contractId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<FileListDto, void>({
        path: `/organizations/${organizationId}/sib-contracts/${contractId}/files`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SIB Contract Files
     * @name SibContractFilesControllerFindOne
     * @request GET:/organizations/{organizationId}/sib-contracts/{contractId}/files/{fileId}
     * @secure
     */
    sibContractFilesControllerFindOne: (
      contractId: string,
      fileId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<FileDto, void>({
        path: `/organizations/${organizationId}/sib-contracts/${contractId}/files/${fileId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SIB Contract Files
     * @name SibContractFilesControllerDelete
     * @request DELETE:/organizations/{organizationId}/sib-contracts/{contractId}/files/{fileId}
     * @secure
     */
    sibContractFilesControllerDelete: (
      contractId: string,
      fileId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<FileDto, void>({
        path: `/organizations/${organizationId}/sib-contracts/${contractId}/files/${fileId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SIB Contract Files
     * @name SibContractFilesControllerHandleUploadUrl
     * @request POST:/organizations/{organizationId}/sib-contracts/{contractId}/files/upload-url
     * @secure
     */
    sibContractFilesControllerHandleUploadUrl: (
      contractId: string,
      organizationId: string,
      data: GenerateBulkFileUploadUrlDto,
      params: RequestParams = {}
    ) =>
      this.request<FileBulkUploadUrlResponseDto, void>({
        path: `/organizations/${organizationId}/sib-contracts/${contractId}/files/upload-url`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SIB Contract Files
     * @name SibContractFilesControllerUploadFile
     * @request POST:/organizations/{organizationId}/sib-contracts/{contractId}/files/upload
     * @secure
     */
    sibContractFilesControllerUploadFile: (
      contractId: string,
      organizationId: string,
      data: UploadFileDto,
      params: RequestParams = {}
    ) =>
      this.request<FileUploadResultDto, void>({
        path: `/organizations/${organizationId}/sib-contracts/${contractId}/files/upload`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Power BI Reports
     * @name PowerBiReportsControllerGetPowerBiReports
     * @request GET:/organizations/{organizationId}/power-bi-reports
     * @secure
     */
    powerBiReportsControllerGetPowerBiReports: (
      organizationId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - name
         * - groupId
         * - reportId
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key      | Type   | Allowed Rules                                                                | Possible Values |
         * | -------- | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | name     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | groupId  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | reportId | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<PowerBiReportListDto, void>({
        path: `/organizations/${organizationId}/power-bi-reports`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Power BI Reports
     * @name PowerBiReportsControllerGetPowerBiReport
     * @request GET:/organizations/{organizationId}/power-bi-reports/{id}
     * @secure
     */
    powerBiReportsControllerGetPowerBiReport: (
      organizationId: string,
      id: string,
      params: RequestParams = {}
    ) =>
      this.request<PowerBiReportDto, void>({
        path: `/organizations/${organizationId}/power-bi-reports/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Optimization Subjects
     * @name OptimizationSubjectsControllerFindAll
     * @request GET:/organizations/{organizationId}/optimization-subjects
     * @secure
     */
    optimizationSubjectsControllerFindAll: (
      organizationId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - organization
         * - location
         * - spendCategory
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key           | Type   | Allowed Rules                                                                | Possible Values |
         * | ------------- | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | organization  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | location      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | spendCategory | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<OptimizationSubjectListDto, void>({
        path: `/organizations/${organizationId}/optimization-subjects`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Optimization Subjects
     * @name OptimizationSubjectsControllerCreate
     * @request POST:/organizations/{organizationId}/optimization-subjects
     * @secure
     */
    optimizationSubjectsControllerCreate: (
      organizationId: string,
      data: CreateOptimizationSubjectDto,
      params: RequestParams = {}
    ) =>
      this.request<OptimizationSubjectItemDto, void>({
        path: `/organizations/${organizationId}/optimization-subjects`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vendors
     * @name OrganizationVendorsControllerGetAllVendorsByOrganizationName
     * @request GET:/organizations/{organizationId}/vendors
     * @secure
     */
    organizationVendorsControllerGetAllVendorsByOrganizationName: (
      organizationId: string,
      query?: {
        searchTerm?: string;
        serviceCategory?: string;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - name
         * - createdAt
         * - updatedAt
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key       | Type   | Allowed Rules                                                                | Possible Values |
         * | --------- | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | name      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdAt | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | updatedAt | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<VendorsListDto, void>({
        path: `/organizations/${organizationId}/vendors`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vendors
     * @name OrganizationVendorsControllerGetAllVendorServiceCategories
     * @request GET:/organizations/{organizationId}/vendors/service-categories
     * @secure
     */
    organizationVendorsControllerGetAllVendorServiceCategories: (
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<ServiceCategoryDto[], void>({
        path: `/organizations/${organizationId}/vendors/service-categories`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags VectorLocations
     * @name VectorLocationsControllerGetVectorLocations
     * @request GET:/organizations/{organizationId}/locations/vector
     * @secure
     */
    vectorLocationsControllerGetVectorLocations: (
      organizationId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - name
         * - address
         * - city
         * - state
         * - zipCode
         * - status
         * - ledgerNo
         * - savings
         * - autoPay
         * - cost
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key      | Type    | Allowed Rules                                                                | Possible Values |
         * | -------- | ------- | ---------------------------------------------------------------------------- | --------------- |
         * | name     | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | address  | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | city     | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | state    | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | zipCode  | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | status   | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                 |
         * | ledgerNo | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | savings  | number  | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | autoPay  | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | cost     | number  | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<VectorLocationListDto, void>({
        path: `/organizations/${organizationId}/locations/vector`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags VectorLocations
     * @name VectorLocationsControllerExportVectorLocations
     * @request GET:/organizations/{organizationId}/locations/vector/export
     * @secure
     */
    vectorLocationsControllerExportVectorLocations: (
      organizationId: string,
      query: {
        /** Column paths to export. Pass as repeated query params (preferred) or a JSON array string. Headers are auto-generated from keys. Example: columns=name&columns=status */
        columns: string[];
        /** Custom filename for the CSV download (without extension). */
        filename?: string;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - name
         * - address
         * - city
         * - state
         * - zipCode
         * - status
         * - ledgerNo
         * - savings
         * - autoPay
         * - cost
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key      | Type    | Allowed Rules                                                                | Possible Values |
         * | -------- | ------- | ---------------------------------------------------------------------------- | --------------- |
         * | name     | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | address  | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | city     | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | state    | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | zipCode  | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | status   | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                 |
         * | ledgerNo | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | savings  | number  | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | autoPay  | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | cost     | number  | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<StreamableFile, void>({
        path: `/organizations/${organizationId}/locations/vector/export`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags VectorLocations
     * @name VectorLocationsControllerGetVectorLocationByPropertyId
     * @request GET:/organizations/{organizationId}/locations/vector/{propertyId}
     * @secure
     */
    vectorLocationsControllerGetVectorLocationByPropertyId: (
      propertyId: number,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<VectorLocationDto, void>({
        path: `/organizations/${organizationId}/locations/vector/${propertyId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags OrganizationVectorContracts
     * @name OrganizationVectorContractsControllerGetVectorContracts
     * @request GET:/organizations/{organizationId}/vector/contracts
     * @secure
     */
    organizationVectorContractsControllerGetVectorContracts: (
      organizationId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - negotiationNo
         * - locationName
         * - vendorName
         * - status
         * - effectiveDate
         * - isVetted
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key           | Type   | Allowed Rules                                                                | Possible Values                                |
         * | ------------- | ------ | ---------------------------------------------------------------------------- | ---------------------------------------------- |
         * | id            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                |
         * | negotiationNo | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                |
         * | locationName  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                |
         * | vendorName    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                |
         * | status        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | Archived, Fully Executed, Bill Processing Only |
         * | effectiveDate | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                |
         * | isVetted      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<VectorContractsListDto, void>({
        path: `/organizations/${organizationId}/vector/contracts`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags VectorContracts
     * @name VectorContractsControllerGetVectorContracts
     * @request GET:/organizations/{organizationId}/vendors/{vendorId}/vector/contracts
     * @secure
     */
    vectorContractsControllerGetVectorContracts: (
      organizationId: string,
      vendorId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - negotiationNo
         * - locationName
         * - vendorName
         * - status
         * - effectiveDate
         * - isVetted
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key           | Type   | Allowed Rules                                                                | Possible Values                                |
         * | ------------- | ------ | ---------------------------------------------------------------------------- | ---------------------------------------------- |
         * | id            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                |
         * | negotiationNo | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                |
         * | locationName  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                |
         * | vendorName    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                |
         * | status        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | Archived, Fully Executed, Bill Processing Only |
         * | effectiveDate | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                |
         * | isVetted      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<VectorContractsListDto, void>({
        path: `/organizations/${organizationId}/vendors/${vendorId}/vector/contracts`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  internalPortal = {
    /**
     * No description
     *
     * @tags Internal Portal - Vendor accounts
     * @name VendorAccountsControllerGetVendorAccounts
     * @request GET:/internal-portal/organizations/{organizationId}/vendor-accounts
     * @secure
     */
    vendorAccountsControllerGetVendorAccounts: (
      organizationId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - accountNumber
         * - name
         * - createdAt
         * - invoiceFrequency
         * - billingType
         * - serviceType
         * - summaryAccountNumber
         * - glCode
         * - customGlField
         * - glAllocations
         * - usageLimit
         * - dollarLimit
         * - paymentTerms
         * - invoiceDay
         * - portalLoginEmailId
         * - note
         * - vendorName
         * - auditsCount
         * - status
         * - spendCategories
         * - locations
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                  | Type   | Allowed Rules                                                                | Possible Values                                   |
         * | -------------------- | ------ | ---------------------------------------------------------------------------- | ------------------------------------------------- |
         * | id                   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | accountNumber        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | name                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | createdAt            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | invoiceFrequency     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | bi_weekly, weekly, monthly, bi_monthly, quarterly |
         * | billingType          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | paper, email, portal                              |
         * | serviceType          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | summaryAccountNumber | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | glCode               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | customGlField        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | glAllocations        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | usageLimit           | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                   |
         * | dollarLimit          | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                   |
         * | paymentTerms         | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                   |
         * | invoiceDay           | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                   |
         * | portalLoginEmailId   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | note                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | vendorName           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | auditsCount          | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                   |
         * | status               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | active, inactive                                  |
         * | spendCategories      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | locations            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - accountNumber
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<VendorAccountListDto, void>({
        path: `/internal-portal/organizations/${organizationId}/vendor-accounts`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Vendor accounts
     * @name VendorAccountsControllerCreateVendorAccount
     * @request POST:/internal-portal/organizations/{organizationId}/vendor-accounts
     * @secure
     */
    vendorAccountsControllerCreateVendorAccount: (
      organizationId: string,
      data: CreateVendorAccountDto,
      params: RequestParams = {}
    ) =>
      this.request<VendorAccountDto, void>({
        path: `/internal-portal/organizations/${organizationId}/vendor-accounts`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Vendor accounts
     * @name VendorAccountsControllerExportVendorAccounts
     * @request GET:/internal-portal/organizations/{organizationId}/vendor-accounts/export
     * @secure
     */
    vendorAccountsControllerExportVendorAccounts: (
      organizationId: string,
      query: {
        /** Column paths to export. Pass as repeated query params (preferred) or a JSON array string. Headers are auto-generated from keys. Example: columns=name&columns=status */
        columns: string[];
        /** Custom filename for the CSV download (without extension). */
        filename?: string;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - accountNumber
         * - name
         * - createdAt
         * - invoiceFrequency
         * - billingType
         * - serviceType
         * - summaryAccountNumber
         * - glCode
         * - customGlField
         * - glAllocations
         * - usageLimit
         * - dollarLimit
         * - paymentTerms
         * - invoiceDay
         * - portalLoginEmailId
         * - note
         * - vendorName
         * - auditsCount
         * - status
         * - spendCategories
         * - locations
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                  | Type   | Allowed Rules                                                                | Possible Values                                   |
         * | -------------------- | ------ | ---------------------------------------------------------------------------- | ------------------------------------------------- |
         * | id                   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | accountNumber        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | name                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | createdAt            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | invoiceFrequency     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | bi_weekly, weekly, monthly, bi_monthly, quarterly |
         * | billingType          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | paper, email, portal                              |
         * | serviceType          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | summaryAccountNumber | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | glCode               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | customGlField        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | glAllocations        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | usageLimit           | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                   |
         * | dollarLimit          | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                   |
         * | paymentTerms         | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                   |
         * | invoiceDay           | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                   |
         * | portalLoginEmailId   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | note                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | vendorName           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | auditsCount          | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                   |
         * | status               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | active, inactive                                  |
         * | spendCategories      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | locations            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - accountNumber
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<StreamableFile, void>({
        path: `/internal-portal/organizations/${organizationId}/vendor-accounts/export`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Vendor accounts
     * @name VendorAccountsControllerGetVendorAccountSelectList
     * @request GET:/internal-portal/organizations/{organizationId}/vendor-accounts/select-list
     * @secure
     */
    vendorAccountsControllerGetVendorAccountSelectList: (
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<SelectListDto, void>({
        path: `/internal-portal/organizations/${organizationId}/vendor-accounts/select-list`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Vendor accounts
     * @name VendorAccountsControllerGetVendorAccountsForVendor
     * @request GET:/internal-portal/organizations/{organizationId}/vendors/{vendorId}/vendor-accounts
     * @secure
     */
    vendorAccountsControllerGetVendorAccountsForVendor: (
      organizationId: string,
      vendorId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - accountNumber
         * - name
         * - createdAt
         * - invoiceFrequency
         * - billingType
         * - serviceType
         * - summaryAccountNumber
         * - glCode
         * - customGlField
         * - glAllocations
         * - usageLimit
         * - dollarLimit
         * - paymentTerms
         * - invoiceDay
         * - portalLoginEmailId
         * - note
         * - vendorName
         * - auditsCount
         * - status
         * - spendCategories
         * - locations
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                  | Type   | Allowed Rules                                                                | Possible Values                                   |
         * | -------------------- | ------ | ---------------------------------------------------------------------------- | ------------------------------------------------- |
         * | id                   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | accountNumber        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | name                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | createdAt            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | invoiceFrequency     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | bi_weekly, weekly, monthly, bi_monthly, quarterly |
         * | billingType          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | paper, email, portal                              |
         * | serviceType          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | summaryAccountNumber | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | glCode               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | customGlField        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | glAllocations        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | usageLimit           | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                   |
         * | dollarLimit          | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                   |
         * | paymentTerms         | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                   |
         * | invoiceDay           | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                   |
         * | portalLoginEmailId   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | note                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | vendorName           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | auditsCount          | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                   |
         * | status               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | active, inactive                                  |
         * | spendCategories      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | locations            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - accountNumber
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<VendorAccountListDto, void>({
        path: `/internal-portal/organizations/${organizationId}/vendors/${vendorId}/vendor-accounts`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Vendor accounts
     * @name VendorAccountsControllerFindVendorAccountDuplicates
     * @summary Find vendor accounts with the same vendor and exactly the same locations
     * @request POST:/internal-portal/organizations/{organizationId}/vendor-accounts/find-duplicates
     * @secure
     */
    vendorAccountsControllerFindVendorAccountDuplicates: (
      organizationId: string,
      data: FindVendorAccountDuplicatesDto,
      params: RequestParams = {}
    ) =>
      this.request<VendorAccountDuplicatesDto, void>({
        path: `/internal-portal/organizations/${organizationId}/vendor-accounts/find-duplicates`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Vendor accounts
     * @name VendorAccountsControllerGetVendorAccountById
     * @request GET:/internal-portal/organizations/{organizationId}/vendor-accounts/{accountId}
     * @secure
     */
    vendorAccountsControllerGetVendorAccountById: (
      organizationId: string,
      accountId: string,
      params: RequestParams = {}
    ) =>
      this.request<VendorAccountDto, void>({
        path: `/internal-portal/organizations/${organizationId}/vendor-accounts/${accountId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Vendor accounts
     * @name VendorAccountsControllerUpdateVendorAccount
     * @request PATCH:/internal-portal/organizations/{organizationId}/vendor-accounts/{accountId}
     * @secure
     */
    vendorAccountsControllerUpdateVendorAccount: (
      organizationId: string,
      accountId: string,
      data: UpdateVendorAccountDto,
      params: RequestParams = {}
    ) =>
      this.request<VendorAccountDto, void>({
        path: `/internal-portal/organizations/${organizationId}/vendor-accounts/${accountId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Vendor accounts
     * @name VendorAccountsControllerDeleteVendorAccount
     * @request DELETE:/internal-portal/organizations/{organizationId}/vendor-accounts/{accountId}
     * @secure
     */
    vendorAccountsControllerDeleteVendorAccount: (
      organizationId: string,
      accountId: string,
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/internal-portal/organizations/${organizationId}/vendor-accounts/${accountId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Projects
     * @name ProjectControllerCreate
     * @request POST:/internal-portal/projects
     * @secure
     */
    projectControllerCreate: (
      data: CreateProjectDto,
      params: RequestParams = {}
    ) =>
      this.request<ProjectDto, void>({
        path: `/internal-portal/projects`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Projects
     * @name ProjectControllerCopy
     * @summary Duplicates the project and its tasks. The copy starts clean — see {@link ProjectCopyService} for what carries over.
     * @request POST:/internal-portal/projects/{projectId}/copy
     * @secure
     */
    projectControllerCopy: (
      projectId: string,
      data: CopyProjectDto,
      params: RequestParams = {}
    ) =>
      this.request<ProjectDto, void>({
        path: `/internal-portal/projects/${projectId}/copy`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Projects
     * @name ProjectControllerGetTeamsWithProjects
     * @request GET:/internal-portal/projects/teams
     * @secure
     */
    projectControllerGetTeamsWithProjects: (
      query?: {
        /** Search by project name within each team */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<TeamWithProjectsListDto, void>({
        path: `/internal-portal/projects/teams`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Projects
     * @name ProjectControllerFindOne
     * @request GET:/internal-portal/projects/{projectId}
     * @secure
     */
    projectControllerFindOne: (projectId: string, params: RequestParams = {}) =>
      this.request<ProjectDto, void>({
        path: `/internal-portal/projects/${projectId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Projects
     * @name ProjectControllerUpdate
     * @request PATCH:/internal-portal/projects/{projectId}
     * @secure
     */
    projectControllerUpdate: (
      projectId: string,
      data: UpdateProjectDto,
      params: RequestParams = {}
    ) =>
      this.request<ProjectDto, void>({
        path: `/internal-portal/projects/${projectId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Project relations
     * @name ProjectRelationsControllerExportProjectTickets
     * @request GET:/internal-portal/projects/{projectId}/tickets/export
     * @secure
     */
    projectRelationsControllerExportProjectTickets: (
      projectId: string,
      query: {
        /** Column paths to export. Pass as repeated query params (preferred) or a JSON array string. Headers are auto-generated from keys. Example: columns=name&columns=status */
        columns: string[];
        /** Custom filename for the CSV download (without extension). */
        filename?: string;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - vectorTicketId
         * - subject
         * - description
         * - status
         * - priority
         * - category
         * - subCategory
         * - vendorName
         * - location
         * - zip
         * - address
         * - city
         * - state
         * - subStatus
         * - assignee
         * - requestor
         * - assigneeEmail
         * - assigneeName
         * - requestorEmail
         * - requestorName
         * - organizationId
         * - organizationName
         * - vendorId
         * - ticketNumber
         * - commentsCount
         * - accessToExternalUser
         * - createdAt
         * - updatedAt
         * - dueDate
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                  | Type    | Allowed Rules                                                                | Possible Values |
         * | -------------------- | ------- | ---------------------------------------------------------------------------- | --------------- |
         * | id                   | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vectorTicketId       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subject              | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | description          | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | status               | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | priority             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | category             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subCategory          | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendorName           | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | location             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | zip                  | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | address              | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | city                 | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | state                | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subStatus            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assignee             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | requestor            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeEmail        | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeName         | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | requestorEmail       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | requestorName        | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organizationId       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organizationName     | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendorId             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | ticketNumber         | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | commentsCount        | number  | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | accessToExternalUser | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                 |
         * | createdAt            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | updatedAt            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | dueDate              | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - subject
         * - description
         * - category
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<StreamableFile, void>({
        path: `/internal-portal/projects/${projectId}/tickets/export`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Project relations
     * @name ProjectRelationsControllerGetProjectTickets
     * @request GET:/internal-portal/projects/{projectId}/tickets
     * @secure
     */
    projectRelationsControllerGetProjectTickets: (
      projectId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - vectorTicketId
         * - subject
         * - description
         * - status
         * - priority
         * - category
         * - subCategory
         * - vendorName
         * - location
         * - zip
         * - address
         * - city
         * - state
         * - subStatus
         * - assignee
         * - requestor
         * - assigneeEmail
         * - assigneeName
         * - requestorEmail
         * - requestorName
         * - organizationId
         * - organizationName
         * - vendorId
         * - ticketNumber
         * - commentsCount
         * - accessToExternalUser
         * - createdAt
         * - updatedAt
         * - dueDate
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                  | Type    | Allowed Rules                                                                | Possible Values |
         * | -------------------- | ------- | ---------------------------------------------------------------------------- | --------------- |
         * | id                   | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vectorTicketId       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subject              | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | description          | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | status               | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | priority             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | category             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subCategory          | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendorName           | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | location             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | zip                  | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | address              | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | city                 | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | state                | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subStatus            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assignee             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | requestor            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeEmail        | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeName         | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | requestorEmail       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | requestorName        | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organizationId       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organizationName     | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendorId             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | ticketNumber         | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | commentsCount        | number  | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | accessToExternalUser | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                 |
         * | createdAt            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | updatedAt            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | dueDate              | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - subject
         * - description
         * - category
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<TicketListDto, void>({
        path: `/internal-portal/projects/${projectId}/tickets`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Project relations
     * @name ProjectRelationsControllerExportProjectTasks
     * @request GET:/internal-portal/projects/{projectId}/tasks/export
     * @secure
     */
    projectRelationsControllerExportProjectTasks: (
      projectId: string,
      query: {
        /** Column paths to export. Pass as repeated query params (preferred) or a JSON array string. Headers are auto-generated from keys. Example: columns=name&columns=status */
        columns: string[];
        /** Custom filename for the CSV download (without extension). */
        filename?: string;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - title
         * - description
         * - completed
         * - priorityLevel
         * - createdAt
         * - updatedAt
         * - deadline
         * - completedAt
         * - timeLogged
         * - estimatedTime
         * - category
         * - status
         * - referenceLink
         * - referenceName
         * - organizationId
         * - organizationName
         * - organization
         * - vendorId
         * - vendorName
         * - vendor
         * - seenAt
         * - seen
         * - assignee
         * - assigneeName
         * - assigneeEmail
         * - createdBy
         * - createdByName
         * - createdByEmail
         * - tagName
         * - tagColor
         * - tagId
         * - tagCreatedBy
         * - taskTagContactId
         * - taskTagEmployeeId
         * - taskTagType
         * - taskTagEmployeeName
         * - taskTagEmployeeEmail
         * - taskTagContactName
         * - taskTagContactEmail
         * - subauditId
         * - project
         * - commentsCount
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                  | Type   | Allowed Rules                                                                | Possible Values |
         * | -------------------- | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | id                   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | title                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | description          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | completed            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | priorityLevel        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdAt            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | updatedAt            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | deadline             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | completedAt          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | timeLogged           | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | estimatedTime        | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | category             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | status               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | referenceLink        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | referenceName        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organizationId       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organizationName     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organization         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendorId             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendorName           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendor               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | seenAt               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | seen                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assignee             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeName         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeEmail        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdBy            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdByName        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdByEmail       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | tagName              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | tagColor             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | tagId                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | tagCreatedBy         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | taskTagContactId     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | taskTagEmployeeId    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | taskTagType          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | taskTagEmployeeName  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | taskTagEmployeeEmail | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | taskTagContactName   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | taskTagContactEmail  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subauditId           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | project              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | commentsCount        | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - title
         * - description
         * - referenceName
         * - referenceLink
         * - assignee.name
         * - assignee.emailAddress
         * - createdBy.name
         * - createdBy.emailAddress
         * - organization.name
         * - taskTagss.tag.name
         * - taskTagss.employee.name
         * - taskTagss.employee.emailAddress
         * - taskTagss.contact.name
         * - taskTagss.contact.email
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<StreamableFile, void>({
        path: `/internal-portal/projects/${projectId}/tasks/export`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Project relations
     * @name ProjectRelationsControllerGetProjectTasks
     * @request GET:/internal-portal/projects/{projectId}/tasks
     * @secure
     */
    projectRelationsControllerGetProjectTasks: (
      projectId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - title
         * - description
         * - completed
         * - priorityLevel
         * - createdAt
         * - updatedAt
         * - deadline
         * - completedAt
         * - timeLogged
         * - estimatedTime
         * - category
         * - status
         * - referenceLink
         * - referenceName
         * - organizationId
         * - organizationName
         * - organization
         * - vendorId
         * - vendorName
         * - vendor
         * - seenAt
         * - seen
         * - assignee
         * - assigneeName
         * - assigneeEmail
         * - createdBy
         * - createdByName
         * - createdByEmail
         * - tagName
         * - tagColor
         * - tagId
         * - tagCreatedBy
         * - taskTagContactId
         * - taskTagEmployeeId
         * - taskTagType
         * - taskTagEmployeeName
         * - taskTagEmployeeEmail
         * - taskTagContactName
         * - taskTagContactEmail
         * - subauditId
         * - project
         * - commentsCount
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                  | Type   | Allowed Rules                                                                | Possible Values |
         * | -------------------- | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | id                   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | title                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | description          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | completed            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | priorityLevel        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdAt            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | updatedAt            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | deadline             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | completedAt          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | timeLogged           | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | estimatedTime        | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | category             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | status               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | referenceLink        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | referenceName        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organizationId       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organizationName     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organization         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendorId             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendorName           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendor               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | seenAt               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | seen                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assignee             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeName         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeEmail        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdBy            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdByName        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdByEmail       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | tagName              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | tagColor             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | tagId                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | tagCreatedBy         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | taskTagContactId     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | taskTagEmployeeId    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | taskTagType          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | taskTagEmployeeName  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | taskTagEmployeeEmail | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | taskTagContactName   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | taskTagContactEmail  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subauditId           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | project              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | commentsCount        | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - title
         * - description
         * - referenceName
         * - referenceLink
         * - assignee.name
         * - assignee.emailAddress
         * - createdBy.name
         * - createdBy.emailAddress
         * - organization.name
         * - taskTagss.tag.name
         * - taskTagss.employee.name
         * - taskTagss.employee.emailAddress
         * - taskTagss.contact.name
         * - taskTagss.contact.email
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<TaskListDto, void>({
        path: `/internal-portal/projects/${projectId}/tasks`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Project Files
     * @name ProjectFileControllerGetProjectFiles
     * @request GET:/internal-portal/projects/{projectId}/files
     * @secure
     */
    projectFileControllerGetProjectFiles: (
      projectId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - fileName
         * - fileType
         * - fileUrl
         * - fileSize
         * - uploadStage
         * - id
         * - createdAt
         * - createdBy
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type                 | Allowed Rules                                                                | Possible Values                    |
         * | ----------- | -------------------- | ---------------------------------------------------------------------------- | ---------------------------------- |
         * | fileName    | string               | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                    |
         * | fileType    | object               |                                                                              |                                    |
         * | fileUrl     | string               | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                    |
         * | fileSize    | object               |                                                                              |                                    |
         * | uploadStage | string               | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | pending, failed, uploaded, removed |
         * | id          | string               | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                    |
         * | createdAt   | string               | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                    |
         * | createdBy   | plainexternaluserdto |                                                                              |                                    |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<ProjectFileListDto, void>({
        path: `/internal-portal/projects/${projectId}/files`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Project Files
     * @name ProjectFileControllerExportProjectFiles
     * @request GET:/internal-portal/projects/{projectId}/files/export
     * @secure
     */
    projectFileControllerExportProjectFiles: (
      projectId: string,
      query: {
        /** Column paths to export. Pass as repeated query params (preferred) or a JSON array string. Headers are auto-generated from keys. Example: columns=name&columns=status */
        columns: string[];
        /** Custom filename for the CSV download (without extension). */
        filename?: string;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - fileName
         * - fileType
         * - fileUrl
         * - fileSize
         * - uploadStage
         * - id
         * - createdAt
         * - createdBy
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type                 | Allowed Rules                                                                | Possible Values                    |
         * | ----------- | -------------------- | ---------------------------------------------------------------------------- | ---------------------------------- |
         * | fileName    | string               | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                    |
         * | fileType    | object               |                                                                              |                                    |
         * | fileUrl     | string               | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                    |
         * | fileSize    | object               |                                                                              |                                    |
         * | uploadStage | string               | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | pending, failed, uploaded, removed |
         * | id          | string               | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                    |
         * | createdAt   | string               | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                    |
         * | createdBy   | plainexternaluserdto |                                                                              |                                    |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<StreamableFile, void>({
        path: `/internal-portal/projects/${projectId}/files/export`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Project Files
     * @name ProjectFileControllerDeleteProjectFile
     * @request DELETE:/internal-portal/projects/{projectId}/files/{fileId}
     * @secure
     */
    projectFileControllerDeleteProjectFile: (
      projectId: string,
      fileId: string,
      params: RequestParams = {}
    ) =>
      this.request<boolean, void>({
        path: `/internal-portal/projects/${projectId}/files/${fileId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Project Files
     * @name ProjectFileControllerGetUploadStatus
     * @request GET:/internal-portal/projects/{projectId}/files/batch/{batchId}/status
     * @secure
     */
    projectFileControllerGetUploadStatus: (
      batchId: string,
      projectId: string,
      params: RequestParams = {}
    ) =>
      this.request<FileBatchStatusListDto, void>({
        path: `/internal-portal/projects/${projectId}/files/batch/${batchId}/status`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Project Files - Upload
     * @name ProjectFileUploadControllerHandleUploadUrl
     * @request POST:/internal-portal/projects/{projectId}/files/upload-url
     * @secure
     */
    projectFileUploadControllerHandleUploadUrl: (
      projectId: string,
      data: GenerateBulkFileUploadUrlDto,
      params: RequestParams = {}
    ) =>
      this.request<FileBulkUploadUrlResponseDto, void>({
        path: `/internal-portal/projects/${projectId}/files/upload-url`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Project Files - Upload
     * @name ProjectFileUploadControllerUploadFile
     * @request POST:/internal-portal/projects/{projectId}/files/upload
     * @secure
     */
    projectFileUploadControllerUploadFile: (
      projectId: string,
      data: UploadFileDto,
      params: RequestParams = {}
    ) =>
      this.request<FileUploadResultDto, void>({
        path: `/internal-portal/projects/${projectId}/files/upload`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Project Files - Upload
     * @name ProjectFileUploadControllerPostprocessFile
     * @request POST:/internal-portal/projects/{projectId}/files/postprocess
     * @secure
     */
    projectFileUploadControllerPostprocessFile: (
      projectId: string,
      data: PostprocessFileDto,
      params: RequestParams = {}
    ) =>
      this.request<FileUploadResultDto, void>({
        path: `/internal-portal/projects/${projectId}/files/postprocess`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Project Files - Upload
     * @name ProjectFileUploadControllerPostprocessFiles
     * @request POST:/internal-portal/projects/{projectId}/files/postprocess-many
     * @secure
     */
    projectFileUploadControllerPostprocessFiles: (
      projectId: string,
      data: PostprocessFilesDto,
      params: RequestParams = {}
    ) =>
      this.request<PostprocessFilesResultDto, void>({
        path: `/internal-portal/projects/${projectId}/files/postprocess-many`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Organizations
     * @name OrganizationsControllerGetOrganizations
     * @request GET:/internal-portal/organizations
     * @secure
     */
    organizationsControllerGetOrganizations: (
      query?: {
        isActive?: boolean;
        /** Quick filter: only organizations the caller manages as their CRM. */
        myOrganizations?: boolean;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - status
         * - clientStatus
         * - isActive
         * - primaryContact
         * - locationsCount
         * - openAuditsCount
         * - parentOrganization
         * - financialMetrics.inScopeSpend
         * - financialMetrics.savingsIdentified
         * - financialMetrics.savingsApproved
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                                | Type                          | Allowed Rules                                                                | Possible Values                                                                                              |
         * | ---------------------------------- | ----------------------------- | ---------------------------------------------------------------------------- | ------------------------------------------------------------------------------------------------------------ |
         * | id                                 | string                        | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                              |
         * | name                               | string                        | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                              |
         * | status                             | string                        | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | active, inactive                                                                                             |
         * | clientStatus                       | object                        |                                                                              | dormant, mobilization, negotiation, post_negotiation, pre_negotiation, prospect, update_required, validation |
         * | isActive                           | boolean                       | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                                                                                                              |
         * | primaryContact                     | organizationprimarycontactdto |                                                                              |                                                                                                              |
         * | locationsCount                     | number                        | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                                              |
         * | openAuditsCount                    | number                        | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                                              |
         * | parentOrganization                 | plainorganizationdto          |                                                                              |                                                                                                              |
         * | financialMetrics.inScopeSpend      | number                        | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                                              |
         * | financialMetrics.savingsIdentified | number                        | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                                              |
         * | financialMetrics.savingsApproved   | number                        | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                                              |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - name
         * - primaryContact.name
         * - primaryContact.email
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<OrganizationListDto, void>({
        path: `/internal-portal/organizations`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Organizations
     * @name OrganizationsControllerCreateOrganization
     * @request POST:/internal-portal/organizations
     * @secure
     */
    organizationsControllerCreateOrganization: (
      data: CreateOrganizationDto,
      params: RequestParams = {}
    ) =>
      this.request<OrganizationListItemDto, void>({
        path: `/internal-portal/organizations`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Organizations
     * @name OrganizationsControllerExportOrganizations
     * @request GET:/internal-portal/organizations/export
     * @secure
     */
    organizationsControllerExportOrganizations: (
      query: {
        isActive?: boolean;
        /** Quick filter: only organizations the caller manages as their CRM. */
        myOrganizations?: boolean;
        /** Column paths to export. Pass as repeated query params (preferred) or a JSON array string. Headers are auto-generated from keys. Example: columns=name&columns=status */
        columns: string[];
        /** Custom filename for the CSV download (without extension). */
        filename?: string;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - status
         * - clientStatus
         * - isActive
         * - primaryContact
         * - locationsCount
         * - openAuditsCount
         * - parentOrganization
         * - financialMetrics.inScopeSpend
         * - financialMetrics.savingsIdentified
         * - financialMetrics.savingsApproved
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                                | Type                          | Allowed Rules                                                                | Possible Values                                                                                              |
         * | ---------------------------------- | ----------------------------- | ---------------------------------------------------------------------------- | ------------------------------------------------------------------------------------------------------------ |
         * | id                                 | string                        | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                              |
         * | name                               | string                        | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                              |
         * | status                             | string                        | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | active, inactive                                                                                             |
         * | clientStatus                       | object                        |                                                                              | dormant, mobilization, negotiation, post_negotiation, pre_negotiation, prospect, update_required, validation |
         * | isActive                           | boolean                       | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                                                                                                              |
         * | primaryContact                     | organizationprimarycontactdto |                                                                              |                                                                                                              |
         * | locationsCount                     | number                        | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                                              |
         * | openAuditsCount                    | number                        | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                                              |
         * | parentOrganization                 | plainorganizationdto          |                                                                              |                                                                                                              |
         * | financialMetrics.inScopeSpend      | number                        | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                                              |
         * | financialMetrics.savingsIdentified | number                        | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                                              |
         * | financialMetrics.savingsApproved   | number                        | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                                              |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - name
         * - primaryContact.name
         * - primaryContact.email
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<StreamableFile, void>({
        path: `/internal-portal/organizations/export`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Organizations
     * @name OrganizationsControllerGetSubsidiaries
     * @request GET:/internal-portal/organizations/{organizationId}/subsidiaries
     * @secure
     */
    organizationsControllerGetSubsidiaries: (
      organizationId: string,
      query?: {
        isActive?: boolean;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - status
         * - clientStatus
         * - isActive
         * - primaryContact
         * - locationsCount
         * - openAuditsCount
         * - parentOrganization
         * - financialMetrics.inScopeSpend
         * - financialMetrics.savingsIdentified
         * - financialMetrics.savingsApproved
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                                | Type                          | Allowed Rules                                                                | Possible Values                                                                                              |
         * | ---------------------------------- | ----------------------------- | ---------------------------------------------------------------------------- | ------------------------------------------------------------------------------------------------------------ |
         * | id                                 | string                        | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                              |
         * | name                               | string                        | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                              |
         * | status                             | string                        | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | active, inactive                                                                                             |
         * | clientStatus                       | object                        |                                                                              | dormant, mobilization, negotiation, post_negotiation, pre_negotiation, prospect, update_required, validation |
         * | isActive                           | boolean                       | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                                                                                                              |
         * | primaryContact                     | organizationprimarycontactdto |                                                                              |                                                                                                              |
         * | locationsCount                     | number                        | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                                              |
         * | openAuditsCount                    | number                        | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                                              |
         * | parentOrganization                 | plainorganizationdto          |                                                                              |                                                                                                              |
         * | financialMetrics.inScopeSpend      | number                        | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                                              |
         * | financialMetrics.savingsIdentified | number                        | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                                              |
         * | financialMetrics.savingsApproved   | number                        | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                                              |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - name
         * - primaryContact.name
         * - primaryContact.email
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<OrganizationListDto, void>({
        path: `/internal-portal/organizations/${organizationId}/subsidiaries`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Organizations
     * @name OrganizationsControllerExportSubsidiaries
     * @request GET:/internal-portal/organizations/{organizationId}/subsidiaries/export
     * @secure
     */
    organizationsControllerExportSubsidiaries: (
      organizationId: string,
      query: {
        isActive?: boolean;
        /** Column paths to export. Pass as repeated query params (preferred) or a JSON array string. Headers are auto-generated from keys. Example: columns=name&columns=status */
        columns: string[];
        /** Custom filename for the CSV download (without extension). */
        filename?: string;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - status
         * - clientStatus
         * - isActive
         * - primaryContact
         * - locationsCount
         * - openAuditsCount
         * - parentOrganization
         * - financialMetrics.inScopeSpend
         * - financialMetrics.savingsIdentified
         * - financialMetrics.savingsApproved
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                                | Type                          | Allowed Rules                                                                | Possible Values                                                                                              |
         * | ---------------------------------- | ----------------------------- | ---------------------------------------------------------------------------- | ------------------------------------------------------------------------------------------------------------ |
         * | id                                 | string                        | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                              |
         * | name                               | string                        | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                              |
         * | status                             | string                        | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | active, inactive                                                                                             |
         * | clientStatus                       | object                        |                                                                              | dormant, mobilization, negotiation, post_negotiation, pre_negotiation, prospect, update_required, validation |
         * | isActive                           | boolean                       | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                                                                                                              |
         * | primaryContact                     | organizationprimarycontactdto |                                                                              |                                                                                                              |
         * | locationsCount                     | number                        | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                                              |
         * | openAuditsCount                    | number                        | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                                              |
         * | parentOrganization                 | plainorganizationdto          |                                                                              |                                                                                                              |
         * | financialMetrics.inScopeSpend      | number                        | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                                              |
         * | financialMetrics.savingsIdentified | number                        | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                                              |
         * | financialMetrics.savingsApproved   | number                        | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                                              |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - name
         * - primaryContact.name
         * - primaryContact.email
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<StreamableFile, void>({
        path: `/internal-portal/organizations/${organizationId}/subsidiaries/export`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Organizations
     * @name OrganizationsControllerGetOrganizationOverview
     * @request GET:/internal-portal/organizations/{organizationId}/overview
     * @secure
     */
    organizationsControllerGetOrganizationOverview: (
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<OrganizationOverviewDto, void>({
        path: `/internal-portal/organizations/${organizationId}/overview`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Organizations
     * @name OrganizationsControllerGetMainPointOfContact
     * @request GET:/internal-portal/organizations/{organizationId}/main-point-of-contact
     * @secure
     */
    organizationsControllerGetMainPointOfContact: (
      organizationId: string,
      query?: {
        locationId?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<ContactDto, void>({
        path: `/internal-portal/organizations/${organizationId}/main-point-of-contact`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Organizations
     * @name OrganizationsControllerUpdateOrganization
     * @request PATCH:/internal-portal/organizations/{organizationId}
     * @secure
     */
    organizationsControllerUpdateOrganization: (
      organizationId: string,
      data: UpdateOrganizationDto,
      params: RequestParams = {}
    ) =>
      this.request<OrganizationOverviewDto, void>({
        path: `/internal-portal/organizations/${organizationId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Contacts
     * @name OrganizationContactsControllerGetOrganizationContacts
     * @request GET:/internal-portal/organizations/{organizationId}/contacts
     * @secure
     */
    organizationContactsControllerGetOrganizationContacts: (
      organizationId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - name
         * - email
         * - phone
         * - title
         * - firstName
         * - lastName
         * - isActive
         * - hasMicrositeAccess
         * - micrositeRole
         * - status
         * - lastActiveAt
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                | Type   | Allowed Rules                                                                | Possible Values                 |
         * | ------------------ | ------ | ---------------------------------------------------------------------------- | ------------------------------- |
         * | name               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                 |
         * | email              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                 |
         * | phone              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                 |
         * | title              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                 |
         * | firstName          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                 |
         * | lastName           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                 |
         * | isActive           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                 |
         * | hasMicrositeAccess | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                 |
         * | micrositeRole      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                 |
         * | status             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | active, inactive, out_of_office |
         * | lastActiveAt       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - name
         * - email
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<OrganizationContactsListDto, void>({
        path: `/internal-portal/organizations/${organizationId}/contacts`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Contacts
     * @name OrganizationContactsControllerCreateOrganizationContact
     * @request POST:/internal-portal/organizations/{organizationId}/contacts
     * @secure
     */
    organizationContactsControllerCreateOrganizationContact: (
      organizationId: string,
      data: CreateOrganizationContactDto,
      params: RequestParams = {}
    ) =>
      this.request<OrganizationContactDto, void>({
        path: `/internal-portal/organizations/${organizationId}/contacts`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Contacts
     * @name OrganizationContactsControllerGetOrganizationContact
     * @request GET:/internal-portal/organizations/{organizationId}/contacts/{contactId}
     * @secure
     */
    organizationContactsControllerGetOrganizationContact: (
      organizationId: string,
      contactId: string,
      params: RequestParams = {}
    ) =>
      this.request<OrganizationContactDto, void>({
        path: `/internal-portal/organizations/${organizationId}/contacts/${contactId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Contacts
     * @name OrganizationContactsControllerUpdateOrganizationContact
     * @request PATCH:/internal-portal/organizations/{organizationId}/contacts/{contactId}
     * @secure
     */
    organizationContactsControllerUpdateOrganizationContact: (
      organizationId: string,
      contactId: string,
      data: UpdateOrganizationContactDto,
      params: RequestParams = {}
    ) =>
      this.request<OrganizationContactDto, void>({
        path: `/internal-portal/organizations/${organizationId}/contacts/${contactId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Organization Users
     * @name OrganizationUsersControllerListSibEmployees
     * @request GET:/internal-portal/organizations/{organizationId}/users/sib-employees
     * @secure
     */
    organizationUsersControllerListSibEmployees: (
      organizationId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - name
         * - email
         * - title
         * - role
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key   | Type   | Allowed Rules                                                                | Possible Values |
         * | ----- | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | name  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | email | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | title | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | role  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - user.name
         * - user.emailAddress
         * - user.contactEmail
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<SibEmployeesListDto, void>({
        path: `/internal-portal/organizations/${organizationId}/users/sib-employees`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Organization Users
     * @name OrganizationUsersControllerAssignSibEmployee
     * @request POST:/internal-portal/organizations/{organizationId}/users/sib-employees
     * @secure
     */
    organizationUsersControllerAssignSibEmployee: (
      organizationId: string,
      data: AssignSibEmployeeDto,
      params: RequestParams = {}
    ) =>
      this.request<SibEmployeesListDto, void>({
        path: `/internal-portal/organizations/${organizationId}/users/sib-employees`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Ends this person's membership of this organization only. Their account, and their place in every other organization, are untouched.
     *
     * @tags Internal Portal - Organization Users
     * @name OrganizationUsersControllerUnassignSibEmployee
     * @request DELETE:/internal-portal/organizations/{organizationId}/users/sib-employees/{userId}
     * @secure
     */
    organizationUsersControllerUnassignSibEmployee: (
      organizationId: string,
      userId: string,
      params: RequestParams = {}
    ) =>
      this.request<StreamableFile, void>({
        path: `/internal-portal/organizations/${organizationId}/users/sib-employees/${userId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description What `PATCH organizations/:orgId` with `removeVendorIds: [vendorId]` would do: unlinking is allowed only when no vendor account of the pair has an account number or data and the pair has no audit; otherwise it is rejected with 409. Lists what blocks it.
     *
     * @tags Organization relations
     * @name OrganizationRelationsControllerGetVendorUnlinkSummary
     * @summary Whether a vendor can be unlinked from the organization
     * @request GET:/internal-portal/organizations/{organizationId}/vendors/{vendorId}/unlink-summary
     * @secure
     */
    organizationRelationsControllerGetVendorUnlinkSummary: (
      organizationId: string,
      vendorId: string,
      params: RequestParams = {}
    ) =>
      this.request<VendorUnlinkSummaryDto, void>({
        path: `/internal-portal/organizations/${organizationId}/vendors/${vendorId}/unlink-summary`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organization relations
     * @name OrganizationRelationsControllerGetUnassignedOrganizationVendors
     * @request GET:/internal-portal/organizations/{organizationId}/vendors/unassigned
     * @secure
     */
    organizationRelationsControllerGetUnassignedOrganizationVendors: (
      organizationId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - lastUpdated
         * - clientOrganisationsCount
         * - contactsCount
         * - openTicketsCount
         * - openTasksCount
         * - contractsCount
         * - auditsCount
         * - orgScopedAuditsCount
         * - totalSpend
         * - status
         * - assignee
         * - spendCategories
         * - spendAreas
         * - vendorAccounts
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                      | Type   | Allowed Rules                                                                | Possible Values |
         * | ------------------------ | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | id                       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | name                     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | lastUpdated              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | clientOrganisationsCount | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | contactsCount            | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | openTicketsCount         | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | openTasksCount           | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | contractsCount           | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | auditsCount              | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | orgScopedAuditsCount     | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | totalSpend               | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | status                   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assignee                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | spendCategories          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | spendAreas               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendorAccounts           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - name
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<VendorClientListDto, void>({
        path: `/internal-portal/organizations/${organizationId}/vendors/unassigned`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organization relations
     * @name OrganizationRelationsControllerGetVendorSpendAreaSelectList
     * @request GET:/internal-portal/organizations/{organizationId}/vendors/select-list/spend-areas
     * @secure
     */
    organizationRelationsControllerGetVendorSpendAreaSelectList: (
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<SelectListDto, void>({
        path: `/internal-portal/organizations/${organizationId}/vendors/select-list/spend-areas`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organization relations
     * @name OrganizationRelationsControllerGetVendorSpendCategorySelectList
     * @request GET:/internal-portal/organizations/{organizationId}/vendors/select-list/spend-categories
     * @secure
     */
    organizationRelationsControllerGetVendorSpendCategorySelectList: (
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<SelectListDto, void>({
        path: `/internal-portal/organizations/${organizationId}/vendors/select-list/spend-categories`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organization relations
     * @name OrganizationRelationsControllerExportOrganizationVendors
     * @request GET:/internal-portal/organizations/{organizationId}/vendors/export
     * @secure
     */
    organizationRelationsControllerExportOrganizationVendors: (
      organizationId: string,
      query: {
        /** Column paths to export. Pass as repeated query params (preferred) or a JSON array string. Headers are auto-generated from keys. Example: columns=name&columns=status */
        columns: string[];
        /** Custom filename for the CSV download (without extension). */
        filename?: string;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - lastUpdated
         * - clientOrganisationsCount
         * - contactsCount
         * - openTicketsCount
         * - openTasksCount
         * - contractsCount
         * - auditsCount
         * - orgScopedAuditsCount
         * - totalSpend
         * - status
         * - assignee
         * - spendCategories
         * - spendAreas
         * - vendorAccounts
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                      | Type   | Allowed Rules                                                                | Possible Values |
         * | ------------------------ | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | id                       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | name                     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | lastUpdated              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | clientOrganisationsCount | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | contactsCount            | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | openTicketsCount         | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | openTasksCount           | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | contractsCount           | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | auditsCount              | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | orgScopedAuditsCount     | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | totalSpend               | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | status                   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assignee                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | spendCategories          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | spendAreas               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendorAccounts           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - name
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<StreamableFile, void>({
        path: `/internal-portal/organizations/${organizationId}/vendors/export`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organization relations
     * @name OrganizationRelationsControllerGetOrganizationVendors
     * @request GET:/internal-portal/organizations/{organizationId}/vendors
     * @secure
     */
    organizationRelationsControllerGetOrganizationVendors: (
      organizationId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - lastUpdated
         * - clientOrganisationsCount
         * - contactsCount
         * - openTicketsCount
         * - openTasksCount
         * - contractsCount
         * - auditsCount
         * - orgScopedAuditsCount
         * - totalSpend
         * - status
         * - assignee
         * - spendCategories
         * - spendAreas
         * - vendorAccounts
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                      | Type   | Allowed Rules                                                                | Possible Values |
         * | ------------------------ | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | id                       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | name                     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | lastUpdated              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | clientOrganisationsCount | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | contactsCount            | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | openTicketsCount         | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | openTasksCount           | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | contractsCount           | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | auditsCount              | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | orgScopedAuditsCount     | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | totalSpend               | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | status                   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assignee                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | spendCategories          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | spendAreas               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendorAccounts           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - name
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<VendorClientListDto, void>({
        path: `/internal-portal/organizations/${organizationId}/vendors`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organization relations
     * @name OrganizationRelationsControllerExportOrganizationTasks
     * @request GET:/internal-portal/organizations/{organizationId}/tasks/export
     * @secure
     */
    organizationRelationsControllerExportOrganizationTasks: (
      organizationId: string,
      query: {
        /** Column paths to export. Pass as repeated query params (preferred) or a JSON array string. Headers are auto-generated from keys. Example: columns=name&columns=status */
        columns: string[];
        /** Custom filename for the CSV download (without extension). */
        filename?: string;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - title
         * - description
         * - category
         * - status
         * - priorityLevel
         * - completed
         * - deadline
         * - assigneeName
         * - assigneeEmail
         * - referenceName
         * - ticketId
         * - ticketNumber
         * - createdAt
         * - updatedAt
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key           | Type   | Allowed Rules                                                                | Possible Values |
         * | ------------- | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | id            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | title         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | description   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | category      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | status        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | priorityLevel | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | completed     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | deadline      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeName  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeEmail | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | referenceName | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | ticketId      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | ticketNumber  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdAt     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | updatedAt     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - title
         * - description
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<StreamableFile, void>({
        path: `/internal-portal/organizations/${organizationId}/tasks/export`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organization relations
     * @name OrganizationRelationsControllerGetOrganizationTasks
     * @request GET:/internal-portal/organizations/{organizationId}/tasks
     * @secure
     */
    organizationRelationsControllerGetOrganizationTasks: (
      organizationId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - title
         * - description
         * - category
         * - status
         * - priorityLevel
         * - completed
         * - deadline
         * - assigneeName
         * - assigneeEmail
         * - referenceName
         * - ticketId
         * - ticketNumber
         * - createdAt
         * - updatedAt
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key           | Type   | Allowed Rules                                                                | Possible Values |
         * | ------------- | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | id            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | title         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | description   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | category      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | status        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | priorityLevel | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | completed     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | deadline      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeName  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeEmail | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | referenceName | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | ticketId      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | ticketNumber  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdAt     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | updatedAt     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - title
         * - description
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<IpOrganizationTaskListDto, void>({
        path: `/internal-portal/organizations/${organizationId}/tasks`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organization relations
     * @name OrganizationRelationsControllerGetOrganizationTickets
     * @request GET:/internal-portal/organizations/{organizationId}/tickets
     * @secure
     */
    organizationRelationsControllerGetOrganizationTickets: (
      organizationId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - vectorTicketId
         * - subject
         * - description
         * - status
         * - priority
         * - category
         * - subCategory
         * - vendorName
         * - location
         * - zip
         * - address
         * - city
         * - state
         * - subStatus
         * - assignee
         * - requestor
         * - assigneeEmail
         * - assigneeName
         * - requestorEmail
         * - requestorName
         * - organizationId
         * - organizationName
         * - vendorId
         * - ticketNumber
         * - commentsCount
         * - accessToExternalUser
         * - createdAt
         * - updatedAt
         * - dueDate
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                  | Type    | Allowed Rules                                                                | Possible Values |
         * | -------------------- | ------- | ---------------------------------------------------------------------------- | --------------- |
         * | id                   | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vectorTicketId       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subject              | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | description          | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | status               | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | priority             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | category             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subCategory          | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendorName           | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | location             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | zip                  | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | address              | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | city                 | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | state                | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subStatus            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assignee             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | requestor            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeEmail        | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeName         | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | requestorEmail       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | requestorName        | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organizationId       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organizationName     | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendorId             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | ticketNumber         | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | commentsCount        | number  | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | accessToExternalUser | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                 |
         * | createdAt            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | updatedAt            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | dueDate              | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - subject
         * - description
         * - category
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<IpOrganizationTicketListDto, void>({
        path: `/internal-portal/organizations/${organizationId}/tickets`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Vendors
     * @name VendorsControllerGetVendors
     * @request GET:/internal-portal/vendors
     * @secure
     */
    vendorsControllerGetVendors: (
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - lastUpdated
         * - clientOrganisationsCount
         * - contactsCount
         * - openTicketsCount
         * - openTasksCount
         * - contractsCount
         * - auditsCount
         * - orgScopedAuditsCount
         * - totalSpend
         * - status
         * - assignee
         * - spendCategories
         * - spendAreas
         * - vendorAccounts
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                      | Type   | Allowed Rules                                                                | Possible Values |
         * | ------------------------ | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | id                       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | name                     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | lastUpdated              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | clientOrganisationsCount | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | contactsCount            | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | openTicketsCount         | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | openTasksCount           | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | contractsCount           | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | auditsCount              | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | orgScopedAuditsCount     | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | totalSpend               | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | status                   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assignee                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | spendCategories          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | spendAreas               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendorAccounts           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - name
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<VendorListDto, void>({
        path: `/internal-portal/vendors`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Vendors
     * @name VendorsControllerCreateVendor
     * @request POST:/internal-portal/vendors
     * @secure
     */
    vendorsControllerCreateVendor: (
      data: CreateVendorDto,
      params: RequestParams = {}
    ) =>
      this.request<VendorDetailDto, void>({
        path: `/internal-portal/vendors`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Vendors
     * @name VendorsControllerExportVendors
     * @request GET:/internal-portal/vendors/export
     * @secure
     */
    vendorsControllerExportVendors: (
      query: {
        /** Column paths to export. Pass as repeated query params (preferred) or a JSON array string. Headers are auto-generated from keys. Example: columns=name&columns=status */
        columns: string[];
        /** Custom filename for the CSV download (without extension). */
        filename?: string;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - lastUpdated
         * - clientOrganisationsCount
         * - contactsCount
         * - openTicketsCount
         * - openTasksCount
         * - contractsCount
         * - auditsCount
         * - orgScopedAuditsCount
         * - totalSpend
         * - status
         * - assignee
         * - spendCategories
         * - spendAreas
         * - vendorAccounts
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                      | Type   | Allowed Rules                                                                | Possible Values |
         * | ------------------------ | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | id                       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | name                     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | lastUpdated              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | clientOrganisationsCount | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | contactsCount            | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | openTicketsCount         | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | openTasksCount           | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | contractsCount           | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | auditsCount              | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | orgScopedAuditsCount     | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | totalSpend               | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | status                   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assignee                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | spendCategories          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | spendAreas               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendorAccounts           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - name
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<StreamableFile, void>({
        path: `/internal-portal/vendors/export`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Vendors
     * @name VendorsControllerListSpendCategories
     * @request GET:/internal-portal/vendors/spend-categories
     * @secure
     */
    vendorsControllerListSpendCategories: (
      query?: {
        /** When set, spend categories already linked to this vendor are excluded from the list (use when adding categories to an existing vendor). Accepts any vendor.id value. */
        excludeVendorId?: string;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - spendAreaId
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type   | Allowed Rules                                                                | Possible Values |
         * | ----------- | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | id          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | name        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | spendAreaId | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - name
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<SpendCategoryListDto, void>({
        path: `/internal-portal/vendors/spend-categories`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Vendors
     * @name VendorsControllerGetSpendAreaSelectList
     * @request GET:/internal-portal/vendors/select-list/spend-areas
     * @secure
     */
    vendorsControllerGetSpendAreaSelectList: (params: RequestParams = {}) =>
      this.request<SelectListDto, void>({
        path: `/internal-portal/vendors/select-list/spend-areas`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Vendors
     * @name VendorsControllerGetSpendCategorySelectList
     * @request GET:/internal-portal/vendors/select-list/spend-categories
     * @secure
     */
    vendorsControllerGetSpendCategorySelectList: (params: RequestParams = {}) =>
      this.request<SelectListDto, void>({
        path: `/internal-portal/vendors/select-list/spend-categories`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Vendors
     * @name VendorsControllerGetImportTemplate
     * @request GET:/internal-portal/vendors/template
     * @secure
     */
    vendorsControllerGetImportTemplate: (params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/internal-portal/vendors/template`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Vendors
     * @name VendorsControllerGetVendorById
     * @request GET:/internal-portal/vendors/{vendorId}
     * @secure
     */
    vendorsControllerGetVendorById: (
      vendorId: string,
      params: RequestParams = {}
    ) =>
      this.request<VendorDetailDto, void>({
        path: `/internal-portal/vendors/${vendorId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Vendors
     * @name VendorsControllerUpdateVendor
     * @request PATCH:/internal-portal/vendors/{vendorId}
     * @secure
     */
    vendorsControllerUpdateVendor: (
      vendorId: string,
      data: UpdateVendorDto,
      params: RequestParams = {}
    ) =>
      this.request<VendorDetailDto, void>({
        path: `/internal-portal/vendors/${vendorId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Vendors
     * @name VendorsControllerGetVendorOrganizations
     * @request GET:/internal-portal/vendors/{vendorId}/organizations
     * @secure
     */
    vendorsControllerGetVendorOrganizations: (
      vendorId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key  | Type   | Allowed Rules                                                                | Possible Values |
         * | ---- | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | id   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | name | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<VendorOrganizationSelectListDto, void>({
        path: `/internal-portal/vendors/${vendorId}/organizations`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Vendors
     * @name VendorsControllerGetVendorByIdForOrganization
     * @request GET:/internal-portal/vendors/{vendorId}/organizations/{organizationId}
     * @secure
     */
    vendorsControllerGetVendorByIdForOrganization: (
      vendorId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<VendorClientDetailDto, void>({
        path: `/internal-portal/vendors/${vendorId}/organizations/${organizationId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Vendors
     * @name VendorsControllerValidateImport
     * @request POST:/internal-portal/vendors/import
     * @secure
     */
    vendorsControllerValidateImport: (
      data: FileUploadDto,
      params: RequestParams = {}
    ) =>
      this.request<VendorImportResultDto, void>({
        path: `/internal-portal/vendors/import`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Vendors
     * @name VendorsControllerCreateMany
     * @request POST:/internal-portal/vendors/many
     * @secure
     */
    vendorsControllerCreateMany: (
      data: VendorCreateManyDto,
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/internal-portal/vendors/many`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Vendors
     * @name VendorsControllerUpdateVendorBillPay
     * @summary Update vendor bill pay fields and optionally upload, replace, or remove the W9 file
     * @request PATCH:/internal-portal/vendors/{vendorId}/billpay
     * @secure
     */
    vendorsControllerUpdateVendorBillPay: (
      vendorId: string,
      data: UpdateVendorBillPayDto,
      params: RequestParams = {}
    ) =>
      this.request<VendorDetailDto, void>({
        path: `/internal-portal/vendors/${vendorId}/billpay`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contacts
     * @name VendorContactsControllerExportVendorContacts
     * @request GET:/internal-portal/vendors/{vendorId}/contacts/export
     * @secure
     */
    vendorContactsControllerExportVendorContacts: (
      vendorId: string,
      query: {
        /** Column paths to export. Pass as repeated query params (preferred) or a JSON array string. Headers are auto-generated from keys. Example: columns=name&columns=status */
        columns: string[];
        /** Custom filename for the CSV download (without extension). */
        filename?: string;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - email
         * - firstName
         * - lastName
         * - title
         * - isActive
         * - phoneNumber
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type    | Allowed Rules                                                                | Possible Values |
         * | ----------- | ------- | ---------------------------------------------------------------------------- | --------------- |
         * | id          | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | name        | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | email       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | firstName   | object  |                                                                              |                 |
         * | lastName    | object  |                                                                              |                 |
         * | title       | object  |                                                                              |                 |
         * | isActive    | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                 |
         * | phoneNumber | object  |                                                                              |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - name
         * - email
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<StreamableFile, void>({
        path: `/internal-portal/vendors/${vendorId}/contacts/export`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contacts
     * @name VendorContactsControllerGetVendorContacts
     * @request GET:/internal-portal/vendors/{vendorId}/contacts
     * @secure
     */
    vendorContactsControllerGetVendorContacts: (
      vendorId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - email
         * - firstName
         * - lastName
         * - title
         * - isActive
         * - phoneNumber
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type    | Allowed Rules                                                                | Possible Values |
         * | ----------- | ------- | ---------------------------------------------------------------------------- | --------------- |
         * | id          | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | name        | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | email       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | firstName   | object  |                                                                              |                 |
         * | lastName    | object  |                                                                              |                 |
         * | title       | object  |                                                                              |                 |
         * | isActive    | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                 |
         * | phoneNumber | object  |                                                                              |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - name
         * - email
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<ContactsListDto, void>({
        path: `/internal-portal/vendors/${vendorId}/contacts`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contacts
     * @name VendorContactsControllerCreateVendorContact
     * @request POST:/internal-portal/vendors/{vendorId}/contacts
     * @secure
     */
    vendorContactsControllerCreateVendorContact: (
      vendorId: string,
      data: CreateVendorContactDto,
      params: RequestParams = {}
    ) =>
      this.request<ContactDto, void>({
        path: `/internal-portal/vendors/${vendorId}/contacts`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Organization Comments
     * @name OrganizationCommentsControllerListComments
     * @request GET:/internal-portal/organizations/{organizationId}/comments
     * @secure
     */
    organizationCommentsControllerListComments: (
      organizationId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - createdBy
         * - createdAt
         * - updatedAt
         * - id
         * - comment
         * - organizationId
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key            | Type   | Allowed Rules                                                                | Possible Values |
         * | -------------- | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | createdBy      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdAt      | date   | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty   |                 |
         * | updatedAt      | date   | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty   |                 |
         * | id             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | comment        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organizationId | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<OrganizationCommentListDto, void>({
        path: `/internal-portal/organizations/${organizationId}/comments`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Organization Comments
     * @name OrganizationCommentsControllerCreateComment
     * @request POST:/internal-portal/organizations/{organizationId}/comments
     * @secure
     */
    organizationCommentsControllerCreateComment: (
      organizationId: string,
      data: CreateOrganizationCommentDto,
      params: RequestParams = {}
    ) =>
      this.request<OrganizationCommentDto, void>({
        path: `/internal-portal/organizations/${organizationId}/comments`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Organization Comments
     * @name OrganizationCommentsControllerGetFeed
     * @summary Every note kind that reaches this organization in one list — the Comments tab filters it client-side by `source`.
     * @request GET:/internal-portal/organizations/{organizationId}/comments/feed
     * @secure
     */
    organizationCommentsControllerGetFeed: (
      organizationId: string,
      query?: {
        /** Note kinds to include. Omitted means every kind the caller may read. */
        sources?: OrganizationCommentSource[];
        /** Case-insensitive substring, matched against the note, its title, the parent name and the author name. */
        search?: string;
        /** @uniqueItems true */
        createdBy?: string[];
        /**
         * Inclusive lower bound. A value carrying no UTC offset is resolved in the database timezone, not the caller's.
         * @format date-time
         */
        createdFrom?: string;
        /**
         * Inclusive upper bound, same format as `createdFrom`.
         * @format date-time
         */
        createdTo?: string;
        /** @default "desc" */
        direction?: OrganizationCommentsControllerGetFeedParamsDirectionEnum;
        /**
         * Current page number (1-based)
         * @min 1
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @min 1
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<OrganizationCommentFeedListDto, void>({
        path: `/internal-portal/organizations/${organizationId}/comments/feed`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Organization Comments
     * @name OrganizationCommentsControllerGetFeedCounts
     * @summary What each source holds under the current filters — including the sources the feed is not showing, which is what makes the chips worth a click.
     * @request GET:/internal-portal/organizations/{organizationId}/comments/feed/counts
     * @secure
     */
    organizationCommentsControllerGetFeedCounts: (
      organizationId: string,
      query?: {
        /** Case-insensitive substring, matched against the note, its title, the parent name and the author name. */
        search?: string;
        /** @uniqueItems true */
        createdBy?: string[];
        /**
         * Inclusive lower bound. A value carrying no UTC offset is resolved in the database timezone, not the caller's.
         * @format date-time
         */
        createdFrom?: string;
        /**
         * Inclusive upper bound, same format as `createdFrom`.
         * @format date-time
         */
        createdTo?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<OrganizationCommentFeedCountsDto, void>({
        path: `/internal-portal/organizations/${organizationId}/comments/feed/counts`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Organization Comments
     * @name OrganizationCommentsControllerGetFeedAuthors
     * @summary Every author in the feed, so the filter is not limited to one page.
     * @request GET:/internal-portal/organizations/{organizationId}/comments/feed/authors
     * @secure
     */
    organizationCommentsControllerGetFeedAuthors: (
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<OrganizationCommentFeedAuthorsDto, void>({
        path: `/internal-portal/organizations/${organizationId}/comments/feed/authors`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Organization Comments
     * @name OrganizationCommentsControllerUpdateComment
     * @request PATCH:/internal-portal/organizations/{organizationId}/comments/{commentId}
     * @secure
     */
    organizationCommentsControllerUpdateComment: (
      organizationId: string,
      commentId: string,
      data: UpdateOrganizationCommentDto,
      params: RequestParams = {}
    ) =>
      this.request<OrganizationCommentDto, void>({
        path: `/internal-portal/organizations/${organizationId}/comments/${commentId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Organization Comments
     * @name OrganizationCommentsControllerDeleteComment
     * @request DELETE:/internal-portal/organizations/{organizationId}/comments/{commentId}
     * @secure
     */
    organizationCommentsControllerDeleteComment: (
      organizationId: string,
      commentId: string,
      params: RequestParams = {}
    ) =>
      this.request<MessageResponseDto, void>({
        path: `/internal-portal/organizations/${organizationId}/comments/${commentId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vendor relations
     * @name VendorRelationsControllerCreateVendorTicket
     * @request POST:/internal-portal/vendors/{vendorId}/tickets
     * @secure
     */
    vendorRelationsControllerCreateVendorTicket: (
      vendorId: string,
      data: CreateTicketDto,
      params: RequestParams = {}
    ) =>
      this.request<TicketWithDetailsDto, void>({
        path: `/internal-portal/vendors/${vendorId}/tickets`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vendor relations
     * @name VendorRelationsControllerGetVendorTickets
     * @request GET:/internal-portal/vendors/{vendorId}/tickets
     * @secure
     */
    vendorRelationsControllerGetVendorTickets: (
      vendorId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - vectorTicketId
         * - subject
         * - description
         * - status
         * - priority
         * - category
         * - subCategory
         * - vendorName
         * - location
         * - zip
         * - address
         * - city
         * - state
         * - subStatus
         * - assignee
         * - requestor
         * - assigneeEmail
         * - assigneeName
         * - requestorEmail
         * - requestorName
         * - organizationId
         * - organizationName
         * - vendorId
         * - ticketNumber
         * - commentsCount
         * - accessToExternalUser
         * - createdAt
         * - updatedAt
         * - dueDate
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                  | Type    | Allowed Rules                                                                | Possible Values |
         * | -------------------- | ------- | ---------------------------------------------------------------------------- | --------------- |
         * | id                   | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vectorTicketId       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subject              | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | description          | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | status               | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | priority             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | category             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subCategory          | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendorName           | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | location             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | zip                  | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | address              | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | city                 | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | state                | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subStatus            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assignee             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | requestor            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeEmail        | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeName         | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | requestorEmail       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | requestorName        | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organizationId       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organizationName     | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendorId             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | ticketNumber         | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | commentsCount        | number  | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | accessToExternalUser | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                 |
         * | createdAt            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | updatedAt            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | dueDate              | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - subject
         * - description
         * - category
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<TicketListDto, void>({
        path: `/internal-portal/vendors/${vendorId}/tickets`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vendor relations
     * @name VendorRelationsControllerExportVendorTickets
     * @request GET:/internal-portal/vendors/{vendorId}/tickets/export
     * @secure
     */
    vendorRelationsControllerExportVendorTickets: (
      vendorId: string,
      query: {
        /** Column paths to export. Pass as repeated query params (preferred) or a JSON array string. Headers are auto-generated from keys. Example: columns=name&columns=status */
        columns: string[];
        /** Custom filename for the CSV download (without extension). */
        filename?: string;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - vectorTicketId
         * - subject
         * - description
         * - status
         * - priority
         * - category
         * - subCategory
         * - vendorName
         * - location
         * - zip
         * - address
         * - city
         * - state
         * - subStatus
         * - assignee
         * - requestor
         * - assigneeEmail
         * - assigneeName
         * - requestorEmail
         * - requestorName
         * - organizationId
         * - organizationName
         * - vendorId
         * - ticketNumber
         * - commentsCount
         * - accessToExternalUser
         * - createdAt
         * - updatedAt
         * - dueDate
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                  | Type    | Allowed Rules                                                                | Possible Values |
         * | -------------------- | ------- | ---------------------------------------------------------------------------- | --------------- |
         * | id                   | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vectorTicketId       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subject              | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | description          | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | status               | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | priority             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | category             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subCategory          | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendorName           | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | location             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | zip                  | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | address              | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | city                 | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | state                | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subStatus            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assignee             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | requestor            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeEmail        | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeName         | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | requestorEmail       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | requestorName        | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organizationId       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organizationName     | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendorId             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | ticketNumber         | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | commentsCount        | number  | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | accessToExternalUser | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                 |
         * | createdAt            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | updatedAt            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | dueDate              | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - subject
         * - description
         * - category
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<StreamableFile, void>({
        path: `/internal-portal/vendors/${vendorId}/tickets/export`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vendor relations
     * @name VendorRelationsControllerExportVendorTasks
     * @request GET:/internal-portal/vendors/{vendorId}/tasks/export
     * @secure
     */
    vendorRelationsControllerExportVendorTasks: (
      vendorId: string,
      query: {
        /** Column paths to export. Pass as repeated query params (preferred) or a JSON array string. Headers are auto-generated from keys. Example: columns=name&columns=status */
        columns: string[];
        /** Custom filename for the CSV download (without extension). */
        filename?: string;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - title
         * - description
         * - completed
         * - priorityLevel
         * - createdAt
         * - updatedAt
         * - deadline
         * - completedAt
         * - timeLogged
         * - estimatedTime
         * - category
         * - status
         * - referenceLink
         * - referenceName
         * - organizationId
         * - organizationName
         * - organization
         * - vendorId
         * - vendorName
         * - vendor
         * - seenAt
         * - seen
         * - assignee
         * - assigneeName
         * - assigneeEmail
         * - createdBy
         * - createdByName
         * - createdByEmail
         * - tagName
         * - tagColor
         * - tagId
         * - tagCreatedBy
         * - taskTagContactId
         * - taskTagEmployeeId
         * - taskTagType
         * - taskTagEmployeeName
         * - taskTagEmployeeEmail
         * - taskTagContactName
         * - taskTagContactEmail
         * - subauditId
         * - project
         * - commentsCount
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                  | Type   | Allowed Rules                                                                | Possible Values |
         * | -------------------- | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | id                   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | title                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | description          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | completed            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | priorityLevel        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdAt            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | updatedAt            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | deadline             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | completedAt          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | timeLogged           | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | estimatedTime        | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | category             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | status               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | referenceLink        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | referenceName        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organizationId       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organizationName     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organization         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendorId             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendorName           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendor               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | seenAt               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | seen                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assignee             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeName         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeEmail        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdBy            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdByName        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdByEmail       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | tagName              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | tagColor             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | tagId                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | tagCreatedBy         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | taskTagContactId     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | taskTagEmployeeId    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | taskTagType          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | taskTagEmployeeName  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | taskTagEmployeeEmail | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | taskTagContactName   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | taskTagContactEmail  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subauditId           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | project              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | commentsCount        | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - title
         * - description
         * - referenceName
         * - referenceLink
         * - assignee.name
         * - assignee.emailAddress
         * - createdBy.name
         * - createdBy.emailAddress
         * - organization.name
         * - taskTagss.tag.name
         * - taskTagss.employee.name
         * - taskTagss.employee.emailAddress
         * - taskTagss.contact.name
         * - taskTagss.contact.email
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<StreamableFile, void>({
        path: `/internal-portal/vendors/${vendorId}/tasks/export`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vendor relations
     * @name VendorRelationsControllerGetVendorTasks
     * @request GET:/internal-portal/vendors/{vendorId}/tasks
     * @secure
     */
    vendorRelationsControllerGetVendorTasks: (
      vendorId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - title
         * - description
         * - completed
         * - priorityLevel
         * - createdAt
         * - updatedAt
         * - deadline
         * - completedAt
         * - timeLogged
         * - estimatedTime
         * - category
         * - status
         * - referenceLink
         * - referenceName
         * - organizationId
         * - organizationName
         * - organization
         * - vendorId
         * - vendorName
         * - vendor
         * - seenAt
         * - seen
         * - assignee
         * - assigneeName
         * - assigneeEmail
         * - createdBy
         * - createdByName
         * - createdByEmail
         * - tagName
         * - tagColor
         * - tagId
         * - tagCreatedBy
         * - taskTagContactId
         * - taskTagEmployeeId
         * - taskTagType
         * - taskTagEmployeeName
         * - taskTagEmployeeEmail
         * - taskTagContactName
         * - taskTagContactEmail
         * - subauditId
         * - project
         * - commentsCount
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                  | Type   | Allowed Rules                                                                | Possible Values |
         * | -------------------- | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | id                   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | title                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | description          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | completed            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | priorityLevel        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdAt            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | updatedAt            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | deadline             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | completedAt          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | timeLogged           | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | estimatedTime        | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | category             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | status               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | referenceLink        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | referenceName        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organizationId       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organizationName     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organization         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendorId             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendorName           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendor               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | seenAt               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | seen                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assignee             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeName         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeEmail        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdBy            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdByName        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdByEmail       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | tagName              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | tagColor             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | tagId                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | tagCreatedBy         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | taskTagContactId     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | taskTagEmployeeId    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | taskTagType          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | taskTagEmployeeName  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | taskTagEmployeeEmail | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | taskTagContactName   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | taskTagContactEmail  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subauditId           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | project              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | commentsCount        | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - title
         * - description
         * - referenceName
         * - referenceLink
         * - assignee.name
         * - assignee.emailAddress
         * - createdBy.name
         * - createdBy.emailAddress
         * - organization.name
         * - taskTagss.tag.name
         * - taskTagss.employee.name
         * - taskTagss.employee.emailAddress
         * - taskTagss.contact.name
         * - taskTagss.contact.email
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<TaskListDto, void>({
        path: `/internal-portal/vendors/${vendorId}/tasks`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vendor relations
     * @name VendorRelationsControllerExportVendorContracts
     * @request GET:/internal-portal/vendors/{vendorId}/contracts/export
     * @secure
     */
    vendorRelationsControllerExportVendorContracts: (
      vendorId: string,
      query: {
        /** Column paths to export. Pass as repeated query params (preferred) or a JSON array string. Headers are auto-generated from keys. Example: columns=name&columns=status */
        columns: string[];
        /** Custom filename for the CSV download (without extension). */
        filename?: string;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - vendor
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key    | Type   | Allowed Rules                                                                | Possible Values |
         * | ------ | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | vendor | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<StreamableFile, void>({
        path: `/internal-portal/vendors/${vendorId}/contracts/export`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vendor relations
     * @name VendorRelationsControllerGetVendorContracts
     * @request GET:/internal-portal/vendors/{vendorId}/contracts
     * @secure
     */
    vendorRelationsControllerGetVendorContracts: (
      vendorId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - vendor
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key    | Type   | Allowed Rules                                                                | Possible Values |
         * | ------ | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | vendor | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<VendorContractListDto, void>({
        path: `/internal-portal/vendors/${vendorId}/contracts`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Task relations
     * @name TaskRelationsControllerExportTasks
     * @request GET:/internal-portal/tasks/export
     * @secure
     */
    taskRelationsControllerExportTasks: (
      query: {
        /** Column paths to export. Pass as repeated query params (preferred) or a JSON array string. Headers are auto-generated from keys. Example: columns=name&columns=status */
        columns: string[];
        /** Custom filename for the CSV download (without extension). */
        filename?: string;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - title
         * - description
         * - completed
         * - priorityLevel
         * - createdAt
         * - updatedAt
         * - deadline
         * - completedAt
         * - timeLogged
         * - estimatedTime
         * - category
         * - status
         * - referenceLink
         * - referenceName
         * - organizationId
         * - organizationName
         * - organization
         * - vendorId
         * - vendorName
         * - vendor
         * - seenAt
         * - seen
         * - assignee
         * - assigneeName
         * - assigneeEmail
         * - createdBy
         * - createdByName
         * - createdByEmail
         * - tagName
         * - tagColor
         * - tagId
         * - tagCreatedBy
         * - taskTagContactId
         * - taskTagEmployeeId
         * - taskTagType
         * - taskTagEmployeeName
         * - taskTagEmployeeEmail
         * - taskTagContactName
         * - taskTagContactEmail
         * - subauditId
         * - project
         * - commentsCount
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                  | Type   | Allowed Rules                                                                | Possible Values |
         * | -------------------- | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | id                   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | title                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | description          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | completed            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | priorityLevel        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdAt            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | updatedAt            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | deadline             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | completedAt          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | timeLogged           | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | estimatedTime        | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | category             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | status               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | referenceLink        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | referenceName        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organizationId       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organizationName     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organization         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendorId             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendorName           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendor               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | seenAt               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | seen                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assignee             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeName         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeEmail        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdBy            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdByName        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdByEmail       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | tagName              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | tagColor             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | tagId                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | tagCreatedBy         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | taskTagContactId     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | taskTagEmployeeId    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | taskTagType          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | taskTagEmployeeName  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | taskTagEmployeeEmail | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | taskTagContactName   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | taskTagContactEmail  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subauditId           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | project              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | commentsCount        | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - title
         * - description
         * - referenceName
         * - referenceLink
         * - assignee.name
         * - assignee.emailAddress
         * - createdBy.name
         * - createdBy.emailAddress
         * - organization.name
         * - taskTagss.tag.name
         * - taskTagss.employee.name
         * - taskTagss.employee.emailAddress
         * - taskTagss.contact.name
         * - taskTagss.contact.email
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<StreamableFile, void>({
        path: `/internal-portal/tasks/export`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Task relations
     * @name TaskRelationsControllerGetTasks
     * @request GET:/internal-portal/tasks
     * @secure
     */
    taskRelationsControllerGetTasks: (
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - title
         * - description
         * - completed
         * - priorityLevel
         * - createdAt
         * - updatedAt
         * - deadline
         * - completedAt
         * - timeLogged
         * - estimatedTime
         * - category
         * - status
         * - referenceLink
         * - referenceName
         * - organizationId
         * - organizationName
         * - organization
         * - vendorId
         * - vendorName
         * - vendor
         * - seenAt
         * - seen
         * - assignee
         * - assigneeName
         * - assigneeEmail
         * - createdBy
         * - createdByName
         * - createdByEmail
         * - tagName
         * - tagColor
         * - tagId
         * - tagCreatedBy
         * - taskTagContactId
         * - taskTagEmployeeId
         * - taskTagType
         * - taskTagEmployeeName
         * - taskTagEmployeeEmail
         * - taskTagContactName
         * - taskTagContactEmail
         * - subauditId
         * - project
         * - commentsCount
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                  | Type   | Allowed Rules                                                                | Possible Values |
         * | -------------------- | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | id                   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | title                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | description          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | completed            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | priorityLevel        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdAt            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | updatedAt            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | deadline             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | completedAt          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | timeLogged           | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | estimatedTime        | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | category             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | status               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | referenceLink        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | referenceName        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organizationId       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organizationName     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organization         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendorId             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendorName           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendor               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | seenAt               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | seen                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assignee             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeName         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeEmail        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdBy            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdByName        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdByEmail       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | tagName              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | tagColor             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | tagId                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | tagCreatedBy         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | taskTagContactId     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | taskTagEmployeeId    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | taskTagType          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | taskTagEmployeeName  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | taskTagEmployeeEmail | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | taskTagContactName   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | taskTagContactEmail  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subauditId           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | project              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | commentsCount        | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - title
         * - description
         * - referenceName
         * - referenceLink
         * - assignee.name
         * - assignee.emailAddress
         * - createdBy.name
         * - createdBy.emailAddress
         * - organization.name
         * - taskTagss.tag.name
         * - taskTagss.employee.name
         * - taskTagss.employee.emailAddress
         * - taskTagss.contact.name
         * - taskTagss.contact.email
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<TaskListDto, void>({
        path: `/internal-portal/tasks`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ticket relations
     * @name TicketRelationsControllerGetTicketTasks
     * @request GET:/internal-portal/tickets/{ticketId}/tasks
     * @secure
     */
    ticketRelationsControllerGetTicketTasks: (
      ticketId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - title
         * - description
         * - completed
         * - priorityLevel
         * - createdAt
         * - updatedAt
         * - deadline
         * - completedAt
         * - timeLogged
         * - estimatedTime
         * - category
         * - status
         * - referenceLink
         * - referenceName
         * - organizationId
         * - organizationName
         * - organization
         * - vendorId
         * - vendorName
         * - vendor
         * - seenAt
         * - seen
         * - assignee
         * - assigneeName
         * - assigneeEmail
         * - createdBy
         * - createdByName
         * - createdByEmail
         * - tagName
         * - tagColor
         * - tagId
         * - tagCreatedBy
         * - taskTagContactId
         * - taskTagEmployeeId
         * - taskTagType
         * - taskTagEmployeeName
         * - taskTagEmployeeEmail
         * - taskTagContactName
         * - taskTagContactEmail
         * - subauditId
         * - project
         * - commentsCount
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                  | Type   | Allowed Rules                                                                | Possible Values |
         * | -------------------- | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | id                   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | title                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | description          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | completed            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | priorityLevel        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdAt            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | updatedAt            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | deadline             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | completedAt          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | timeLogged           | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | estimatedTime        | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | category             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | status               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | referenceLink        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | referenceName        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organizationId       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organizationName     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organization         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendorId             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendorName           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendor               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | seenAt               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | seen                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assignee             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeName         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeEmail        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdBy            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdByName        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdByEmail       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | tagName              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | tagColor             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | tagId                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | tagCreatedBy         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | taskTagContactId     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | taskTagEmployeeId    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | taskTagType          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | taskTagEmployeeName  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | taskTagEmployeeEmail | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | taskTagContactName   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | taskTagContactEmail  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subauditId           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | project              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | commentsCount        | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - title
         * - description
         * - referenceName
         * - referenceLink
         * - assignee.name
         * - assignee.emailAddress
         * - createdBy.name
         * - createdBy.emailAddress
         * - organization.name
         * - taskTagss.tag.name
         * - taskTagss.employee.name
         * - taskTagss.employee.emailAddress
         * - taskTagss.contact.name
         * - taskTagss.contact.email
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<TaskListDto, void>({
        path: `/internal-portal/tickets/${ticketId}/tasks`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Locations
     * @name LocationsControllerGetLocations
     * @request GET:/internal-portal/organizations/{organizationId}/locations
     * @secure
     */
    locationsControllerGetLocations: (
      organizationId: string,
      query?: {
        withSubsidiaries?: boolean;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - kind
         * - id
         * - name
         * - displayName
         * - mainPointOfContact
         * - address
         * - locationIdentifier
         * - city
         * - state
         * - zip
         * - taxId
         * - phone
         * - subsidiaryOrganizationName
         * - status
         * - stages
         * - savings
         * - documentFieldStatus
         * - activeAudits
         * - isMissingRow
         * - squareFootage
         * - weatherStation
         * - hoursOfOperation
         * - units
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                        | Type       | Allowed Rules                                                                | Possible Values                                                                     |
         * | -------------------------- | ---------- | ---------------------------------------------------------------------------- | ----------------------------------------------------------------------------------- |
         * | kind                       | string     | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | site, organization_wide                                                             |
         * | id                         | string     | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | name                       | string     | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | displayName                | string     | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | mainPointOfContact         | contactdto |                                                                              |                                                                                     |
         * | address                    | string     | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | locationIdentifier         | string     | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | city                       | string     | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | state                      | string     | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | zip                        | string     | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | taxId                      | string     | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | phone                      | string     | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | subsidiaryOrganizationName | string     | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | status                     | object     |                                                                              | Active, Monitored, Sold, Closed, Under Construction, Not Active                     |
         * | stages                     | string     | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | savings                    | number     | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                     |
         * | documentFieldStatus        | object     |                                                                              | COMPLETE, MISSING_FIELDS, UPLOAD_INVOICES, NOT_APPLICABLE_REQUESTED, NOT_APPLICABLE |
         * | activeAudits               | number     | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                     |
         * | isMissingRow               | boolean    | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                                                                                     |
         * | squareFootage              | number     | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                     |
         * | weatherStation             | string     | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | hoursOfOperation           | string     | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | units                      | number     | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                     |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - name
         * - address
         * - city
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<LocationsDto, void>({
        path: `/internal-portal/organizations/${organizationId}/locations`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Locations
     * @name LocationsControllerCreateLocation
     * @request POST:/internal-portal/organizations/{organizationId}/locations
     * @secure
     */
    locationsControllerCreateLocation: (
      organizationId: string,
      data: IpCreateLocationDto,
      params: RequestParams = {}
    ) =>
      this.request<LocationDetailDto, void>({
        path: `/internal-portal/organizations/${organizationId}/locations`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Locations
     * @name LocationsControllerExportLocations
     * @request GET:/internal-portal/organizations/{organizationId}/locations/export
     * @secure
     */
    locationsControllerExportLocations: (
      organizationId: string,
      query: {
        withSubsidiaries?: boolean;
        /** Column paths to export. Pass as repeated query params (preferred) or a JSON array string. Headers are auto-generated from keys. Example: columns=name&columns=status */
        columns: string[];
        /** Custom filename for the CSV download (without extension). */
        filename?: string;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - kind
         * - id
         * - name
         * - displayName
         * - mainPointOfContact
         * - address
         * - locationIdentifier
         * - city
         * - state
         * - zip
         * - taxId
         * - phone
         * - subsidiaryOrganizationName
         * - status
         * - stages
         * - savings
         * - documentFieldStatus
         * - activeAudits
         * - isMissingRow
         * - squareFootage
         * - weatherStation
         * - hoursOfOperation
         * - units
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                        | Type       | Allowed Rules                                                                | Possible Values                                                                     |
         * | -------------------------- | ---------- | ---------------------------------------------------------------------------- | ----------------------------------------------------------------------------------- |
         * | kind                       | string     | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | site, organization_wide                                                             |
         * | id                         | string     | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | name                       | string     | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | displayName                | string     | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | mainPointOfContact         | contactdto |                                                                              |                                                                                     |
         * | address                    | string     | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | locationIdentifier         | string     | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | city                       | string     | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | state                      | string     | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | zip                        | string     | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | taxId                      | string     | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | phone                      | string     | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | subsidiaryOrganizationName | string     | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | status                     | object     |                                                                              | Active, Monitored, Sold, Closed, Under Construction, Not Active                     |
         * | stages                     | string     | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | savings                    | number     | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                     |
         * | documentFieldStatus        | object     |                                                                              | COMPLETE, MISSING_FIELDS, UPLOAD_INVOICES, NOT_APPLICABLE_REQUESTED, NOT_APPLICABLE |
         * | activeAudits               | number     | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                     |
         * | isMissingRow               | boolean    | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                                                                                     |
         * | squareFootage              | number     | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                     |
         * | weatherStation             | string     | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | hoursOfOperation           | string     | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | units                      | number     | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                     |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - name
         * - address
         * - city
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<StreamableFile, void>({
        path: `/internal-portal/organizations/${organizationId}/locations/export`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Locations
     * @name LocationsControllerGetImportTemplate
     * @request GET:/internal-portal/organizations/{organizationId}/locations/template
     * @secure
     */
    locationsControllerGetImportTemplate: (
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/internal-portal/organizations/${organizationId}/locations/template`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Locations
     * @name LocationsControllerGetLocationById
     * @request GET:/internal-portal/organizations/{organizationId}/locations/{locationId}
     * @secure
     */
    locationsControllerGetLocationById: (
      locationId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<LocationDetailDto, void>({
        path: `/internal-portal/organizations/${organizationId}/locations/${locationId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Locations
     * @name LocationsControllerUpdateLocation
     * @request PATCH:/internal-portal/organizations/{organizationId}/locations/{locationId}
     * @secure
     */
    locationsControllerUpdateLocation: (
      locationId: string,
      organizationId: string,
      data: IpUpdateLocationDto,
      params: RequestParams = {}
    ) =>
      this.request<LocationDetailDto, void>({
        path: `/internal-portal/organizations/${organizationId}/locations/${locationId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Locations
     * @name LocationsControllerDeleteLocation
     * @request DELETE:/internal-portal/organizations/{organizationId}/locations/{locationId}
     * @secure
     */
    locationsControllerDeleteLocation: (
      locationId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/internal-portal/organizations/${organizationId}/locations/${locationId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Locations
     * @name LocationsControllerValidateImport
     * @request POST:/internal-portal/organizations/{organizationId}/locations/import
     * @secure
     */
    locationsControllerValidateImport: (
      organizationId: string,
      data: FileUploadDto,
      params: RequestParams = {}
    ) =>
      this.request<LocationImportResultDto, void>({
        path: `/internal-portal/organizations/${organizationId}/locations/import`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Locations
     * @name LocationsControllerCreateMany
     * @request POST:/internal-portal/organizations/{organizationId}/locations/many
     * @secure
     */
    locationsControllerCreateMany: (
      organizationId: string,
      data: LocationCreateManyDto,
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/internal-portal/organizations/${organizationId}/locations/many`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Online access
     * @name OnlineAccessControllerGetOnlineAccessRecords
     * @request GET:/internal-portal/organizations/{organizationId}/online-access
     * @secure
     */
    onlineAccessControllerGetOnlineAccessRecords: (
      organizationId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - status
         * - websiteUrl
         * - username
         * - securityQuestionsCount
         * - note
         * - vendor
         * - vendorAccounts
         * - hasCredential
         * - hasSecurityQuestions
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                    | Type     | Allowed Rules                                                                | Possible Values  |
         * | ---------------------- | -------- | ---------------------------------------------------------------------------- | ---------------- |
         * | id                     | string   | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                  |
         * | name                   | string   | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                  |
         * | status                 | string   | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | active, archived |
         * | websiteUrl             | string   | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                  |
         * | username               | string   | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                  |
         * | securityQuestionsCount | number   | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                  |
         * | note                   | string   | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                  |
         * | vendor                 | plaindto |                                                                              |                  |
         * | vendorAccounts         | plaindto |                                                                              |                  |
         * | hasCredential          | boolean  | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                  |
         * | hasSecurityQuestions   | boolean  | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                  |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - name
         * - username
         * - websiteUrl
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<OnlineAccessListDto, void>({
        path: `/internal-portal/organizations/${organizationId}/online-access`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Online access
     * @name OnlineAccessControllerCreateOnlineAccess
     * @request POST:/internal-portal/organizations/{organizationId}/online-access
     * @secure
     */
    onlineAccessControllerCreateOnlineAccess: (
      organizationId: string,
      data: CreateOnlineAccessDto,
      params: RequestParams = {}
    ) =>
      this.request<OnlineAccessListItemDto, void>({
        path: `/internal-portal/organizations/${organizationId}/online-access`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Online access
     * @name OnlineAccessControllerGetCredential
     * @request GET:/internal-portal/organizations/{organizationId}/online-access/{onlineAccessId}/credential
     * @secure
     */
    onlineAccessControllerGetCredential: (
      organizationId: string,
      onlineAccessId: string,
      params: RequestParams = {}
    ) =>
      this.request<OnlineAccessCredentialDto, void>({
        path: `/internal-portal/organizations/${organizationId}/online-access/${onlineAccessId}/credential`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Online access
     * @name OnlineAccessControllerGetSecrets
     * @request GET:/internal-portal/organizations/{organizationId}/online-access/{onlineAccessId}/secrets
     * @secure
     */
    onlineAccessControllerGetSecrets: (
      organizationId: string,
      onlineAccessId: string,
      params: RequestParams = {}
    ) =>
      this.request<OnlineAccessSecretsDto, void>({
        path: `/internal-portal/organizations/${organizationId}/online-access/${onlineAccessId}/secrets`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Online access
     * @name OnlineAccessControllerUpdateOnlineAccess
     * @request PATCH:/internal-portal/organizations/{organizationId}/online-access/{onlineAccessId}
     * @secure
     */
    onlineAccessControllerUpdateOnlineAccess: (
      organizationId: string,
      onlineAccessId: string,
      data: UpdateOnlineAccessDto,
      params: RequestParams = {}
    ) =>
      this.request<OnlineAccessListItemDto, void>({
        path: `/internal-portal/organizations/${organizationId}/online-access/${onlineAccessId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Online access
     * @name OnlineAccessControllerDeleteOnlineAccess
     * @request DELETE:/internal-portal/organizations/{organizationId}/online-access/{onlineAccessId}
     * @secure
     */
    onlineAccessControllerDeleteOnlineAccess: (
      organizationId: string,
      onlineAccessId: string,
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/internal-portal/organizations/${organizationId}/online-access/${onlineAccessId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Action Items
     * @name ActionItemsControllerExportActionItems
     * @request GET:/internal-portal/action-items/export
     * @secure
     */
    actionItemsControllerExportActionItems: (
      query: {
        /** Column paths to export. Pass as repeated query params (preferred) or a JSON array string. Headers are auto-generated from keys. Example: columns=name&columns=status */
        columns: string[];
        /** Custom filename for the CSV download (without extension). */
        filename?: string;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - assigneeName
         * - assigneeEmail
         * - assignee
         * - createdBy
         * - title
         * - description
         * - createdAt
         * - updatedAt
         * - deadline
         * - completedAt
         * - spendAreaStage
         * - priorityLevel
         * - actionType
         * - organizationId
         * - organizationName
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key              | Type   | Allowed Rules                                                                | Possible Values |
         * | ---------------- | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | id               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | name             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeName     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeEmail    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assignee         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdBy        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | title            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | description      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdAt        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | updatedAt        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | deadline         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | completedAt      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | spendAreaStage   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | priorityLevel    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | actionType       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organizationId   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organizationName | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - title
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<StreamableFile, void>({
        path: `/internal-portal/action-items/export`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Action Items
     * @name ActionItemsControllerGetActionItems
     * @request GET:/internal-portal/action-items
     * @secure
     */
    actionItemsControllerGetActionItems: (
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - assigneeName
         * - assigneeEmail
         * - assignee
         * - createdBy
         * - title
         * - description
         * - createdAt
         * - updatedAt
         * - deadline
         * - completedAt
         * - spendAreaStage
         * - priorityLevel
         * - actionType
         * - organizationId
         * - organizationName
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key              | Type   | Allowed Rules                                                                | Possible Values |
         * | ---------------- | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | id               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | name             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeName     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeEmail    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assignee         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdBy        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | title            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | description      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdAt        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | updatedAt        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | deadline         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | completedAt      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | spendAreaStage   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | priorityLevel    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | actionType       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organizationId   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organizationName | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - title
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<IPActionItemListDto, void>({
        path: `/internal-portal/action-items`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Action Items
     * @name ActionItemsControllerGetGlobalWorkActionItems
     * @request GET:/internal-portal/action-items/global-work
     * @secure
     */
    actionItemsControllerGetGlobalWorkActionItems: (
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - assigneeName
         * - assigneeEmail
         * - assignee
         * - createdBy
         * - title
         * - description
         * - createdAt
         * - updatedAt
         * - deadline
         * - completedAt
         * - spendAreaStage
         * - priorityLevel
         * - actionType
         * - organizationId
         * - organizationName
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key              | Type   | Allowed Rules                                                                | Possible Values |
         * | ---------------- | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | id               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | name             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeName     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeEmail    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assignee         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdBy        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | title            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | description      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdAt        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | updatedAt        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | deadline         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | completedAt      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | spendAreaStage   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | priorityLevel    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | actionType       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organizationId   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organizationName | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - title
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<GlobalWorkActionItemListDto, void>({
        path: `/internal-portal/action-items/global-work`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Dashboard
     * @name DashboardControllerGetMetrics
     * @request GET:/internal-portal/dashboard/metrics
     * @secure
     */
    dashboardControllerGetMetrics: (
      query: {
        /** The metric fields to include in the response. */
        fields: DashboardMetricsField[];
      },
      params: RequestParams = {}
    ) =>
      this.request<DashboardMetricsDto, void>({
        path: `/internal-portal/dashboard/metrics`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Dashboard
     * @name DashboardControllerGetManagedOrganizations
     * @request GET:/internal-portal/dashboard/managed-organizations
     * @secure
     */
    dashboardControllerGetManagedOrganizations: (
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key  | Type   | Allowed Rules                                                                | Possible Values |
         * | ---- | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | id   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | name | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<ManagedOrganizationsListDto, void>({
        path: `/internal-portal/dashboard/managed-organizations`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Dashboard
     * @name DashboardControllerGetPinnedOrganizations
     * @request GET:/internal-portal/dashboard/pinned/organizations
     * @secure
     */
    dashboardControllerGetPinnedOrganizations: (
      query: {
        key: string;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - status
         * - clientStatus
         * - isActive
         * - primaryContact
         * - locationsCount
         * - openAuditsCount
         * - parentOrganization
         * - financialMetrics.inScopeSpend
         * - financialMetrics.savingsIdentified
         * - financialMetrics.savingsApproved
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                                | Type                          | Allowed Rules                                                                | Possible Values                                                                                              |
         * | ---------------------------------- | ----------------------------- | ---------------------------------------------------------------------------- | ------------------------------------------------------------------------------------------------------------ |
         * | id                                 | string                        | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                              |
         * | name                               | string                        | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                              |
         * | status                             | string                        | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | active, inactive                                                                                             |
         * | clientStatus                       | object                        |                                                                              | dormant, mobilization, negotiation, post_negotiation, pre_negotiation, prospect, update_required, validation |
         * | isActive                           | boolean                       | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                                                                                                              |
         * | primaryContact                     | organizationprimarycontactdto |                                                                              |                                                                                                              |
         * | locationsCount                     | number                        | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                                              |
         * | openAuditsCount                    | number                        | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                                              |
         * | parentOrganization                 | plainorganizationdto          |                                                                              |                                                                                                              |
         * | financialMetrics.inScopeSpend      | number                        | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                                              |
         * | financialMetrics.savingsIdentified | number                        | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                                              |
         * | financialMetrics.savingsApproved   | number                        | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                                              |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - name
         * - primaryContact.name
         * - primaryContact.email
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<OrganizationListDto, void>({
        path: `/internal-portal/dashboard/pinned/organizations`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Dashboard
     * @name DashboardControllerGetPinnedVendors
     * @request GET:/internal-portal/dashboard/pinned/vendors
     * @secure
     */
    dashboardControllerGetPinnedVendors: (
      query: {
        key: string;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - lastUpdated
         * - clientOrganisationsCount
         * - contactsCount
         * - openTicketsCount
         * - openTasksCount
         * - contractsCount
         * - auditsCount
         * - orgScopedAuditsCount
         * - totalSpend
         * - status
         * - assignee
         * - spendCategories
         * - spendAreas
         * - vendorAccounts
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                      | Type   | Allowed Rules                                                                | Possible Values |
         * | ------------------------ | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | id                       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | name                     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | lastUpdated              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | clientOrganisationsCount | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | contactsCount            | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | openTicketsCount         | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | openTasksCount           | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | contractsCount           | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | auditsCount              | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | orgScopedAuditsCount     | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | totalSpend               | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | status                   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assignee                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | spendCategories          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | spendAreas               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendorAccounts           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - name
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<VendorListDto, void>({
        path: `/internal-portal/dashboard/pinned/vendors`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Dashboard
     * @name DashboardControllerGetPinnedProjects
     * @request GET:/internal-portal/dashboard/pinned/projects
     * @secure
     */
    dashboardControllerGetPinnedProjects: (
      query: {
        key: string;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - projectStatus
         * - id
         * - name
         * - startDate
         * - targetEndDate
         * - assignee
         * - updatedAt
         * - createdAt
         * - team.id
         * - team.name
         * - owner.id
         * - owner.name
         * - owner.email
         * - owner.avatarUrl
         * - owner.deletedAt
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key             | Type   | Allowed Rules                                                                | Possible Values                                                                         |
         * | --------------- | ------ | ---------------------------------------------------------------------------- | --------------------------------------------------------------------------------------- |
         * | projectStatus   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | unassigned, unstarted, in-progress, on-hold, view-only, in-review, escalated, completed |
         * | id              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                         |
         * | name            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                         |
         * | startDate       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                         |
         * | targetEndDate   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                         |
         * | assignee        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                         |
         * | updatedAt       | date   | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty   |                                                                                         |
         * | createdAt       | date   | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty   |                                                                                         |
         * | team.id         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                         |
         * | team.name       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                         |
         * | owner.id        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                         |
         * | owner.name      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                         |
         * | owner.email     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                         |
         * | owner.avatarUrl | object |                                                                              |                                                                                         |
         * | owner.deletedAt | object |                                                                              |                                                                                         |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - name
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<ProjectListDto, void>({
        path: `/internal-portal/dashboard/pinned/projects`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Dashboard
     * @name DashboardControllerGetPinnedTeams
     * @request GET:/internal-portal/dashboard/pinned/teams
     * @secure
     */
    dashboardControllerGetPinnedTeams: (
      query: {
        key: string;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - activeTaskCount
         * - allTaskCount
         * - userCount
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key             | Type   | Allowed Rules                                                                | Possible Values |
         * | --------------- | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | id              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | name            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | activeTaskCount | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | allTaskCount    | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | userCount       | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - name
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<IpTeamListDto, void>({
        path: `/internal-portal/dashboard/pinned/teams`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Dashboard
     * @name DashboardControllerGetPinnedAudits
     * @request GET:/internal-portal/dashboard/pinned/audits
     * @secure
     */
    dashboardControllerGetPinnedAudits: (
      query: {
        key: string;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - name
         * - status
         * - salesforceSource
         * - stage
         * - vendor
         * - creator
         * - owner
         * - team
         * - createdAt
         * - dueDate
         * - savingsStartDate
         * - baselineSpend
         * - invoicesAttachedCount
         * - spendCategory
         * - includedLocations
         * - contractId
         * - contract
         * - organization
         * - organizationId
         * - isMigrated
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                   | Type   | Allowed Rules                                                                | Possible Values                      |
         * | --------------------- | ------ | ---------------------------------------------------------------------------- | ------------------------------------ |
         * | name                  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | status                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | salesforceSource      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | parent_audit, vendor_split, subaudit |
         * | stage                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | vendor                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | creator               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | owner                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | team                  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | createdAt             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | dueDate               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | savingsStartDate      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | baselineSpend         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | invoicesAttachedCount | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | spendCategory         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | includedLocations     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | contractId            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | contract              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | organization          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | organizationId        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | isMigrated            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<PinnedAuditListDto, void>({
        path: `/internal-portal/dashboard/pinned/audits`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Teams
     * @name TeamsControllerGetTeams
     * @request GET:/internal-portal/teams
     * @secure
     */
    teamsControllerGetTeams: (
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - activeTaskCount
         * - allTaskCount
         * - userCount
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key             | Type   | Allowed Rules                                                                | Possible Values |
         * | --------------- | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | id              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | name            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | activeTaskCount | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | allTaskCount    | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | userCount       | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - name
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<IpTeamListDto, void>({
        path: `/internal-portal/teams`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audits
     * @name AuditsControllerGetSpendCategorySelectList
     * @request GET:/internal-portal/audits/select-list/spend-categories
     * @secure
     */
    auditsControllerGetSpendCategorySelectList: (params: RequestParams = {}) =>
      this.request<SelectListDto, void>({
        path: `/internal-portal/audits/select-list/spend-categories`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audits
     * @name AuditsControllerGetVendorSelectList
     * @request GET:/internal-portal/audits/select-list/vendors
     * @secure
     */
    auditsControllerGetVendorSelectList: (params: RequestParams = {}) =>
      this.request<SelectListDto, void>({
        path: `/internal-portal/audits/select-list/vendors`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audits
     * @name AuditsControllerExportAudits
     * @request GET:/internal-portal/audits/export
     * @secure
     */
    auditsControllerExportAudits: (
      query: {
        /** Column paths to export. Pass as repeated query params (preferred) or a JSON array string. Headers are auto-generated from keys. Example: columns=name&columns=status */
        columns: string[];
        /** Custom filename for the CSV download (without extension). */
        filename?: string;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - name
         * - status
         * - salesforceSource
         * - stage
         * - vendor
         * - creator
         * - owner
         * - team
         * - createdAt
         * - dueDate
         * - savingsStartDate
         * - baselineSpend
         * - invoicesAttachedCount
         * - spendCategory
         * - includedLocations
         * - contractId
         * - contract
         * - organization
         * - organizationId
         * - isMigrated
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                   | Type   | Allowed Rules                                                                | Possible Values                      |
         * | --------------------- | ------ | ---------------------------------------------------------------------------- | ------------------------------------ |
         * | name                  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | status                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | salesforceSource      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | parent_audit, vendor_split, subaudit |
         * | stage                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | vendor                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | creator               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | owner                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | team                  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | createdAt             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | dueDate               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | savingsStartDate      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | baselineSpend         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | invoicesAttachedCount | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | spendCategory         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | includedLocations     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | contractId            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | contract              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | organization          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | organizationId        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | isMigrated            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<StreamableFile, void>({
        path: `/internal-portal/audits/export`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audits
     * @name AuditsControllerFindAll
     * @request GET:/internal-portal/audits
     * @secure
     */
    auditsControllerFindAll: (
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - name
         * - status
         * - salesforceSource
         * - stage
         * - vendor
         * - creator
         * - owner
         * - team
         * - createdAt
         * - dueDate
         * - savingsStartDate
         * - baselineSpend
         * - invoicesAttachedCount
         * - spendCategory
         * - includedLocations
         * - contractId
         * - contract
         * - organization
         * - organizationId
         * - isMigrated
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                   | Type   | Allowed Rules                                                                | Possible Values                      |
         * | --------------------- | ------ | ---------------------------------------------------------------------------- | ------------------------------------ |
         * | name                  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | status                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | salesforceSource      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | parent_audit, vendor_split, subaudit |
         * | stage                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | vendor                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | creator               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | owner                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | team                  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | createdAt             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | dueDate               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | savingsStartDate      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | baselineSpend         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | invoicesAttachedCount | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | spendCategory         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | includedLocations     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | contractId            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | contract              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | organization          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | organizationId        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | isMigrated            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<AuditsListDto, void>({
        path: `/internal-portal/audits`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audits
     * @name OrganizationAuditsControllerFindAll
     * @request GET:/internal-portal/organizations/{organizationId}/audits
     * @secure
     */
    organizationAuditsControllerFindAll: (
      organizationId: string,
      query?: {
        /** Filter audits by included location ids */
        locationIds?: string[];
        withSubsidiaries?: boolean;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - name
         * - status
         * - salesforceSource
         * - stage
         * - vendor
         * - creator
         * - owner
         * - team
         * - createdAt
         * - dueDate
         * - savingsStartDate
         * - baselineSpend
         * - invoicesAttachedCount
         * - spendCategory
         * - includedLocations
         * - contractId
         * - contract
         * - organization
         * - organizationId
         * - isMigrated
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                   | Type   | Allowed Rules                                                                | Possible Values                      |
         * | --------------------- | ------ | ---------------------------------------------------------------------------- | ------------------------------------ |
         * | name                  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | status                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | salesforceSource      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | parent_audit, vendor_split, subaudit |
         * | stage                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | vendor                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | creator               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | owner                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | team                  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | createdAt             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | dueDate               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | savingsStartDate      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | baselineSpend         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | invoicesAttachedCount | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | spendCategory         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | includedLocations     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | contractId            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | contract              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | organization          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | organizationId        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | isMigrated            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<AuditListDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audits
     * @name OrganizationAuditsControllerCreate
     * @request POST:/internal-portal/organizations/{organizationId}/audits
     * @secure
     */
    organizationAuditsControllerCreate: (
      organizationId: string,
      data: CreateAuditDto,
      params: RequestParams = {}
    ) =>
      this.request<AuditItemDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audits
     * @name OrganizationAuditsControllerExportAudits
     * @request GET:/internal-portal/organizations/{organizationId}/audits/export
     * @secure
     */
    organizationAuditsControllerExportAudits: (
      organizationId: string,
      query: {
        /** Filter audits by included location ids */
        locationIds?: string[];
        withSubsidiaries?: boolean;
        /** Column paths to export. Pass as repeated query params (preferred) or a JSON array string. Headers are auto-generated from keys. Example: columns=name&columns=status */
        columns: string[];
        /** Custom filename for the CSV download (without extension). */
        filename?: string;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - name
         * - status
         * - salesforceSource
         * - stage
         * - vendor
         * - creator
         * - owner
         * - team
         * - createdAt
         * - dueDate
         * - savingsStartDate
         * - baselineSpend
         * - invoicesAttachedCount
         * - spendCategory
         * - includedLocations
         * - contractId
         * - contract
         * - organization
         * - organizationId
         * - isMigrated
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                   | Type   | Allowed Rules                                                                | Possible Values                      |
         * | --------------------- | ------ | ---------------------------------------------------------------------------- | ------------------------------------ |
         * | name                  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | status                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | salesforceSource      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | parent_audit, vendor_split, subaudit |
         * | stage                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | vendor                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | creator               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | owner                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | team                  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | createdAt             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | dueDate               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | savingsStartDate      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | baselineSpend         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | invoicesAttachedCount | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | spendCategory         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | includedLocations     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | contractId            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | contract              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | organization          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | organizationId        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | isMigrated            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<StreamableFile, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/export`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audits
     * @name OrganizationAuditsControllerGetAverageDuration
     * @request GET:/internal-portal/organizations/{organizationId}/audits/average-duration
     * @secure
     */
    organizationAuditsControllerGetAverageDuration: (
      organizationId: string,
      query: {
        /**
         * Spend category id to compute the average for
         * @format uuid
         */
        spendCategoryId: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<AverageAuditDurationDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/average-duration`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audits
     * @name OrganizationAuditsControllerGetSpendCategorySelectList
     * @request GET:/internal-portal/organizations/{organizationId}/audits/select-list/spend-categories
     * @secure
     */
    organizationAuditsControllerGetSpendCategorySelectList: (
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<SelectListDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/select-list/spend-categories`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audits
     * @name OrganizationAuditsControllerGetVendorSelectList
     * @request GET:/internal-portal/organizations/{organizationId}/audits/select-list/vendors
     * @secure
     */
    organizationAuditsControllerGetVendorSelectList: (
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<SelectListDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/select-list/vendors`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audits
     * @name OrganizationAuditsControllerFindOne
     * @request GET:/internal-portal/organizations/{organizationId}/audits/{auditId}
     * @secure
     */
    organizationAuditsControllerFindOne: (
      auditId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<AuditItemDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audits
     * @name OrganizationAuditsControllerUpdate
     * @request PATCH:/internal-portal/organizations/{organizationId}/audits/{auditId}
     * @secure
     */
    organizationAuditsControllerUpdate: (
      auditId: string,
      organizationId: string,
      data: UpdateAuditDto,
      params: RequestParams = {}
    ) =>
      this.request<AuditItemDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audits
     * @name OrganizationAuditsControllerListLinkedAudits
     * @request GET:/internal-portal/organizations/{organizationId}/audits/{auditId}/linked-audits
     * @secure
     */
    organizationAuditsControllerListLinkedAudits: (
      auditId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<LinkedAuditItemDto[], void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/linked-audits`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audits
     * @name OrganizationAuditsControllerCopyAudit
     * @request POST:/internal-portal/organizations/{organizationId}/audits/{auditId}/copy
     * @secure
     */
    organizationAuditsControllerCopyAudit: (
      organizationId: string,
      auditId: string,
      params: RequestParams = {}
    ) =>
      this.request<CopyAuditResultDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/copy`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Backfill
     * @name AuditBackfillControllerListBackfillRequired
     * @summary Spend of the migrated audit family not attributed to one audit, grouped by vendor account and location
     * @request GET:/internal-portal/organizations/{organizationId}/audits/{auditId}/backfill
     * @secure
     */
    auditBackfillControllerListBackfillRequired: (
      auditId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<BackfillRequiredDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/backfill`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Backfill
     * @name AuditBackfillControllerGetBackfillStatus
     * @summary Whether the audit in the path has a vendor and a SIB contract
     * @request GET:/internal-portal/organizations/{organizationId}/audits/{auditId}/backfill/status
     * @secure
     */
    auditBackfillControllerGetBackfillStatus: (
      auditId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<BackfillAuditStatusDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/backfill/status`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Backfill
     * @name AuditBackfillControllerListBackfillSpends
     * @summary Unattributed spends of one group across the whole migrated audit family, each flagged as assignable or not
     * @request GET:/internal-portal/organizations/{organizationId}/audits/{auditId}/backfill/spends
     * @secure
     */
    auditBackfillControllerListBackfillSpends: (
      auditId: string,
      organizationId: string,
      query: {
        vendorAccountId: string;
        locationId: string;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - assignable
         * - id
         * - name
         * - vendorName
         * - vendorAccountNumber
         * - locationName
         * - pricingModel
         * - unit
         * - quantity
         * - pricePerUnit
         * - percentageRate
         * - total
         * - type
         * - frequency
         * - reason
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                 | Type    | Allowed Rules                                                                | Possible Values                                                                  |
         * | ------------------- | ------- | ---------------------------------------------------------------------------- | -------------------------------------------------------------------------------- |
         * | assignable          | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                                                                                  |
         * | id                  | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                  |
         * | name                | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                  |
         * | vendorName          | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                  |
         * | vendorAccountNumber | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                  |
         * | locationName        | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                  |
         * | pricingModel        | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | usage_based, fixed_fee, percentage_rate                                          |
         * | unit                | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                  |
         * | quantity            | number  | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                  |
         * | pricePerUnit        | number  | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                  |
         * | percentageRate      | number  | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                  |
         * | total               | number  | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                  |
         * | type                | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | one_time, recurring                                                              |
         * | frequency           | object  |                                                                              | weekly, monthly, quarterly, annually, on_call_as_needed                          |
         * | reason              | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | ambiguous_audit_match, no_matching_audit, missing_vendor_account, missing_vendor |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - name
         * - vendorAccount.accountNumber
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<BackfillSpendListDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/backfill/spends`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Backfill
     * @name AuditBackfillControllerAssignBackfillSpend
     * @summary Attribute the spends of one vendor account and location that the target audit's vendor covers to that audit
     * @request POST:/internal-portal/organizations/{organizationId}/audits/{auditId}/backfill/assign
     * @secure
     */
    auditBackfillControllerAssignBackfillSpend: (
      auditId: string,
      organizationId: string,
      data: AssignBackfillSpendDto,
      params: RequestParams = {}
    ) =>
      this.request<BackfillRequiredDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/backfill/assign`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Comments
     * @name AuditCommentsControllerListComments
     * @request GET:/internal-portal/organizations/{organizationId}/audits/{auditId}/comments
     * @secure
     */
    auditCommentsControllerListComments: (
      auditId: string,
      organizationId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - createdBy
         * - assignee
         * - createdAt
         * - updatedAt
         * - id
         * - subject
         * - comment
         * - auditStage
         * - auditId
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key        | Type   | Allowed Rules                                                                | Possible Values                                                                                                 |
         * | ---------- | ------ | ---------------------------------------------------------------------------- | --------------------------------------------------------------------------------------------------------------- |
         * | createdBy  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                                 |
         * | assignee   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                                 |
         * | createdAt  | date   | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty   |                                                                                                                 |
         * | updatedAt  | date   | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty   |                                                                                                                 |
         * | id         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                                 |
         * | subject    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                                 |
         * | comment    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                                 |
         * | auditStage | object |                                                                              | MONITORING_SAVINGS, INITIAL_VALIDATION, SPEND_ESTIMATED, MOBILIZATION, NEGOTIATIONS_VENDOR, NEGOTIATIONS_CLIENT |
         * | auditId    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                                 |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<AuditCommentListDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/comments`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Comments
     * @name AuditCommentsControllerCreateComment
     * @request POST:/internal-portal/organizations/{organizationId}/audits/{auditId}/comments
     * @secure
     */
    auditCommentsControllerCreateComment: (
      auditId: string,
      organizationId: string,
      data: CreateAuditCommentDto,
      params: RequestParams = {}
    ) =>
      this.request<AuditCommentDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/comments`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Comments
     * @name AuditCommentsControllerDeleteComment
     * @request DELETE:/internal-portal/organizations/{organizationId}/audits/{auditId}/comments/{commentId}
     * @secure
     */
    auditCommentsControllerDeleteComment: (
      auditId: string,
      commentId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<MessageResponseDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/comments/${commentId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Documents
     * @name AuditDocumentControllerListAttachedDocuments
     * @request GET:/internal-portal/organizations/{organizationId}/audits/{auditId}/documents
     * @secure
     */
    auditDocumentControllerListAttachedDocuments: (
      organizationId: string,
      auditId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - uploadedAuditStage
         * - attachedFromDocumentsRepo
         * - invoiceId
         * - stage
         * - vendor
         * - name
         * - createdAt
         * - updatedAt
         * - providedBy
         * - type
         * - spendCategory
         * - id
         * - uploadedBy
         * - startDate
         * - endDate
         * - renewalDate
         * - annualContractValue
         * - notToExceed
         * - annualPriceIncrease
         * - earlyTerminationFee
         * - contractType
         * - categoryManager
         * - categoryManagerUser
         * - paymentFrequency
         * - cancellationDateNoticePeriod
         * - autoRenewalClause
         * - autoRenewalLength
         * - notToExceedPercentage
         * - sensitive
         * - internal
         * - tags
         * - virtual
         * - additionalColumns
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                          | Type   | Allowed Rules                                                                | Possible Values |
         * | ---------------------------- | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | uploadedAuditStage           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | attachedFromDocumentsRepo    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | invoiceId                    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | stage                        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendor                       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | name                         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdAt                    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | updatedAt                    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | providedBy                   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | type                         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | spendCategory                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | id                           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | uploadedBy                   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | startDate                    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | endDate                      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | renewalDate                  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | annualContractValue          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | notToExceed                  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | annualPriceIncrease          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | earlyTerminationFee          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | contractType                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | categoryManager              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | categoryManagerUser          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | paymentFrequency             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | cancellationDateNoticePeriod | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | autoRenewalClause            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | autoRenewalLength            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | notToExceedPercentage        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | sensitive                    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | internal                     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | tags                         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | virtual                      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | additionalColumns            | object |                                                                              |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - document.filename
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<AuditDocumentListDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/documents`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Documents
     * @name AuditDocumentControllerListPickerDocuments
     * @request GET:/internal-portal/organizations/{organizationId}/audits/{auditId}/documents/picker
     * @secure
     */
    auditDocumentControllerListPickerDocuments: (
      organizationId: string,
      auditId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - linkedToThisAudit
         * - uploadedAuditStage
         * - attachedFromDocumentsRepo
         * - stage
         * - vendor
         * - name
         * - createdAt
         * - updatedAt
         * - providedBy
         * - type
         * - spendCategory
         * - id
         * - uploadedBy
         * - startDate
         * - endDate
         * - renewalDate
         * - annualContractValue
         * - notToExceed
         * - annualPriceIncrease
         * - earlyTerminationFee
         * - contractType
         * - categoryManager
         * - categoryManagerUser
         * - paymentFrequency
         * - cancellationDateNoticePeriod
         * - autoRenewalClause
         * - autoRenewalLength
         * - notToExceedPercentage
         * - sensitive
         * - internal
         * - tags
         * - virtual
         * - additionalColumns
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                          | Type   | Allowed Rules                                                                | Possible Values |
         * | ---------------------------- | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | linkedToThisAudit            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | uploadedAuditStage           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | attachedFromDocumentsRepo    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | stage                        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendor                       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | name                         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdAt                    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | updatedAt                    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | providedBy                   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | type                         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | spendCategory                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | id                           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | uploadedBy                   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | startDate                    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | endDate                      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | renewalDate                  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | annualContractValue          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | notToExceed                  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | annualPriceIncrease          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | earlyTerminationFee          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | contractType                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | categoryManager              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | categoryManagerUser          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | paymentFrequency             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | cancellationDateNoticePeriod | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | autoRenewalClause            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | autoRenewalLength            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | notToExceedPercentage        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | sensitive                    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | internal                     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | tags                         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | virtual                      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | additionalColumns            | object |                                                                              |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - filename
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<AuditDocumentListDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/documents/picker`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Documents
     * @name AuditDocumentControllerAttachDocuments
     * @request POST:/internal-portal/organizations/{organizationId}/audits/{auditId}/documents/attach
     * @secure
     */
    auditDocumentControllerAttachDocuments: (
      auditId: string,
      organizationId: string,
      data: AttachAuditDocumentsDto,
      params: RequestParams = {}
    ) =>
      this.request<AttachAuditDocumentsResultDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/documents/attach`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Documents
     * @name AuditDocumentControllerDetachDocuments
     * @request POST:/internal-portal/organizations/{organizationId}/audits/{auditId}/documents/detach
     * @secure
     */
    auditDocumentControllerDetachDocuments: (
      auditId: string,
      organizationId: string,
      data: DetachAuditDocumentsDto,
      params: RequestParams = {}
    ) =>
      this.request<DetachAuditDocumentsResultDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/documents/detach`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Documents
     * @name AuditDocumentControllerBulkUpdateDocuments
     * @summary Update fields on multiple documents linked to this audit (same body as org bulk update)
     * @request PATCH:/internal-portal/organizations/{organizationId}/audits/{auditId}/documents/bulk-update
     * @secure
     */
    auditDocumentControllerBulkUpdateDocuments: (
      auditId: string,
      organizationId: string,
      data: BulkUpdateDocumentDto,
      params: RequestParams = {}
    ) =>
      this.request<AuditDocumentDto[], void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/documents/bulk-update`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Documents
     * @name AuditDocumentControllerUpdateDocument
     * @summary Update fields on a document linked to this audit
     * @request PATCH:/internal-portal/organizations/{organizationId}/audits/{auditId}/documents/{documentId}
     * @secure
     */
    auditDocumentControllerUpdateDocument: (
      documentId: string,
      auditId: string,
      organizationId: string,
      data: UpdateDocumentDto,
      params: RequestParams = {}
    ) =>
      this.request<AuditDocumentDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/documents/${documentId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Documents
     * @name AuditDocumentControllerDeleteDocument
     * @request DELETE:/internal-portal/organizations/{organizationId}/audits/{auditId}/documents/{documentId}
     * @secure
     */
    auditDocumentControllerDeleteDocument: (
      documentId: string,
      auditId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<DeleteAuditDocumentsResultDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/documents/${documentId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Documents
     * @name AuditDocumentControllerInitUploadSession
     * @summary Initialize a chunked direct-to-Azure upload session (metadata only)
     * @request POST:/internal-portal/organizations/{organizationId}/audits/{auditId}/documents/upload/init
     * @secure
     */
    auditDocumentControllerInitUploadSession: (
      auditId: string,
      organizationId: string,
      data: InitUploadDocumentsDto,
      params: RequestParams = {}
    ) =>
      this.request<InitUploadDocumentsResponseDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/documents/upload/init`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Documents
     * @name AuditDocumentControllerCompleteUploadSession
     * @summary Finalize a chunked upload after all blocks are staged in Azure
     * @request POST:/internal-portal/organizations/{organizationId}/audits/{auditId}/documents/upload/complete
     * @secure
     */
    auditDocumentControllerCompleteUploadSession: (
      auditId: string,
      organizationId: string,
      data: CompleteUploadDocumentDto,
      params: RequestParams = {}
    ) =>
      this.request<AuditDocumentDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/documents/upload/complete`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Vendor Accounts
     * @name AuditVendorAccountsControllerList
     * @request GET:/internal-portal/organizations/{organizationId}/audits/{auditId}/vendor-accounts
     * @secure
     */
    auditVendorAccountsControllerList: (
      auditId: string,
      organizationId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - attachedFromVendorAccountsList
         * - id
         * - accountNumber
         * - name
         * - createdAt
         * - invoiceFrequency
         * - billingType
         * - serviceType
         * - summaryAccountNumber
         * - glCode
         * - customGlField
         * - glAllocations
         * - usageLimit
         * - dollarLimit
         * - paymentTerms
         * - invoiceDay
         * - portalLoginEmailId
         * - note
         * - vendorName
         * - auditsCount
         * - status
         * - spendCategories
         * - locations
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                            | Type   | Allowed Rules                                                                | Possible Values                                   |
         * | ------------------------------ | ------ | ---------------------------------------------------------------------------- | ------------------------------------------------- |
         * | attachedFromVendorAccountsList | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | id                             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | accountNumber                  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | name                           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | createdAt                      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | invoiceFrequency               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | bi_weekly, weekly, monthly, bi_monthly, quarterly |
         * | billingType                    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | paper, email, portal                              |
         * | serviceType                    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | summaryAccountNumber           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | glCode                         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | customGlField                  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | glAllocations                  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | usageLimit                     | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                   |
         * | dollarLimit                    | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                   |
         * | paymentTerms                   | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                   |
         * | invoiceDay                     | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                   |
         * | portalLoginEmailId             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | note                           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | vendorName                     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | auditsCount                    | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                   |
         * | status                         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | active, inactive                                  |
         * | spendCategories                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | locations                      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - accountNumber
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<AuditVendorAccountListDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/vendor-accounts`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Vendor Accounts
     * @name AuditVendorAccountsControllerListPicker
     * @request GET:/internal-portal/organizations/{organizationId}/audits/{auditId}/vendor-accounts/picker
     * @secure
     */
    auditVendorAccountsControllerListPicker: (
      organizationId: string,
      auditId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - linkedToThisAudit
         * - attachedFromVendorAccountsList
         * - id
         * - accountNumber
         * - name
         * - createdAt
         * - invoiceFrequency
         * - billingType
         * - serviceType
         * - summaryAccountNumber
         * - glCode
         * - customGlField
         * - glAllocations
         * - usageLimit
         * - dollarLimit
         * - paymentTerms
         * - invoiceDay
         * - portalLoginEmailId
         * - note
         * - vendorName
         * - auditsCount
         * - status
         * - spendCategories
         * - locations
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                            | Type   | Allowed Rules                                                                | Possible Values                                   |
         * | ------------------------------ | ------ | ---------------------------------------------------------------------------- | ------------------------------------------------- |
         * | linkedToThisAudit              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | attachedFromVendorAccountsList | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | id                             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | accountNumber                  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | name                           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | createdAt                      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | invoiceFrequency               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | bi_weekly, weekly, monthly, bi_monthly, quarterly |
         * | billingType                    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | paper, email, portal                              |
         * | serviceType                    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | summaryAccountNumber           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | glCode                         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | customGlField                  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | glAllocations                  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | usageLimit                     | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                   |
         * | dollarLimit                    | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                   |
         * | paymentTerms                   | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                   |
         * | invoiceDay                     | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                   |
         * | portalLoginEmailId             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | note                           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | vendorName                     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | auditsCount                    | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                   |
         * | status                         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | active, inactive                                  |
         * | spendCategories                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | locations                      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - accountNumber
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<AuditVendorAccountListDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/vendor-accounts/picker`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Vendor Accounts
     * @name AuditVendorAccountsControllerAttach
     * @request POST:/internal-portal/organizations/{organizationId}/audits/{auditId}/vendor-accounts/attach
     * @secure
     */
    auditVendorAccountsControllerAttach: (
      auditId: string,
      organizationId: string,
      data: AttachAuditVendorAccountsDto,
      params: RequestParams = {}
    ) =>
      this.request<AttachAuditVendorAccountsResultDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/vendor-accounts/attach`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Vendor Accounts
     * @name AuditVendorAccountsControllerDetach
     * @request POST:/internal-portal/organizations/{organizationId}/audits/{auditId}/vendor-accounts/detach
     * @secure
     */
    auditVendorAccountsControllerDetach: (
      auditId: string,
      organizationId: string,
      data: DetachAuditVendorAccountsDto,
      params: RequestParams = {}
    ) =>
      this.request<DetachAuditVendorAccountsResultDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/vendor-accounts/detach`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Spend Estimated
     * @name AuditSpendEstimatedControllerListSpends
     * @request GET:/internal-portal/organizations/{organizationId}/audits/{auditId}/spend-estimated
     * @secure
     */
    auditSpendEstimatedControllerListSpends: (
      auditId: string,
      organizationId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - taxable
         * - id
         * - auditSpendId
         * - pricingModel
         * - name
         * - vendorAccountNumber
         * - quantityType
         * - unit
         * - quantity
         * - pricePerUnit
         * - percentageRate
         * - total
         * - type
         * - frequency
         * - locationName
         * - minimumFee
         * - minimumFeeNote
         * - tierType
         * - tierValue
         * - indexRate
         * - notesCount
         * - createdAt
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                 | Type    | Allowed Rules                                                                | Possible Values                                         |
         * | ------------------- | ------- | ---------------------------------------------------------------------------- | ------------------------------------------------------- |
         * | taxable             | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                                                         |
         * | id                  | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | auditSpendId        | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | pricingModel        | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | usage_based, fixed_fee, percentage_rate                 |
         * | name                | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | vendorAccountNumber | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | quantityType        | object  |                                                                              | estimate, average, actual                               |
         * | unit                | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | quantity            | number  | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                         |
         * | pricePerUnit        | number  | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                         |
         * | percentageRate      | number  | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                         |
         * | total               | number  | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                         |
         * | type                | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | one_time, recurring                                     |
         * | frequency           | object  |                                                                              | weekly, monthly, quarterly, annually, on_call_as_needed |
         * | locationName        | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | minimumFee          | number  | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                         |
         * | minimumFeeNote      | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | tierType            | object  |                                                                              | volume, usage_band, discount_tier                       |
         * | tierValue           | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | indexRate           | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | notesCount          | number  | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                         |
         * | createdAt           | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - name
         * - accountNumber
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<SpendEstimatedListDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/spend-estimated`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Spend Estimated
     * @name AuditSpendEstimatedControllerGetImportTemplate
     * @request GET:/internal-portal/organizations/{organizationId}/audits/{auditId}/spend-estimated/template
     * @secure
     */
    auditSpendEstimatedControllerGetImportTemplate: (
      auditId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/spend-estimated/template`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Spend Estimated
     * @name AuditSpendEstimatedControllerValidateImport
     * @request POST:/internal-portal/organizations/{organizationId}/audits/{auditId}/spend-estimated/import
     * @secure
     */
    auditSpendEstimatedControllerValidateImport: (
      auditId: string,
      organizationId: string,
      data: FileUploadDto,
      params: RequestParams = {}
    ) =>
      this.request<SpendEstimatedImportResultDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/spend-estimated/import`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Spend Estimated
     * @name AuditSpendEstimatedControllerConfirmImport
     * @request POST:/internal-portal/organizations/{organizationId}/audits/{auditId}/spend-estimated/import/confirm
     * @secure
     */
    auditSpendEstimatedControllerConfirmImport: (
      auditId: string,
      organizationId: string,
      data: ConfirmSpendEstimatedDto,
      params: RequestParams = {}
    ) =>
      this.request<ConfirmSpendEstimatedResultDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/spend-estimated/import/confirm`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Spend Estimated
     * @name AuditSpendEstimatedControllerGetVendorAccountOptions
     * @request GET:/internal-portal/organizations/{organizationId}/audits/{auditId}/spend-estimated/vendor-accounts
     * @secure
     */
    auditSpendEstimatedControllerGetVendorAccountOptions: (
      auditId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<SpendEstimatedVendorAccountOptionDto[], void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/spend-estimated/vendor-accounts`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Spend Estimated
     * @name AuditSpendEstimatedControllerCreateSpend
     * @request POST:/internal-portal/organizations/{organizationId}/audits/{auditId}/spend-estimated/spends
     * @secure
     */
    auditSpendEstimatedControllerCreateSpend: (
      auditId: string,
      organizationId: string,
      data: CreateSpendEstimatedSpendDto,
      params: RequestParams = {}
    ) =>
      this.request<SpendEstimatedSpendDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/spend-estimated/spends`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Spend Estimated
     * @name AuditSpendEstimatedControllerBulkUpdateSpends
     * @request PATCH:/internal-portal/organizations/{organizationId}/audits/{auditId}/spend-estimated/spends/bulk-update
     * @secure
     */
    auditSpendEstimatedControllerBulkUpdateSpends: (
      auditId: string,
      organizationId: string,
      data: BulkUpdateSpendEstimatedSpendsDto,
      params: RequestParams = {}
    ) =>
      this.request<BulkUpdateSpendEstimatedResultDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/spend-estimated/spends/bulk-update`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Spend Estimated
     * @name AuditSpendEstimatedControllerUpdateSpend
     * @request PATCH:/internal-portal/organizations/{organizationId}/audits/{auditId}/spend-estimated/spends/{spendId}
     * @secure
     */
    auditSpendEstimatedControllerUpdateSpend: (
      auditId: string,
      spendId: string,
      organizationId: string,
      data: UpdateSpendEstimatedSpendDto,
      params: RequestParams = {}
    ) =>
      this.request<SpendEstimatedSpendDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/spend-estimated/spends/${spendId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Spend Estimated
     * @name AuditSpendEstimatedControllerDeleteSpend
     * @request DELETE:/internal-portal/organizations/{organizationId}/audits/{auditId}/spend-estimated/spends/{spendId}
     * @secure
     */
    auditSpendEstimatedControllerDeleteSpend: (
      auditId: string,
      spendId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<DeleteSpendEstimatedResultDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/spend-estimated/spends/${spendId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Spend Estimated
     * @name AuditSpendEstimatedControllerBulkDeleteSpends
     * @request POST:/internal-portal/organizations/{organizationId}/audits/{auditId}/spend-estimated/spends/bulk-delete
     * @secure
     */
    auditSpendEstimatedControllerBulkDeleteSpends: (
      auditId: string,
      organizationId: string,
      data: BulkDeleteSpendEstimatedSpendsDto,
      params: RequestParams = {}
    ) =>
      this.request<DeleteSpendEstimatedResultDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/spend-estimated/spends/bulk-delete`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Meetings
     * @name AuditMeetingsControllerListMeetings
     * @request GET:/internal-portal/organizations/{organizationId}/audits/{auditId}/negotiations/meetings
     * @secure
     */
    auditMeetingsControllerListMeetings: (
      auditId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<AuditMeetingListDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/negotiations/meetings`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Meetings
     * @name AuditMeetingsControllerCreateMeeting
     * @request POST:/internal-portal/organizations/{organizationId}/audits/{auditId}/negotiations/meetings
     * @secure
     */
    auditMeetingsControllerCreateMeeting: (
      auditId: string,
      organizationId: string,
      data: CreateAuditMeetingDto,
      params: RequestParams = {}
    ) =>
      this.request<AuditMeetingDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/negotiations/meetings`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Meetings
     * @name AuditMeetingsControllerUpdateMeeting
     * @request PATCH:/internal-portal/organizations/{organizationId}/audits/{auditId}/negotiations/meetings/{meetingId}
     * @secure
     */
    auditMeetingsControllerUpdateMeeting: (
      auditId: string,
      meetingId: string,
      organizationId: string,
      data: UpdateAuditMeetingDto,
      params: RequestParams = {}
    ) =>
      this.request<AuditMeetingDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/negotiations/meetings/${meetingId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Meetings
     * @name AuditMeetingsControllerDeleteMeeting
     * @request DELETE:/internal-portal/organizations/{organizationId}/audits/{auditId}/negotiations/meetings/{meetingId}
     * @secure
     */
    auditMeetingsControllerDeleteMeeting: (
      auditId: string,
      meetingId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<MessageResponseDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/negotiations/meetings/${meetingId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Meetings
     * @name AuditMeetingsControllerCreateNote
     * @request POST:/internal-portal/organizations/{organizationId}/audits/{auditId}/negotiations/meetings/{meetingId}/notes
     * @secure
     */
    auditMeetingsControllerCreateNote: (
      auditId: string,
      meetingId: string,
      organizationId: string,
      data: CreateAuditMeetingNoteDto,
      params: RequestParams = {}
    ) =>
      this.request<AuditMeetingNoteDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/negotiations/meetings/${meetingId}/notes`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Meetings
     * @name AuditMeetingsControllerDeleteNote
     * @request DELETE:/internal-portal/organizations/{organizationId}/audits/{auditId}/negotiations/meetings/{meetingId}/notes/{noteId}
     * @secure
     */
    auditMeetingsControllerDeleteNote: (
      auditId: string,
      meetingId: string,
      noteId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<MessageResponseDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/negotiations/meetings/${meetingId}/notes/${noteId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Negotiations
     * @name AuditNegotiationsControllerGetSummary
     * @request GET:/internal-portal/organizations/{organizationId}/audits/{auditId}/negotiations
     * @secure
     */
    auditNegotiationsControllerGetSummary: (
      auditId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<NegotiationSummaryDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/negotiations`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Negotiations
     * @name AuditNegotiationsControllerGetContinue
     * @request GET:/internal-portal/organizations/{organizationId}/audits/{auditId}/negotiations/continue
     * @secure
     */
    auditNegotiationsControllerGetContinue: (
      auditId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<NegotiationContinueDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/negotiations/continue`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Savings Sources
     * @name SavingsSourcesControllerGetSavingsSources
     * @request GET:/internal-portal/savings-sources
     * @secure
     */
    savingsSourcesControllerGetSavingsSources: (params: RequestParams = {}) =>
      this.request<SavingsSourceDto[], void>({
        path: `/internal-portal/savings-sources`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Negotiations
     * @name AuditSavingsSourceControllerSetSavingsSource
     * @request PUT:/internal-portal/organizations/{organizationId}/audits/{auditId}/negotiations/savings-source
     * @secure
     */
    auditSavingsSourceControllerSetSavingsSource: (
      auditId: string,
      organizationId: string,
      data: SetAuditSavingsSourceDto,
      params: RequestParams = {}
    ) =>
      this.request<SavingsSourceDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/negotiations/savings-source`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Negotiations
     * @name AuditNegotiationsControllerListSpends
     * @request GET:/internal-portal/organizations/{organizationId}/audits/{auditId}/negotiations/spends
     * @secure
     */
    auditNegotiationsControllerListSpends: (
      auditId: string,
      organizationId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - approved
         * - clientApproved
         * - notesCount
         * - id
         * - auditSpendId
         * - spendId
         * - name
         * - negotiatedSpend
         * - savingsIdentified
         * - status
         * - type
         * - frequency
         * - clientStatus
         * - clientApprovedSavings
         * - clientApprovedBaseline
         * - vendor
         * - locationName
         * - vendorAccountNumber
         * - baselineSpend.id
         * - baselineSpend.pricingModel
         * - baselineSpend.quantityType
         * - baselineSpend.unit
         * - baselineSpend.quantity
         * - baselineSpend.pricePerUnit
         * - baselineSpend.percentageRate
         * - baselineSpend.percentageBasisMembers
         * - baselineSpend.minimumFee
         * - baselineSpend.minimumFeeNote
         * - baselineSpend.taxable
         * - baselineSpend.indexRate
         * - baselineSpend.tierType
         * - baselineSpend.tierValue
         * - baselineSpend.totalValue
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                                  | Type                        | Allowed Rules                                                                | Possible Values                                         |
         * | ------------------------------------ | --------------------------- | ---------------------------------------------------------------------------- | ------------------------------------------------------- |
         * | approved                             | boolean                     | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                                                         |
         * | clientApproved                       | boolean                     | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                                                         |
         * | notesCount                           | number                      | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                         |
         * | id                                   | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | auditSpendId                         | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | spendId                              | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | name                                 | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | negotiatedSpend                      | negotiationspenddetailsdto  |                                                                              |                                                         |
         * | savingsIdentified                    | number                      | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                         |
         * | status                               | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | pending, approved, rejected                             |
         * | type                                 | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | one_time, recurring                                     |
         * | frequency                            | object                      |                                                                              | weekly, monthly, quarterly, annually, on_call_as_needed |
         * | clientStatus                         | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | meeting_scheduled, in_review, rejected, accepted        |
         * | clientApprovedSavings                | number                      | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                         |
         * | clientApprovedBaseline               | number                      | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                         |
         * | vendor                               | plaindto                    |                                                                              |                                                         |
         * | locationName                         | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | vendorAccountNumber                  | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | baselineSpend.id                     | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | baselineSpend.pricingModel           | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | usage_based, fixed_fee, percentage_rate                 |
         * | baselineSpend.quantityType           | object                      |                                                                              | estimate, average, actual                               |
         * | baselineSpend.unit                   | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | baselineSpend.quantity               | number                      | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                         |
         * | baselineSpend.pricePerUnit           | number                      | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                         |
         * | baselineSpend.percentageRate         | number                      | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                         |
         * | baselineSpend.percentageBasisMembers | percentagebasiscandidatedto |                                                                              |                                                         |
         * | baselineSpend.minimumFee             | number                      | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                         |
         * | baselineSpend.minimumFeeNote         | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | baselineSpend.taxable                | boolean                     | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                                                         |
         * | baselineSpend.indexRate              | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | baselineSpend.tierType               | object                      |                                                                              | volume, usage_band, discount_tier                       |
         * | baselineSpend.tierValue              | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | baselineSpend.totalValue             | number                      | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                         |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - name
         * - negotiationVendorName
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<NegotiationSpendListDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/negotiations/spends`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Negotiations
     * @name AuditNegotiationsControllerExportSpends
     * @request GET:/internal-portal/organizations/{organizationId}/audits/{auditId}/negotiations/spends/export
     * @secure
     */
    auditNegotiationsControllerExportSpends: (
      auditId: string,
      organizationId: string,
      query: {
        /** Column paths to export. Pass as repeated query params (preferred) or a JSON array string. Headers are auto-generated from keys. Example: columns=name&columns=status */
        columns: string[];
        /** Custom filename for the CSV download (without extension). */
        filename?: string;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - approved
         * - clientApproved
         * - notesCount
         * - id
         * - auditSpendId
         * - spendId
         * - name
         * - negotiatedSpend
         * - savingsIdentified
         * - status
         * - type
         * - frequency
         * - clientStatus
         * - clientApprovedSavings
         * - clientApprovedBaseline
         * - vendor
         * - locationName
         * - vendorAccountNumber
         * - baselineSpend.id
         * - baselineSpend.pricingModel
         * - baselineSpend.quantityType
         * - baselineSpend.unit
         * - baselineSpend.quantity
         * - baselineSpend.pricePerUnit
         * - baselineSpend.percentageRate
         * - baselineSpend.percentageBasisMembers
         * - baselineSpend.minimumFee
         * - baselineSpend.minimumFeeNote
         * - baselineSpend.taxable
         * - baselineSpend.indexRate
         * - baselineSpend.tierType
         * - baselineSpend.tierValue
         * - baselineSpend.totalValue
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                                  | Type                        | Allowed Rules                                                                | Possible Values                                         |
         * | ------------------------------------ | --------------------------- | ---------------------------------------------------------------------------- | ------------------------------------------------------- |
         * | approved                             | boolean                     | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                                                         |
         * | clientApproved                       | boolean                     | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                                                         |
         * | notesCount                           | number                      | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                         |
         * | id                                   | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | auditSpendId                         | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | spendId                              | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | name                                 | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | negotiatedSpend                      | negotiationspenddetailsdto  |                                                                              |                                                         |
         * | savingsIdentified                    | number                      | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                         |
         * | status                               | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | pending, approved, rejected                             |
         * | type                                 | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | one_time, recurring                                     |
         * | frequency                            | object                      |                                                                              | weekly, monthly, quarterly, annually, on_call_as_needed |
         * | clientStatus                         | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | meeting_scheduled, in_review, rejected, accepted        |
         * | clientApprovedSavings                | number                      | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                         |
         * | clientApprovedBaseline               | number                      | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                         |
         * | vendor                               | plaindto                    |                                                                              |                                                         |
         * | locationName                         | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | vendorAccountNumber                  | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | baselineSpend.id                     | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | baselineSpend.pricingModel           | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | usage_based, fixed_fee, percentage_rate                 |
         * | baselineSpend.quantityType           | object                      |                                                                              | estimate, average, actual                               |
         * | baselineSpend.unit                   | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | baselineSpend.quantity               | number                      | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                         |
         * | baselineSpend.pricePerUnit           | number                      | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                         |
         * | baselineSpend.percentageRate         | number                      | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                         |
         * | baselineSpend.percentageBasisMembers | percentagebasiscandidatedto |                                                                              |                                                         |
         * | baselineSpend.minimumFee             | number                      | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                         |
         * | baselineSpend.minimumFeeNote         | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | baselineSpend.taxable                | boolean                     | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                                                         |
         * | baselineSpend.indexRate              | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | baselineSpend.tierType               | object                      |                                                                              | volume, usage_band, discount_tier                       |
         * | baselineSpend.tierValue              | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | baselineSpend.totalValue             | number                      | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                         |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - name
         * - negotiationVendorName
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<StreamableFile, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/negotiations/spends/export`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Negotiations
     * @name AuditNegotiationsControllerBulkSetApproval
     * @request PATCH:/internal-portal/organizations/{organizationId}/audits/{auditId}/negotiations/spends/bulk-approval
     * @secure
     */
    auditNegotiationsControllerBulkSetApproval: (
      auditId: string,
      organizationId: string,
      data: BulkSetNegotiationSpendApprovalDto,
      params: RequestParams = {}
    ) =>
      this.request<BulkNegotiationResultDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/negotiations/spends/bulk-approval`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Negotiations
     * @name AuditNegotiationsControllerBulkSetClientStatus
     * @request PATCH:/internal-portal/organizations/{organizationId}/audits/{auditId}/negotiations/spends/bulk-client-status
     * @secure
     */
    auditNegotiationsControllerBulkSetClientStatus: (
      auditId: string,
      organizationId: string,
      data: BulkSetNegotiationClientStatusDto,
      params: RequestParams = {}
    ) =>
      this.request<BulkNegotiationResultDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/negotiations/spends/bulk-client-status`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Negotiations
     * @name AuditNegotiationsControllerBulkSetClientApproval
     * @request PATCH:/internal-portal/organizations/{organizationId}/audits/{auditId}/negotiations/spends/bulk-client-approval
     * @secure
     */
    auditNegotiationsControllerBulkSetClientApproval: (
      auditId: string,
      organizationId: string,
      data: BulkSetNegotiationClientApprovalDto,
      params: RequestParams = {}
    ) =>
      this.request<BulkNegotiationResultDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/negotiations/spends/bulk-client-approval`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Negotiations
     * @name AuditNegotiationsControllerUpsertNegotiatedSpend
     * @request PUT:/internal-portal/organizations/{organizationId}/audits/{auditId}/negotiations/spends/{auditSpendId}/negotiated-spend
     * @secure
     */
    auditNegotiationsControllerUpsertNegotiatedSpend: (
      auditId: string,
      auditSpendId: string,
      organizationId: string,
      data: UpsertNegotiatedSpendDto,
      params: RequestParams = {}
    ) =>
      this.request<NegotiationSpendItemDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/negotiations/spends/${auditSpendId}/negotiated-spend`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Negotiations
     * @name AuditNegotiationsControllerDeleteNegotiatedSpend
     * @request DELETE:/internal-portal/organizations/{organizationId}/audits/{auditId}/negotiations/spends/{auditSpendId}/negotiated-spend
     * @secure
     */
    auditNegotiationsControllerDeleteNegotiatedSpend: (
      auditId: string,
      auditSpendId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<NegotiationSpendItemDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/negotiations/spends/${auditSpendId}/negotiated-spend`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Negotiations
     * @name AuditNegotiationsControllerSetSpendApproval
     * @request PUT:/internal-portal/organizations/{organizationId}/audits/{auditId}/negotiations/spends/{auditSpendId}/approval
     * @secure
     */
    auditNegotiationsControllerSetSpendApproval: (
      auditId: string,
      auditSpendId: string,
      organizationId: string,
      data: SetNegotiationSpendApprovalDto,
      params: RequestParams = {}
    ) =>
      this.request<NegotiationSpendItemDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/negotiations/spends/${auditSpendId}/approval`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Negotiations
     * @name AuditNegotiationsControllerSetClientStatus
     * @request PUT:/internal-portal/organizations/{organizationId}/audits/{auditId}/negotiations/spends/{auditSpendId}/client-status
     * @secure
     */
    auditNegotiationsControllerSetClientStatus: (
      auditId: string,
      auditSpendId: string,
      organizationId: string,
      data: SetNegotiationClientStatusDto,
      params: RequestParams = {}
    ) =>
      this.request<NegotiationSpendItemDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/negotiations/spends/${auditSpendId}/client-status`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Negotiations
     * @name AuditNegotiationsControllerSetClientApproval
     * @request PUT:/internal-portal/organizations/{organizationId}/audits/{auditId}/negotiations/spends/{auditSpendId}/client-approval
     * @secure
     */
    auditNegotiationsControllerSetClientApproval: (
      auditId: string,
      auditSpendId: string,
      organizationId: string,
      data: SetNegotiationClientApprovalDto,
      params: RequestParams = {}
    ) =>
      this.request<NegotiationSpendItemDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/negotiations/spends/${auditSpendId}/client-approval`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Negotiations
     * @name AuditNegotiationsControllerListNegotiations
     * @request GET:/internal-portal/organizations/{organizationId}/audits/{auditId}/negotiations/contract-negotiations
     * @secure
     */
    auditNegotiationsControllerListNegotiations: (
      auditId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<NegotiationItemDto[], void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/negotiations/contract-negotiations`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Negotiations
     * @name AuditNegotiationsControllerCreateNegotiation
     * @request POST:/internal-portal/organizations/{organizationId}/audits/{auditId}/negotiations/contract-negotiations
     * @secure
     */
    auditNegotiationsControllerCreateNegotiation: (
      auditId: string,
      organizationId: string,
      data: CreateNegotiationDto,
      params: RequestParams = {}
    ) =>
      this.request<NegotiationItemDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/negotiations/contract-negotiations`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Negotiations
     * @name AuditNegotiationsControllerCloseNegotiation
     * @request PATCH:/internal-portal/organizations/{organizationId}/audits/{auditId}/negotiations/contract-negotiations/{negotiationId}/close
     * @secure
     */
    auditNegotiationsControllerCloseNegotiation: (
      auditId: string,
      negotiationId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<NegotiationItemDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/negotiations/contract-negotiations/${negotiationId}/close`,
        method: 'PATCH',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Negotiations
     * @name AuditNegotiationsControllerAttachProposedVendor
     * @request POST:/internal-portal/organizations/{organizationId}/audits/{auditId}/negotiations/vendors/proposed
     * @secure
     */
    auditNegotiationsControllerAttachProposedVendor: (
      auditId: string,
      organizationId: string,
      data: AttachProposedVendorDto,
      params: RequestParams = {}
    ) =>
      this.request<NegotiationItemDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/negotiations/vendors/proposed`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Negotiations
     * @name AuditNegotiationsControllerRemoveProposedVendor
     * @request DELETE:/internal-portal/organizations/{organizationId}/audits/{auditId}/negotiations/vendors/proposed
     * @secure
     */
    auditNegotiationsControllerRemoveProposedVendor: (
      auditId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<RemoveProposedVendorResultDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/negotiations/vendors/proposed`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Negotiations
     * @name AuditNegotiationsControllerListAvailableVendors
     * @request GET:/internal-portal/organizations/{organizationId}/audits/{auditId}/negotiations/vendors
     * @secure
     */
    auditNegotiationsControllerListAvailableVendors: (
      auditId: string,
      organizationId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - lastUpdated
         * - clientOrganisationsCount
         * - contactsCount
         * - openTicketsCount
         * - openTasksCount
         * - contractsCount
         * - auditsCount
         * - orgScopedAuditsCount
         * - totalSpend
         * - status
         * - assignee
         * - spendCategories
         * - spendAreas
         * - vendorAccounts
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                      | Type   | Allowed Rules                                                                | Possible Values |
         * | ------------------------ | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | id                       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | name                     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | lastUpdated              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | clientOrganisationsCount | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | contactsCount            | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | openTicketsCount         | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | openTasksCount           | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | contractsCount           | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | auditsCount              | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | orgScopedAuditsCount     | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | totalSpend               | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | status                   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assignee                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | spendCategories          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | spendAreas               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendorAccounts           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - name
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<NegotiationAvailableVendorListDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/negotiations/vendors`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Negotiations
     * @name AuditNegotiationsControllerDeleteAuditScopedVendor
     * @request DELETE:/internal-portal/organizations/{organizationId}/audits/{auditId}/negotiations/vendors/{vendorId}
     * @secure
     */
    auditNegotiationsControllerDeleteAuditScopedVendor: (
      auditId: string,
      vendorId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<DeleteAuditScopedVendorResultDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/negotiations/vendors/${vendorId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Percentage Basis
     * @name AuditPercentageBasisControllerFindCandidates
     * @request GET:/internal-portal/organizations/{organizationId}/audits/{auditId}/percentage-basis/candidates
     * @secure
     */
    auditPercentageBasisControllerFindCandidates: (
      auditId: string,
      organizationId: string,
      query: {
        /** Decides what the candidates are: spend estimated and mobilization offer baseline spends, the negotiation stages offer negotiated spends, and initial validation and monitoring savings offer spend line items. */
        stage: AuditStage;
        /**
         * A fee may only be a percentage of charges billed on the same account.
         * @format uuid
         */
        vendorAccountId: string;
        /**
         * A fee may only be a percentage of charges at its location.
         * @format uuid
         */
        locationId: string;
        /**
         * The fee being edited: it and every fee that already includes it are excluded from its candidates. Omit when creating one.
         * @format uuid
         */
        spendId?: string;
        /**
         * Initial validation and monitoring savings only. A line may only be a percentage of lines on the same invoice — in monitoring, the round bill; omit for a line not yet billed, which matches the other unbilled lines.
         * @format uuid
         */
        invoiceId?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<PercentageBasisCandidateDto[], void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/percentage-basis/candidates`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Percentage Basis
     * @name AuditPercentageBasisControllerCalculateTotal
     * @request GET:/internal-portal/organizations/{organizationId}/audits/{auditId}/percentage-basis/total
     * @secure
     */
    auditPercentageBasisControllerCalculateTotal: (
      auditId: string,
      organizationId: string,
      query: {
        /** Decides what the candidates are: spend estimated and mobilization offer baseline spends, the negotiation stages offer negotiated spends, and initial validation and monitoring savings offer spend line items. */
        stage: AuditStage;
        /**
         * A fee may only be a percentage of charges billed on the same account.
         * @format uuid
         */
        vendorAccountId: string;
        /**
         * A fee may only be a percentage of charges at its location.
         * @format uuid
         */
        locationId: string;
        /**
         * The fee being edited: it and every fee that already includes it are excluded from its candidates. Omit when creating one.
         * @format uuid
         */
        spendId?: string;
        /**
         * Initial validation and monitoring savings only. A line may only be a percentage of lines on the same invoice — in monitoring, the round bill; omit for a line not yet billed, which matches the other unbilled lines.
         * @format uuid
         */
        invoiceId?: string;
        /**
         * Ids from the candidates endpoint, called with the same stage, account, location, spend and invoice. Omit when nothing is selected.
         * @uniqueItems true
         */
        candidateIds?: string[];
        /** Percentage POINTS (7.5 = 7.5%). */
        percentageRate: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<PercentageBasisTotalDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/percentage-basis/total`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Initial Validation
     * @name AuditInitialValidationControllerListSpends
     * @request GET:/internal-portal/organizations/{organizationId}/audits/{auditId}/initial-validation/spends
     * @secure
     */
    auditInitialValidationControllerListSpends: (
      auditId: string,
      organizationId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - isValidated
         * - approved
         * - clientApproved
         * - notesCount
         * - validatedDifference
         * - savings
         * - sibRevenue
         * - validatedPricePerUnit
         * - validatedQuantity
         * - validatedSpend
         * - vendorAccountName
         * - vendorAccountId
         * - locationId
         * - firstValidationInvoiceId
         * - firstValidationInvoice
         * - startDate
         * - endDate
         * - validationStatus
         * - validatedUnit
         * - validatedPercentageRate
         * - id
         * - auditSpendId
         * - spendId
         * - name
         * - negotiatedSpend
         * - savingsIdentified
         * - status
         * - type
         * - frequency
         * - clientStatus
         * - clientApprovedSavings
         * - clientApprovedBaseline
         * - vendor
         * - locationName
         * - vendorAccountNumber
         * - baselineSpend.id
         * - baselineSpend.pricingModel
         * - baselineSpend.quantityType
         * - baselineSpend.unit
         * - baselineSpend.quantity
         * - baselineSpend.pricePerUnit
         * - baselineSpend.percentageRate
         * - baselineSpend.percentageBasisMembers
         * - baselineSpend.minimumFee
         * - baselineSpend.minimumFeeNote
         * - baselineSpend.taxable
         * - baselineSpend.indexRate
         * - baselineSpend.tierType
         * - baselineSpend.tierValue
         * - baselineSpend.totalValue
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                                  | Type                        | Allowed Rules                                                                | Possible Values                                         |
         * | ------------------------------------ | --------------------------- | ---------------------------------------------------------------------------- | ------------------------------------------------------- |
         * | isValidated                          | boolean                     | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                                                         |
         * | approved                             | boolean                     | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                                                         |
         * | clientApproved                       | boolean                     | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                                                         |
         * | notesCount                           | number                      | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                         |
         * | validatedDifference                  | object                      |                                                                              |                                                         |
         * | savings                              | object                      |                                                                              |                                                         |
         * | sibRevenue                           | object                      |                                                                              |                                                         |
         * | validatedPricePerUnit                | object                      |                                                                              |                                                         |
         * | validatedQuantity                    | object                      |                                                                              |                                                         |
         * | validatedSpend                       | object                      |                                                                              |                                                         |
         * | vendorAccountName                    | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | vendorAccountId                      | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | locationId                           | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | firstValidationInvoiceId             | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | firstValidationInvoice               | attachableinvoicedto        |                                                                              |                                                         |
         * | startDate                            | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | endDate                              | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | validationStatus                     | object                      |                                                                              | match, mismatch, pending                                |
         * | validatedUnit                        | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | validatedPercentageRate              | number                      | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                         |
         * | id                                   | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | auditSpendId                         | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | spendId                              | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | name                                 | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | negotiatedSpend                      | negotiationspenddetailsdto  |                                                                              |                                                         |
         * | savingsIdentified                    | number                      | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                         |
         * | status                               | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | pending, approved, rejected                             |
         * | type                                 | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | one_time, recurring                                     |
         * | frequency                            | object                      |                                                                              | weekly, monthly, quarterly, annually, on_call_as_needed |
         * | clientStatus                         | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | meeting_scheduled, in_review, rejected, accepted        |
         * | clientApprovedSavings                | number                      | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                         |
         * | clientApprovedBaseline               | number                      | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                         |
         * | vendor                               | plaindto                    |                                                                              |                                                         |
         * | locationName                         | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | vendorAccountNumber                  | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | baselineSpend.id                     | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | baselineSpend.pricingModel           | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | usage_based, fixed_fee, percentage_rate                 |
         * | baselineSpend.quantityType           | object                      |                                                                              | estimate, average, actual                               |
         * | baselineSpend.unit                   | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | baselineSpend.quantity               | number                      | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                         |
         * | baselineSpend.pricePerUnit           | number                      | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                         |
         * | baselineSpend.percentageRate         | number                      | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                         |
         * | baselineSpend.percentageBasisMembers | percentagebasiscandidatedto |                                                                              |                                                         |
         * | baselineSpend.minimumFee             | number                      | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                         |
         * | baselineSpend.minimumFeeNote         | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | baselineSpend.taxable                | boolean                     | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                                                         |
         * | baselineSpend.indexRate              | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | baselineSpend.tierType               | object                      |                                                                              | volume, usage_band, discount_tier                       |
         * | baselineSpend.tierValue              | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | baselineSpend.totalValue             | number                      | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                         |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - name
         * - negotiationVendorName
         * - vendorAccountNumber
         * - vendorAccountName
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<InitialValidationSpendListDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/initial-validation/spends`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Initial Validation
     * @name AuditInitialValidationControllerValidateSpend
     * @request PUT:/internal-portal/organizations/{organizationId}/audits/{auditId}/initial-validation/spends/{auditSpendId}/validation
     * @secure
     */
    auditInitialValidationControllerValidateSpend: (
      auditId: string,
      auditSpendId: string,
      organizationId: string,
      data: ValidateInitialSpendDto,
      params: RequestParams = {}
    ) =>
      this.request<InitialValidationResultDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/initial-validation/spends/${auditSpendId}/validation`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Every bill on the streams of the charge's validation group (vendor account + location), newest issue date first. `fileName` is empty while the bill was keyed in without a file.
     *
     * @tags Internal Portal - Audit Initial Validation
     * @name AuditInitialValidationControllerListAttachableInvoices
     * @summary Bills this charge may be validated against
     * @request GET:/internal-portal/organizations/{organizationId}/audits/{auditId}/initial-validation/spends/{auditSpendId}/invoices
     * @secure
     */
    auditInitialValidationControllerListAttachableInvoices: (
      auditId: string,
      auditSpendId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<AttachableInvoiceListDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/initial-validation/spends/${auditSpendId}/invoices`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Moves the charge onto that bill without validating it. Rejected once the charge is validated — un-validate it first.
     *
     * @tags Internal Portal - Audit Initial Validation
     * @name AuditInitialValidationControllerAttachInvoice
     * @summary Attach the bill the initial round is read from
     * @request PUT:/internal-portal/organizations/{organizationId}/audits/{auditId}/initial-validation/spends/{auditSpendId}/invoice
     * @secure
     */
    auditInitialValidationControllerAttachInvoice: (
      auditId: string,
      auditSpendId: string,
      organizationId: string,
      data: AttachInitialSpendInvoiceDto,
      params: RequestParams = {}
    ) =>
      this.request<AttachInitialSpendInvoiceResultDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/initial-validation/spends/${auditSpendId}/invoice`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description The end date follows from the start and the audit contract term and cannot be set. Validated or not; refused once the charge is billed.
     *
     * @tags Internal Portal - Audit Initial Validation
     * @name AuditInitialValidationControllerSetSavingsDates
     * @summary Set the charge's savings start date
     * @request PUT:/internal-portal/organizations/{organizationId}/audits/{auditId}/initial-validation/spends/{auditSpendId}/savings-dates
     * @secure
     */
    auditInitialValidationControllerSetSavingsDates: (
      auditId: string,
      auditSpendId: string,
      organizationId: string,
      data: SetSavingsDatesDto,
      params: RequestParams = {}
    ) =>
      this.request<SavingsDatesResultDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/initial-validation/spends/${auditSpendId}/savings-dates`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description "Apply to all" of a validation group: every charge gets the same start and the end that follows from it. All or nothing — refused when one charge is not on the audit or is billed.
     *
     * @tags Internal Portal - Audit Initial Validation
     * @name AuditInitialValidationControllerBulkSetSavingsDates
     * @summary Set one savings start date on many charges
     * @request POST:/internal-portal/organizations/{organizationId}/audits/{auditId}/initial-validation/spends/bulk-savings-dates
     * @secure
     */
    auditInitialValidationControllerBulkSetSavingsDates: (
      auditId: string,
      organizationId: string,
      data: BulkSetSavingsDatesDto,
      params: RequestParams = {}
    ) =>
      this.request<BulkSavingsDatesResultDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/initial-validation/spends/bulk-savings-dates`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Initial Validation
     * @name AuditInitialValidationControllerBulkValidateSpends
     * @request POST:/internal-portal/organizations/{organizationId}/audits/{auditId}/initial-validation/spends/bulk-validate
     * @secure
     */
    auditInitialValidationControllerBulkValidateSpends: (
      auditId: string,
      organizationId: string,
      data: BulkValidateSpendsDto,
      params: RequestParams = {}
    ) =>
      this.request<BulkValidateSpendsResultDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/initial-validation/spends/bulk-validate`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Monitoring Savings
     * @name AuditMonitoringSavingsControllerListSpends
     * @request GET:/internal-portal/organizations/{organizationId}/audits/{auditId}/monitoring-savings/periods/{periodId}/spends
     * @secure
     */
    auditMonitoringSavingsControllerListSpends: (
      organizationId: string,
      auditId: string,
      periodId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - auditId
         * - auditName
         * - periodId
         * - issueDate
         * - invoiceId
         * - spendLineItemId
         * - validatedAt
         * - hidden
         * - excludedFromSavings
         * - locked
         * - vendorAccountName
         * - vendorAccountId
         * - locationId
         * - firstValidationInvoiceId
         * - firstValidationInvoice
         * - startDate
         * - endDate
         * - validationStatus
         * - validatedUnit
         * - validatedPercentageRate
         * - id
         * - auditSpendId
         * - spendId
         * - name
         * - negotiatedSpend
         * - savingsIdentified
         * - status
         * - type
         * - frequency
         * - clientStatus
         * - clientApprovedSavings
         * - clientApprovedBaseline
         * - vendor
         * - locationName
         * - vendorAccountNumber
         * - isValidated
         * - approved
         * - clientApproved
         * - notesCount
         * - validatedDifference
         * - savings
         * - sibRevenue
         * - validatedPricePerUnit
         * - validatedQuantity
         * - validatedSpend
         * - baselineSpend.id
         * - baselineSpend.pricingModel
         * - baselineSpend.quantityType
         * - baselineSpend.unit
         * - baselineSpend.quantity
         * - baselineSpend.pricePerUnit
         * - baselineSpend.percentageRate
         * - baselineSpend.percentageBasisMembers
         * - baselineSpend.minimumFee
         * - baselineSpend.minimumFeeNote
         * - baselineSpend.taxable
         * - baselineSpend.indexRate
         * - baselineSpend.tierType
         * - baselineSpend.tierValue
         * - baselineSpend.totalValue
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                                  | Type                        | Allowed Rules                                                                | Possible Values                                         |
         * | ------------------------------------ | --------------------------- | ---------------------------------------------------------------------------- | ------------------------------------------------------- |
         * | auditId                              | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | auditName                            | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | periodId                             | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | issueDate                            | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | invoiceId                            | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | spendLineItemId                      | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | validatedAt                          | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | hidden                               | boolean                     | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                                                         |
         * | excludedFromSavings                  | boolean                     | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                                                         |
         * | locked                               | boolean                     | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                                                         |
         * | vendorAccountName                    | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | vendorAccountId                      | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | locationId                           | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | firstValidationInvoiceId             | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | firstValidationInvoice               | attachableinvoicedto        |                                                                              |                                                         |
         * | startDate                            | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | endDate                              | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | validationStatus                     | object                      |                                                                              | match, mismatch, pending                                |
         * | validatedUnit                        | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | validatedPercentageRate              | number                      | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                         |
         * | id                                   | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | auditSpendId                         | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | spendId                              | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | name                                 | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | negotiatedSpend                      | negotiationspenddetailsdto  |                                                                              |                                                         |
         * | savingsIdentified                    | number                      | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                         |
         * | status                               | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | pending, approved, rejected                             |
         * | type                                 | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | one_time, recurring                                     |
         * | frequency                            | object                      |                                                                              | weekly, monthly, quarterly, annually, on_call_as_needed |
         * | clientStatus                         | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | meeting_scheduled, in_review, rejected, accepted        |
         * | clientApprovedSavings                | number                      | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                         |
         * | clientApprovedBaseline               | number                      | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                         |
         * | vendor                               | plaindto                    |                                                                              |                                                         |
         * | locationName                         | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | vendorAccountNumber                  | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | isValidated                          | boolean                     | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                                                         |
         * | approved                             | boolean                     | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                                                         |
         * | clientApproved                       | boolean                     | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                                                         |
         * | notesCount                           | number                      | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                         |
         * | validatedDifference                  | object                      |                                                                              |                                                         |
         * | savings                              | object                      |                                                                              |                                                         |
         * | sibRevenue                           | object                      |                                                                              |                                                         |
         * | validatedPricePerUnit                | object                      |                                                                              |                                                         |
         * | validatedQuantity                    | object                      |                                                                              |                                                         |
         * | validatedSpend                       | object                      |                                                                              |                                                         |
         * | baselineSpend.id                     | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | baselineSpend.pricingModel           | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | usage_based, fixed_fee, percentage_rate                 |
         * | baselineSpend.quantityType           | object                      |                                                                              | estimate, average, actual                               |
         * | baselineSpend.unit                   | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | baselineSpend.quantity               | number                      | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                         |
         * | baselineSpend.pricePerUnit           | number                      | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                         |
         * | baselineSpend.percentageRate         | number                      | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                         |
         * | baselineSpend.percentageBasisMembers | percentagebasiscandidatedto |                                                                              |                                                         |
         * | baselineSpend.minimumFee             | number                      | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                         |
         * | baselineSpend.minimumFeeNote         | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | baselineSpend.taxable                | boolean                     | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                                                         |
         * | baselineSpend.indexRate              | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | baselineSpend.tierType               | object                      |                                                                              | volume, usage_band, discount_tier                       |
         * | baselineSpend.tierValue              | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | baselineSpend.totalValue             | number                      | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                         |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - name
         * - negotiationVendorName
         * - vendorAccountNumber
         * - vendorAccountName
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<SpendRoundListDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/monitoring-savings/periods/${periodId}/spends`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Data Entry - Spends
     * @name SpendsControllerListRounds
     * @request GET:/internal-portal/organizations/{organizationId}/spends/rounds
     * @secure
     */
    spendsControllerListRounds: (
      organizationId: string,
      query: {
        validationGroupPeriodId: string;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - auditId
         * - auditName
         * - periodId
         * - issueDate
         * - invoiceId
         * - spendLineItemId
         * - validatedAt
         * - hidden
         * - excludedFromSavings
         * - locked
         * - vendorAccountName
         * - vendorAccountId
         * - locationId
         * - firstValidationInvoiceId
         * - firstValidationInvoice
         * - startDate
         * - endDate
         * - validationStatus
         * - validatedUnit
         * - validatedPercentageRate
         * - id
         * - auditSpendId
         * - spendId
         * - name
         * - negotiatedSpend
         * - savingsIdentified
         * - status
         * - type
         * - frequency
         * - clientStatus
         * - clientApprovedSavings
         * - clientApprovedBaseline
         * - vendor
         * - locationName
         * - vendorAccountNumber
         * - isValidated
         * - approved
         * - clientApproved
         * - notesCount
         * - validatedDifference
         * - savings
         * - sibRevenue
         * - validatedPricePerUnit
         * - validatedQuantity
         * - validatedSpend
         * - baselineSpend.id
         * - baselineSpend.pricingModel
         * - baselineSpend.quantityType
         * - baselineSpend.unit
         * - baselineSpend.quantity
         * - baselineSpend.pricePerUnit
         * - baselineSpend.percentageRate
         * - baselineSpend.percentageBasisMembers
         * - baselineSpend.minimumFee
         * - baselineSpend.minimumFeeNote
         * - baselineSpend.taxable
         * - baselineSpend.indexRate
         * - baselineSpend.tierType
         * - baselineSpend.tierValue
         * - baselineSpend.totalValue
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                                  | Type                        | Allowed Rules                                                                | Possible Values                                         |
         * | ------------------------------------ | --------------------------- | ---------------------------------------------------------------------------- | ------------------------------------------------------- |
         * | auditId                              | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | auditName                            | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | periodId                             | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | issueDate                            | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | invoiceId                            | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | spendLineItemId                      | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | validatedAt                          | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | hidden                               | boolean                     | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                                                         |
         * | excludedFromSavings                  | boolean                     | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                                                         |
         * | locked                               | boolean                     | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                                                         |
         * | vendorAccountName                    | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | vendorAccountId                      | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | locationId                           | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | firstValidationInvoiceId             | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | firstValidationInvoice               | attachableinvoicedto        |                                                                              |                                                         |
         * | startDate                            | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | endDate                              | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | validationStatus                     | object                      |                                                                              | match, mismatch, pending                                |
         * | validatedUnit                        | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | validatedPercentageRate              | number                      | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                         |
         * | id                                   | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | auditSpendId                         | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | spendId                              | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | name                                 | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | negotiatedSpend                      | negotiationspenddetailsdto  |                                                                              |                                                         |
         * | savingsIdentified                    | number                      | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                         |
         * | status                               | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | pending, approved, rejected                             |
         * | type                                 | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | one_time, recurring                                     |
         * | frequency                            | object                      |                                                                              | weekly, monthly, quarterly, annually, on_call_as_needed |
         * | clientStatus                         | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | meeting_scheduled, in_review, rejected, accepted        |
         * | clientApprovedSavings                | number                      | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                         |
         * | clientApprovedBaseline               | number                      | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                         |
         * | vendor                               | plaindto                    |                                                                              |                                                         |
         * | locationName                         | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | vendorAccountNumber                  | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | isValidated                          | boolean                     | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                                                         |
         * | approved                             | boolean                     | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                                                         |
         * | clientApproved                       | boolean                     | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                                                         |
         * | notesCount                           | number                      | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                         |
         * | validatedDifference                  | object                      |                                                                              |                                                         |
         * | savings                              | object                      |                                                                              |                                                         |
         * | sibRevenue                           | object                      |                                                                              |                                                         |
         * | validatedPricePerUnit                | object                      |                                                                              |                                                         |
         * | validatedQuantity                    | object                      |                                                                              |                                                         |
         * | validatedSpend                       | object                      |                                                                              |                                                         |
         * | baselineSpend.id                     | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | baselineSpend.pricingModel           | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | usage_based, fixed_fee, percentage_rate                 |
         * | baselineSpend.quantityType           | object                      |                                                                              | estimate, average, actual                               |
         * | baselineSpend.unit                   | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | baselineSpend.quantity               | number                      | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                         |
         * | baselineSpend.pricePerUnit           | number                      | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                         |
         * | baselineSpend.percentageRate         | number                      | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                         |
         * | baselineSpend.percentageBasisMembers | percentagebasiscandidatedto |                                                                              |                                                         |
         * | baselineSpend.minimumFee             | number                      | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                         |
         * | baselineSpend.minimumFeeNote         | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | baselineSpend.taxable                | boolean                     | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                                                         |
         * | baselineSpend.indexRate              | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | baselineSpend.tierType               | object                      |                                                                              | volume, usage_band, discount_tier                       |
         * | baselineSpend.tierValue              | string                      | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                         |
         * | baselineSpend.totalValue             | number                      | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                         |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - name
         * - negotiationVendorName
         * - vendorAccountNumber
         * - vendorAccountName
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<SpendRoundListDto, void>({
        path: `/internal-portal/organizations/${organizationId}/spends/rounds`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Data Entry - Spends
     * @name SpendsControllerValidateRound
     * @request PUT:/internal-portal/organizations/{organizationId}/spends/rounds/{auditSpendId}/validation
     * @secure
     */
    spendsControllerValidateRound: (
      organizationId: string,
      auditSpendId: string,
      data: ValidateSpendRoundDto,
      params: RequestParams = {}
    ) =>
      this.request<SpendRoundValidationResultDto, void>({
        path: `/internal-portal/organizations/${organizationId}/spends/rounds/${auditSpendId}/validation`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Data Entry - Spends
     * @name SpendsControllerSetRoundFlags
     * @request PUT:/internal-portal/organizations/{organizationId}/spends/rounds/{auditSpendId}/flags
     * @secure
     */
    spendsControllerSetRoundFlags: (
      organizationId: string,
      auditSpendId: string,
      data: SetSpendRoundFlagsDto,
      params: RequestParams = {}
    ) =>
      this.request<SpendRoundFlagsResultDto, void>({
        path: `/internal-portal/organizations/${organizationId}/spends/rounds/${auditSpendId}/flags`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Data Entry - Spends
     * @name SpendsControllerBulkValidateRounds
     * @request POST:/internal-portal/organizations/{organizationId}/spends/rounds/bulk-validate
     * @secure
     */
    spendsControllerBulkValidateRounds: (
      organizationId: string,
      data: BulkValidateSpendRoundsDto,
      params: RequestParams = {}
    ) =>
      this.request<BulkValidateSpendsResultDto, void>({
        path: `/internal-portal/organizations/${organizationId}/spends/rounds/bulk-validate`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Data Entry - Spends
     * @name SpendsControllerCreate
     * @request POST:/internal-portal/organizations/{organizationId}/spends
     * @secure
     */
    spendsControllerCreate: (
      organizationId: string,
      data: CreateSpendDto,
      params: RequestParams = {}
    ) =>
      this.request<SpendItemDto, void>({
        path: `/internal-portal/organizations/${organizationId}/spends`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Data Entry - Validation Spend Group Periods
     * @name ValidationSpendGroupPeriodsControllerList
     * @request GET:/internal-portal/organizations/{organizationId}/validation-spend-group-periods
     * @secure
     */
    validationSpendGroupPeriodsControllerList: (
      organizationId: string,
      query?: {
        issueDateFrom?: string;
        issueDateTo?: string;
        vendorId?: string;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - group
         * - locationId
         * - invoice
         * - spendCategoryId
         * - issueDate
         * - validationStatus
         * - validatedAt
         * - id
         * - auditIds
         * - omittedValidationReason
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                     | Type   | Allowed Rules                                                                | Possible Values          |
         * | ----------------------- | ------ | ---------------------------------------------------------------------------- | ------------------------ |
         * | group                   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                          |
         * | locationId              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                          |
         * | invoice                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                          |
         * | spendCategoryId         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                          |
         * | issueDate               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                          |
         * | validationStatus        | object |                                                                              | match, mismatch, pending |
         * | validatedAt             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                          |
         * | id                      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                          |
         * | auditIds                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                          |
         * | omittedValidationReason | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                          |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<ValidationSpendGroupPeriodListDto, void>({
        path: `/internal-portal/organizations/${organizationId}/validation-spend-group-periods`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Data Entry - Validation Spend Group Periods
     * @name ValidationSpendGroupPeriodsControllerGetOne
     * @request GET:/internal-portal/organizations/{organizationId}/validation-spend-group-periods/{periodId}
     * @secure
     */
    validationSpendGroupPeriodsControllerGetOne: (
      organizationId: string,
      periodId: string,
      params: RequestParams = {}
    ) =>
      this.request<ValidationSpendGroupPeriodDto, void>({
        path: `/internal-portal/organizations/${organizationId}/validation-spend-group-periods/${periodId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Data Entry - Validation Spend Group Periods
     * @name ValidationSpendGroupPeriodsControllerValidate
     * @request PUT:/internal-portal/organizations/{organizationId}/validation-spend-group-periods/{periodId}
     * @secure
     */
    validationSpendGroupPeriodsControllerValidate: (
      organizationId: string,
      periodId: string,
      data: ValidateValidationSpendGroupPeriodDto,
      params: RequestParams = {}
    ) =>
      this.request<ValidationSpendGroupPeriodDto, void>({
        path: `/internal-portal/organizations/${organizationId}/validation-spend-group-periods/${periodId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Data Entry - Validation Spend Group Periods
     * @name ValidationSpendGroupPeriodsControllerSetOmittedValidation
     * @request PUT:/internal-portal/organizations/{organizationId}/validation-spend-group-periods/{periodId}/omitted-validation
     * @secure
     */
    validationSpendGroupPeriodsControllerSetOmittedValidation: (
      organizationId: string,
      periodId: string,
      data: OmitValidationSpendGroupPeriodDto,
      params: RequestParams = {}
    ) =>
      this.request<ValidationSpendGroupPeriodDto, void>({
        path: `/internal-portal/organizations/${organizationId}/validation-spend-group-periods/${periodId}/omitted-validation`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Data Entry - Validation Spend Group Periods
     * @name ValidationSpendGroupPeriodsControllerListNotes
     * @request GET:/internal-portal/organizations/{organizationId}/validation-spend-group-periods/{periodId}/notes
     * @secure
     */
    validationSpendGroupPeriodsControllerListNotes: (
      organizationId: string,
      periodId: string,
      query?: {
        /**
         * Current page number (1-based)
         * @min 1
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @min 1
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
        /**
         * Narrow to notes written while reviewing this audit.
         * @format uuid
         */
        auditId?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<ValidationSpendGroupNoteListDto, void>({
        path: `/internal-portal/organizations/${organizationId}/validation-spend-group-periods/${periodId}/notes`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Data Entry - Validation Spend Group Periods
     * @name ValidationSpendGroupPeriodsControllerCreateNote
     * @request POST:/internal-portal/organizations/{organizationId}/validation-spend-group-periods/{periodId}/notes
     * @secure
     */
    validationSpendGroupPeriodsControllerCreateNote: (
      organizationId: string,
      periodId: string,
      data: CreateValidationSpendGroupPeriodNoteDto,
      params: RequestParams = {}
    ) =>
      this.request<ValidationSpendGroupNoteDto, void>({
        path: `/internal-portal/organizations/${organizationId}/validation-spend-group-periods/${periodId}/notes`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Data Entry - Validation Spend Group Periods
     * @name ValidationSpendGroupPeriodsControllerDeleteNote
     * @request DELETE:/internal-portal/organizations/{organizationId}/validation-spend-group-periods/{periodId}/notes/{noteId}
     * @secure
     */
    validationSpendGroupPeriodsControllerDeleteNote: (
      organizationId: string,
      periodId: string,
      noteId: string,
      params: RequestParams = {}
    ) =>
      this.request<MessageResponseDto, void>({
        path: `/internal-portal/organizations/${organizationId}/validation-spend-group-periods/${periodId}/notes/${noteId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Initial Validation
     * @name ValidationSpendGroupNotesControllerListNotes
     * @request GET:/internal-portal/organizations/{organizationId}/validation-spend-groups/{groupId}/notes
     * @secure
     */
    validationSpendGroupNotesControllerListNotes: (
      groupId: string,
      organizationId: string,
      query?: {
        /**
         * Current page number (1-based)
         * @min 1
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @min 1
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
        /**
         * Narrow to notes written while reviewing this audit.
         * @format uuid
         */
        auditId?: string;
        /**
         * Narrow to notes on this validation period of the group.
         * @format uuid
         */
        periodId?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<ValidationSpendGroupNoteListDto, void>({
        path: `/internal-portal/organizations/${organizationId}/validation-spend-groups/${groupId}/notes`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Initial Validation
     * @name ValidationSpendGroupNotesControllerCreateNote
     * @request POST:/internal-portal/organizations/{organizationId}/validation-spend-groups/{groupId}/notes
     * @secure
     */
    validationSpendGroupNotesControllerCreateNote: (
      groupId: string,
      organizationId: string,
      data: CreateValidationSpendGroupNoteDto,
      params: RequestParams = {}
    ) =>
      this.request<ValidationSpendGroupNoteDto, void>({
        path: `/internal-portal/organizations/${organizationId}/validation-spend-groups/${groupId}/notes`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Initial Validation
     * @name ValidationSpendGroupNotesControllerDeleteNote
     * @request DELETE:/internal-portal/organizations/{organizationId}/validation-spend-groups/{groupId}/notes/{noteId}
     * @secure
     */
    validationSpendGroupNotesControllerDeleteNote: (
      groupId: string,
      noteId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<MessageResponseDto, void>({
        path: `/internal-portal/organizations/${organizationId}/validation-spend-groups/${groupId}/notes/${noteId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Spend Notes
     * @name AuditSpendNotesControllerListNotes
     * @request GET:/internal-portal/organizations/{organizationId}/audits/{auditId}/spends/{auditSpendId}/notes
     * @secure
     */
    auditSpendNotesControllerListNotes: (
      auditId: string,
      auditSpendId: string,
      organizationId: string,
      query?: {
        /** The bill being viewed; defaults to the charge's first validation bill */
        invoiceId?: string;
        /** `scoped` (default): notes on the bill and those on none. `all`: every note on the charge */
        displaySpendNotes?: AuditSpendNotesControllerListNotesParamsDisplaySpendNotesEnum;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - createdBy
         * - createdAt
         * - id
         * - value
         * - invoiceId
         * - auditStage
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key        | Type   | Allowed Rules                                                                | Possible Values                                                                                                 |
         * | ---------- | ------ | ---------------------------------------------------------------------------- | --------------------------------------------------------------------------------------------------------------- |
         * | createdBy  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                                 |
         * | createdAt  | date   | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty   |                                                                                                                 |
         * | id         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                                 |
         * | value      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                                 |
         * | invoiceId  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                                 |
         * | auditStage | object |                                                                              | MONITORING_SAVINGS, INITIAL_VALIDATION, SPEND_ESTIMATED, MOBILIZATION, NEGOTIATIONS_VENDOR, NEGOTIATIONS_CLIENT |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<AuditSpendNoteListDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/spends/${auditSpendId}/notes`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Spend Notes
     * @name AuditSpendNotesControllerCreateNote
     * @request POST:/internal-portal/organizations/{organizationId}/audits/{auditId}/spends/{auditSpendId}/notes
     * @secure
     */
    auditSpendNotesControllerCreateNote: (
      auditId: string,
      auditSpendId: string,
      organizationId: string,
      data: CreateAuditSpendNoteDto,
      params: RequestParams = {}
    ) =>
      this.request<AuditSpendNoteDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/spends/${auditSpendId}/notes`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Spend Notes
     * @name AuditSpendNotesControllerDeleteNote
     * @request DELETE:/internal-portal/organizations/{organizationId}/audits/{auditId}/spends/{auditSpendId}/notes/{noteId}
     * @secure
     */
    auditSpendNotesControllerDeleteNote: (
      auditId: string,
      auditSpendId: string,
      noteId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<MessageResponseDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/spends/${auditSpendId}/notes/${noteId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Data Entry - Invoices
     * @name DataEntryInvoicesControllerList
     * @request GET:/internal-portal/organizations/{organizationId}/invoices
     * @secure
     */
    dataEntryInvoicesControllerList: (
      organizationId: string,
      query?: {
        auditId?: string;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - internal
         * - id
         * - fileName
         * - documentId
         * - invoiceTemplateId
         * - issueDate
         * - uploadDate
         * - status
         * - createdBy
         * - updatedBy
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key               | Type    | Allowed Rules                                                                | Possible Values                                                                |
         * | ----------------- | ------- | ---------------------------------------------------------------------------- | ------------------------------------------------------------------------------ |
         * | internal          | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                                                                                |
         * | id                | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                |
         * | fileName          | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                |
         * | documentId        | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                |
         * | invoiceTemplateId | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                |
         * | issueDate         | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                |
         * | uploadDate        | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                |
         * | status            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | draft, notCollected, confirmed, approved, superseded, vendorCorrection, review |
         * | createdBy         | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                |
         * | updatedBy         | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - document.filename
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<DataEntryInvoiceListDto, void>({
        path: `/internal-portal/organizations/${organizationId}/invoices`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Data Entry - Invoices
     * @name DataEntryInvoicesControllerCreateManual
     * @request POST:/internal-portal/organizations/{organizationId}/invoices
     * @secure
     */
    dataEntryInvoicesControllerCreateManual: (
      organizationId: string,
      data: CreateManualInvoiceDto,
      params: RequestParams = {}
    ) =>
      this.request<DataEntryInvoiceDto, void>({
        path: `/internal-portal/organizations/${organizationId}/invoices`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Data Entry - Invoices
     * @name DataEntryInvoicesControllerListPickerDocuments
     * @request GET:/internal-portal/organizations/{organizationId}/invoices/picker
     * @secure
     */
    dataEntryInvoicesControllerListPickerDocuments: (
      organizationId: string,
      query?: {
        /** Hides documents added to this audit before vendor negotiations (Spend Estimated, Mobilization). */
        auditId?: string;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - linkedToInvoice
         * - invoiceId
         * - invoiceTemplateId
         * - stage
         * - vendor
         * - name
         * - createdAt
         * - updatedAt
         * - providedBy
         * - type
         * - spendCategory
         * - id
         * - uploadedBy
         * - startDate
         * - endDate
         * - renewalDate
         * - annualContractValue
         * - notToExceed
         * - annualPriceIncrease
         * - earlyTerminationFee
         * - contractType
         * - categoryManager
         * - categoryManagerUser
         * - paymentFrequency
         * - cancellationDateNoticePeriod
         * - autoRenewalClause
         * - autoRenewalLength
         * - notToExceedPercentage
         * - sensitive
         * - internal
         * - tags
         * - virtual
         * - additionalColumns
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                          | Type   | Allowed Rules                                                                | Possible Values |
         * | ---------------------------- | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | linkedToInvoice              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | invoiceId                    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | invoiceTemplateId            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | stage                        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendor                       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | name                         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdAt                    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | updatedAt                    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | providedBy                   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | type                         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | spendCategory                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | id                           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | uploadedBy                   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | startDate                    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | endDate                      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | renewalDate                  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | annualContractValue          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | notToExceed                  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | annualPriceIncrease          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | earlyTerminationFee          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | contractType                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | categoryManager              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | categoryManagerUser          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | paymentFrequency             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | cancellationDateNoticePeriod | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | autoRenewalClause            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | autoRenewalLength            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | notToExceedPercentage        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | sensitive                    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | internal                     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | tags                         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | virtual                      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | additionalColumns            | object |                                                                              |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - filename
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<InvoiceDocumentPickerListDto, void>({
        path: `/internal-portal/organizations/${organizationId}/invoices/picker`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Data Entry - Invoices
     * @name DataEntryInvoicesControllerUpload
     * @request POST:/internal-portal/organizations/{organizationId}/invoices/upload
     * @secure
     */
    dataEntryInvoicesControllerUpload: (
      organizationId: string,
      data: UploadDataEntryInvoiceDto,
      params: RequestParams = {}
    ) =>
      this.request<DataEntryInvoiceDto, void>({
        path: `/internal-portal/organizations/${organizationId}/invoices/upload`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Data Entry - Invoices
     * @name DataEntryInvoicesControllerAttachFromRepository
     * @request POST:/internal-portal/organizations/{organizationId}/invoices/attach
     * @secure
     */
    dataEntryInvoicesControllerAttachFromRepository: (
      organizationId: string,
      data: AttachDataEntryInvoiceDto,
      params: RequestParams = {}
    ) =>
      this.request<DataEntryInvoiceDto, void>({
        path: `/internal-portal/organizations/${organizationId}/invoices/attach`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Data Entry - Invoices
     * @name DataEntryInvoicesControllerUploadDocumentTo
     * @request POST:/internal-portal/organizations/{organizationId}/invoices/{invoiceId}/upload
     * @secure
     */
    dataEntryInvoicesControllerUploadDocumentTo: (
      organizationId: string,
      invoiceId: string,
      data: UploadDataEntryInvoiceDocumentDto,
      params: RequestParams = {}
    ) =>
      this.request<DataEntryInvoiceDetailDto, void>({
        path: `/internal-portal/organizations/${organizationId}/invoices/${invoiceId}/upload`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Data Entry - Invoices
     * @name DataEntryInvoicesControllerGetDetail
     * @request GET:/internal-portal/organizations/{organizationId}/invoices/{invoiceId}
     * @secure
     */
    dataEntryInvoicesControllerGetDetail: (
      organizationId: string,
      invoiceId: string,
      params: RequestParams = {}
    ) =>
      this.request<DataEntryInvoiceDetailDto, void>({
        path: `/internal-portal/organizations/${organizationId}/invoices/${invoiceId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Data Entry - Invoices
     * @name DataEntryInvoicesControllerUpdate
     * @request PUT:/internal-portal/organizations/{organizationId}/invoices/{invoiceId}
     * @secure
     */
    dataEntryInvoicesControllerUpdate: (
      organizationId: string,
      invoiceId: string,
      data: UpdateDataEntryInvoiceDto,
      params: RequestParams = {}
    ) =>
      this.request<DataEntryInvoiceDetailDto, void>({
        path: `/internal-portal/organizations/${organizationId}/invoices/${invoiceId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Data Entry - Invoices
     * @name DataEntryInvoicesControllerRemove
     * @request DELETE:/internal-portal/organizations/{organizationId}/invoices/{invoiceId}
     * @secure
     */
    dataEntryInvoicesControllerRemove: (
      organizationId: string,
      invoiceId: string,
      params: RequestParams = {}
    ) =>
      this.request<MessageResponseDto, void>({
        path: `/internal-portal/organizations/${organizationId}/invoices/${invoiceId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Data Entry - Invoices
     * @name DataEntryInvoicesControllerListAssignableLocations
     * @request GET:/internal-portal/organizations/{organizationId}/invoices/{invoiceId}/locations
     * @secure
     */
    dataEntryInvoicesControllerListAssignableLocations: (
      organizationId: string,
      invoiceId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - isAttached
         * - id
         * - name
         * - locationIdentifier
         * - address
         * - city
         * - state
         * - zip
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                | Type    | Allowed Rules                                                                | Possible Values |
         * | ------------------ | ------- | ---------------------------------------------------------------------------- | --------------- |
         * | isAttached         | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                 |
         * | id                 | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | name               | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | locationIdentifier | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | address            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | city               | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | state              | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | zip                | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - name
         * - locationIdentifier
         * - address
         * - city
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<AssignableLocationListDto, void>({
        path: `/internal-portal/organizations/${organizationId}/invoices/${invoiceId}/locations`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Data Entry - Audit Invoices
     * @name AuditDataEntryInvoicesControllerUpload
     * @request POST:/internal-portal/organizations/{organizationId}/audits/{auditId}/invoices/upload
     * @secure
     */
    auditDataEntryInvoicesControllerUpload: (
      organizationId: string,
      auditId: string,
      data: UploadAuditDataEntryInvoiceDto,
      params: RequestParams = {}
    ) =>
      this.request<DataEntryInvoiceDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/invoices/upload`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Data Entry - Audit Invoices
     * @name AuditDataEntryInvoicesControllerAttachFromRepository
     * @request POST:/internal-portal/organizations/{organizationId}/audits/{auditId}/invoices/attach
     * @secure
     */
    auditDataEntryInvoicesControllerAttachFromRepository: (
      organizationId: string,
      auditId: string,
      data: AttachAuditDataEntryInvoiceDto,
      params: RequestParams = {}
    ) =>
      this.request<DataEntryInvoiceDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/invoices/attach`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Data Entry - Audit Invoices
     * @name AuditDataEntryInvoicesControllerCreateManual
     * @request POST:/internal-portal/organizations/{organizationId}/audits/{auditId}/invoices
     * @secure
     */
    auditDataEntryInvoicesControllerCreateManual: (
      organizationId: string,
      auditId: string,
      data: CreateAuditManualInvoiceDto,
      params: RequestParams = {}
    ) =>
      this.request<DataEntryInvoiceDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/invoices`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description The upload picker: each stream with the accounts and sites it bills and the invoices it issued. `vendorId` keeps the streams billing an account of that vendor; `spendCategoryId` those stamped with that category; `auditId` those with a bill attached to that audit; `vendorAccountIds` / `locationIds` (comma-separated) those linked to any of the listed accounts / sites, both lists must match when both are given. `issueDateFrom` / `issueDateTo` (YYYY-MM-DD, inclusive) filter only the bills, never the streams.
     *
     * @tags Internal Portal - Data Entry - Invoice Templates
     * @name InvoiceTemplatesControllerList
     * @summary Bill streams of the organization with their bills
     * @request GET:/internal-portal/organizations/{organizationId}/invoice-templates
     * @secure
     */
    invoiceTemplatesControllerList: (
      organizationId: string,
      query?: {
        issueDateFrom?: string;
        issueDateTo?: string;
        vendorId?: string;
        spendCategoryId?: string;
        auditId?: string;
        vendorAccountIds?: string;
        locationIds?: string;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - createdFromUpload
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key               | Type    | Allowed Rules                                                                | Possible Values |
         * | ----------------- | ------- | ---------------------------------------------------------------------------- | --------------- |
         * | id                | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | name              | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdFromUpload | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - name
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<InvoiceTemplateListDto, void>({
        path: `/internal-portal/organizations/${organizationId}/invoice-templates`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Data Entry - Invoice Templates
     * @name InvoiceTemplatesControllerGetOne
     * @summary One bill stream with every bill on it
     * @request GET:/internal-portal/organizations/{organizationId}/invoice-templates/{invoiceTemplateId}
     * @secure
     */
    invoiceTemplatesControllerGetOne: (
      organizationId: string,
      invoiceTemplateId: string,
      params: RequestParams = {}
    ) =>
      this.request<InvoiceTemplateDto, void>({
        path: `/internal-portal/organizations/${organizationId}/invoice-templates/${invoiceTemplateId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Renames the stream and attaches or detaches vendor accounts and locations; every bill on the stream has its validation period re-derived. Locations left unserved by any remaining account are detached with it.
     *
     * @tags Internal Portal - Data Entry - Invoice Templates
     * @name InvoiceTemplatesControllerUpdate
     * @summary Edit a bill stream
     * @request PUT:/internal-portal/organizations/{organizationId}/invoice-templates/{invoiceTemplateId}
     * @secure
     */
    invoiceTemplatesControllerUpdate: (
      organizationId: string,
      invoiceTemplateId: string,
      data: UpdateInvoiceTemplateDto,
      params: RequestParams = {}
    ) =>
      this.request<InvoiceTemplateDto, void>({
        path: `/internal-portal/organizations/${organizationId}/invoice-templates/${invoiceTemplateId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Data Entry - Spends
     * @name SpendValuesControllerListValues
     * @request GET:/internal-portal/organizations/{organizationId}/spends/{spendId}/values
     * @secure
     */
    spendValuesControllerListValues: (
      organizationId: string,
      spendId: string,
      query?: {
        /**
         * YYYY-MM-DD; marks the breakpoint in force on this day `isActive`. Omit to mark the latest one.
         * @format date
         */
        activeDate?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<SpendValueListDto, void>({
        path: `/internal-portal/organizations/${organizationId}/spends/${spendId}/values`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Data Entry - Spends
     * @name SpendValuesControllerCreateValue
     * @request POST:/internal-portal/organizations/{organizationId}/spends/{spendId}/values
     * @secure
     */
    spendValuesControllerCreateValue: (
      organizationId: string,
      spendId: string,
      data: CreateSpendValueDto,
      params: RequestParams = {}
    ) =>
      this.request<SpendValueDto, void>({
        path: `/internal-portal/organizations/${organizationId}/spends/${spendId}/values`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Initial Validation
     * @name ValidationSpendGroupsControllerListGroups
     * @request GET:/internal-portal/organizations/{organizationId}/audits/{auditId}/initial-validation/validation-spend-groups
     * @secure
     */
    validationSpendGroupsControllerListGroups: (
      auditId: string,
      organizationId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - vendorAccountId
         * - locationId
         * - validatedAt
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key             | Type   | Allowed Rules                                                                | Possible Values |
         * | --------------- | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | vendorAccountId | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | locationId      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | validatedAt     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<ValidationSpendGroupListDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/initial-validation/validation-spend-groups`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Initial Validation
     * @name ValidationSpendGroupsControllerGetGroup
     * @request GET:/internal-portal/organizations/{organizationId}/audits/{auditId}/initial-validation/validation-spend-groups/{groupId}
     * @secure
     */
    validationSpendGroupsControllerGetGroup: (
      auditId: string,
      groupId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<ValidationSpendGroupItemDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/initial-validation/validation-spend-groups/${groupId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Groups are never removed by an audit change; this is the manual way out. Refused while a bill is still filed under the group.
     *
     * @tags Internal Portal - Audit Initial Validation
     * @name ValidationSpendGroupsControllerDeleteGroup
     * @summary Delete an obsolete validation spend group
     * @request DELETE:/internal-portal/organizations/{organizationId}/audits/{auditId}/initial-validation/validation-spend-groups/{groupId}
     * @secure
     */
    validationSpendGroupsControllerDeleteGroup: (
      auditId: string,
      groupId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<MessageResponseDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/initial-validation/validation-spend-groups/${groupId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Stamps the group itself as validated (status, by, at). Validating requires a linked bill stream (see `PUT :groupId/invoice-template`). `validated: false` is rejected once the group is already stamped — validation is final. No side effects on its periods and spend lines.
     *
     * @tags Internal Portal - Audit Initial Validation
     * @name ValidationSpendGroupsControllerValidateGroup
     * @summary Validate a whole validation spend group
     * @request PUT:/internal-portal/organizations/{organizationId}/audits/{auditId}/initial-validation/validation-spend-groups/{groupId}/validation
     * @secure
     */
    validationSpendGroupsControllerValidateGroup: (
      auditId: string,
      groupId: string,
      organizationId: string,
      data: ValidateValidationSpendGroupDto,
      params: RequestParams = {}
    ) =>
      this.request<ValidationSpendGroupItemDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/initial-validation/validation-spend-groups/${groupId}/validation`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Opens a period per bill on the stream and seeds the spend lines of this audit. **Relinking is destructive:** the initial-validation line of each charge goes back to invoiceless (`firstValidationInvoiceId` cleared), and every other spend line and period of the group on the old stream bills is deleted, validated or not. The group validation is cleared too. A validated group can be relinked only by an admin. The frontend must warn the user first. Refused while an old stream bill is on a locked or sent VSR report. Linking the stream the group already has is a no-op. A group cannot be unlinked.
     *
     * @tags Internal Portal - Audit Initial Validation
     * @name ValidationSpendGroupsControllerLinkInvoiceTemplate
     * @summary Link a validation spend group to a bill stream (destructive on relink)
     * @request PUT:/internal-portal/organizations/{organizationId}/audits/{auditId}/initial-validation/validation-spend-groups/{groupId}/invoice-template
     * @secure
     */
    validationSpendGroupsControllerLinkInvoiceTemplate: (
      auditId: string,
      groupId: string,
      organizationId: string,
      data: LinkValidationSpendGroupInvoiceTemplateDto,
      params: RequestParams = {}
    ) =>
      this.request<ValidationSpendGroupItemDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/initial-validation/validation-spend-groups/${groupId}/invoice-template`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Locations
     * @name AuditLocationsControllerList
     * @request GET:/internal-portal/organizations/{organizationId}/audits/{auditId}/locations
     * @secure
     */
    auditLocationsControllerList: (
      auditId: string,
      organizationId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - displayName
         * - locationIdentifier
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                | Type   | Allowed Rules                                                                | Possible Values |
         * | ------------------ | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | id                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | name               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | displayName        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | locationIdentifier | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - name
         * - locationIdentifier
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<AuditLocationListDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/locations`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - SIB Contract Audits
     * @name SibContractAuditsControllerFindAll
     * @request GET:/internal-portal/organizations/{organizationId}/sib-contracts/{contractId}/audits
     * @secure
     */
    sibContractAuditsControllerFindAll: (
      organizationId: string,
      contractId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - name
         * - status
         * - salesforceSource
         * - stage
         * - vendor
         * - creator
         * - owner
         * - team
         * - createdAt
         * - dueDate
         * - savingsStartDate
         * - baselineSpend
         * - invoicesAttachedCount
         * - spendCategory
         * - includedLocations
         * - contractId
         * - contract
         * - organization
         * - organizationId
         * - isMigrated
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                   | Type   | Allowed Rules                                                                | Possible Values                      |
         * | --------------------- | ------ | ---------------------------------------------------------------------------- | ------------------------------------ |
         * | name                  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | status                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | salesforceSource      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | parent_audit, vendor_split, subaudit |
         * | stage                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | vendor                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | creator               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | owner                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | team                  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | createdAt             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | dueDate               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | savingsStartDate      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | baselineSpend         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | invoicesAttachedCount | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | spendCategory         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | includedLocations     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | contractId            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | contract              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | organization          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | organizationId        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         * | isMigrated            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                      |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<AuditListDto, void>({
        path: `/internal-portal/organizations/${organizationId}/sib-contracts/${contractId}/audits`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Banks
     * @name BanksControllerGetBanks
     * @request GET:/internal-portal/banks
     * @secure
     */
    banksControllerGetBanks: (params: RequestParams = {}) =>
      this.request<BankDto[], void>({
        path: `/internal-portal/banks`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Global Search
     * @name GlobalSearchControllerSearch
     * @request GET:/internal-portal/global-search
     * @secure
     */
    globalSearchControllerSearch: (
      query: {
        /**
         * Free-text term, at least 3 characters. Matched as a case-insensitive substring; typos are not tolerated.
         * @minLength 3
         */
        searchTerm: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<GlobalSearchResultDto, void>({
        path: `/internal-portal/global-search`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Global Search
     * @name GlobalSearchControllerSearchModule
     * @request GET:/internal-portal/global-search/{module}
     * @secure
     */
    globalSearchControllerSearchModule: (
      module: GlobalSearchControllerSearchModuleParamsEnum,
      query: {
        /**
         * Free-text term, at least 3 characters. Matched as a case-insensitive substring; typos are not tolerated.
         * @minLength 3
         */
        searchTerm: string;
        /**
         * Current page number (1-based)
         * @min 1
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @min 1
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<GlobalSearchListDto, void>({
        path: `/internal-portal/global-search/${module}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description A draft's `totalSavings` and `totalRevenue` are calculated live, but `filter` / `sort` on them read the stored totals, which are zero until the draft is locked.
     *
     * @tags Internal Portal - VSR Reports
     * @name VsrReportsControllerListReports
     * @summary List VSR reports
     * @request GET:/internal-portal/organizations/{organizationId}/vsr-reports
     * @secure
     */
    vsrReportsControllerListReports: (
      organizationId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - title
         * - organizationId
         * - sibContractId
         * - periodFrom
         * - periodTo
         * - savingsPeriod
         * - reportDate
         * - sibInvoiceId
         * - sibInvoiceNumber
         * - sibInvoiceDate
         * - sibInvoiceNetsuiteTransactionId
         * - totalSavings
         * - totalRevenue
         * - status
         * - sentAt
         * - createdById
         * - previousReportId
         * - createdAt
         * - updatedAt
         * - locationsCount
         * - spendCategoriesCount
         * - spendCategories
         * - locationIds
         * - spendCategoryIds
         * - auditIds
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                             | Type   | Allowed Rules                                                                | Possible Values                         |
         * | ------------------------------- | ------ | ---------------------------------------------------------------------------- | --------------------------------------- |
         * | id                              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                         |
         * | title                           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                         |
         * | organizationId                  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                         |
         * | sibContractId                   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                         |
         * | periodFrom                      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                         |
         * | periodTo                        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                         |
         * | savingsPeriod                   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                         |
         * | reportDate                      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                         |
         * | sibInvoiceId                    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                         |
         * | sibInvoiceNumber                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                         |
         * | sibInvoiceDate                  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                         |
         * | sibInvoiceNetsuiteTransactionId | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                         |
         * | totalSavings                    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                         |
         * | totalRevenue                    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                         |
         * | status                          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | draft, ready_for_review, approved, sent |
         * | sentAt                          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                         |
         * | createdById                     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                         |
         * | previousReportId                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                         |
         * | createdAt                       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                         |
         * | updatedAt                       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                         |
         * | locationsCount                  | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                         |
         * | spendCategoriesCount            | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                         |
         * | spendCategories                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                         |
         * | locationIds                     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                         |
         * | spendCategoryIds                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                         |
         * | auditIds                        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                         |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<VsrReportListDto, void>({
        path: `/internal-portal/organizations/${organizationId}/vsr-reports`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - VSR Reports
     * @name VsrReportsControllerGenerateReport
     * @request POST:/internal-portal/organizations/{organizationId}/vsr-reports
     * @secure
     */
    vsrReportsControllerGenerateReport: (
      organizationId: string,
      data: GenerateVsrReportDto,
      params: RequestParams = {}
    ) =>
      this.request<VsrReportDto, void>({
        path: `/internal-portal/organizations/${organizationId}/vsr-reports`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description The spend categories the organization’s audits are scoped to, enabled or not.
     *
     * @tags Internal Portal - VSR Reports
     * @name VsrReportsControllerListSpendCategoryOptions
     * @summary List VSR spend category filter options
     * @request GET:/internal-portal/organizations/{organizationId}/vsr-reports/spend-categories
     * @secure
     */
    vsrReportsControllerListSpendCategoryOptions: (
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<SelectListDto, void>({
        path: `/internal-portal/organizations/${organizationId}/vsr-reports/spend-categories`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - VSR Reports
     * @name VsrReportsControllerListLocationOptions
     * @request GET:/internal-portal/organizations/{organizationId}/vsr-reports/locations
     * @secure
     */
    vsrReportsControllerListLocationOptions: (
      organizationId: string,
      query?: {
        /** Comma-separated spend category ids — the report’s categories. Omit to list every site. */
        spendCategoryIds?: string;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - address
         * - city
         * - state
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key     | Type   | Allowed Rules                                                                | Possible Values |
         * | ------- | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | id      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | name    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | address | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | city    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | state   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - name
         * - address
         * - city
         * - state
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<VsrReportLocationOptionListDto, void>({
        path: `/internal-portal/organizations/${organizationId}/vsr-reports/locations`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - VSR Reports
     * @name VsrReportsControllerGetReport
     * @request GET:/internal-portal/organizations/{organizationId}/vsr-reports/{reportId}
     * @secure
     */
    vsrReportsControllerGetReport: (
      organizationId: string,
      reportId: string,
      params: RequestParams = {}
    ) =>
      this.request<VsrReportDto, void>({
        path: `/internal-portal/organizations/${organizationId}/vsr-reports/${reportId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - VSR Reports
     * @name VsrReportsControllerUpdateReport
     * @request PUT:/internal-portal/organizations/{organizationId}/vsr-reports/{reportId}
     * @secure
     */
    vsrReportsControllerUpdateReport: (
      organizationId: string,
      reportId: string,
      data: UpdateVsrReportDto,
      params: RequestParams = {}
    ) =>
      this.request<VsrReportDto, void>({
        path: `/internal-portal/organizations/${organizationId}/vsr-reports/${reportId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - VSR Reports
     * @name VsrReportsControllerDeleteReport
     * @request DELETE:/internal-portal/organizations/{organizationId}/vsr-reports/{reportId}
     * @secure
     */
    vsrReportsControllerDeleteReport: (
      organizationId: string,
      reportId: string,
      params: RequestParams = {}
    ) =>
      this.request<MessageResponseDto, void>({
        path: `/internal-portal/organizations/${organizationId}/vsr-reports/${reportId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - VSR Reports
     * @name VsrReportsControllerCopyReport
     * @request GET:/internal-portal/organizations/{organizationId}/vsr-reports/{reportId}/copy
     * @secure
     */
    vsrReportsControllerCopyReport: (
      organizationId: string,
      reportId: string,
      params: RequestParams = {}
    ) =>
      this.request<VsrReportCopyDto, void>({
        path: `/internal-portal/organizations/${organizationId}/vsr-reports/${reportId}/copy`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - VSR Reports
     * @name VsrReportsControllerPreviewSource
     * @request GET:/internal-portal/organizations/{organizationId}/vsr-reports/{reportId}/preview
     * @secure
     */
    vsrReportsControllerPreviewSource: (
      organizationId: string,
      reportId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - spendLineItemId
         * - invoiceId
         * - auditId
         * - auditSpendId
         * - periodId
         * - spendCategoryId
         * - issueDate
         * - locationId
         * - address
         * - cityState
         * - vendor
         * - accountNumber
         * - charge
         * - chargeBasis
         * - pricingModel
         * - quantity
         * - oldRate
         * - oldPercentageRate
         * - basisOldTotal
         * - oldTotal
         * - newRate
         * - newPercentageRate
         * - basisNewTotal
         * - newTotal
         * - savings
         * - contractId
         * - savingsStartDate
         * - savingsEndDate
         * - billedMonth
         * - contractPeriodId
         * - feeRate
         * - fee
         * - invoiceStatus
         * - locked
         * - lockedBy
         * - hidden
         * - excludedFromSavings
         * - validationStatus
         * - validatedAt
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                 | Type    | Allowed Rules                                                                | Possible Values |
         * | ------------------- | ------- | ---------------------------------------------------------------------------- | --------------- |
         * | spendLineItemId     | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | invoiceId           | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | auditId             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | auditSpendId        | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | periodId            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | spendCategoryId     | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | issueDate           | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | locationId          | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | address             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | cityState           | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendor              | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | accountNumber       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | charge              | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | chargeBasis         | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | pricingModel        | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | quantity            | number  | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | oldRate             | number  | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | oldPercentageRate   | number  | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | basisOldTotal       | number  | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | oldTotal            | number  | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | newRate             | number  | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | newPercentageRate   | number  | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | basisNewTotal       | number  | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | newTotal            | number  | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | savings             | number  | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | contractId          | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | savingsStartDate    | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | savingsEndDate      | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | billedMonth         | number  | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | contractPeriodId    | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | feeRate             | number  | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | fee                 | number  | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | invoiceStatus       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | locked              | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                 |
         * | lockedBy            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | hidden              | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                 |
         * | excludedFromSavings | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                 |
         * | validationStatus    | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | validatedAt         | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - site
         * - address
         * - city
         * - state
         * - vendor
         * - accountNumber
         * - charge
         * - invoiceNumber
         * - spendCategory
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<VsrReportPreviewRowListDto, void>({
        path: `/internal-portal/organizations/${organizationId}/vsr-reports/${reportId}/preview`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - VSR Reports
     * @name VsrReportsControllerPreviewMatrix
     * @request GET:/internal-portal/organizations/{organizationId}/vsr-reports/{reportId}/preview/matrix
     * @secure
     */
    vsrReportsControllerPreviewMatrix: (
      organizationId: string,
      reportId: string,
      params: RequestParams = {}
    ) =>
      this.request<VsrReportPreviewMatrixDto, void>({
        path: `/internal-portal/organizations/${organizationId}/vsr-reports/${reportId}/preview/matrix`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - VSR Reports
     * @name VsrReportsControllerReportPdf
     * @request GET:/internal-portal/organizations/{organizationId}/vsr-reports/{reportId}/pdf
     * @secure
     */
    vsrReportsControllerReportPdf: (
      organizationId: string,
      reportId: string,
      params: RequestParams = {}
    ) =>
      this.request<Blob, void>({
        path: `/internal-portal/organizations/${organizationId}/vsr-reports/${reportId}/pdf`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - VSR Reports
     * @name VsrReportsControllerReportXlsx
     * @request GET:/internal-portal/organizations/{organizationId}/vsr-reports/{reportId}/xlsx
     * @secure
     */
    vsrReportsControllerReportXlsx: (
      organizationId: string,
      reportId: string,
      query?: {
        /** Export this page only. Omit for every page but the summary. */
        section?: VsrReportsControllerReportXlsxParamsSectionEnum;
        /**
         * Required with `CategoryOverview` and `CategoryDetail`, ignored otherwise.
         * @format uuid
         */
        spendCategoryId?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<Blob, void>({
        path: `/internal-portal/organizations/${organizationId}/vsr-reports/${reportId}/xlsx`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - VSR Reports
     * @name VsrReportsControllerSetStatus
     * @request PUT:/internal-portal/organizations/{organizationId}/vsr-reports/{reportId}/status
     * @secure
     */
    vsrReportsControllerSetStatus: (
      organizationId: string,
      reportId: string,
      data: UpdateVsrReportStatusDto,
      params: RequestParams = {}
    ) =>
      this.request<VsrReportDto, void>({
        path: `/internal-portal/organizations/${organizationId}/vsr-reports/${reportId}/status`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - VSR Reports
     * @name VsrReportsControllerLockReport
     * @request POST:/internal-portal/organizations/{organizationId}/vsr-reports/{reportId}/lock
     * @secure
     */
    vsrReportsControllerLockReport: (
      organizationId: string,
      reportId: string,
      params: RequestParams = {}
    ) =>
      this.request<VsrReportDto, void>({
        path: `/internal-portal/organizations/${organizationId}/vsr-reports/${reportId}/lock`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - VSR Reports
     * @name VsrReportsControllerUnlockReport
     * @request POST:/internal-portal/organizations/{organizationId}/vsr-reports/{reportId}/unlock
     * @secure
     */
    vsrReportsControllerUnlockReport: (
      organizationId: string,
      reportId: string,
      params: RequestParams = {}
    ) =>
      this.request<VsrReportDto, void>({
        path: `/internal-portal/organizations/${organizationId}/vsr-reports/${reportId}/unlock`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - VSR Reports
     * @name VsrReportsControllerSendReport
     * @request POST:/internal-portal/organizations/{organizationId}/vsr-reports/{reportId}/send
     * @secure
     */
    vsrReportsControllerSendReport: (
      organizationId: string,
      reportId: string,
      params: RequestParams = {}
    ) =>
      this.request<VsrReportDto, void>({
        path: `/internal-portal/organizations/${organizationId}/vsr-reports/${reportId}/send`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - VSR Reports
     * @name VsrReportsControllerRecordInvoice
     * @request POST:/internal-portal/organizations/{organizationId}/vsr-reports/{reportId}/invoice
     * @secure
     */
    vsrReportsControllerRecordInvoice: (
      organizationId: string,
      reportId: string,
      data: RecordVsrInvoiceDto,
      params: RequestParams = {}
    ) =>
      this.request<VsrReportDto, void>({
        path: `/internal-portal/organizations/${organizationId}/vsr-reports/${reportId}/invoice`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - VSR Reports
     * @name VsrReportNotesControllerListNotes
     * @request GET:/internal-portal/organizations/{organizationId}/vsr-reports/{reportId}/notes
     * @secure
     */
    vsrReportNotesControllerListNotes: (
      organizationId: string,
      reportId: string,
      params: RequestParams = {}
    ) =>
      this.request<VsrReportNoteDto[], void>({
        path: `/internal-portal/organizations/${organizationId}/vsr-reports/${reportId}/notes`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - VSR Reports
     * @name VsrReportNotesControllerCreateNote
     * @request POST:/internal-portal/organizations/{organizationId}/vsr-reports/{reportId}/notes
     * @secure
     */
    vsrReportNotesControllerCreateNote: (
      organizationId: string,
      reportId: string,
      data: CreateVsrReportNoteDto,
      params: RequestParams = {}
    ) =>
      this.request<VsrReportNoteDto, void>({
        path: `/internal-portal/organizations/${organizationId}/vsr-reports/${reportId}/notes`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - VSR Reports
     * @name VsrReportNotesControllerUpdateNote
     * @request PATCH:/internal-portal/organizations/{organizationId}/vsr-reports/{reportId}/notes/{noteId}
     * @secure
     */
    vsrReportNotesControllerUpdateNote: (
      organizationId: string,
      reportId: string,
      noteId: string,
      data: UpdateVsrReportNoteDto,
      params: RequestParams = {}
    ) =>
      this.request<VsrReportNoteDto, void>({
        path: `/internal-portal/organizations/${organizationId}/vsr-reports/${reportId}/notes/${noteId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - VSR Reports
     * @name VsrReportNotesControllerDeleteNote
     * @request DELETE:/internal-portal/organizations/{organizationId}/vsr-reports/{reportId}/notes/{noteId}
     * @secure
     */
    vsrReportNotesControllerDeleteNote: (
      organizationId: string,
      reportId: string,
      noteId: string,
      params: RequestParams = {}
    ) =>
      this.request<MessageResponseDto, void>({
        path: `/internal-portal/organizations/${organizationId}/vsr-reports/${reportId}/notes/${noteId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  task = {
    /**
     * No description
     *
     * @tags Task
     * @name TaskControllerCreate
     * @request POST:/task
     * @secure
     */
    taskControllerCreate: (data: CreateTaskDto, params: RequestParams = {}) =>
      this.request<TaskDto, void>({
        path: `/task`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Task
     * @name TaskControllerFindAll
     * @request GET:/task
     * @secure
     */
    taskControllerFindAll: (
      query?: {
        /**
         * User ID to filter tasks by assignee (overrides current user)
         * @format uuid
         */
        userId?: string;
        /**
         * User ID to filter tasks by creator
         * @format uuid
         */
        createdBy?: string;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - title
         * - description
         * - completed
         * - priorityLevel
         * - createdAt
         * - updatedAt
         * - deadline
         * - completedAt
         * - timeLogged
         * - estimatedTime
         * - category
         * - status
         * - referenceLink
         * - referenceName
         * - organizationId
         * - organizationName
         * - organization
         * - vendorId
         * - vendorName
         * - vendor
         * - seenAt
         * - seen
         * - assignee
         * - assigneeName
         * - assigneeEmail
         * - createdBy
         * - createdByName
         * - createdByEmail
         * - tagName
         * - tagColor
         * - tagId
         * - tagCreatedBy
         * - taskTagContactId
         * - taskTagEmployeeId
         * - taskTagType
         * - taskTagEmployeeName
         * - taskTagEmployeeEmail
         * - taskTagContactName
         * - taskTagContactEmail
         * - subauditId
         * - project
         * - commentsCount
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                  | Type   | Allowed Rules                                                                | Possible Values |
         * | -------------------- | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | id                   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | title                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | description          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | completed            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | priorityLevel        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdAt            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | updatedAt            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | deadline             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | completedAt          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | timeLogged           | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | estimatedTime        | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | category             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | status               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | referenceLink        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | referenceName        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organizationId       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organizationName     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organization         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendorId             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendorName           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendor               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | seenAt               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | seen                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assignee             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeName         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeEmail        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdBy            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdByName        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdByEmail       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | tagName              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | tagColor             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | tagId                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | tagCreatedBy         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | taskTagContactId     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | taskTagEmployeeId    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | taskTagType          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | taskTagEmployeeName  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | taskTagEmployeeEmail | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | taskTagContactName   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | taskTagContactEmail  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subauditId           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | project              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | commentsCount        | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - title
         * - description
         * - referenceName
         * - referenceLink
         * - assignee.name
         * - assignee.emailAddress
         * - createdBy.name
         * - createdBy.emailAddress
         * - organization.name
         * - taskTagss.tag.name
         * - taskTagss.employee.name
         * - taskTagss.employee.emailAddress
         * - taskTagss.contact.name
         * - taskTagss.contact.email
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<TaskListDto, void>({
        path: `/task`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Task
     * @name TaskControllerExportTasks
     * @request GET:/task/export
     * @secure
     */
    taskControllerExportTasks: (
      query: {
        /**
         * User ID to filter tasks by assignee (overrides current user)
         * @format uuid
         */
        userId?: string;
        /**
         * User ID to filter tasks by creator
         * @format uuid
         */
        createdBy?: string;
        /** Column paths to export. Pass as repeated query params (preferred) or a JSON array string. Headers are auto-generated from keys. Example: columns=name&columns=status */
        columns: string[];
        /** Custom filename for the CSV download (without extension). */
        filename?: string;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - title
         * - description
         * - completed
         * - priorityLevel
         * - createdAt
         * - updatedAt
         * - deadline
         * - completedAt
         * - timeLogged
         * - estimatedTime
         * - category
         * - status
         * - referenceLink
         * - referenceName
         * - organizationId
         * - organizationName
         * - organization
         * - vendorId
         * - vendorName
         * - vendor
         * - seenAt
         * - seen
         * - assignee
         * - assigneeName
         * - assigneeEmail
         * - createdBy
         * - createdByName
         * - createdByEmail
         * - tagName
         * - tagColor
         * - tagId
         * - tagCreatedBy
         * - taskTagContactId
         * - taskTagEmployeeId
         * - taskTagType
         * - taskTagEmployeeName
         * - taskTagEmployeeEmail
         * - taskTagContactName
         * - taskTagContactEmail
         * - subauditId
         * - project
         * - commentsCount
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                  | Type   | Allowed Rules                                                                | Possible Values |
         * | -------------------- | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | id                   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | title                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | description          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | completed            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | priorityLevel        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdAt            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | updatedAt            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | deadline             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | completedAt          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | timeLogged           | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | estimatedTime        | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | category             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | status               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | referenceLink        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | referenceName        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organizationId       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organizationName     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organization         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendorId             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendorName           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendor               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | seenAt               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | seen                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assignee             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeName         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeEmail        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdBy            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdByName        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdByEmail       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | tagName              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | tagColor             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | tagId                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | tagCreatedBy         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | taskTagContactId     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | taskTagEmployeeId    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | taskTagType          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | taskTagEmployeeName  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | taskTagEmployeeEmail | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | taskTagContactName   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | taskTagContactEmail  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subauditId           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | project              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | commentsCount        | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - title
         * - description
         * - referenceName
         * - referenceLink
         * - assignee.name
         * - assignee.emailAddress
         * - createdBy.name
         * - createdBy.emailAddress
         * - organization.name
         * - taskTagss.tag.name
         * - taskTagss.employee.name
         * - taskTagss.employee.emailAddress
         * - taskTagss.contact.name
         * - taskTagss.contact.email
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<StreamableFile, void>({
        path: `/task/export`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Task
     * @name TaskControllerFindOne
     * @request GET:/task/{id}
     * @secure
     */
    taskControllerFindOne: (id: string, params: RequestParams = {}) =>
      this.request<TaskDto, void>({
        path: `/task/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Task
     * @name TaskControllerUpdate
     * @request PUT:/task/{id}
     * @secure
     */
    taskControllerUpdate: (
      id: string,
      data: UpdateTaskDto,
      params: RequestParams = {}
    ) =>
      this.request<TaskDto, void>({
        path: `/task/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Task
     * @name TaskControllerDeleteOne
     * @request DELETE:/task/{id}
     * @secure
     */
    taskControllerDeleteOne: (
      id: string,
      query?: {
        /** Whether to also delete all follow-up tasks */
        cascadeFollowUps?: boolean;
      },
      params: RequestParams = {}
    ) =>
      this.request<DeleteResult, void>({
        path: `/task/${id}`,
        method: 'DELETE',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Task
     * @name TaskControllerGetAssignedUsersWithTaskCountsByCreator
     * @request GET:/task/assigned-users-by-creator/task-count
     * @secure
     */
    taskControllerGetAssignedUsersWithTaskCountsByCreator: (
      query?: {
        /**
         * Current page number (1-based)
         * @min 1
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @min 1
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
        /**
         * Global search term.
         *
         * Searchable fields: title, description, referenceName, referenceLink, assigneeName, assigneeEmail, createdByName, createdByEmail, organizationName, tagName, taskTagEmployeeName, taskTagEmployeeEmail, taskTagContactName, taskTagContactEmail
         */
        searchTerm?: string;
        /** Filter by completion status. If true, returns only completed tasks. If false, returns only non-completed tasks. */
        completed?: boolean;
      },
      params: RequestParams = {}
    ) =>
      this.request<AssignedUserTaskSummaryListDto, void>({
        path: `/task/assigned-users-by-creator/task-count`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Task
     * @name TaskControllerLogTime
     * @request PATCH:/task/{id}/log-time
     * @secure
     */
    taskControllerLogTime: (
      id: string,
      data: LogTimeDto,
      params: RequestParams = {}
    ) =>
      this.request<TaskDto, void>({
        path: `/task/${id}/log-time`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Task
     * @name TaskControllerImportTasks
     * @request POST:/task/import/{userId}
     * @secure
     */
    taskControllerImportTasks: (
      userId: string,
      query: {
        ownerFilter: string;
      },
      data: ImportTasksDto,
      params: RequestParams = {}
    ) =>
      this.request<TaskDto[], void>({
        path: `/task/import/${userId}`,
        method: 'POST',
        query: query,
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Task
     * @name TaskControllerCreateManyTasks
     * @request POST:/task/many
     * @secure
     */
    taskControllerCreateManyTasks: (
      data: CreateTaskDto[],
      params: RequestParams = {}
    ) =>
      this.request<TaskDto[], void>({
        path: `/task/many`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  tasks = {
    /**
     * No description
     *
     * @tags TaskHistory
     * @name TaskHistoryControllerFindAllChangeLogs
     * @request GET:/tasks/{taskUuid}/versions/changelogs
     * @secure
     */
    taskHistoryControllerFindAllChangeLogs: (
      taskUuid: string,
      params: RequestParams = {}
    ) =>
      this.request<TaskVersionChangelogList, void>({
        path: `/tasks/${taskUuid}/versions/changelogs`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subtask Versions
     * @name SubtaskVersionsControllerFindAllChangeLogs
     * @request GET:/tasks/{taskId}/subtasks/{subtaskId}/versions/changelogs
     * @secure
     */
    subtaskVersionsControllerFindAllChangeLogs: (
      taskId: string,
      subtaskId: string,
      params: RequestParams = {}
    ) =>
      this.request<SubtaskVersionChangelogList, void>({
        path: `/tasks/${taskId}/subtasks/${subtaskId}/versions/changelogs`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Task Tag Versions
     * @name TaskTagVersionsControllerFindAllChangeLogs
     * @request GET:/tasks/{taskId}/task-tags/versions
     * @secure
     */
    taskTagVersionsControllerFindAllChangeLogs: (
      taskId: string,
      params: RequestParams = {}
    ) =>
      this.request<TaskTagVersionChangelogList, void>({
        path: `/tasks/${taskId}/task-tags/versions`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subtask
     * @name SubtaskControllerCreate
     * @request POST:/tasks/{taskUuid}/subtasks
     * @secure
     */
    subtaskControllerCreate: (
      taskUuid: string,
      data: CreateSubtaskDto,
      params: RequestParams = {}
    ) =>
      this.request<SubtaskDto, void>({
        path: `/tasks/${taskUuid}/subtasks`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subtask
     * @name SubtaskControllerFindAll
     * @request GET:/tasks/{taskUuid}/subtasks
     * @secure
     */
    subtaskControllerFindAll: (
      taskUuid: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - title
         * - description
         * - completed
         * - priorityLevel
         * - taskId
         * - updatedById
         * - assigneeId
         * - assigneeName
         * - assigneeEmail
         * - createdByName
         * - createdByEmail
         * - deadline
         * - createdAt
         * - updatedAt
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key            | Type    | Allowed Rules                                                                | Possible Values   |
         * | -------------- | ------- | ---------------------------------------------------------------------------- | ----------------- |
         * | title          | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                   |
         * | description    | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                   |
         * | completed      | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                   |
         * | priorityLevel  | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | low, medium, high |
         * | taskId         | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                   |
         * | updatedById    | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                   |
         * | assigneeId     | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                   |
         * | assigneeName   | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                   |
         * | assigneeEmail  | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                   |
         * | createdByName  | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                   |
         * | createdByEmail | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                   |
         * | deadline       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                   |
         * | createdAt      | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                   |
         * | updatedAt      | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                   |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<SubtaskListDto, void>({
        path: `/tasks/${taskUuid}/subtasks`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subtask
     * @name SubtaskControllerFindOne
     * @request GET:/tasks/{taskUuid}/subtasks/{subtaskId}
     * @secure
     */
    subtaskControllerFindOne: (
      taskUuid: string,
      subtaskId: string,
      params: RequestParams = {}
    ) =>
      this.request<SubtaskDto, void>({
        path: `/tasks/${taskUuid}/subtasks/${subtaskId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subtask
     * @name SubtaskControllerUpdate
     * @request PUT:/tasks/{taskUuid}/subtasks/{subtaskId}
     * @secure
     */
    subtaskControllerUpdate: (
      taskUuid: string,
      subtaskId: string,
      data: UpdateSubtaskDto,
      params: RequestParams = {}
    ) =>
      this.request<SubtaskDto, void>({
        path: `/tasks/${taskUuid}/subtasks/${subtaskId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subtask
     * @name SubtaskControllerDeleteOne
     * @request DELETE:/tasks/{taskUuid}/subtasks/{subtaskId}
     * @secure
     */
    subtaskControllerDeleteOne: (
      taskUuid: string,
      subtaskId: string,
      params: RequestParams = {}
    ) =>
      this.request<DeleteResult, void>({
        path: `/tasks/${taskUuid}/subtasks/${subtaskId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Task Comment
     * @name TaskCommentControllerFindAll
     * @request GET:/tasks/{taskId}/comments
     * @secure
     */
    taskCommentControllerFindAll: (
      taskId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - comment
         * - taskId
         * - createdByName
         * - createdByEmail
         * - createdAt
         * - updatedAt
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key            | Type   | Allowed Rules                                                                | Possible Values |
         * | -------------- | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | id             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | comment        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | taskId         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdByName  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdByEmail | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdAt      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | updatedAt      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<TaskCommentListDto, void>({
        path: `/tasks/${taskId}/comments`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Task Comment
     * @name TaskCommentControllerCreate
     * @request POST:/tasks/{taskId}/comments
     * @secure
     */
    taskCommentControllerCreate: (
      taskId: string,
      data: CreateTaskCommentDto,
      params: RequestParams = {}
    ) =>
      this.request<TaskCommentDto, void>({
        path: `/tasks/${taskId}/comments`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  userSettings = {
    /**
     * No description
     *
     * @tags User Settings
     * @name UserSettingsControllerGetUserSettings
     * @summary Get user settings
     * @request GET:/user-settings
     * @secure
     */
    userSettingsControllerGetUserSettings: (params: RequestParams = {}) =>
      this.request<any, void | UserSettingsResponseDto>({
        path: `/user-settings`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Settings
     * @name UserSettingsControllerUpdateUserSettings
     * @summary Update user settings (partial update)
     * @request PATCH:/user-settings
     * @secure
     */
    userSettingsControllerUpdateUserSettings: (
      data: UpdateUserSettingsDto,
      params: RequestParams = {}
    ) =>
      this.request<any, void | UserSettingsResponseDto>({
        path: `/user-settings`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  team = {
    /**
     * No description
     *
     * @tags Team
     * @name TeamControllerFindAll
     * @request GET:/team
     * @secure
     */
    teamControllerFindAll: (
      query?: {
        /** Include team members in the response */
        withUsers?: boolean;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - name
         * - description
         * - subtitle
         * - createdAt
         * - updatedAt
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type   | Allowed Rules                                                                | Possible Values |
         * | ----------- | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | name        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | description | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subtitle    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdAt   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | updatedAt   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - name
         * - description
         * - subtitle
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<TeamListDto, void>({
        path: `/team`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Team
     * @name TeamControllerFindOne
     * @request GET:/team/{teamUuid}
     * @secure
     */
    teamControllerFindOne: (teamUuid: string, params: RequestParams = {}) =>
      this.request<TeamDto, void>({
        path: `/team/${teamUuid}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Team
     * @name TeamControllerGetMembers
     * @request GET:/team/{teamUuid}/members
     * @secure
     */
    teamControllerGetMembers: (
      teamUuid: string,
      query?: {
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - name
         * - emailAddress
         */
        searchTerm?: string;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - emailAddress
         * - surname
         * - contactPhoneNumber
         * - title
         * - userLoginStatus
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                | Type   | Allowed Rules                                                                | Possible Values |
         * | ------------------ | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | id                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | name               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | emailAddress       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | surname            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | contactPhoneNumber | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | title              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | userLoginStatus    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<TeamMemberListDto, void>({
        path: `/team/${teamUuid}/members`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Team
     * @name TeamControllerGetTaskCount
     * @request GET:/team/{teamUuid}/task-count
     * @secure
     */
    teamControllerGetTaskCount: (
      teamUuid: string,
      query?: {
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<TeamTaskCountDto, void>({
        path: `/team/${teamUuid}/task-count`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Team
     * @name TeamControllerUpdateTeamMembers
     * @request PATCH:/team/{teamUuid}/team-members
     * @secure
     */
    teamControllerUpdateTeamMembers: (
      teamUuid: string,
      data: UpdateTeamMembersDto,
      params: RequestParams = {}
    ) =>
      this.request<UpdateTeamMembersResponseDto, void>({
        path: `/team/${teamUuid}/team-members`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  contacts = {
    /**
     * No description
     *
     * @tags Contacts
     * @name ContactsControllerGetContact
     * @request GET:/contacts/{contactId}
     * @secure
     */
    contactsControllerGetContact: (
      contactId: string,
      params: RequestParams = {}
    ) =>
      this.request<ContactDto, void>({
        path: `/contacts/${contactId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contacts
     * @name ContactsControllerUpdateContact
     * @request PUT:/contacts/{contactId}
     * @secure
     */
    contactsControllerUpdateContact: (
      contactId: string,
      data: UpdateContactDto,
      params: RequestParams = {}
    ) =>
      this.request<ContactDto, void>({
        path: `/contacts/${contactId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contacts
     * @name ContactsControllerDeleteContact
     * @request DELETE:/contacts/{contactId}
     * @secure
     */
    contactsControllerDeleteContact: (
      contactId: string,
      params: RequestParams = {}
    ) =>
      this.request<ContactDto, void>({
        path: `/contacts/${contactId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  spendAndAnalysis = {
    /**
     * No description
     *
     * @tags SpendAndAnalysis
     * @name SpendAndAnalysisControllerGetOrganizationSavingsSummary
     * @request GET:/spend-and-analysis/{organizationId}/spend-areas-savings-spend
     * @secure
     */
    spendAndAnalysisControllerGetOrganizationSavingsSummary: (
      organizationId: string,
      query?: {
        /**
         * Optional array of spend areas to filter the results
         * @example ["Waste","Treasury"]
         */
        spendArea?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<SpendAreasSavingsSpendResponseDto, void>({
        path: `/spend-and-analysis/${organizationId}/spend-areas-savings-spend`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SpendAndAnalysis
     * @name SpendAndAnalysisControllerGetAnnualSavingsForSpendArea
     * @request GET:/spend-and-analysis/{organizationId}/annual-savings-for-spend-area
     * @secure
     */
    spendAndAnalysisControllerGetAnnualSavingsForSpendArea: (
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<AnnualSavingsForSpendAreaResponseDto, void>({
        path: `/spend-and-analysis/${organizationId}/annual-savings-for-spend-area`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SpendAndAnalysis
     * @name SpendAndAnalysisControllerGetVectorClientInfo
     * @request GET:/spend-and-analysis/vector-client-info/{id}
     * @secure
     */
    spendAndAnalysisControllerGetVectorClientInfo: (
      id: string,
      params: RequestParams = {}
    ) =>
      this.request<VectorClientInfoDto, void>({
        path: `/spend-and-analysis/vector-client-info/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  spendSavings = {
    /**
     * No description
     *
     * @tags Spend & Savings
     * @name SpendSavingsControllerGetSavingsSummary
     * @request GET:/spend-savings/{organizationId}/summary
     * @secure
     */
    spendSavingsControllerGetSavingsSummary: (
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<SavingSummaryResponseDto, void>({
        path: `/spend-savings/${organizationId}/summary`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Spend & Savings
     * @name SpendSavingsControllerGetOrganizationSpendAreasDetailsNew
     * @request GET:/spend-savings/{organizationId}/spend-areas-details
     * @secure
     */
    spendSavingsControllerGetOrganizationSpendAreasDetailsNew: (
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<SpendAreaDetailsDto, void>({
        path: `/spend-savings/${organizationId}/spend-areas-details`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Spend & Savings
     * @name SpendSavingsControllerGetSpendAreasOverview
     * @request GET:/spend-savings/{organizationId}/spend-areas-overview
     * @secure
     */
    spendSavingsControllerGetSpendAreasOverview: (
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<SpendAreasOverviewResponseDto, void>({
        path: `/spend-savings/${organizationId}/spend-areas-overview`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Spend & Savings
     * @name SpendSavingsControllerGetAnnualSavingsBreakdown
     * @request GET:/spend-savings/{organizationId}/annual-savings-breakdown
     * @secure
     */
    spendSavingsControllerGetAnnualSavingsBreakdown: (
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<AnnualSavingsBreakdownResponseDto, void>({
        path: `/spend-savings/${organizationId}/annual-savings-breakdown`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Spend & Savings
     * @name SpendSavingsControllerGetVectorClientInfo
     * @request GET:/spend-savings/{organizationId}/vector-client-info
     * @secure
     */
    spendSavingsControllerGetVectorClientInfo: (
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<VectorClientInfoResponseDto, void>({
        path: `/spend-savings/${organizationId}/vector-client-info`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  spendArea = {
    /**
     * No description
     *
     * @tags Spend Area
     * @name SpendAreaControllerGetSpendAreasOverview
     * @request GET:/spend-area/{organizationId}/overview
     * @secure
     */
    spendAreaControllerGetSpendAreasOverview: (
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<SpendAreasListResponseDto, void>({
        path: `/spend-area/${organizationId}/overview`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  spendCategories = {
    /**
     * No description
     *
     * @tags Spend Categories
     * @name SpendCategoryControllerFindAll
     * @request GET:/spend-categories
     * @secure
     */
    spendCategoryControllerFindAll: (
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - spendAreaId
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type   | Allowed Rules                                                                | Possible Values |
         * | ----------- | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | id          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | name        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | spendAreaId | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - name
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<SpendCategoryListDto, void>({
        path: `/spend-categories`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  tickets = {
    /**
     * No description
     *
     * @tags Ticket Files
     * @name TicketFilesControllerGetTicketFiles
     * @request GET:/tickets/{ticketId}/files
     * @secure
     */
    ticketFilesControllerGetTicketFiles: (
      ticketId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - filename
         * - createdAt
         * - updatedAt
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key       | Type   | Allowed Rules                                                                | Possible Values |
         * | --------- | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | filename  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdAt | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | updatedAt | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<TicketFileListDto, void>({
        path: `/tickets/${ticketId}/files`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ticket Files
     * @name TicketFilesControllerMoveToDocumentRepo
     * @request PUT:/tickets/{ticketId}/files/{fileId}/documents-repo/add
     * @secure
     */
    ticketFilesControllerMoveToDocumentRepo: (
      ticketId: string,
      fileId: string,
      params: RequestParams = {}
    ) =>
      this.request<string, void>({
        path: `/tickets/${ticketId}/files/${fileId}/documents-repo/add`,
        method: 'PUT',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ticket Files
     * @name TicketFilesControllerRemoveFromDocumentRepo
     * @request PUT:/tickets/{ticketId}/files/{fileId}/documents-repo/remove
     * @secure
     */
    ticketFilesControllerRemoveFromDocumentRepo: (
      ticketId: string,
      fileId: string,
      params: RequestParams = {}
    ) =>
      this.request<string, void>({
        path: `/tickets/${ticketId}/files/${fileId}/documents-repo/remove`,
        method: 'PUT',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ticket Files
     * @name TicketFilesControllerDeleteTicketFile
     * @request DELETE:/tickets/{ticketId}/files/{fileId}
     * @secure
     */
    ticketFilesControllerDeleteTicketFile: (
      ticketId: string,
      fileId: string,
      params: RequestParams = {}
    ) =>
      this.request<string, void>({
        path: `/tickets/${ticketId}/files/${fileId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tickets
     * @name TicketsControllerGetTickets
     * @request GET:/tickets
     * @secure
     */
    ticketsControllerGetTickets: (
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - vectorTicketId
         * - subject
         * - description
         * - status
         * - priority
         * - category
         * - subCategory
         * - vendorName
         * - location
         * - zip
         * - address
         * - city
         * - state
         * - subStatus
         * - assignee
         * - requestor
         * - assigneeEmail
         * - assigneeName
         * - requestorEmail
         * - requestorName
         * - organizationId
         * - organizationName
         * - vendorId
         * - ticketNumber
         * - commentsCount
         * - accessToExternalUser
         * - createdAt
         * - updatedAt
         * - dueDate
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                  | Type    | Allowed Rules                                                                | Possible Values |
         * | -------------------- | ------- | ---------------------------------------------------------------------------- | --------------- |
         * | id                   | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vectorTicketId       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subject              | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | description          | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | status               | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | priority             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | category             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subCategory          | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendorName           | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | location             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | zip                  | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | address              | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | city                 | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | state                | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subStatus            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assignee             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | requestor            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeEmail        | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeName         | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | requestorEmail       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | requestorName        | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organizationId       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organizationName     | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendorId             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | ticketNumber         | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | commentsCount        | number  | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | accessToExternalUser | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                 |
         * | createdAt            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | updatedAt            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | dueDate              | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - subject
         * - description
         * - category
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<TicketListDto, void>({
        path: `/tickets`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tickets
     * @name TicketsControllerExportTickets
     * @request GET:/tickets/export
     * @secure
     */
    ticketsControllerExportTickets: (
      query: {
        /** Column paths to export. Pass as repeated query params (preferred) or a JSON array string. Headers are auto-generated from keys. Example: columns=name&columns=status */
        columns: string[];
        /** Custom filename for the CSV download (without extension). */
        filename?: string;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - vectorTicketId
         * - subject
         * - description
         * - status
         * - priority
         * - category
         * - subCategory
         * - vendorName
         * - location
         * - zip
         * - address
         * - city
         * - state
         * - subStatus
         * - assignee
         * - requestor
         * - assigneeEmail
         * - assigneeName
         * - requestorEmail
         * - requestorName
         * - organizationId
         * - organizationName
         * - vendorId
         * - ticketNumber
         * - commentsCount
         * - accessToExternalUser
         * - createdAt
         * - updatedAt
         * - dueDate
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                  | Type    | Allowed Rules                                                                | Possible Values |
         * | -------------------- | ------- | ---------------------------------------------------------------------------- | --------------- |
         * | id                   | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vectorTicketId       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subject              | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | description          | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | status               | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | priority             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | category             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subCategory          | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendorName           | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | location             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | zip                  | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | address              | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | city                 | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | state                | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subStatus            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assignee             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | requestor            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeEmail        | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeName         | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | requestorEmail       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | requestorName        | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organizationId       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organizationName     | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendorId             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | ticketNumber         | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | commentsCount        | number  | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | accessToExternalUser | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                 |
         * | createdAt            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | updatedAt            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | dueDate              | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - subject
         * - description
         * - category
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<StreamableFile, void>({
        path: `/tickets/export`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tickets
     * @name TicketsControllerGetTicket
     * @request GET:/tickets/{ticketId}
     * @secure
     */
    ticketsControllerGetTicket: (
      ticketId: string,
      params: RequestParams = {}
    ) =>
      this.request<TicketDto, void>({
        path: `/tickets/${ticketId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tickets
     * @name TicketsControllerUpdateTicket
     * @request PUT:/tickets/{ticketId}
     * @secure
     */
    ticketsControllerUpdateTicket: (
      ticketId: string,
      data: UpdateTicketDto,
      params: RequestParams = {}
    ) =>
      this.request<TicketDto, void>({
        path: `/tickets/${ticketId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tickets
     * @name TicketsControllerPermanentlyDeleteTicket
     * @request DELETE:/tickets/{ticketId}
     * @secure
     */
    ticketsControllerPermanentlyDeleteTicket: (
      ticketId: string,
      params: RequestParams = {}
    ) =>
      this.request<MessageResponseDto, void>({
        path: `/tickets/${ticketId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tickets
     * @name TicketsControllerGetTicketCounts
     * @request GET:/tickets/{ticketId}/counts
     * @secure
     */
    ticketsControllerGetTicketCounts: (
      ticketId: string,
      params: RequestParams = {}
    ) =>
      this.request<TicketCountsDto, void>({
        path: `/tickets/${ticketId}/counts`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ticket Comments
     * @name TicketsCommentsControllerCreateComment
     * @request POST:/tickets/{ticketId}/comments
     * @secure
     */
    ticketsCommentsControllerCreateComment: (
      ticketId: string,
      data: CreateTicketCommentDto,
      params: RequestParams = {}
    ) =>
      this.request<CreateTicketCommentResponseDto, void>({
        path: `/tickets/${ticketId}/comments`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ticket Comments
     * @name TicketsCommentsControllerGetCommentsByTicketId
     * @request GET:/tickets/{ticketId}/comments
     * @secure
     */
    ticketsCommentsControllerGetCommentsByTicketId: (
      ticketId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - comment
         * - scope
         * - createdAt
         * - updatedAt
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key       | Type   | Allowed Rules                                                                | Possible Values    |
         * | --------- | ------ | ---------------------------------------------------------------------------- | ------------------ |
         * | comment   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                    |
         * | scope     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | internal, external |
         * | createdAt | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                    |
         * | updatedAt | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                    |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - comment
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<TicketCommentListDto, void>({
        path: `/tickets/${ticketId}/comments`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ticket Comments
     * @name TicketsCommentsControllerDeleteComment
     * @request DELETE:/tickets/{ticketId}/comments/{commentId}
     * @secure
     */
    ticketsCommentsControllerDeleteComment: (
      ticketId: string,
      commentId: string,
      params: RequestParams = {}
    ) =>
      this.request<MessageResponseDto, void>({
        path: `/tickets/${ticketId}/comments/${commentId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ticket Grouping
     * @name TicketGroupingControllerGroupByOrganization
     * @request GET:/tickets/group/organization
     * @secure
     */
    ticketGroupingControllerGroupByOrganization: (
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - ticketCount
         * - status
         * - priority
         * - category
         * - vendorName
         * - assignee
         * - requestor
         * - assigneeEmail
         * - assigneeName
         * - requestorEmail
         * - requestorName
         * - organizationId
         * - organizationName
         * - vendorId
         * - commentsCount
         * - createdAt
         * - updatedAt
         * - dueDate
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                  | Type    | Allowed Rules                                                                | Possible Values |
         * | -------------------- | ------- | ---------------------------------------------------------------------------- | --------------- |
         * | id                   | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vectorTicketId       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subject              | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | description          | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | status               | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | priority             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | category             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subCategory          | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendorName           | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | location             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | zip                  | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | address              | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | city                 | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | state                | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subStatus            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assignee             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | requestor            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeEmail        | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeName         | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | requestorEmail       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | requestorName        | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organizationId       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organizationName     | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendorId             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | ticketNumber         | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | commentsCount        | number  | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | accessToExternalUser | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                 |
         * | createdAt            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | updatedAt            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | dueDate              | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - subject
         * - description
         * - category
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<OrganizationTicketCountListDto, void>({
        path: `/tickets/group/organization`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ticket Grouping
     * @name TicketGroupingControllerGroupByAssignee
     * @request GET:/tickets/group/assignee
     * @secure
     */
    ticketGroupingControllerGroupByAssignee: (
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - ticketCount
         * - status
         * - priority
         * - category
         * - vendorName
         * - assignee
         * - requestor
         * - assigneeEmail
         * - assigneeName
         * - requestorEmail
         * - requestorName
         * - organizationId
         * - organizationName
         * - vendorId
         * - commentsCount
         * - createdAt
         * - updatedAt
         * - dueDate
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                  | Type    | Allowed Rules                                                                | Possible Values |
         * | -------------------- | ------- | ---------------------------------------------------------------------------- | --------------- |
         * | id                   | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vectorTicketId       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subject              | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | description          | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | status               | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | priority             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | category             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subCategory          | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendorName           | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | location             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | zip                  | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | address              | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | city                 | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | state                | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subStatus            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assignee             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | requestor            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeEmail        | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeName         | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | requestorEmail       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | requestorName        | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organizationId       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organizationName     | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendorId             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | ticketNumber         | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | commentsCount        | number  | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | accessToExternalUser | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                 |
         * | createdAt            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | updatedAt            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | dueDate              | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - subject
         * - description
         * - category
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<AssigneeTicketGroupingListDto, void>({
        path: `/tickets/group/assignee`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ticket Grouping
     * @name TicketGroupingControllerGroupByStatus
     * @request GET:/tickets/group/status
     * @secure
     */
    ticketGroupingControllerGroupByStatus: (
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - ticketCount
         * - status
         * - priority
         * - category
         * - vendorName
         * - assignee
         * - requestor
         * - assigneeEmail
         * - assigneeName
         * - requestorEmail
         * - requestorName
         * - organizationId
         * - organizationName
         * - vendorId
         * - commentsCount
         * - createdAt
         * - updatedAt
         * - dueDate
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                  | Type    | Allowed Rules                                                                | Possible Values |
         * | -------------------- | ------- | ---------------------------------------------------------------------------- | --------------- |
         * | id                   | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vectorTicketId       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subject              | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | description          | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | status               | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | priority             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | category             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subCategory          | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendorName           | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | location             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | zip                  | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | address              | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | city                 | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | state                | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subStatus            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assignee             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | requestor            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeEmail        | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeName         | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | requestorEmail       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | requestorName        | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organizationId       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organizationName     | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendorId             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | ticketNumber         | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | commentsCount        | number  | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | accessToExternalUser | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                 |
         * | createdAt            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | updatedAt            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | dueDate              | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - subject
         * - description
         * - category
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<any, void | StatusTicketGroupingListDto>({
        path: `/tickets/group/status`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ticket Grouping
     * @name TicketGroupingControllerGroupByCatgory
     * @request GET:/tickets/group/category
     * @secure
     */
    ticketGroupingControllerGroupByCatgory: (
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - ticketCount
         * - status
         * - priority
         * - category
         * - vendorName
         * - assignee
         * - requestor
         * - assigneeEmail
         * - assigneeName
         * - requestorEmail
         * - requestorName
         * - organizationId
         * - organizationName
         * - vendorId
         * - commentsCount
         * - createdAt
         * - updatedAt
         * - dueDate
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                  | Type    | Allowed Rules                                                                | Possible Values |
         * | -------------------- | ------- | ---------------------------------------------------------------------------- | --------------- |
         * | id                   | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vectorTicketId       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subject              | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | description          | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | status               | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | priority             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | category             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subCategory          | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendorName           | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | location             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | zip                  | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | address              | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | city                 | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | state                | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subStatus            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assignee             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | requestor            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeEmail        | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeName         | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | requestorEmail       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | requestorName        | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organizationId       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organizationName     | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendorId             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | ticketNumber         | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | commentsCount        | number  | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | accessToExternalUser | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                 |
         * | createdAt            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | updatedAt            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | dueDate              | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - subject
         * - description
         * - category
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<any, void | CategoryTicketGroupingListDto>({
        path: `/tickets/group/category`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags TicketHistory
     * @name TicketHistoryControllerFindAllChangeLogs
     * @request GET:/tickets/{ticketId}/versions/changelogs
     * @secure
     */
    ticketHistoryControllerFindAllChangeLogs: (
      ticketId: string,
      query?: {
        /**
         * Current page number (1-based)
         * @min 1
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @min 1
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
        /** Order of the changelog feed by change date. Defaults to newest first. */
        sortDirection?: SortDirection;
      },
      params: RequestParams = {}
    ) =>
      this.request<TicketVersionChangelogList, void>({
        path: `/tickets/${ticketId}/versions/changelogs`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags TicketHistory
     * @name TicketHistoryControllerFindVersionSnapshot
     * @request GET:/tickets/{ticketId}/versions/{versionId}
     * @secure
     */
    ticketHistoryControllerFindVersionSnapshot: (
      ticketId: string,
      versionId: string,
      params: RequestParams = {}
    ) =>
      this.request<TicketVersionSnapshotDto, void>({
        path: `/tickets/${ticketId}/versions/${versionId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  vendorContracts = {
    /**
     * No description
     *
     * @tags Vendor Contracts
     * @name VendorContractsControllerFindAll
     * @request GET:/vendor-contracts
     * @secure
     */
    vendorContractsControllerFindAll: (
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - vendor
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key    | Type   | Allowed Rules                                                                | Possible Values |
         * | ------ | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | vendor | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<VendorContractListDto, void>({
        path: `/vendor-contracts`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vendor Contracts
     * @name VendorContractsControllerCreate
     * @request POST:/vendor-contracts
     * @secure
     */
    vendorContractsControllerCreate: (
      data: CreateVendorContractDto,
      params: RequestParams = {}
    ) =>
      this.request<VendorContractItemDto, void>({
        path: `/vendor-contracts`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  preference = {
    /**
     * No description
     *
     * @tags Preferences
     * @name PreferenceControllerUpsertPreferences
     * @request PUT:/preference/{key}
     * @secure
     */
    preferenceControllerUpsertPreferences: (
      key: string,
      query: {
        /** @example "user" */
        type: PreferenceControllerUpsertPreferencesParamsTypeEnum;
        organizationId?: string;
        key: string;
      },
      data: UpsertPreferenceBodyDto,
      params: RequestParams = {}
    ) =>
      this.request<PreferenceDto, void>({
        path: `/preference/${key}`,
        method: 'PUT',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Preferences
     * @name PreferenceControllerGetPreferences
     * @request GET:/preference
     * @secure
     */
    preferenceControllerGetPreferences: (
      query?: {
        /** @example "user" */
        type?: PreferenceControllerGetPreferencesParamsTypeEnum;
        organizationId?: string;
        key?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<PreferenceListDto, void>({
        path: `/preference`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  sibServices = {
    /**
     * No description
     *
     * @tags Internal Portal - SIB Services
     * @name SibServicesControllerListCatalogue
     * @request GET:/sib-services
     * @secure
     */
    sibServicesControllerListCatalogue: (params: RequestParams = {}) =>
      this.request<SibServiceCatalogueItemDto[], void>({
        path: `/sib-services`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - SIB Services
     * @name SibServicesControllerListSpendCategoryCatalogue
     * @request GET:/sib-services/catalogue/spend-categories
     * @secure
     */
    sibServicesControllerListSpendCategoryCatalogue: (
      params: RequestParams = {}
    ) =>
      this.request<SpendCategoryCatalogueItemDto[], void>({
        path: `/sib-services/catalogue/spend-categories`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - SIB Services
     * @name SibServicesControllerUpdateCatalogueEntry
     * @request PATCH:/sib-services/{itemId}
     * @secure
     */
    sibServicesControllerUpdateCatalogueEntry: (
      itemId: string,
      data: CadenceDto,
      params: RequestParams = {}
    ) =>
      this.request<SibServiceCatalogueItemDto, void>({
        path: `/sib-services/${itemId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  revenue = {
    /**
     * @description Use `GET /revenue/organizations`.
     *
     * @tags Internal Portal - SIB Revenue
     * @name RevenueControllerByOrganization
     * @request GET:/revenue
     * @deprecated
     * @secure
     */
    revenueControllerByOrganization: (
      query?: {
        /** First day of the window. Omit with `to` for all time. */
        from?: string;
        /** Last day of the window. Omit with `from` for all time. */
        to?: string;
        /** Also count billings scheduled ahead and not yet revealed: fee periods and savings shares more than a week before their billing date. */
        includeProjected?: boolean;
        /** Also count spend that has not passed initial validation in expected savings. */
        includeNotValidated?: boolean;
        /** Also revenue no synced SIB contract backs. Defaults to true; false counts only revenue a contract backs. */
        includeWithoutContract?: boolean;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - organizationName
         * - netsuiteOnly
         * - total
         * - savingsShare
         * - fee
         * - earnedOnContracts
         * - expectedFee
         * - expectedContractValidated
         * - expectedContractTotal
         * - estimatedTcvForWindow
         * - estimatedTcv
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key              | Type    | Allowed Rules                                                                | Possible Values |
         * | ---------------- | ------- | ---------------------------------------------------------------------------- | --------------- |
         * | organizationName | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | netsuiteOnly     | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - organizationName
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<OrganizationRevenueDto[], void>({
        path: `/revenue`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - SIB Revenue
     * @name RevenueControllerOrganizations
     * @request GET:/revenue/organizations
     * @secure
     */
    revenueControllerOrganizations: (
      query?: {
        /** First day of the window. Omit with `to` for all time. */
        from?: string;
        /** Last day of the window. Omit with `from` for all time. */
        to?: string;
        /** Also count billings scheduled ahead and not yet revealed: fee periods and savings shares more than a week before their billing date. */
        includeProjected?: boolean;
        /** Also count spend that has not passed initial validation in expected savings. */
        includeNotValidated?: boolean;
        /** Also revenue no synced SIB contract backs. Defaults to true; false counts only revenue a contract backs. */
        includeWithoutContract?: boolean;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - organizationName
         * - netsuiteOnly
         * - total
         * - savingsShare
         * - fee
         * - earnedOnContracts
         * - expectedFee
         * - expectedContractValidated
         * - expectedContractTotal
         * - estimatedTcvForWindow
         * - estimatedTcv
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key              | Type    | Allowed Rules                                                                | Possible Values |
         * | ---------------- | ------- | ---------------------------------------------------------------------------- | --------------- |
         * | organizationName | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | netsuiteOnly     | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - organizationName
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<OrganizationRevenueListDto, void>({
        path: `/revenue/organizations`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - SIB Revenue
     * @name RevenueControllerOrganizationSources
     * @request GET:/revenue/organizations/{organizationId}/sources
     * @secure
     */
    revenueControllerOrganizationSources: (
      organizationId: string,
      query?: {
        /** First day of the window. Omit with `to` for all time. */
        from?: string;
        /** Last day of the window. Omit with `from` for all time. */
        to?: string;
        /** Also count billings scheduled ahead and not yet revealed: fee periods and savings shares more than a week before their billing date. */
        includeProjected?: boolean;
        /** Also count spend that has not passed initial validation in expected savings. */
        includeNotValidated?: boolean;
        /** Also revenue no synced SIB contract backs. Defaults to true; false counts only revenue a contract backs. */
        includeWithoutContract?: boolean;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - name
         * - revenueType
         * - organizationName
         * - netsuiteOnly
         * - amount
         * - expectedAmount
         * - billingCount
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key              | Type    | Allowed Rules                                                                | Possible Values    |
         * | ---------------- | ------- | ---------------------------------------------------------------------------- | ------------------ |
         * | name             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                    |
         * | revenueType      | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | savings_share, fee |
         * | organizationName | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                    |
         * | netsuiteOnly     | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                    |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - groupName
         * - organizationName
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<RevenueReportDto, void>({
        path: `/revenue/organizations/${organizationId}/sources`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - SIB Revenue
     * @name RevenueControllerSources
     * @request GET:/revenue/sources
     * @secure
     */
    revenueControllerSources: (
      query?: {
        /** First day of the window. Omit with `to` for all time. */
        from?: string;
        /** Last day of the window. Omit with `from` for all time. */
        to?: string;
        /** Also count billings scheduled ahead and not yet revealed: fee periods and savings shares more than a week before their billing date. */
        includeProjected?: boolean;
        /** Also count spend that has not passed initial validation in expected savings. */
        includeNotValidated?: boolean;
        /** Also revenue no synced SIB contract backs. Defaults to true; false counts only revenue a contract backs. */
        includeWithoutContract?: boolean;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - name
         * - revenueType
         * - organizationName
         * - netsuiteOnly
         * - amount
         * - expectedAmount
         * - billingCount
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key              | Type    | Allowed Rules                                                                | Possible Values    |
         * | ---------------- | ------- | ---------------------------------------------------------------------------- | ------------------ |
         * | name             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                    |
         * | revenueType      | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | savings_share, fee |
         * | organizationName | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                    |
         * | netsuiteOnly     | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                    |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - groupName
         * - organizationName
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<RevenueReportDto, void>({
        path: `/revenue/sources`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - SIB Revenue
     * @name RevenueControllerSourceOrganizations
     * @request GET:/revenue/sources/{sourceId}/organizations
     * @secure
     */
    revenueControllerSourceOrganizations: (
      sourceId: string,
      query?: {
        /** First day of the window. Omit with `to` for all time. */
        from?: string;
        /** Last day of the window. Omit with `from` for all time. */
        to?: string;
        /** Also count billings scheduled ahead and not yet revealed: fee periods and savings shares more than a week before their billing date. */
        includeProjected?: boolean;
        /** Also count spend that has not passed initial validation in expected savings. */
        includeNotValidated?: boolean;
        /** Also revenue no synced SIB contract backs. Defaults to true; false counts only revenue a contract backs. */
        includeWithoutContract?: boolean;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - name
         * - revenueType
         * - organizationName
         * - netsuiteOnly
         * - amount
         * - expectedAmount
         * - billingCount
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key              | Type    | Allowed Rules                                                                | Possible Values    |
         * | ---------------- | ------- | ---------------------------------------------------------------------------- | ------------------ |
         * | name             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                    |
         * | revenueType      | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | savings_share, fee |
         * | organizationName | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                    |
         * | netsuiteOnly     | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                    |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - groupName
         * - organizationName
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<RevenueGroupListDto, void>({
        path: `/revenue/sources/${sourceId}/organizations`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Use `GET /revenue/sources`, `GET /revenue/organizations/:organizationId/sources` or `GET /revenue/sources/:sourceId/organizations`.
     *
     * @tags Internal Portal - SIB Revenue
     * @name RevenueControllerGroups
     * @request GET:/revenue/groups
     * @deprecated
     * @secure
     */
    revenueControllerGroups: (
      query: {
        /** Add up per SIB service and spend category, or per organization. */
        by: RevenueGrouping;
        /** Only this organization's revenue. */
        organizationId?: string;
        /** With groupId, only one SIB service or spend category. */
        revenueType?: RevenueType;
        /** The SIB service of a fee, or the spend category of a savings share. Absent: one with neither. */
        groupId?: string;
        /** First day of the window. Omit with `to` for all time. */
        from?: string;
        /** Last day of the window. Omit with `from` for all time. */
        to?: string;
        /** Also count billings scheduled ahead and not yet revealed: fee periods and savings shares more than a week before their billing date. */
        includeProjected?: boolean;
        /** Also count spend that has not passed initial validation in expected savings. */
        includeNotValidated?: boolean;
        /** Also revenue no synced SIB contract backs. Defaults to true; false counts only revenue a contract backs. */
        includeWithoutContract?: boolean;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - name
         * - revenueType
         * - organizationName
         * - netsuiteOnly
         * - amount
         * - expectedAmount
         * - billingCount
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key              | Type    | Allowed Rules                                                                | Possible Values    |
         * | ---------------- | ------- | ---------------------------------------------------------------------------- | ------------------ |
         * | name             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                    |
         * | revenueType      | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | savings_share, fee |
         * | organizationName | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                    |
         * | netsuiteOnly     | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                    |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - groupName
         * - organizationName
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<RevenueGroupDto[], void>({
        path: `/revenue/groups`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  notifications = {
    /**
     * No description
     *
     * @tags Notifications
     * @name NotificationControllerFindAll
     * @request GET:/notifications
     * @secure
     */
    notificationControllerFindAll: (
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - type
         * - priority
         * - description
         * - seenAt
         * - createdAt
         * - updatedAt
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type   | Allowed Rules                                                                | Possible Values                                                                                                                                                                                                                                                                                                     |
         * | ----------- | ------ | ---------------------------------------------------------------------------- | ------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- |
         * | type        | object |                                                                              | document_uploaded, task_completed, task_assigned, task_unassigned, task_edited, task_tagged, action_item_created, action_item_assigned, action_item_deadline_approaching, action_item_overdue, ticket_created, ticket_comment_added, ticket_status_changed, spend_area_requested, user_invited, contract_expiration |
         * | priority    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | success, error, warning, info                                                                                                                                                                                                                                                                                       |
         * | description | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                                                                                                                                                                                                                                     |
         * | seenAt      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                                                                                                                                                                                                                                     |
         * | createdAt   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                                                                                                                                                                                                                                     |
         * | updatedAt   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                                                                                                                                                                                                                                     |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - title
         * - description
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<NotificationListDto, void>({
        path: `/notifications`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notifications
     * @name NotificationControllerUpdate
     * @request PATCH:/notifications/{id}
     * @secure
     */
    notificationControllerUpdate: (
      id: string,
      data: UpdateNotificationDto,
      params: RequestParams = {}
    ) =>
      this.request<NotificationDto, void>({
        path: `/notifications/${id}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notifications
     * @name NotificationControllerGetCount
     * @request GET:/notifications/count
     * @secure
     */
    notificationControllerGetCount: (
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - type
         * - priority
         * - description
         * - seenAt
         * - createdAt
         * - updatedAt
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type   | Allowed Rules                                                                | Possible Values                                                                                                                                                                                                                                                                                                     |
         * | ----------- | ------ | ---------------------------------------------------------------------------- | ------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- |
         * | type        | object |                                                                              | document_uploaded, task_completed, task_assigned, task_unassigned, task_edited, task_tagged, action_item_created, action_item_assigned, action_item_deadline_approaching, action_item_overdue, ticket_created, ticket_comment_added, ticket_status_changed, spend_area_requested, user_invited, contract_expiration |
         * | priority    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | success, error, warning, info                                                                                                                                                                                                                                                                                       |
         * | description | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                                                                                                                                                                                                                                     |
         * | seenAt      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                                                                                                                                                                                                                                     |
         * | createdAt   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                                                                                                                                                                                                                                     |
         * | updatedAt   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                                                                                                                                                                                                                                     |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - title
         * - description
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<NotificationCountDto, void>({
        path: `/notifications/count`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Establishes a continuous SSE stream. **Note:** Swagger UI will keep loading indefinitely, because SSE does not close the connection.
     *
     * @tags Notifications (SSE)
     * @name NotificationSSeControllerSubscribe
     * @summary Subscribe to SSE notifications
     * @request GET:/notifications/{userId}
     * @secure
     */
    notificationSSeControllerSubscribe: (
      userId: string,
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/notifications/${userId}`,
        method: 'GET',
        secure: true,
        ...params,
      }),
  };
  recurringTask = {
    /**
     * No description
     *
     * @tags Recurring Task
     * @name RecurringTaskControllerCreateRecurringTask
     * @request POST:/recurring-task
     * @secure
     */
    recurringTaskControllerCreateRecurringTask: (
      data: CreateRecurringTaskDto,
      params: RequestParams = {}
    ) =>
      this.request<RecurringTaskDto, void>({
        path: `/recurring-task`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Recurring Task
     * @name RecurringTaskControllerFindAll
     * @request GET:/recurring-task
     * @secure
     */
    recurringTaskControllerFindAll: (
      query?: {
        searchTerm?: string;
        userId?: string;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - title
         * - description
         * - priorityLevel
         * - category
         * - referenceLink
         * - referenceName
         * - organizationId
         * - vendorId
         * - timeToComplete
         * - timeToCompleteAmount
         * - estimatedTime
         * - createdAt
         * - updatedAt
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                  | Type   | Allowed Rules                                                                | Possible Values                                                                                                                                                                      |
         * | -------------------- | ------ | ---------------------------------------------------------------------------- | ------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------ |
         * | title                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                                                                                                      |
         * | description          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                                                                                                      |
         * | priorityLevel        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | low, medium, high                                                                                                                                                                    |
         * | category             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | Vendor Call, Client Call, Internal outreach, Vendor email, Client email, Data analysis, Report build, Data gathering, Invoice Collection, Research, Proactive Client Outreach, Other |
         * | referenceLink        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                                                                                                      |
         * | referenceName        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                                                                                                      |
         * | organizationId       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                                                                                                      |
         * | vendorId             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                                                                                                      |
         * | timeToComplete       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | day, week, month                                                                                                                                                                     |
         * | timeToCompleteAmount | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                                                                                                                      |
         * | estimatedTime        | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                                                                                                                      |
         * | createdAt            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                                                                                                      |
         * | updatedAt            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                                                                                                      |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<RecurringTaskListDto, void>({
        path: `/recurring-task`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Recurring Task
     * @name RecurringTaskControllerExportRecurringTasks
     * @request GET:/recurring-task/export
     * @secure
     */
    recurringTaskControllerExportRecurringTasks: (
      query: {
        searchTerm?: string;
        userId?: string;
        /** Column paths to export. Pass as repeated query params (preferred) or a JSON array string. Headers are auto-generated from keys. Example: columns=name&columns=status */
        columns: string[];
        /** Custom filename for the CSV download (without extension). */
        filename?: string;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - title
         * - description
         * - priorityLevel
         * - category
         * - referenceLink
         * - referenceName
         * - organizationId
         * - vendorId
         * - timeToComplete
         * - timeToCompleteAmount
         * - estimatedTime
         * - createdAt
         * - updatedAt
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                  | Type   | Allowed Rules                                                                | Possible Values                                                                                                                                                                      |
         * | -------------------- | ------ | ---------------------------------------------------------------------------- | ------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------ |
         * | title                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                                                                                                      |
         * | description          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                                                                                                      |
         * | priorityLevel        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | low, medium, high                                                                                                                                                                    |
         * | category             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | Vendor Call, Client Call, Internal outreach, Vendor email, Client email, Data analysis, Report build, Data gathering, Invoice Collection, Research, Proactive Client Outreach, Other |
         * | referenceLink        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                                                                                                      |
         * | referenceName        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                                                                                                      |
         * | organizationId       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                                                                                                      |
         * | vendorId             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                                                                                                      |
         * | timeToComplete       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | day, week, month                                                                                                                                                                     |
         * | timeToCompleteAmount | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                                                                                                                      |
         * | estimatedTime        | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                                                                                                                      |
         * | createdAt            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                                                                                                      |
         * | updatedAt            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                                                                                                      |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<StreamableFile, void>({
        path: `/recurring-task/export`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Recurring Task
     * @name RecurringTaskControllerGetRecurringTaskNextOccurrences
     * @request GET:/recurring-task/{id}/preview
     * @secure
     */
    recurringTaskControllerGetRecurringTaskNextOccurrences: (
      id: string,
      query: {
        limit: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<Date[], void>({
        path: `/recurring-task/${id}/preview`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Recurring Task
     * @name RecurringTaskControllerFindOne
     * @request GET:/recurring-task/{id}
     * @secure
     */
    recurringTaskControllerFindOne: (id: string, params: RequestParams = {}) =>
      this.request<RecurringTaskDto, void>({
        path: `/recurring-task/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Recurring Task
     * @name RecurringTaskControllerUpdate
     * @request PATCH:/recurring-task/{id}
     * @secure
     */
    recurringTaskControllerUpdate: (
      id: string,
      data: UpdateRecurringTaskDto,
      params: RequestParams = {}
    ) =>
      this.request<RecurringTaskDto, void>({
        path: `/recurring-task/${id}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Recurring Task
     * @name RecurringTaskControllerDeleteOne
     * @request DELETE:/recurring-task/{id}
     * @secure
     */
    recurringTaskControllerDeleteOne: (
      id: string,
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/recurring-task/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  };
  member = {
    /**
     * No description
     *
     * @tags Member
     * @name MemberControllerFindUsersWithTaskByOrganization
     * @request GET:/member/{organizationId}
     * @secure
     */
    memberControllerFindUsersWithTaskByOrganization: (
      organizationId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - emailAddress
         * - surname
         * - contactPhoneNumber
         * - title
         * - userLoginStatus
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                | Type   | Allowed Rules                                                                | Possible Values |
         * | ------------------ | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | id                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | name               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | emailAddress       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | surname            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | contactPhoneNumber | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | title              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | userLoginStatus    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - name
         * - emailAddress
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<MemberListDto, void>({
        path: `/member/${organizationId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member
     * @name MemberControllerGetOrganizationMembersSummary
     * @request GET:/member/organizations/summary
     * @secure
     */
    memberControllerGetOrganizationMembersSummary: (
      query?: {
        type?: OrganizationSpecialFilter;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key  | Type   | Allowed Rules                                                                | Possible Values |
         * | ---- | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | id   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | name | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<OrganizationSummaryWithCountsListDto, void>({
        path: `/member/organizations/summary`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member
     * @name MemberControllerGetOrganizationMembersSummaryByActiveTasks
     * @request GET:/member/organizations/summary/active-tasks
     * @secure
     */
    memberControllerGetOrganizationMembersSummaryByActiveTasks: (
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key  | Type   | Allowed Rules                                                                | Possible Values |
         * | ---- | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | id   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | name | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<OrganizationSummaryWithMyActiveTasksCountListDto, void>({
        path: `/member/organizations/summary/active-tasks`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member
     * @name MemberControllerGetOrganizationMembersSummaryActionItems
     * @request GET:/member/organizations/summary/action-items
     * @secure
     */
    memberControllerGetOrganizationMembersSummaryActionItems: (
      query?: {
        myOrganizations?: boolean;
        searchTerm?: string;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - completedAt
         * - actionItem.completedAt
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                    | Type   | Allowed Rules                                                                | Possible Values |
         * | ---------------------- | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | id                     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | name                   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | completedAt            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | actionItem.completedAt | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<OrganizationSummaryWithActionItemsCountListDto, void>({
        path: `/member/organizations/summary/action-items`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  user = {
    /**
     * No description
     *
     * @tags User
     * @name UsersControllerGetCurrentUser
     * @request GET:/user/current
     * @secure
     */
    usersControllerGetCurrentUser: (params: RequestParams = {}) =>
      this.request<CurrentUserDto, void>({
        path: `/user/current`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UsersControllerGetUserOrganizations
     * @request GET:/user/organizations
     * @secure
     */
    usersControllerGetUserOrganizations: (
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - createdAt
         * - updatedAt
         * - micrositesEnabled
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key               | Type    | Allowed Rules                                                                | Possible Values |
         * | ----------------- | ------- | ---------------------------------------------------------------------------- | --------------- |
         * | id                | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | name              | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdAt         | date    | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty   |                 |
         * | updatedAt         | date    | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty   |                 |
         * | micrositesEnabled | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                 |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<PlainOrganizationListDto, void>({
        path: `/user/organizations`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Access Share
     * @name AccessShareControllerDeleteInvitedUser
     * @request DELETE:/user/invited-users/{userId}
     * @secure
     */
    accessShareControllerDeleteInvitedUser: (
      userId: string,
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/user/invited-users/${userId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Access Share
     * @name AccessShareControllerInviteUsersDeprecated
     * @summary Use organization/:organizationId/invite instead
     * @request POST:/user/{organizationId}/invite
     * @deprecated
     * @secure
     */
    accessShareControllerInviteUsersDeprecated: (
      organizationId: string,
      data: InviteUserBodyDto,
      params: RequestParams = {}
    ) =>
      this.request<InviteUserResponseDto, void>({
        path: `/user/${organizationId}/invite`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Access Share
     * @name AccessShareControllerResendInvitationDeprecated
     * @summary Use organization/:organizationId/invited-users/:userId/resend-invitation instead
     * @request POST:/user/invited-users/{userId}/resend-invitation
     * @deprecated
     * @secure
     */
    accessShareControllerResendInvitationDeprecated: (
      userId: string,
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/user/invited-users/${userId}/resend-invitation`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AI Agent Integration - Users
     * @name UsersControllerHasUserAccessDeprecated
     * @request GET:/user/{userId}/organizations/{organizationId}
     * @secure
     */
    usersControllerHasUserAccessDeprecated: (
      userId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/user/${userId}/organizations/${organizationId}`,
        method: 'GET',
        secure: true,
        ...params,
      }),
  };
  organizationId = {
    /**
     * No description
     *
     * @tags Organization Audits
     * @name OrganizationAuditsControllerGetAllAuditsByOrganizationId
     * @request GET:/{organizationId}/audits
     * @secure
     */
    organizationAuditsControllerGetAllAuditsByOrganizationId: (
      organizationId: string,
      query?: {
        /**
         * Current page number (1-based)
         * @min 1
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @min 1
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
        /** Search by audit name or related fields */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<ExtensionAuditsListDto, void>({
        path: `/${organizationId}/audits`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SubauditVersions
     * @name SubauditVersionsControllerFindAllChangeLogs
     * @request GET:/{organizationId}/subaudit/{subauditId}/versions/changelogs
     * @secure
     */
    subauditVersionsControllerFindAllChangeLogs: (
      subauditId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<SubauditVersionChangelogList, void>({
        path: `/${organizationId}/subaudit/${subauditId}/versions/changelogs`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Document Tags
     * @name DocumentTagsControllerFindAll
     * @request GET:/{organizationId}/document-tags
     * @secure
     */
    documentTagsControllerFindAll: (
      organizationId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - name
         * - createdAt
         * - updatedAt
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key       | Type   | Allowed Rules                                                                | Possible Values |
         * | --------- | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | name      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdAt | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | updatedAt | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<DocumentTagsListDto, void>({
        path: `/${organizationId}/document-tags`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Document Tags
     * @name DocumentTagsControllerCreate
     * @request POST:/{organizationId}/document-tags
     * @secure
     */
    documentTagsControllerCreate: (
      organizationId: string,
      data: CreateDocumentTagDto,
      params: RequestParams = {}
    ) =>
      this.request<DocumentTagDto, void>({
        path: `/${organizationId}/document-tags`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Document Tags
     * @name DocumentTagsControllerFindOne
     * @request GET:/{organizationId}/document-tags/{uuid}
     * @secure
     */
    documentTagsControllerFindOne: (
      uuid: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<DocumentTagDto, void>({
        path: `/${organizationId}/document-tags/${uuid}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Document Tags
     * @name DocumentTagsControllerUpdate
     * @request PATCH:/{organizationId}/document-tags/{uuid}
     * @secure
     */
    documentTagsControllerUpdate: (
      uuid: string,
      organizationId: string,
      data: UpdateDocumentTagDto,
      params: RequestParams = {}
    ) =>
      this.request<DocumentTagDto, void>({
        path: `/${organizationId}/document-tags/${uuid}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Document Tags
     * @name DocumentTagsControllerDeleteOne
     * @request DELETE:/{organizationId}/document-tags/{uuid}
     * @secure
     */
    documentTagsControllerDeleteOne: (
      uuid: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<DocumentTagDto, void>({
        path: `/${organizationId}/document-tags/${uuid}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  siteList = {
    /**
     * No description
     *
     * @tags SiteList
     * @name SiteListControllerGetOrganizationSavingsSummary
     * @request GET:/site-list/{organizationId}/locations-list
     * @secure
     */
    siteListControllerGetOrganizationSavingsSummary: (
      organizationId: string,
      query?: {
        /** Start date for filtering savings/spend (YYYY-MM-DD) */
        startOfSavingsPeriod?: string;
        /** End date for filtering savings/spend (YYYY-MM-DD) */
        endOfSavingsPeriod?: string;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - address
         * - city
         * - state
         * - zip
         * - taxId
         * - phone
         * - kind
         * - status
         * - documentFieldStatus
         * - locationIdentifier
         * - name
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                 | Type   | Allowed Rules                                                                | Possible Values                                                                     |
         * | ------------------- | ------ | ---------------------------------------------------------------------------- | ----------------------------------------------------------------------------------- |
         * | id                  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | address             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | city                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | state               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | zip                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | taxId               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | phone               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | kind                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | site, organization_wide                                                             |
         * | status              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | Active, Monitored, Sold, Closed, Under Construction, Not Active                     |
         * | documentFieldStatus | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | COMPLETE, MISSING_FIELDS, UPLOAD_INVOICES, NOT_APPLICABLE_REQUESTED, NOT_APPLICABLE |
         * | locationIdentifier  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | name                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<LocationListDto, void>({
        path: `/site-list/${organizationId}/locations-list`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SiteList
     * @name SiteListControllerExportOrganizationLocations
     * @request GET:/site-list/{organizationId}/locations-list/export
     * @secure
     */
    siteListControllerExportOrganizationLocations: (
      organizationId: string,
      query: {
        /** Start date for filtering savings/spend (YYYY-MM-DD) */
        startOfSavingsPeriod?: string;
        /** End date for filtering savings/spend (YYYY-MM-DD) */
        endOfSavingsPeriod?: string;
        /** Column paths to export. Pass as repeated query params (preferred) or a JSON array string. Headers are auto-generated from keys. Example: columns=name&columns=status */
        columns: string[];
        /** Custom filename for the CSV download (without extension). */
        filename?: string;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - address
         * - city
         * - state
         * - zip
         * - taxId
         * - phone
         * - kind
         * - status
         * - documentFieldStatus
         * - locationIdentifier
         * - name
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                 | Type   | Allowed Rules                                                                | Possible Values                                                                     |
         * | ------------------- | ------ | ---------------------------------------------------------------------------- | ----------------------------------------------------------------------------------- |
         * | id                  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | address             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | city                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | state               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | zip                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | taxId               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | phone               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | kind                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | site, organization_wide                                                             |
         * | status              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | Active, Monitored, Sold, Closed, Under Construction, Not Active                     |
         * | documentFieldStatus | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | COMPLETE, MISSING_FIELDS, UPLOAD_INVOICES, NOT_APPLICABLE_REQUESTED, NOT_APPLICABLE |
         * | locationIdentifier  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | name                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<StreamableFile, void>({
        path: `/site-list/${organizationId}/locations-list/export`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags SiteList
     * @name SiteListControllerGetFilesUnderValidation
     * @request GET:/site-list/{organizationId}/files-under-validation
     * @secure
     */
    siteListControllerGetFilesUnderValidation: (
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<GetFilesUnderValidationResponseDto, void>({
        path: `/site-list/${organizationId}/files-under-validation`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SiteList
     * @name SiteListControllerUploadLocationList
     * @request POST:/site-list/{organizationId}/upload
     * @secure
     */
    siteListControllerUploadLocationList: (
      organizationId: string,
      data: UploadDocumentDto,
      params: RequestParams = {}
    ) =>
      this.request<ExcelUploadResponseDto, void>({
        path: `/site-list/${organizationId}/upload`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SiteList
     * @name SiteListControllerRequestLocationStatusChange
     * @request POST:/site-list/{organizationId}/location/actions
     * @secure
     */
    siteListControllerRequestLocationStatusChange: (
      organizationId: string,
      data: LocationActionBodyDto,
      params: RequestParams = {}
    ) =>
      this.request<LocationActionResponseDto, void>({
        path: `/site-list/${organizationId}/location/actions`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SiteList
     * @name SiteListControllerGetLocationById
     * @request GET:/site-list/{id}
     * @secure
     */
    siteListControllerGetLocationById: (
      id: string,
      params: RequestParams = {}
    ) =>
      this.request<LocationDto, void>({
        path: `/site-list/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SiteList
     * @name SiteListControllerDeleteLocation
     * @request DELETE:/site-list/{id}
     * @secure
     */
    siteListControllerDeleteLocation: (
      id: string,
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/site-list/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags SiteList
     * @name SiteListControllerUpdateLocation
     * @request PATCH:/site-list/{id}
     * @secure
     */
    siteListControllerUpdateLocation: (
      id: string,
      data: UpdateLocationDto,
      params: RequestParams = {}
    ) =>
      this.request<LocationDto, void>({
        path: `/site-list/${id}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  actionItemTemplate = {
    /**
     * No description
     *
     * @tags ActionItemTemplate
     * @name ActionItemTemplateControllerGetAllActionItemTemplates
     * @request GET:/action-item-template
     * @secure
     */
    actionItemTemplateControllerGetAllActionItemTemplates: (
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - description
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type   | Allowed Rules                                                                | Possible Values |
         * | ----------- | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | id          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | name        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | description | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<ActionItemTemplateListDto, void>({
        path: `/action-item-template`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  faqs = {
    /**
     * No description
     *
     * @tags FAQ
     * @name FaqControllerGetAllFaqs
     * @summary Get all FAQs with pagination and filtering
     * @request GET:/faqs
     * @secure
     */
    faqControllerGetAllFaqs: (
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - title
         * - description
         * - category
         * - createdAt
         * - updatedAt
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type   | Allowed Rules                                                                | Possible Values |
         * | ----------- | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | title       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | description | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | category    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdAt   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | updatedAt   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<FaqListDto, void>({
        path: `/faqs`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  parcelPay = {
    /**
     * No description
     *
     * @tags ParcelPay
     * @name ParcelPayControllerGetInvoices
     * @request GET:/parcel-pay/invoices
     * @secure
     */
    parcelPayControllerGetInvoices: (params: RequestParams = {}) =>
      this.request<ParcelPayInvoiceListDto, void>({
        path: `/parcel-pay/invoices`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ParcelPay
     * @name ParcelPayControllerApproveInvoices
     * @request POST:/parcel-pay/invoices/approve
     * @secure
     */
    parcelPayControllerApproveInvoices: (
      data: ApproveInvoicesRequestDto,
      params: RequestParams = {}
    ) =>
      this.request<ApproveInvoicesResponseItemDto[], void>({
        path: `/parcel-pay/invoices/approve`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  shipware = {
    /**
     * No description
     *
     * @tags Shipware
     * @name ShipwareControllerGetAccessToken
     * @request GET:/shipware/access-token
     * @secure
     */
    shipwareControllerGetAccessToken: (params: RequestParams = {}) =>
      this.request<ShipwareAccessTokenDto, void>({
        path: `/shipware/access-token`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  blobHealthCheck = {
    /**
     * @description Ensures an empty `check.txt` probe exists (via existing upload flow), then returns a time-limited read SAS URL in the JSON body so the client can open it (for example in a new window) without an HTTP redirect.
     *
     * @tags Blob health check
     * @name BlobHealthCheckControllerBrowserConnectivity
     * @summary Returns a read SAS URL for Azure Blob Storage connectivity verification
     * @request GET:/blob-health-check/browser-connectivity
     * @secure
     */
    blobHealthCheckControllerBrowserConnectivity: (
      params: RequestParams = {}
    ) =>
      this.request<BlobBrowserConnectivityResponseDto, void>({
        path: `/blob-health-check/browser-connectivity`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  invoices = {
    /**
     * No description
     *
     * @tags Invoices
     * @name InvoicesControllerFindAll
     * @request GET:/invoices
     * @secure
     */
    invoicesControllerFindAll: (
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - status
         * - value
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key    | Type   | Allowed Rules                                                                | Possible Values |
         * | ------ | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | status | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | value  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<InvoiceListDto, void>({
        path: `/invoices`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invoices
     * @name InvoicesControllerCreate
     * @request POST:/invoices
     * @secure
     */
    invoicesControllerCreate: (
      data: CreateInvoiceDto,
      params: RequestParams = {}
    ) =>
      this.request<InvoiceItemDto, void>({
        path: `/invoices`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  deviceTokens = {
    /**
     * @description Registers or updates an FCM device token for push notifications. If the token already exists, it will be reactivated and updated.
     *
     * @tags Device Tokens
     * @name DeviceTokenControllerRegister
     * @summary Register a device token
     * @request POST:/device-tokens
     * @secure
     */
    deviceTokenControllerRegister: (
      data: RegisterDeviceTokenDto,
      params: RequestParams = {}
    ) =>
      this.request<DeviceTokenDto, void>({
        path: `/device-tokens`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Device Tokens
     * @name DeviceTokenControllerGetMyTokens
     * @request GET:/device-tokens
     * @secure
     */
    deviceTokenControllerGetMyTokens: (
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - platform
         * - deviceName
         * - createdAt
         * - lastUsedAt
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key        | Type   | Allowed Rules                                                                | Possible Values   |
         * | ---------- | ------ | ---------------------------------------------------------------------------- | ----------------- |
         * | platform   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | ios, android, web |
         * | deviceName | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                   |
         * | createdAt  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                   |
         * | lastUsedAt | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                   |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<DeviceTokensListDto, void>({
        path: `/device-tokens`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Unregisters an FCM device token. Call this when the user logs out or disables notifications.
     *
     * @tags Device Tokens
     * @name DeviceTokenControllerUnregister
     * @summary Unregister a device token
     * @request DELETE:/device-tokens/{id}
     * @secure
     */
    deviceTokenControllerUnregister: (id: string, params: RequestParams = {}) =>
      this.request<UnregisterTokenDto, void>({
        path: `/device-tokens/${id}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  review = {
    /**
     * No description
     *
     * @tags Review
     * @name ReviewControllerCreateReview
     * @request POST:/review
     * @secure
     */
    reviewControllerCreateReview: (
      data: CreateReviewDto,
      params: RequestParams = {}
    ) =>
      this.request<CreateReviewDto, void>({
        path: `/review`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  tags = {
    /**
     * No description
     *
     * @tags Tags
     * @name TagsControllerFindAll
     * @request GET:/tags
     * @secure
     */
    tagsControllerFindAll: (
      query?: {
        searchTerm?: string;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - name
         * - color
         * - createdBy
         * - isPredefined
         * - createdAt
         * - updatedAt
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key          | Type    | Allowed Rules                                                                | Possible Values |
         * | ------------ | ------- | ---------------------------------------------------------------------------- | --------------- |
         * | name         | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | color        | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdBy    | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | isPredefined | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                 |
         * | createdAt    | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | updatedAt    | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<TagsListDto, void>({
        path: `/tags`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tags
     * @name TagsControllerCreate
     * @request POST:/tags
     * @secure
     */
    tagsControllerCreate: (data: CreateTagDto, params: RequestParams = {}) =>
      this.request<TagDto, void>({
        path: `/tags`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tags
     * @name TagsControllerFindOne
     * @request GET:/tags/{uuid}
     * @secure
     */
    tagsControllerFindOne: (uuid: string, params: RequestParams = {}) =>
      this.request<TagDto, void>({
        path: `/tags/${uuid}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tags
     * @name TagsControllerUpdate
     * @request PATCH:/tags/{uuid}
     * @secure
     */
    tagsControllerUpdate: (
      uuid: string,
      data: UpdateTagDto,
      params: RequestParams = {}
    ) =>
      this.request<TagDto, void>({
        path: `/tags/${uuid}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tags
     * @name TagsControllerDeleteOne
     * @request DELETE:/tags/{uuid}
     * @secure
     */
    tagsControllerDeleteOne: (uuid: string, params: RequestParams = {}) =>
      this.request<any, void>({
        path: `/tags/${uuid}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  vendors = {
    /**
     * No description
     *
     * @tags Vendors
     * @name VendorsControllerGetAllVendorsSelectList
     * @request GET:/vendors/select-list
     * @secure
     */
    vendorsControllerGetAllVendorsSelectList: (
      query?: {
        searchTerm?: string;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - name
         * - createdAt
         * - updatedAt
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key       | Type   | Allowed Rules                                                                | Possible Values |
         * | --------- | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | name      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdAt | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | updatedAt | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<VendorSelectListDto, void>({
        path: `/vendors/select-list`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vendors
     * @name VendorsControllerGetVendorById
     * @request GET:/vendors/{vendorId}
     * @secure
     */
    vendorsControllerGetVendorById: (
      vendorId: string,
      params: RequestParams = {}
    ) =>
      this.request<VendorDto, void>({
        path: `/vendors/${vendorId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  profilePicture = {
    /**
     * No description
     *
     * @tags ProfilePicture
     * @name ProfilePictureControllerUpdateTicket
     * @request PUT:/profile-picture
     * @secure
     */
    profilePictureControllerUpdateTicket: (
      data: UpdateProfilePictureDto,
      params: RequestParams = {}
    ) =>
      this.request<string, void>({
        path: `/profile-picture`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),
  };
  staticContent = {
    /**
     * No description
     *
     * @tags Static Content
     * @name StaticContentControllerGetTosContent
     * @request GET:/static-content/tos-content
     * @secure
     */
    staticContentControllerGetTosContent: (params: RequestParams = {}) =>
      this.request<TosContentResponseDto, void>({
        path: `/static-content/tos-content`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  sfMigration = {
    /**
     * No description
     *
     * @tags SF Migration (debug)
     * @name SfMigrationControllerListOrphanBaselineSpends
     * @summary List orphan migrated baseline spends for an SF1 parent audit (provenance via spend_audit_origin)
     * @request GET:/sf-migration/audits/{salesforceAuditId}/orphan-baseline-spends
     * @secure
     */
    sfMigrationControllerListOrphanBaselineSpends: (
      salesforceAuditId: string,
      query?: {
        /**
         * Filter by app location id
         * @format uuid
         */
        locationId?: string;
        /** Filter by app vendor id */
        vendorId?: string;
        /**
         * Filter by affected vendor account (vendor_account) id
         * @format uuid
         */
        vendorAccountId?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<SfMigrationOrphanBaselineSpendListDto, void>({
        path: `/sf-migration/audits/${salesforceAuditId}/orphan-baseline-spends`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SF Migration (debug)
     * @name SfMigrationControllerListVendorScope
     * @summary List vendors for orphan migrated baseline spends under an SF1 parent audit, with distinct locations and affected vendor accounts
     * @request GET:/sf-migration/audits/{salesforceAuditId}/vendor-scope
     * @secure
     */
    sfMigrationControllerListVendorScope: (
      salesforceAuditId: string,
      params: RequestParams = {}
    ) =>
      this.request<SfMigrationVendorScopeListDto, void>({
        path: `/sf-migration/audits/${salesforceAuditId}/vendor-scope`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  token = {
    /**
     * No description
     *
     * @tags Token
     * @name TokenControllerGetFranzOboToken
     * @request GET:/token/franz/{organizationId}
     * @secure
     */
    tokenControllerGetFranzOboToken: (
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<string, void>({
        path: `/token/franz/${organizationId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  integrations = {
    /**
     * @description Creates a support ticket on behalf of the Franz integration. Requires an Entra ID client-credentials token belonging to the Franz integration account, which holds the Global-scoped Franz Integration permission.
     *
     * @tags Franz Integration - Tickets
     * @name FranzTicketsControllerCreateTicket
     * @summary Create a ticket (Franz integration)
     * @request POST:/integrations/franz/organizations/{organizationId}/tickets
     * @secure
     */
    franzTicketsControllerCreateTicket: (
      organizationId: string,
      data: CreateIntegrationTicketDto,
      params: RequestParams = {}
    ) =>
      this.request<IntegrationTicketResponseDto, void>({
        path: `/integrations/franz/organizations/${organizationId}/tickets`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description The `summary` KPI block is not computed or returned here.
     *
     * @tags Franz Integration - Vendors
     * @name FranzVendorsControllerGetVendorDetailsById
     * @summary Get the vendor record by id (Franz integration)
     * @request GET:/integrations/franz/vendors/{vendorId}/details
     * @secure
     */
    franzVendorsControllerGetVendorDetailsById: (
      vendorId: string,
      params: RequestParams = {}
    ) =>
      this.request<VendorDetailDto, void>({
        path: `/integrations/franz/vendors/${vendorId}/details`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns a single vendor. Requires an Entra ID client-credentials token belonging to the Franz integration account, which holds the Global-scoped Franz Integration permission.
     *
     * @tags Franz Integration - Vendors
     * @name FranzVendorsControllerGetVendorById
     * @summary Get a vendor by id (Franz integration)
     * @request GET:/integrations/franz/vendors/{vendorId}
     * @secure
     */
    franzVendorsControllerGetVendorById: (
      vendorId: string,
      params: RequestParams = {}
    ) =>
      this.request<VendorDto, void>({
        path: `/integrations/franz/vendors/${vendorId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns the paginated vendors of a single organization, enriched with contract counts when the organization is linked to Vector. Requires an Entra ID client-credentials token belonging to the Franz integration account, which holds the Global-scoped Franz Integration permission.
     *
     * @tags Franz Integration - Vendors
     * @name FranzOrganizationVendorsControllerGetOrganizationVendors
     * @summary List an organization's vendors (Franz integration)
     * @request GET:/integrations/franz/organizations/{organizationId}/vendors
     * @secure
     */
    franzOrganizationVendorsControllerGetOrganizationVendors: (
      organizationId: string,
      query?: {
        searchTerm?: string;
        serviceCategory?: string;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - name
         * - createdAt
         * - updatedAt
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key       | Type   | Allowed Rules                                                                | Possible Values |
         * | --------- | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | name      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdAt | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | updatedAt | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<VendorsListDto, void>({
        path: `/integrations/franz/organizations/${organizationId}/vendors`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns the paginated vendor accounts of a single organization, with the same filtering and sorting surface as the internal portal endpoint. Requires an Entra ID client-credentials token belonging to the Franz integration account, which holds the Global-scoped Franz Integration permission.
     *
     * @tags Franz Integration - Vendor accounts
     * @name FranzVendorAccountsControllerGetVendorAccounts
     * @summary List an organization's vendor accounts (Franz integration)
     * @request GET:/integrations/franz/organizations/{organizationId}/vendor-accounts
     * @secure
     */
    franzVendorAccountsControllerGetVendorAccounts: (
      organizationId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - accountNumber
         * - name
         * - createdAt
         * - invoiceFrequency
         * - billingType
         * - serviceType
         * - summaryAccountNumber
         * - glCode
         * - customGlField
         * - glAllocations
         * - usageLimit
         * - dollarLimit
         * - paymentTerms
         * - invoiceDay
         * - portalLoginEmailId
         * - note
         * - vendorName
         * - auditsCount
         * - status
         * - spendCategories
         * - locations
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                  | Type   | Allowed Rules                                                                | Possible Values                                   |
         * | -------------------- | ------ | ---------------------------------------------------------------------------- | ------------------------------------------------- |
         * | id                   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | accountNumber        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | name                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | createdAt            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | invoiceFrequency     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | bi_weekly, weekly, monthly, bi_monthly, quarterly |
         * | billingType          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | paper, email, portal                              |
         * | serviceType          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | summaryAccountNumber | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | glCode               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | customGlField        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | glAllocations        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | usageLimit           | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                   |
         * | dollarLimit          | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                   |
         * | paymentTerms         | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                   |
         * | invoiceDay           | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                   |
         * | portalLoginEmailId   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | note                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | vendorName           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | auditsCount          | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                   |
         * | status               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | active, inactive                                  |
         * | spendCategories      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | locations            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - accountNumber
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<VendorAccountListDto, void>({
        path: `/integrations/franz/organizations/${organizationId}/vendor-accounts`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns a single vendor account of the given organization. Requires an Entra ID client-credentials token belonging to the Franz integration account, which holds the Global-scoped Franz Integration permission.
     *
     * @tags Franz Integration - Vendor accounts
     * @name FranzVendorAccountsControllerGetVendorAccountById
     * @summary Get a vendor account by id (Franz integration)
     * @request GET:/integrations/franz/organizations/{organizationId}/vendor-accounts/{accountId}
     * @secure
     */
    franzVendorAccountsControllerGetVendorAccountById: (
      organizationId: string,
      accountId: string,
      params: RequestParams = {}
    ) =>
      this.request<VendorAccountDto, void>({
        path: `/integrations/franz/organizations/${organizationId}/vendor-accounts/${accountId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Requested Salesforce 2 ids. Ids with no matching organization are omitted. POST is used so large id arrays are not constrained by URL length. Requires an Entra ID client-credentials token belonging to the Franz integration account, which holds the Global-scoped Franz Integration permission.
     *
     * @tags Integrations - Organizations mappings
     * @name OrganizationMappingsControllerListMappings
     * @summary Resolve Salesforce 2 ids to SpendBrain organization ids
     * @request POST:/integrations/organizations/mappings
     * @secure
     */
    organizationMappingsControllerListMappings: (
      data: OrganizationMappingLookupDto,
      params: RequestParams = {}
    ) =>
      this.request<OrganizationMappingListDto, any>({
        path: `/integrations/organizations/mappings`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  mobile = {
    /**
     * No description
     *
     * @tags Mobile Versions
     * @name VersionsControllerGetMobileVersions
     * @request GET:/mobile/versions
     */
    versionsControllerGetMobileVersions: (params: RequestParams = {}) =>
      this.request<MobileVersionsDto, any>({
        path: `/mobile/versions`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
}
